import * as M from "react";
import te, { createContext as Rt, useRef as ce, useLayoutEffect as Na, useEffect as se, useState as ue, useContext as Xe, useMemo as _t, useCallback as ge, useInsertionEffect as V1, forwardRef as Th, Fragment as Kr, createElement as Wr, useId as B1, useReducer as H1, cloneElement as _a, Component as xl, Children as Aa, isValidElement as K1 } from "react";
import * as Ph from "react-dom";
import W1, { createPortal as di } from "react-dom";
const z1 = "5.6.0", G1 = {
  version: z1
}, U1 = "1.4.0", q1 = {
  version: U1
}, Y1 = `https://cdn.yonderland.com/andes/${q1.version}/`, X1 = (e) => ({
  asadventure: [
    `${e}fonts/dm-serif-text/DMSerifText-Regular-subset.woff2`,
    `${e}fonts/source-sans-3/source-sans-3-latin-ext-wght-normal.woff2`,
    `${e}fonts/source-sans-3/source-sans-3-latin-wght-normal.woff2`
  ],
  bever: [
    `${e}fonts/camingo-dos-pro-bold/CamingoDosPro-Bold.woff2`,
    `${e}fonts/source-sans-3/source-sans-3-latin-ext-wght-normal.woff2`,
    `${e}fonts/source-sans-3/source-sans-3-latin-wght-normal.woff2`
  ],
  cotswold: [
    `${e}fonts/antwerp/Antwerp-Bold.woff2`,
    `${e}fonts/source-sans-3/source-sans-3-latin-ext-wght-normal.woff2`,
    `${e}fonts/source-sans-3/source-sans-3-latin-wght-normal.woff2`
  ],
  juttu: [
    `${e}fonts/good-headline-web/GoodHeadlineWeb-subset.woff2`,
    `${e}fonts/good-headline-web/GoodHeadlineWeb-Bold-subset.woff2`,
    `${e}fonts/source-sans-3/source-sans-3-latin-ext-wght-normal.woff2`,
    `${e}fonts/source-sans-3/source-sans-3-latin-wght-normal.woff2`
  ],
  runnersneed: [
    `${e}fonts/antwerp/Antwerp-Bold.woff2`,
    `${e}fonts/source-sans-3/source-sans-3-latin-ext-wght-normal.woff2`,
    `${e}fonts/source-sans-3/source-sans-3-latin-wght-normal.woff2`
  ],
  snowandrock: [
    `${e}fonts/antwerp/Antwerp-Bold.woff2`,
    `${e}fonts/source-sans-3/source-sans-3-latin-ext-wght-normal.woff2`,
    `${e}fonts/source-sans-3/source-sans-3-latin-wght-normal.woff2`
  ],
  yonderland: [
    `${e}fonts/open-sans/open-sans-latin-700-normal.woff2`,
    `${e}fonts/source-sans-3/source-sans-3-latin-ext-wght-normal.woff2`,
    `${e}fonts/source-sans-3/source-sans-3-latin-wght-normal.woff2`
  ]
});
function rn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ii = { exports: {} }, Pr = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ic;
function Z1() {
  if (Ic) return Pr;
  Ic = 1;
  var e = te, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(s, l, u) {
    var c, f = {}, p = null, h = null;
    u !== void 0 && (p = "" + u), l.key !== void 0 && (p = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (c in l) r.call(l, c) && !a.hasOwnProperty(c) && (f[c] = l[c]);
    if (s && s.defaultProps) for (c in l = s.defaultProps, l) f[c] === void 0 && (f[c] = l[c]);
    return { $$typeof: t, type: s, key: p, ref: h, props: f, _owner: i.current };
  }
  return Pr.Fragment = n, Pr.jsx = o, Pr.jsxs = o, Pr;
}
var Nr = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ec;
function J1() {
  return Ec || (Ec = 1, process.env.NODE_ENV !== "production" && function() {
    var e = te, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), m = Symbol.iterator, v = "@@iterator";
    function g(P) {
      if (P === null || typeof P != "object")
        return null;
      var Q = m && P[m] || P[v];
      return typeof Q == "function" ? Q : null;
    }
    var b = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(P) {
      {
        for (var Q = arguments.length, oe = new Array(Q > 1 ? Q - 1 : 0), pe = 1; pe < Q; pe++)
          oe[pe - 1] = arguments[pe];
        x("error", P, oe);
      }
    }
    function x(P, Q, oe) {
      {
        var pe = b.ReactDebugCurrentFrame, we = pe.getStackAddendum();
        we !== "" && (Q += "%s", oe = oe.concat([we]));
        var Ne = oe.map(function(xe) {
          return String(xe);
        });
        Ne.unshift("Warning: " + Q), Function.prototype.apply.call(console[P], console, Ne);
      }
    }
    var w = !1, $ = !1, C = !1, T = !1, S = !1, N;
    N = Symbol.for("react.module.reference");
    function k(P) {
      return !!(typeof P == "string" || typeof P == "function" || P === r || P === a || S || P === i || P === u || P === c || T || P === h || w || $ || C || typeof P == "object" && P !== null && (P.$$typeof === p || P.$$typeof === f || P.$$typeof === o || P.$$typeof === s || P.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      P.$$typeof === N || P.getModuleId !== void 0));
    }
    function L(P, Q, oe) {
      var pe = P.displayName;
      if (pe)
        return pe;
      var we = Q.displayName || Q.name || "";
      return we !== "" ? oe + "(" + we + ")" : oe;
    }
    function _(P) {
      return P.displayName || "Context";
    }
    function B(P) {
      if (P == null)
        return null;
      if (typeof P.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof P == "function")
        return P.displayName || P.name || null;
      if (typeof P == "string")
        return P;
      switch (P) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case a:
          return "Profiler";
        case i:
          return "StrictMode";
        case u:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof P == "object")
        switch (P.$$typeof) {
          case s:
            var Q = P;
            return _(Q) + ".Consumer";
          case o:
            var oe = P;
            return _(oe._context) + ".Provider";
          case l:
            return L(P, P.render, "ForwardRef");
          case f:
            var pe = P.displayName || null;
            return pe !== null ? pe : B(P.type) || "Memo";
          case p: {
            var we = P, Ne = we._payload, xe = we._init;
            try {
              return B(xe(Ne));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var A = Object.assign, q = 0, X, I, O, D, E, j, F;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function H() {
      {
        if (q === 0) {
          X = console.log, I = console.info, O = console.warn, D = console.error, E = console.group, j = console.groupCollapsed, F = console.groupEnd;
          var P = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: P,
            log: P,
            warn: P,
            error: P,
            group: P,
            groupCollapsed: P,
            groupEnd: P
          });
        }
        q++;
      }
    }
    function W() {
      {
        if (q--, q === 0) {
          var P = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: A({}, P, {
              value: X
            }),
            info: A({}, P, {
              value: I
            }),
            warn: A({}, P, {
              value: O
            }),
            error: A({}, P, {
              value: D
            }),
            group: A({}, P, {
              value: E
            }),
            groupCollapsed: A({}, P, {
              value: j
            }),
            groupEnd: A({}, P, {
              value: F
            })
          });
        }
        q < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var G = b.ReactCurrentDispatcher, z;
    function U(P, Q, oe) {
      {
        if (z === void 0)
          try {
            throw Error();
          } catch (we) {
            var pe = we.stack.trim().match(/\n( *(at )?)/);
            z = pe && pe[1] || "";
          }
        return `
` + z + P;
      }
    }
    var J = !1, ne;
    {
      var ae = typeof WeakMap == "function" ? WeakMap : Map;
      ne = new ae();
    }
    function V(P, Q) {
      if (!P || J)
        return "";
      {
        var oe = ne.get(P);
        if (oe !== void 0)
          return oe;
      }
      var pe;
      J = !0;
      var we = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ne;
      Ne = G.current, G.current = null, H();
      try {
        if (Q) {
          var xe = function() {
            throw Error();
          };
          if (Object.defineProperty(xe.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(xe, []);
            } catch (Ht) {
              pe = Ht;
            }
            Reflect.construct(P, [], xe);
          } else {
            try {
              xe.call();
            } catch (Ht) {
              pe = Ht;
            }
            P.call(xe.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ht) {
            pe = Ht;
          }
          P();
        }
      } catch (Ht) {
        if (Ht && pe && typeof Ht.stack == "string") {
          for (var be = Ht.stack.split(`
`), rt = pe.stack.split(`
`), Be = be.length - 1, ze = rt.length - 1; Be >= 1 && ze >= 0 && be[Be] !== rt[ze]; )
            ze--;
          for (; Be >= 1 && ze >= 0; Be--, ze--)
            if (be[Be] !== rt[ze]) {
              if (Be !== 1 || ze !== 1)
                do
                  if (Be--, ze--, ze < 0 || be[Be] !== rt[ze]) {
                    var vt = `
` + be[Be].replace(" at new ", " at ");
                    return P.displayName && vt.includes("<anonymous>") && (vt = vt.replace("<anonymous>", P.displayName)), typeof P == "function" && ne.set(P, vt), vt;
                  }
                while (Be >= 1 && ze >= 0);
              break;
            }
        }
      } finally {
        J = !1, G.current = Ne, W(), Error.prepareStackTrace = we;
      }
      var Bn = P ? P.displayName || P.name : "", Sc = Bn ? U(Bn) : "";
      return typeof P == "function" && ne.set(P, Sc), Sc;
    }
    function le(P, Q, oe) {
      return V(P, !1);
    }
    function ee(P) {
      var Q = P.prototype;
      return !!(Q && Q.isReactComponent);
    }
    function ye(P, Q, oe) {
      if (P == null)
        return "";
      if (typeof P == "function")
        return V(P, ee(P));
      if (typeof P == "string")
        return U(P);
      switch (P) {
        case u:
          return U("Suspense");
        case c:
          return U("SuspenseList");
      }
      if (typeof P == "object")
        switch (P.$$typeof) {
          case l:
            return le(P.render);
          case f:
            return ye(P.type, Q, oe);
          case p: {
            var pe = P, we = pe._payload, Ne = pe._init;
            try {
              return ye(Ne(we), Q, oe);
            } catch {
            }
          }
        }
      return "";
    }
    var ve = Object.prototype.hasOwnProperty, Te = {}, je = b.ReactDebugCurrentFrame;
    function Ae(P) {
      if (P) {
        var Q = P._owner, oe = ye(P.type, P._source, Q ? Q.type : null);
        je.setExtraStackFrame(oe);
      } else
        je.setExtraStackFrame(null);
    }
    function tt(P, Q, oe, pe, we) {
      {
        var Ne = Function.call.bind(ve);
        for (var xe in P)
          if (Ne(P, xe)) {
            var be = void 0;
            try {
              if (typeof P[xe] != "function") {
                var rt = Error((pe || "React class") + ": " + oe + " type `" + xe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof P[xe] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw rt.name = "Invariant Violation", rt;
              }
              be = P[xe](Q, xe, pe, oe, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Be) {
              be = Be;
            }
            be && !(be instanceof Error) && (Ae(we), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", pe || "React class", oe, xe, typeof be), Ae(null)), be instanceof Error && !(be.message in Te) && (Te[be.message] = !0, Ae(we), y("Failed %s type: %s", oe, be.message), Ae(null));
          }
      }
    }
    var Ve = Array.isArray;
    function Ue(P) {
      return Ve(P);
    }
    function $t(P) {
      {
        var Q = typeof Symbol == "function" && Symbol.toStringTag, oe = Q && P[Symbol.toStringTag] || P.constructor.name || "Object";
        return oe;
      }
    }
    function Vt(P) {
      try {
        return ot(P), !1;
      } catch {
        return !0;
      }
    }
    function ot(P) {
      return "" + P;
    }
    function gt(P) {
      if (Vt(P))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $t(P)), ot(P);
    }
    var st = b.ReactCurrentOwner, nt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, on, Bt;
    function Cr(P) {
      if (ve.call(P, "ref")) {
        var Q = Object.getOwnPropertyDescriptor(P, "ref").get;
        if (Q && Q.isReactWarning)
          return !1;
      }
      return P.ref !== void 0;
    }
    function Sr(P) {
      if (ve.call(P, "key")) {
        var Q = Object.getOwnPropertyDescriptor(P, "key").get;
        if (Q && Q.isReactWarning)
          return !1;
      }
      return P.key !== void 0;
    }
    function Ln(P, Q) {
      typeof P.ref == "string" && st.current;
    }
    function lo(P, Q) {
      {
        var oe = function() {
          on || (on = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Q));
        };
        oe.isReactWarning = !0, Object.defineProperty(P, "key", {
          get: oe,
          configurable: !0
        });
      }
    }
    function uo(P, Q) {
      {
        var oe = function() {
          Bt || (Bt = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Q));
        };
        oe.isReactWarning = !0, Object.defineProperty(P, "ref", {
          get: oe,
          configurable: !0
        });
      }
    }
    var co = function(P, Q, oe, pe, we, Ne, xe) {
      var be = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: P,
        key: Q,
        ref: oe,
        props: xe,
        // Record the component responsible for creating this element.
        _owner: Ne
      };
      return be._store = {}, Object.defineProperty(be._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(be, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: pe
      }), Object.defineProperty(be, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: we
      }), Object.freeze && (Object.freeze(be.props), Object.freeze(be)), be;
    };
    function fo(P, Q, oe, pe, we) {
      {
        var Ne, xe = {}, be = null, rt = null;
        oe !== void 0 && (gt(oe), be = "" + oe), Sr(Q) && (gt(Q.key), be = "" + Q.key), Cr(Q) && (rt = Q.ref, Ln(Q, we));
        for (Ne in Q)
          ve.call(Q, Ne) && !nt.hasOwnProperty(Ne) && (xe[Ne] = Q[Ne]);
        if (P && P.defaultProps) {
          var Be = P.defaultProps;
          for (Ne in Be)
            xe[Ne] === void 0 && (xe[Ne] = Be[Ne]);
        }
        if (be || rt) {
          var ze = typeof P == "function" ? P.displayName || P.name || "Unknown" : P;
          be && lo(xe, ze), rt && uo(xe, ze);
        }
        return co(P, be, rt, we, pe, st.current, xe);
      }
    }
    var Ir = b.ReactCurrentOwner, Er = b.ReactDebugCurrentFrame;
    function sn(P) {
      if (P) {
        var Q = P._owner, oe = ye(P.type, P._source, Q ? Q.type : null);
        Er.setExtraStackFrame(oe);
      } else
        Er.setExtraStackFrame(null);
    }
    var Fn;
    Fn = !1;
    function Vn(P) {
      return typeof P == "object" && P !== null && P.$$typeof === t;
    }
    function Or() {
      {
        if (Ir.current) {
          var P = B(Ir.current.type);
          if (P)
            return `

Check the render method of \`` + P + "`.";
        }
        return "";
      }
    }
    function po(P) {
      return "";
    }
    var Tr = {};
    function Ci(P) {
      {
        var Q = Or();
        if (!Q) {
          var oe = typeof P == "string" ? P : P.displayName || P.name;
          oe && (Q = `

Check the top-level render call using <` + oe + ">.");
        }
        return Q;
      }
    }
    function Si(P, Q) {
      {
        if (!P._store || P._store.validated || P.key != null)
          return;
        P._store.validated = !0;
        var oe = Ci(Q);
        if (Tr[oe])
          return;
        Tr[oe] = !0;
        var pe = "";
        P && P._owner && P._owner !== Ir.current && (pe = " It was passed a child from " + B(P._owner.type) + "."), sn(P), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', oe, pe), sn(null);
      }
    }
    function wc(P, Q) {
      {
        if (typeof P != "object")
          return;
        if (Ue(P))
          for (var oe = 0; oe < P.length; oe++) {
            var pe = P[oe];
            Vn(pe) && Si(pe, Q);
          }
        else if (Vn(P))
          P._store && (P._store.validated = !0);
        else if (P) {
          var we = g(P);
          if (typeof we == "function" && we !== P.entries)
            for (var Ne = we.call(P), xe; !(xe = Ne.next()).done; )
              Vn(xe.value) && Si(xe.value, Q);
        }
      }
    }
    function M1(P) {
      {
        var Q = P.type;
        if (Q == null || typeof Q == "string")
          return;
        var oe;
        if (typeof Q == "function")
          oe = Q.propTypes;
        else if (typeof Q == "object" && (Q.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Q.$$typeof === f))
          oe = Q.propTypes;
        else
          return;
        if (oe) {
          var pe = B(Q);
          tt(oe, P.props, "prop", pe, P);
        } else if (Q.PropTypes !== void 0 && !Fn) {
          Fn = !0;
          var we = B(Q);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", we || "Unknown");
        }
        typeof Q.getDefaultProps == "function" && !Q.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function j1(P) {
      {
        for (var Q = Object.keys(P.props), oe = 0; oe < Q.length; oe++) {
          var pe = Q[oe];
          if (pe !== "children" && pe !== "key") {
            sn(P), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", pe), sn(null);
            break;
          }
        }
        P.ref !== null && (sn(P), y("Invalid attribute `ref` supplied to `React.Fragment`."), sn(null));
      }
    }
    function Cc(P, Q, oe, pe, we, Ne) {
      {
        var xe = k(P);
        if (!xe) {
          var be = "";
          (P === void 0 || typeof P == "object" && P !== null && Object.keys(P).length === 0) && (be += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var rt = po();
          rt ? be += rt : be += Or();
          var Be;
          P === null ? Be = "null" : Ue(P) ? Be = "array" : P !== void 0 && P.$$typeof === t ? (Be = "<" + (B(P.type) || "Unknown") + " />", be = " Did you accidentally export a JSX literal instead of a component?") : Be = typeof P, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Be, be);
        }
        var ze = fo(P, Q, oe, we, Ne);
        if (ze == null)
          return ze;
        if (xe) {
          var vt = Q.children;
          if (vt !== void 0)
            if (pe)
              if (Ue(vt)) {
                for (var Bn = 0; Bn < vt.length; Bn++)
                  wc(vt[Bn], P);
                Object.freeze && Object.freeze(vt);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              wc(vt, P);
        }
        return P === r ? j1(ze) : M1(ze), ze;
      }
    }
    function D1(P, Q, oe) {
      return Cc(P, Q, oe, !0);
    }
    function k1(P, Q, oe) {
      return Cc(P, Q, oe, !1);
    }
    var L1 = k1, F1 = D1;
    Nr.Fragment = r, Nr.jsx = L1, Nr.jsxs = F1;
  }()), Nr;
}
var Oc;
function Q1() {
  return Oc || (Oc = 1, process.env.NODE_ENV === "production" ? Ii.exports = Z1() : Ii.exports = J1()), Ii.exports;
}
var d = Q1();
function Nh(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var i = e.length;
    for (t = 0; t < i; t++) e[t] && (n = Nh(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function ey() {
  for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = Nh(e)) && (r && (r += " "), r += t);
  return r;
}
const Tc = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Pc = ey, de = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null) return Pc(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: i, defaultVariants: a } = t, o = Object.keys(i).map((u) => {
    const c = n == null ? void 0 : n[u], f = a == null ? void 0 : a[u];
    if (c === null) return null;
    const p = Tc(c) || Tc(f);
    return i[u][p];
  }), s = n && Object.entries(n).reduce((u, c) => {
    let [f, p] = c;
    return p === void 0 || (u[f] = p), u;
  }, {}), l = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((u, c) => {
    let { class: f, className: p, ...h } = c;
    return Object.entries(h).every((m) => {
      let [v, g] = m;
      return Array.isArray(g) ? g.includes({
        ...a,
        ...s
      }[v]) : {
        ...a,
        ...s
      }[v] === g;
    }) ? [
      ...u,
      f,
      p
    ] : u;
  }, []);
  return Pc(e, o, l, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
};
function _h(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (n = _h(e[t])) && (r && (r += " "), r += n);
  else for (t in e) e[t] && (r && (r += " "), r += t);
  return r;
}
function Oe() {
  for (var e, t, n = 0, r = ""; n < arguments.length; ) (e = arguments[n++]) && (t = _h(e)) && (r && (r += " "), r += t);
  return r;
}
function ty() {
  for (var e = 0, t, n, r = ""; e < arguments.length; )
    (t = arguments[e++]) && (n = Ah(t)) && (r && (r += " "), r += n);
  return r;
}
function Ah(e) {
  if (typeof e == "string")
    return e;
  for (var t, n = "", r = 0; r < e.length; r++)
    e[r] && (t = Ah(e[r])) && (n && (n += " "), n += t);
  return n;
}
var $l = "-";
function ny(e) {
  var t = iy(e), n = e.conflictingClassGroups, r = e.conflictingClassGroupModifiers, i = r === void 0 ? {} : r;
  function a(s) {
    var l = s.split($l);
    return l[0] === "" && l.length !== 1 && l.shift(), Rh(l, t) || ry(s);
  }
  function o(s, l) {
    var u = n[s] || [];
    return l && i[s] ? [].concat(u, i[s]) : u;
  }
  return {
    getClassGroupId: a,
    getConflictingClassGroupIds: o
  };
}
function Rh(e, t) {
  var o;
  if (e.length === 0)
    return t.classGroupId;
  var n = e[0], r = t.nextPart.get(n), i = r ? Rh(e.slice(1), r) : void 0;
  if (i)
    return i;
  if (t.validators.length !== 0) {
    var a = e.join($l);
    return (o = t.validators.find(function(s) {
      var l = s.validator;
      return l(a);
    })) == null ? void 0 : o.classGroupId;
  }
}
var Nc = /^\[(.+)\]$/;
function ry(e) {
  if (Nc.test(e)) {
    var t = Nc.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function iy(e) {
  var t = e.theme, n = e.prefix, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, i = oy(Object.entries(e.classGroups), n);
  return i.forEach(function(a) {
    var o = a[0], s = a[1];
    is(s, r, o, t);
  }), r;
}
function is(e, t, n, r) {
  e.forEach(function(i) {
    if (typeof i == "string") {
      var a = i === "" ? t : _c(t, i);
      a.classGroupId = n;
      return;
    }
    if (typeof i == "function") {
      if (ay(i)) {
        is(i(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: i,
        classGroupId: n
      });
      return;
    }
    Object.entries(i).forEach(function(o) {
      var s = o[0], l = o[1];
      is(l, _c(t, s), n, r);
    });
  });
}
function _c(e, t) {
  var n = e;
  return t.split($l).forEach(function(r) {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}
function ay(e) {
  return e.isThemeGetter;
}
function oy(e, t) {
  return t ? e.map(function(n) {
    var r = n[0], i = n[1], a = i.map(function(o) {
      return typeof o == "string" ? t + o : typeof o == "object" ? Object.fromEntries(Object.entries(o).map(function(s) {
        var l = s[0], u = s[1];
        return [t + l, u];
      })) : o;
    });
    return [r, a];
  }) : e;
}
function sy(e) {
  if (e < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  function i(a, o) {
    n.set(a, o), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get: function(o) {
      var s = n.get(o);
      if (s !== void 0)
        return s;
      if ((s = r.get(o)) !== void 0)
        return i(o, s), s;
    },
    set: function(o, s) {
      n.has(o) ? n.set(o, s) : i(o, s);
    }
  };
}
var Mh = "!";
function ly(e) {
  var t = e.separator || ":", n = t.length === 1, r = t[0], i = t.length;
  return function(o) {
    for (var s = [], l = 0, u = 0, c, f = 0; f < o.length; f++) {
      var p = o[f];
      if (l === 0) {
        if (p === r && (n || o.slice(f, f + i) === t)) {
          s.push(o.slice(u, f)), u = f + i;
          continue;
        }
        if (p === "/") {
          c = f;
          continue;
        }
      }
      p === "[" ? l++ : p === "]" && l--;
    }
    var h = s.length === 0 ? o : o.substring(u), m = h.startsWith(Mh), v = m ? h.substring(1) : h, g = c && c > u ? c - u : void 0;
    return {
      modifiers: s,
      hasImportantModifier: m,
      baseClassName: v,
      maybePostfixModifierPosition: g
    };
  };
}
function uy(e) {
  if (e.length <= 1)
    return e;
  var t = [], n = [];
  return e.forEach(function(r) {
    var i = r[0] === "[";
    i ? (t.push.apply(t, n.sort().concat([r])), n = []) : n.push(r);
  }), t.push.apply(t, n.sort()), t;
}
function cy(e) {
  return {
    cache: sy(e.cacheSize),
    splitModifiers: ly(e),
    ...ny(e)
  };
}
var dy = /\s+/;
function fy(e, t) {
  var n = t.splitModifiers, r = t.getClassGroupId, i = t.getConflictingClassGroupIds, a = /* @__PURE__ */ new Set();
  return e.trim().split(dy).map(function(o) {
    var s = n(o), l = s.modifiers, u = s.hasImportantModifier, c = s.baseClassName, f = s.maybePostfixModifierPosition, p = r(f ? c.substring(0, f) : c), h = !!f;
    if (!p) {
      if (!f)
        return {
          isTailwindClass: !1,
          originalClassName: o
        };
      if (p = r(c), !p)
        return {
          isTailwindClass: !1,
          originalClassName: o
        };
      h = !1;
    }
    var m = uy(l).join(":"), v = u ? m + Mh : m;
    return {
      isTailwindClass: !0,
      modifierId: v,
      classGroupId: p,
      originalClassName: o,
      hasPostfixModifier: h
    };
  }).reverse().filter(function(o) {
    if (!o.isTailwindClass)
      return !0;
    var s = o.modifierId, l = o.classGroupId, u = o.hasPostfixModifier, c = s + l;
    return a.has(c) ? !1 : (a.add(c), i(l, u).forEach(function(f) {
      return a.add(s + f);
    }), !0);
  }).reverse().map(function(o) {
    return o.originalClassName;
  }).join(" ");
}
function Ac() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r, i, a, o = s;
  function s(u) {
    var c = t[0], f = t.slice(1), p = f.reduce(function(h, m) {
      return m(h);
    }, c());
    return r = cy(p), i = r.cache.get, a = r.cache.set, o = l, l(u);
  }
  function l(u) {
    var c = i(u);
    if (c)
      return c;
    var f = fy(u, r);
    return a(u, f), f;
  }
  return function() {
    return o(ty.apply(null, arguments));
  };
}
function Re(e) {
  var t = function(r) {
    return r[e] || [];
  };
  return t.isThemeGetter = !0, t;
}
var jh = /^\[(?:([a-z-]+):)?(.+)\]$/i, py = /^\d+\/\d+$/, hy = /* @__PURE__ */ new Set(["px", "full", "screen"]), my = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, gy = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))/, vy = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function wt(e) {
  return wn(e) || hy.has(e) || py.test(e) || un(e);
}
function un(e) {
  return jn(e, "length", Cy);
}
function yy(e) {
  return jn(e, "size", Dh);
}
function by(e) {
  return jn(e, "position", Dh);
}
function xy(e) {
  return jn(e, "url", Sy);
}
function Ei(e) {
  return jn(e, "number", wn);
}
function wn(e) {
  return !Number.isNaN(Number(e));
}
function $y(e) {
  return e.endsWith("%") && wn(e.slice(0, -1));
}
function _r(e) {
  return Rc(e) || jn(e, "number", Rc);
}
function He(e) {
  return jh.test(e);
}
function Ar() {
  return !0;
}
function ln(e) {
  return my.test(e);
}
function wy(e) {
  return jn(e, "", Iy);
}
function jn(e, t, n) {
  var r = jh.exec(e);
  return r ? r[1] ? r[1] === t : n(r[2]) : !1;
}
function Cy(e) {
  return gy.test(e);
}
function Dh() {
  return !1;
}
function Sy(e) {
  return e.startsWith("url(");
}
function Rc(e) {
  return Number.isInteger(Number(e));
}
function Iy(e) {
  return vy.test(e);
}
function Mc() {
  var e = Re("colors"), t = Re("spacing"), n = Re("blur"), r = Re("brightness"), i = Re("borderColor"), a = Re("borderRadius"), o = Re("borderSpacing"), s = Re("borderWidth"), l = Re("contrast"), u = Re("grayscale"), c = Re("hueRotate"), f = Re("invert"), p = Re("gap"), h = Re("gradientColorStops"), m = Re("gradientColorStopPositions"), v = Re("inset"), g = Re("margin"), b = Re("opacity"), y = Re("padding"), x = Re("saturate"), w = Re("scale"), $ = Re("sepia"), C = Re("skew"), T = Re("space"), S = Re("translate"), N = function() {
    return ["auto", "contain", "none"];
  }, k = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, L = function() {
    return ["auto", t];
  }, _ = function() {
    return ["", wt];
  }, B = function() {
    return ["auto", wn, He];
  }, A = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, q = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, X = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, I = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, O = function() {
    return ["", "0", He];
  }, D = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, E = function() {
    return [wn, Ei];
  }, j = function() {
    return [wn, He];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [Ar],
      spacing: [wt],
      blur: ["none", "", ln, un],
      brightness: E(),
      borderColor: [e],
      borderRadius: ["none", "", "full", ln, un],
      borderSpacing: [t],
      borderWidth: _(),
      contrast: E(),
      grayscale: O(),
      hueRotate: j(),
      invert: O(),
      gap: [t],
      gradientColorStops: [e],
      gradientColorStopPositions: [$y, un],
      inset: L(),
      margin: L(),
      opacity: E(),
      padding: [t],
      saturate: E(),
      scale: E(),
      sepia: O(),
      skew: j(),
      space: [t],
      translate: [t]
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", He]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [ln]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": D()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": D()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(A(), [He])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: k()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": k()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": k()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: N()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": N()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": N()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [v]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [v]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [v]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [v]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [v]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [v]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [v]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [v]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [v]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", _r]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [t]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", He]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: O()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: O()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", _r]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Ar]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: [_r]
        }, He]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": B()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": B()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Ar]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [_r]
        }, He]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": B()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": B()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", He]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", He]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [p]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [p]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [p]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(I())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(I(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(I(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [y]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [y]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [y]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [y]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [y]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [y]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [y]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [y]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [y]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [g]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [g]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [g]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [g]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [g]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [g]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [g]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [g]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [g]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [T]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [T]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", wt]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [ln]
        }, ln, un]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [t, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", wt]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [t, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", ln, un]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Ei]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Ar]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", un]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", wn, Ei]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", wt]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", He]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", He]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [b]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [b]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(q(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", wt]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", wt]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: [t]
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", un]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", He]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [b]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(A(), [by])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", yy]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, xy]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [m]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [a]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [a]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [a]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [a]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [a]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [a]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [a]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [a]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [a]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [a]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [a]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [a]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [a]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [a]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [a]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [b]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(q(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [b]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: q()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [i]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [i]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [i]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [i]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [i]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [i]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [i]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [i]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(q())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [wt]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [wt]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: _()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [b]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [wt]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", ln, wy]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Ar]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [b]
      }],
      /**
       * Mix Beldn Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": X()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": X()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", ln, He]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [c]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [f]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [x]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [$]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [c]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [f]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [b]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [x]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [$]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [o]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [o]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [o]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", He]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: j()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", He]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: j()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", He]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [w]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [w]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [w]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [_r, He]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [S]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [S]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [C]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [C]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", He]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", He]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": [t]
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": [t]
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": [t]
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": [t]
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": [t]
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": [t]
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": [t]
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": [t]
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": [t]
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": [t]
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": [t]
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": [t]
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": [t]
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": [t]
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": [t]
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": [t]
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": [t]
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": [t]
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", He]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [wt, Ei]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
function Ey(e, t) {
  for (var n in t)
    kh(e, n, t[n]);
  return e;
}
var Oy = Object.prototype.hasOwnProperty, Ty = /* @__PURE__ */ new Set(["string", "number", "boolean"]);
function kh(e, t, n) {
  if (!Oy.call(e, t) || Ty.has(typeof n) || n === null) {
    e[t] = n;
    return;
  }
  if (Array.isArray(n) && Array.isArray(e[t])) {
    e[t] = e[t].concat(n);
    return;
  }
  if (typeof n == "object" && typeof e[t] == "object") {
    if (e[t] === null) {
      e[t] = n;
      return;
    }
    for (var r in n)
      kh(e[t], r, n[r]);
  }
}
function Py(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  return typeof e == "function" ? Ac.apply(void 0, [Mc, e].concat(n)) : Ac.apply(void 0, [function() {
    return Ey(Mc(), e);
  }].concat(n));
}
const jc = Re("borderWidth"), Ny = Py({
  classGroups: {
    /**
     * Border Width Start
     * @see https://tailwindcss.com/docs/border-width
     */
    "border-w-bs": [{ "border-bs": [jc] }],
    /**
     * Border Width End
     * @see https://tailwindcss.com/docs/border-width
     */
    "border-w-be": [{ "border-be": [jc] }],
    "grid-cols": ["a:grid-cols-[43px_48px_43px]", "a:grid-cols-1"]
  },
  conflictingClassGroups: {
    "border-w": [
      "border-w-s",
      "border-w-e",
      "border-w-t",
      "border-w-r",
      "border-w-b",
      "border-w-l",
      "border-w-bs",
      "border-w-be"
    ],
    "grid-cols": ["a:grid-cols-[43px_48px_43px]", "a:grid-cols-1"]
  }
}), Y = (...e) => Ny(Oe(...e)), Jt = ({ condition: e, wrapper: t, children: n }) => e ? t(n) : /* @__PURE__ */ d.jsx(d.Fragment, { children: n }), _y = 150, Ay = 200, Ry = 300, Dc = 100, My = 500, jy = 50, Z = ({ testId: e, suffix: t }) => {
  if (e)
    return t ? `${e}-${t}` : e;
}, Dy = [
  "brand",
  "brand-disabled",
  "commercial",
  "emphasised",
  "emphasised-disabled",
  "neutral",
  "neutral-hover",
  "neutral-disabled",
  "subtle",
  "subtle-hover",
  "subtle-disabled",
  "quiet",
  "inverse",
  "on-brand-accent",
  "on-brand-neutral",
  "on-media",
  "on-commercial",
  "error",
  "warning",
  "success",
  "informative",
  "informative-hover",
  "informative-disabled",
  "sustainability"
], wl = (e) => Dy.reduce(
  (t, n) => (t[n] = `a:${e}-content-${n}`, t),
  { current: `a:${e}-current` }
), ky = de("a:max-h-full a:max-w-full a:pointer-events-none a:shrink-0", {
  variants: {
    inline: { true: "a:inline-block", false: "a:block" },
    size: {
      xl: "a:w-12 a:h-12",
      lg: "a:w-8 a:h-8",
      md: "a:w-6 a:h-6",
      sm: "a:w-5 a:h-5",
      xs: "a:w-4 a:h-4"
    },
    animation: {
      bounce: "a:animate-bounce",
      pulse: "a:animate-heart-pulse"
    }
  },
  defaultVariants: {
    inline: !1,
    size: "md"
  }
}), Lh = de("a:relative a:h-full a:max-h-full a:w-full a:max-w-full", {
  variants: {
    color: wl("fill")
  },
  defaultVariants: {
    color: "current"
  }
}), $e = ({ animation: e, color: t, id: n, source: r, inline: i, innerRef: a, size: o, title: s, className: l, testId: u }) => {
  const c = Y(ky({ size: o, animation: e, inline: i }), l), f = r;
  return /* @__PURE__ */ d.jsx("span", { ref: a, role: "img", id: n, className: Y(c), title: s, "data-testid": u, children: /* @__PURE__ */ d.jsx(f, { focusable: "false", "aria-hidden": "true", className: Lh({ color: t }) }) });
}, Ly = Rt({});
function rr(e) {
  const t = ce(null);
  return t.current === null && (t.current = e()), t.current;
}
const Cl = typeof window < "u", Sl = Cl ? Na : se, Fh = /* @__PURE__ */ Rt(null), Il = Rt({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
});
function Vh(e) {
  return typeof e == "object" && e !== null;
}
function El(e) {
  return Vh(e) && "offsetHeight" in e;
}
const Oi = [
  "setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
];
function Fy(e, t) {
  let n = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), i = !1, a = !1;
  const o = /* @__PURE__ */ new WeakSet();
  let s = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function l(c) {
    o.has(c) && (u.schedule(c), e()), c(s);
  }
  const u = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (c, f = !1, p = !1) => {
      const m = p && i ? n : r;
      return f && o.add(c), m.has(c) || m.add(c), c;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (c) => {
      r.delete(c), o.delete(c);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (c) => {
      if (s = c, i) {
        a = !0;
        return;
      }
      i = !0, [n, r] = [r, n], n.forEach(l), n.clear(), i = !1, a && (a = !1, u.process(c));
    }
  };
  return u;
}
const Qt = {}, Vy = 40;
function Bh(e, t) {
  let n = !1, r = !0;
  const i = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, a = () => n = !0, o = Oi.reduce((x, w) => (x[w] = Fy(a), x), {}), { setup: s, read: l, resolveKeyframes: u, preUpdate: c, update: f, preRender: p, render: h, postRender: m } = o, v = () => {
    const x = Qt.useManualTiming ? i.timestamp : performance.now();
    n = !1, Qt.useManualTiming || (i.delta = r ? 1e3 / 60 : Math.max(Math.min(x - i.timestamp, Vy), 1)), i.timestamp = x, i.isProcessing = !0, s.process(i), l.process(i), u.process(i), c.process(i), f.process(i), p.process(i), h.process(i), m.process(i), i.isProcessing = !1, n && t && (r = !1, e(v));
  }, g = () => {
    n = !0, r = !0, i.isProcessing || e(v);
  };
  return { schedule: Oi.reduce((x, w) => {
    const $ = o[w];
    return x[w] = (C, T = !1, S = !1) => (n || g(), $.schedule(C, T, S)), x;
  }, {}), cancel: (x) => {
    for (let w = 0; w < Oi.length; w++)
      o[Oi[w]].cancel(x);
  }, state: i, steps: o };
}
const yn = /* @__NO_SIDE_EFFECTS__ */ (e) => e, { schedule: et, cancel: ir, state: zr } = /* @__PURE__ */ Bh(typeof requestAnimationFrame < "u" ? requestAnimationFrame : yn, !0), Ol = Rt({ strict: !1 }), kc = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, ar = {};
for (const e in kc)
  ar[e] = {
    isEnabled: (t) => kc[e].some((n) => !!t[n])
  };
function Lc(e) {
  for (const t in e)
    ar[t] = {
      ...ar[t],
      ...e[t]
    };
}
function By({ children: e, features: t, strict: n = !1 }) {
  const [, r] = ue(!ho(t)), i = ce(void 0);
  if (!ho(t)) {
    const { renderer: a, ...o } = t;
    i.current = a, Lc(o);
  }
  return se(() => {
    ho(t) && t().then(({ renderer: a, ...o }) => {
      Lc(o), i.current = a, r(!0);
    });
  }, []), d.jsx(Ol.Provider, { value: { renderer: i.current, strict: n }, children: e });
}
function ho(e) {
  return typeof e == "function";
}
const Hy = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function ta(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || Hy.has(e);
}
let Hh = (e) => !ta(e);
function Ky(e) {
  e && (Hh = (t) => t.startsWith("on") ? !ta(t) : e(t));
}
try {
  Ky(require("@emotion/is-prop-valid").default);
} catch {
}
function Wy(e, t, n) {
  const r = {};
  for (const i in e)
    i === "values" && typeof e.values == "object" || (Hh(i) || n === !0 && ta(i) || !t && !ta(i) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && i.startsWith("onDrag")) && (r[i] = e[i]);
  return r;
}
const Fc = /* @__PURE__ */ new Set();
function Tl(e, t, n) {
  e || Fc.has(t) || (console.warn(t), Fc.add(t));
}
const Ra = /* @__PURE__ */ Rt({});
function Ma(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
function Gr(e) {
  return typeof e == "string" || Array.isArray(e);
}
const Pl = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], Nl = ["initial", ...Pl];
function ja(e) {
  return Ma(e.animate) || Nl.some((t) => Gr(e[t]));
}
function Kh(e) {
  return !!(ja(e) || e.variants);
}
function zy(e, t) {
  if (ja(e)) {
    const { initial: n, animate: r } = e;
    return {
      initial: n === !1 || Gr(n) ? n : void 0,
      animate: Gr(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function Gy(e) {
  const { initial: t, animate: n } = zy(e, Xe(Ra));
  return _t(() => ({ initial: t, animate: n }), [Vc(t), Vc(n)]);
}
function Vc(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const Uy = Symbol.for("motionComponentSymbol");
function Wh(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function qy(e, t, n) {
  return ge(
    (r) => {
      r && e.onMount && e.onMount(r), t && (r ? t.mount(r) : t.unmount()), n && (typeof n == "function" ? n(r) : Wh(n) && (n.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [t]
  );
}
const _l = (e) => e.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), Yy = "framerAppearId", zh = "data-" + _l(Yy), Xy = Rt({}), { schedule: Zy } = /* @__PURE__ */ Bh(queueMicrotask, !1);
function Jy(e, t, n, r, i) {
  var v, g;
  const { visualElement: a } = Xe(Ra), o = Xe(Ol), s = Xe(Fh), l = Xe(Il).reducedMotion, u = ce(null);
  r = r || o.renderer, !u.current && r && (u.current = r(e, {
    visualState: t,
    parent: a,
    props: n,
    presenceContext: s,
    blockInitialAnimation: s ? s.initial === !1 : !1,
    reducedMotionConfig: l
  }));
  const c = u.current, f = Xe(Xy);
  c && !c.projection && i && (c.type === "html" || c.type === "svg") && Qy(u.current, n, i, f);
  const p = ce(!1);
  V1(() => {
    c && p.current && c.update(n, s);
  });
  const h = n[zh], m = ce(!!h && !((v = window.MotionHandoffIsComplete) != null && v.call(window, h)) && ((g = window.MotionHasOptimisedAnimation) == null ? void 0 : g.call(window, h)));
  return Sl(() => {
    c && (p.current = !0, window.MotionIsMounted = !0, c.updateFeatures(), Zy.render(c.render), m.current && c.animationState && c.animationState.animateChanges());
  }), se(() => {
    c && (!m.current && c.animationState && c.animationState.animateChanges(), m.current && (queueMicrotask(() => {
      var b;
      (b = window.MotionHandoffMarkAsComplete) == null || b.call(window, h);
    }), m.current = !1));
  }), c;
}
function Qy(e, t, n, r) {
  const { layoutId: i, layout: a, drag: o, dragConstraints: s, layoutScroll: l, layoutRoot: u, layoutCrossfade: c } = t;
  e.projection = new n(e.latestValues, t["data-framer-portal-id"] ? void 0 : Gh(e.parent)), e.projection.setOptions({
    layoutId: i,
    layout: a,
    alwaysMeasureLayout: !!o || s && Wh(s),
    visualElement: e,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof a == "string" ? a : "both",
    initialPromotionConfig: r,
    crossfade: c,
    layoutScroll: l,
    layoutRoot: u
  });
}
function Gh(e) {
  if (e)
    return e.options.allowProjection !== !1 ? e.projection : Gh(e.parent);
}
let dr = () => {
}, en = () => {
};
process.env.NODE_ENV !== "production" && (dr = (e, t) => {
  !e && typeof console < "u" && console.warn(t);
}, en = (e, t) => {
  if (!e)
    throw new Error(t);
});
function eb({ preloadedFeatures: e, createVisualElement: t, useRender: n, useVisualState: r, Component: i }) {
  function a(s, l) {
    let u;
    const c = {
      ...Xe(Il),
      ...s,
      layoutId: tb(s)
    }, { isStatic: f } = c, p = Gy(s), h = r(s, f);
    if (!f && Cl) {
      nb(c, e);
      const m = rb(c);
      u = m.MeasureLayout, p.visualElement = Jy(i, h, c, t, m.ProjectionNode);
    }
    return d.jsxs(Ra.Provider, { value: p, children: [u && p.visualElement ? d.jsx(u, { visualElement: p.visualElement, ...c }) : null, n(i, s, qy(h, p.visualElement, l), h, f, p.visualElement)] });
  }
  a.displayName = `motion.${typeof i == "string" ? i : `create(${i.displayName ?? i.name ?? ""})`}`;
  const o = Th(a);
  return o[Uy] = i, o;
}
function tb({ layoutId: e }) {
  const t = Xe(Ly).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function nb(e, t) {
  Xe(Ol).strict, process.env.NODE_ENV;
}
function rb(e) {
  const { drag: t, layout: n } = ar;
  if (!t && !n)
    return {};
  const r = { ...t, ...n };
  return {
    MeasureLayout: t != null && t.isEnabled(e) || n != null && n.isEnabled(e) ? r.MeasureLayout : void 0,
    ProjectionNode: r.ProjectionNode
  };
}
const Uh = (e) => (t) => typeof t == "string" && t.startsWith(e), qh = /* @__PURE__ */ Uh("--"), ib = /* @__PURE__ */ Uh("var(--"), Al = (e) => ib(e) ? ab.test(e.split("/*")[0].trim()) : !1, ab = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, ob = {}, fr = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], pr = new Set(fr);
function Yh(e, { layout: t, layoutId: n }) {
  return pr.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!ob[e] || e === "opacity");
}
const Xh = (e, t) => t && typeof e == "number" ? t.transform(e) : e, hn = (e, t, n) => n > t ? t : n < e ? e : n, hr = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, Ur = {
  ...hr,
  transform: (e) => hn(0, 1, e)
}, Ti = {
  ...hr,
  default: 1
}, Bc = {
  ...hr,
  transform: Math.round
}, fi = /* @__NO_SIDE_EFFECTS__ */ (e) => ({
  test: (t) => typeof t == "string" && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), cn = /* @__PURE__ */ fi("deg"), Jn = /* @__PURE__ */ fi("%"), he = /* @__PURE__ */ fi("px"), sb = /* @__PURE__ */ fi("vh"), lb = /* @__PURE__ */ fi("vw"), Hc = {
  ...Jn,
  parse: (e) => Jn.parse(e) / 100,
  transform: (e) => Jn.transform(e * 100)
}, ub = {
  rotate: cn,
  rotateX: cn,
  rotateY: cn,
  rotateZ: cn,
  scale: Ti,
  scaleX: Ti,
  scaleY: Ti,
  scaleZ: Ti,
  skew: cn,
  skewX: cn,
  skewY: cn,
  distance: he,
  translateX: he,
  translateY: he,
  translateZ: he,
  x: he,
  y: he,
  z: he,
  perspective: he,
  transformPerspective: he,
  opacity: Ur,
  originX: Hc,
  originY: Hc,
  originZ: he
}, Rl = {
  // Border props
  borderWidth: he,
  borderTopWidth: he,
  borderRightWidth: he,
  borderBottomWidth: he,
  borderLeftWidth: he,
  borderRadius: he,
  radius: he,
  borderTopLeftRadius: he,
  borderTopRightRadius: he,
  borderBottomRightRadius: he,
  borderBottomLeftRadius: he,
  // Positioning props
  width: he,
  maxWidth: he,
  height: he,
  maxHeight: he,
  top: he,
  right: he,
  bottom: he,
  left: he,
  // Spacing props
  padding: he,
  paddingTop: he,
  paddingRight: he,
  paddingBottom: he,
  paddingLeft: he,
  margin: he,
  marginTop: he,
  marginRight: he,
  marginBottom: he,
  marginLeft: he,
  // Misc
  backgroundPositionX: he,
  backgroundPositionY: he,
  ...ub,
  zIndex: Bc,
  // SVG
  fillOpacity: Ur,
  strokeOpacity: Ur,
  numOctaves: Bc
}, cb = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, db = fr.length;
function fb(e, t, n) {
  let r = "", i = !0;
  for (let a = 0; a < db; a++) {
    const o = fr[a], s = e[o];
    if (s === void 0)
      continue;
    let l = !0;
    if (typeof s == "number" ? l = s === (o.startsWith("scale") ? 1 : 0) : l = parseFloat(s) === 0, !l || n) {
      const u = Xh(s, Rl[o]);
      if (!l) {
        i = !1;
        const c = cb[o] || o;
        r += `${c}(${u}) `;
      }
      n && (t[o] = u);
    }
  }
  return r = r.trim(), n ? r = n(t, i ? "" : r) : i && (r = "none"), r;
}
function Ml(e, t, n) {
  const { style: r, vars: i, transformOrigin: a } = e;
  let o = !1, s = !1;
  for (const l in t) {
    const u = t[l];
    if (pr.has(l)) {
      o = !0;
      continue;
    } else if (qh(l)) {
      i[l] = u;
      continue;
    } else {
      const c = Xh(u, Rl[l]);
      l.startsWith("origin") ? (s = !0, a[l] = c) : r[l] = c;
    }
  }
  if (t.transform || (o || n ? r.transform = fb(t, e.transform, n) : r.transform && (r.transform = "none")), s) {
    const { originX: l = "50%", originY: u = "50%", originZ: c = 0 } = a;
    r.transformOrigin = `${l} ${u} ${c}`;
  }
}
const jl = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
}), Ye = (e) => !!(e && e.getVelocity);
function Zh(e, t, n) {
  for (const r in t)
    !Ye(t[r]) && !Yh(r, n) && (e[r] = t[r]);
}
function pb({ transformTemplate: e }, t) {
  return _t(() => {
    const n = jl();
    return Ml(n, t, e), Object.assign({}, n.vars, n.style);
  }, [t]);
}
function hb(e, t) {
  const n = e.style || {}, r = {};
  return Zh(r, n, e), Object.assign(r, pb(e, t)), r;
}
function mb(e, t) {
  const n = {}, r = hb(e, t);
  return e.drag && e.dragListener !== !1 && (n.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (n.tabIndex = 0), n.style = r, n;
}
const gb = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, vb = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function yb(e, t, n = 1, r = 0, i = !0) {
  e.pathLength = 1;
  const a = i ? gb : vb;
  e[a.offset] = he.transform(-r);
  const o = he.transform(t), s = he.transform(n);
  e[a.array] = `${o} ${s}`;
}
function Jh(e, {
  attrX: t,
  attrY: n,
  attrScale: r,
  pathLength: i,
  pathSpacing: a = 1,
  pathOffset: o = 0,
  // This is object creation, which we try to avoid per-frame.
  ...s
}, l, u, c) {
  if (Ml(e, s, u), l) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: f, style: p } = e;
  f.transform && (p.transform = f.transform, delete f.transform), (p.transform || f.transformOrigin) && (p.transformOrigin = f.transformOrigin ?? "50% 50%", delete f.transformOrigin), p.transform && (p.transformBox = (c == null ? void 0 : c.transformBox) ?? "fill-box", delete f.transformBox), t !== void 0 && (f.x = t), n !== void 0 && (f.y = n), r !== void 0 && (f.scale = r), i !== void 0 && yb(f, i, a, o, !1);
}
const Qh = () => ({
  ...jl(),
  attrs: {}
}), em = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function bb(e, t, n, r) {
  const i = _t(() => {
    const a = Qh();
    return Jh(a, t, em(r), e.transformTemplate, e.style), {
      ...a.attrs,
      style: { ...a.style }
    };
  }, [t]);
  if (e.style) {
    const a = {};
    Zh(a, e.style, e), i.style = { ...a, ...i.style };
  }
  return i;
}
const xb = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function Dl(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(xb.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(e))
    )
  );
}
function $b(e = !1) {
  return (n, r, i, { latestValues: a }, o) => {
    const l = (Dl(n) ? bb : mb)(r, a, o, n), u = Wy(r, typeof n == "string", e), c = n !== Kr ? { ...u, ...l, ref: i } : {}, { children: f } = r, p = _t(() => Ye(f) ? f.get() : f, [f]);
    return Wr(n, {
      ...c,
      children: p
    });
  };
}
function Kc(e) {
  const t = [{}, {}];
  return e == null || e.values.forEach((n, r) => {
    t[0][r] = n.get(), t[1][r] = n.getVelocity();
  }), t;
}
function kl(e, t, n, r) {
  if (typeof t == "function") {
    const [i, a] = Kc(r);
    t = t(n !== void 0 ? n : e.custom, i, a);
  }
  if (typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function") {
    const [i, a] = Kc(r);
    t = t(n !== void 0 ? n : e.custom, i, a);
  }
  return t;
}
function wb(e) {
  return Ye(e) ? e.get() : e;
}
function Cb({ scrapeMotionValuesFromProps: e, createRenderState: t }, n, r, i) {
  return {
    latestValues: Sb(n, r, i, e),
    renderState: t()
  };
}
const tm = (e) => (t, n) => {
  const r = Xe(Ra), i = Xe(Fh), a = () => Cb(e, t, r, i);
  return n ? a() : rr(a);
};
function Sb(e, t, n, r) {
  const i = {}, a = r(e, {});
  for (const p in a)
    i[p] = wb(a[p]);
  let { initial: o, animate: s } = e;
  const l = ja(e), u = Kh(e);
  t && u && !l && e.inherit !== !1 && (o === void 0 && (o = t.initial), s === void 0 && (s = t.animate));
  let c = n ? n.initial === !1 : !1;
  c = c || o === !1;
  const f = c ? s : o;
  if (f && typeof f != "boolean" && !Ma(f)) {
    const p = Array.isArray(f) ? f : [f];
    for (let h = 0; h < p.length; h++) {
      const m = kl(e, p[h]);
      if (m) {
        const { transitionEnd: v, transition: g, ...b } = m;
        for (const y in b) {
          let x = b[y];
          if (Array.isArray(x)) {
            const w = c ? x.length - 1 : 0;
            x = x[w];
          }
          x !== null && (i[y] = x);
        }
        for (const y in v)
          i[y] = v[y];
      }
    }
  }
  return i;
}
function Ll(e, t, n) {
  var a;
  const { style: r } = e, i = {};
  for (const o in r)
    (Ye(r[o]) || t.style && Ye(t.style[o]) || Yh(o, e) || ((a = n == null ? void 0 : n.getValue(o)) == null ? void 0 : a.liveStyle) !== void 0) && (i[o] = r[o]);
  return i;
}
const Ib = {
  useVisualState: tm({
    scrapeMotionValuesFromProps: Ll,
    createRenderState: jl
  })
};
function nm(e, t, n) {
  const r = Ll(e, t, n);
  for (const i in e)
    if (Ye(e[i]) || Ye(t[i])) {
      const a = fr.indexOf(i) !== -1 ? "attr" + i.charAt(0).toUpperCase() + i.substring(1) : i;
      r[a] = e[i];
    }
  return r;
}
const Eb = {
  useVisualState: tm({
    scrapeMotionValuesFromProps: nm,
    createRenderState: Qh
  })
};
function Ob(e, t) {
  return function(r, { forwardMotionProps: i } = { forwardMotionProps: !1 }) {
    const o = {
      ...Dl(r) ? Eb : Ib,
      preloadedFeatures: e,
      useRender: $b(i),
      createVisualElement: t,
      Component: r
    };
    return eb(o);
  };
}
const Tb = /* @__PURE__ */ Ob();
function qr(e, t, n) {
  const r = e.getProps();
  return kl(r, t, n !== void 0 ? n : r.custom, e);
}
const as = (e) => Array.isArray(e);
let Ki;
function Pb() {
  Ki = void 0;
}
const bt = {
  now: () => (Ki === void 0 && bt.set(zr.isProcessing || Qt.useManualTiming ? zr.timestamp : performance.now()), Ki),
  set: (e) => {
    Ki = e, queueMicrotask(Pb);
  }
};
function Nb(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function rm(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
class im {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return Nb(this.subscriptions, t), () => rm(this.subscriptions, t);
  }
  notify(t, n, r) {
    const i = this.subscriptions.length;
    if (i)
      if (i === 1)
        this.subscriptions[0](t, n, r);
      else
        for (let a = 0; a < i; a++) {
          const o = this.subscriptions[a];
          o && o(t, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
function Fl(e, t) {
  return t ? e * (1e3 / t) : 0;
}
const Wc = 30, _b = (e) => !isNaN(parseFloat(e)), Lr = {
  current: void 0
};
class Ab {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(t, n = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (r, i = !0) => {
      var o, s;
      const a = bt.now();
      if (this.updatedAt !== a && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && ((o = this.events.change) == null || o.notify(this.current), this.dependents))
        for (const l of this.dependents)
          l.dirty();
      i && ((s = this.events.renderRequest) == null || s.notify(this.current));
    }, this.hasAnimated = !1, this.setCurrent(t), this.owner = n.owner;
  }
  setCurrent(t) {
    this.current = t, this.updatedAt = bt.now(), this.canTrackVelocity === null && t !== void 0 && (this.canTrackVelocity = _b(this.current));
  }
  setPrevFrameValue(t = this.current) {
    this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return process.env.NODE_ENV !== "production" && Tl(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new im());
    const r = this.events[t].add(n);
    return t === "change" ? () => {
      r(), et.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t, n = !0) {
    !n || !this.passiveEffect ? this.updateAndNotify(t, n) : this.passiveEffect(t, this.updateAndNotify);
  }
  setWithVelocity(t, n, r) {
    this.set(n), this.prev = void 0, this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt - r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t, n = !0) {
    this.updateAndNotify(t), this.prev = t, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    var t;
    (t = this.events.change) == null || t.notify(this.current);
  }
  addDependent(t) {
    this.dependents || (this.dependents = /* @__PURE__ */ new Set()), this.dependents.add(t);
  }
  removeDependent(t) {
    this.dependents && this.dependents.delete(t);
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return Lr.current && Lr.current.push(this), this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const t = bt.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || t - this.updatedAt > Wc)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, Wc);
    return Fl(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(t) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    var t, n;
    (t = this.dependents) == null || t.clear(), (n = this.events.destroy) == null || n.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function jt(e, t) {
  return new Ab(e, t);
}
function Rb(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, jt(n));
}
function Mb(e) {
  return as(e) ? e[e.length - 1] || 0 : e;
}
function jb(e, t) {
  const n = qr(e, t);
  let { transitionEnd: r = {}, transition: i = {}, ...a } = n || {};
  a = { ...a, ...r };
  for (const o in a) {
    const s = Mb(a[o]);
    Rb(e, o, s);
  }
}
function Db(e) {
  return !!(Ye(e) && e.add);
}
function kb(e, t) {
  const n = e.getValue("willChange");
  if (Db(n))
    return n.add(t);
  if (!n && Qt.WillChange) {
    const r = new Qt.WillChange("auto");
    e.addValue("willChange", r), r.add(t);
  }
}
function Lb(e) {
  return e.props[zh];
}
const Fb = (e) => e !== null;
function Vb(e, { repeat: t, repeatType: n = "loop" }, r) {
  const i = e.filter(Fb), a = t && n !== "loop" && t % 2 === 1 ? 0 : i.length - 1;
  return i[a];
}
const Bb = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, Hb = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), Kb = {
  type: "keyframes",
  duration: 0.8
}, Wb = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, zb = (e, { keyframes: t }) => t.length > 2 ? Kb : pr.has(e) ? e.startsWith("scale") ? Hb(t[1]) : Bb : Wb;
function Gb({ when: e, delay: t, delayChildren: n, staggerChildren: r, staggerDirection: i, repeat: a, repeatType: o, repeatDelay: s, from: l, elapsed: u, ...c }) {
  return !!Object.keys(c).length;
}
function am(e, t) {
  return (e == null ? void 0 : e[t]) ?? (e == null ? void 0 : e.default) ?? e;
}
const Ot = /* @__NO_SIDE_EFFECTS__ */ (e) => e * 1e3, qt = /* @__NO_SIDE_EFFECTS__ */ (e) => e / 1e3, Fr = (e) => Math.round(e * 1e5) / 1e5, Vl = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function Ub(e) {
  return e == null;
}
const qb = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, Bl = (e, t) => (n) => !!(typeof n == "string" && qb.test(n) && n.startsWith(e) || t && !Ub(n) && Object.prototype.hasOwnProperty.call(n, t)), om = (e, t, n) => (r) => {
  if (typeof r != "string")
    return r;
  const [i, a, o, s] = r.match(Vl);
  return {
    [e]: parseFloat(i),
    [t]: parseFloat(a),
    [n]: parseFloat(o),
    alpha: s !== void 0 ? parseFloat(s) : 1
  };
}, Yb = (e) => hn(0, 255, e), mo = {
  ...hr,
  transform: (e) => Math.round(Yb(e))
}, Cn = {
  test: /* @__PURE__ */ Bl("rgb", "red"),
  parse: /* @__PURE__ */ om("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + mo.transform(e) + ", " + mo.transform(t) + ", " + mo.transform(n) + ", " + Fr(Ur.transform(r)) + ")"
};
function Xb(e) {
  let t = "", n = "", r = "", i = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), r = e.substring(5, 7), i = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), r = e.substring(3, 4), i = e.substring(4, 5), t += t, n += n, r += r, i += i), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: i ? parseInt(i, 16) / 255 : 1
  };
}
const os = {
  test: /* @__PURE__ */ Bl("#"),
  parse: Xb,
  transform: Cn.transform
}, Un = {
  test: /* @__PURE__ */ Bl("hsl", "hue"),
  parse: /* @__PURE__ */ om("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + Jn.transform(Fr(t)) + ", " + Jn.transform(Fr(n)) + ", " + Fr(Ur.transform(r)) + ")"
}, Je = {
  test: (e) => Cn.test(e) || os.test(e) || Un.test(e),
  parse: (e) => Cn.test(e) ? Cn.parse(e) : Un.test(e) ? Un.parse(e) : os.parse(e),
  transform: (e) => typeof e == "string" ? e : e.hasOwnProperty("red") ? Cn.transform(e) : Un.transform(e)
}, Zb = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function Jb(e) {
  var t, n;
  return isNaN(e) && typeof e == "string" && (((t = e.match(Vl)) == null ? void 0 : t.length) || 0) + (((n = e.match(Zb)) == null ? void 0 : n.length) || 0) > 0;
}
const sm = "number", lm = "color", Qb = "var", e2 = "var(", zc = "${}", t2 = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function Yr(e) {
  const t = e.toString(), n = [], r = {
    color: [],
    number: [],
    var: []
  }, i = [];
  let a = 0;
  const s = t.replace(t2, (l) => (Je.test(l) ? (r.color.push(a), i.push(lm), n.push(Je.parse(l))) : l.startsWith(e2) ? (r.var.push(a), i.push(Qb), n.push(l)) : (r.number.push(a), i.push(sm), n.push(parseFloat(l))), ++a, zc)).split(zc);
  return { values: n, split: s, indexes: r, types: i };
}
function um(e) {
  return Yr(e).values;
}
function cm(e) {
  const { split: t, types: n } = Yr(e), r = t.length;
  return (i) => {
    let a = "";
    for (let o = 0; o < r; o++)
      if (a += t[o], i[o] !== void 0) {
        const s = n[o];
        s === sm ? a += Fr(i[o]) : s === lm ? a += Je.transform(i[o]) : a += i[o];
      }
    return a;
  };
}
const n2 = (e) => typeof e == "number" ? 0 : e;
function r2(e) {
  const t = um(e);
  return cm(e)(t.map(n2));
}
const mr = {
  test: Jb,
  parse: um,
  createTransformer: cm,
  getAnimatableNone: r2
};
function go(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function i2({ hue: e, saturation: t, lightness: n, alpha: r }) {
  e /= 360, t /= 100, n /= 100;
  let i = 0, a = 0, o = 0;
  if (!t)
    i = a = o = n;
  else {
    const s = n < 0.5 ? n * (1 + t) : n + t - n * t, l = 2 * n - s;
    i = go(l, s, e + 1 / 3), a = go(l, s, e), o = go(l, s, e - 1 / 3);
  }
  return {
    red: Math.round(i * 255),
    green: Math.round(a * 255),
    blue: Math.round(o * 255),
    alpha: r
  };
}
function na(e, t) {
  return (n) => n > 0 ? t : e;
}
const pi = (e, t, n) => e + (t - e) * n, vo = (e, t, n) => {
  const r = e * e, i = n * (t * t - r) + r;
  return i < 0 ? 0 : Math.sqrt(i);
}, a2 = [os, Cn, Un], o2 = (e) => a2.find((t) => t.test(e));
function Gc(e) {
  const t = o2(e);
  if (dr(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`), !t)
    return !1;
  let n = t.parse(e);
  return t === Un && (n = i2(n)), n;
}
const Uc = (e, t) => {
  const n = Gc(e), r = Gc(t);
  if (!n || !r)
    return na(e, t);
  const i = { ...n };
  return (a) => (i.red = vo(n.red, r.red, a), i.green = vo(n.green, r.green, a), i.blue = vo(n.blue, r.blue, a), i.alpha = pi(n.alpha, r.alpha, a), Cn.transform(i));
}, ss = /* @__PURE__ */ new Set(["none", "hidden"]);
function s2(e, t) {
  return ss.has(e) ? (n) => n <= 0 ? e : t : (n) => n >= 1 ? t : e;
}
const l2 = (e, t) => (n) => t(e(n)), Da = (...e) => e.reduce(l2);
function u2(e, t) {
  return (n) => pi(e, t, n);
}
function Hl(e) {
  return typeof e == "number" ? u2 : typeof e == "string" ? Al(e) ? na : Je.test(e) ? Uc : f2 : Array.isArray(e) ? dm : typeof e == "object" ? Je.test(e) ? Uc : c2 : na;
}
function dm(e, t) {
  const n = [...e], r = n.length, i = e.map((a, o) => Hl(a)(a, t[o]));
  return (a) => {
    for (let o = 0; o < r; o++)
      n[o] = i[o](a);
    return n;
  };
}
function c2(e, t) {
  const n = { ...e, ...t }, r = {};
  for (const i in n)
    e[i] !== void 0 && t[i] !== void 0 && (r[i] = Hl(e[i])(e[i], t[i]));
  return (i) => {
    for (const a in r)
      n[a] = r[a](i);
    return n;
  };
}
function d2(e, t) {
  const n = [], r = { color: 0, var: 0, number: 0 };
  for (let i = 0; i < t.values.length; i++) {
    const a = t.types[i], o = e.indexes[a][r[a]], s = e.values[o] ?? 0;
    n[i] = s, r[a]++;
  }
  return n;
}
const f2 = (e, t) => {
  const n = mr.createTransformer(t), r = Yr(e), i = Yr(t);
  return r.indexes.var.length === i.indexes.var.length && r.indexes.color.length === i.indexes.color.length && r.indexes.number.length >= i.indexes.number.length ? ss.has(e) && !i.values.length || ss.has(t) && !r.values.length ? s2(e, t) : Da(dm(d2(r, i), i.values), n) : (dr(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), na(e, t));
};
function fm(e, t, n) {
  return typeof e == "number" && typeof t == "number" && typeof n == "number" ? pi(e, t, n) : Hl(e)(e, t);
}
const p2 = (e) => {
  const t = ({ timestamp: n }) => e(n);
  return {
    start: (n = !0) => et.update(t, n),
    stop: () => ir(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => zr.isProcessing ? zr.timestamp : bt.now()
  };
}, pm = (e, t, n = 10) => {
  let r = "";
  const i = Math.max(Math.round(t / n), 2);
  for (let a = 0; a < i; a++)
    r += Math.round(e(a / (i - 1)) * 1e4) / 1e4 + ", ";
  return `linear(${r.substring(0, r.length - 2)})`;
}, ra = 2e4;
function Kl(e) {
  let t = 0;
  const n = 50;
  let r = e.next(t);
  for (; !r.done && t < ra; )
    t += n, r = e.next(t);
  return t >= ra ? 1 / 0 : t;
}
function hm(e, t = 100, n) {
  const r = n({ ...e, keyframes: [0, t] }), i = Math.min(Kl(r), ra);
  return {
    type: "keyframes",
    ease: (a) => r.next(i * a).value / t,
    duration: /* @__PURE__ */ qt(i)
  };
}
const h2 = 5;
function mm(e, t, n) {
  const r = Math.max(t - h2, 0);
  return Fl(n - e(r), t - r);
}
const ke = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, yo = 1e-3;
function m2({ duration: e = ke.duration, bounce: t = ke.bounce, velocity: n = ke.velocity, mass: r = ke.mass }) {
  let i, a;
  dr(e <= /* @__PURE__ */ Ot(ke.maxDuration), "Spring duration must be 10 seconds or less");
  let o = 1 - t;
  o = hn(ke.minDamping, ke.maxDamping, o), e = hn(ke.minDuration, ke.maxDuration, /* @__PURE__ */ qt(e)), o < 1 ? (i = (u) => {
    const c = u * o, f = c * e, p = c - n, h = ls(u, o), m = Math.exp(-f);
    return yo - p / h * m;
  }, a = (u) => {
    const f = u * o * e, p = f * n + n, h = Math.pow(o, 2) * Math.pow(u, 2) * e, m = Math.exp(-f), v = ls(Math.pow(u, 2), o);
    return (-i(u) + yo > 0 ? -1 : 1) * ((p - h) * m) / v;
  }) : (i = (u) => {
    const c = Math.exp(-u * e), f = (u - n) * e + 1;
    return -yo + c * f;
  }, a = (u) => {
    const c = Math.exp(-u * e), f = (n - u) * (e * e);
    return c * f;
  });
  const s = 5 / e, l = v2(i, a, s);
  if (e = /* @__PURE__ */ Ot(e), isNaN(l))
    return {
      stiffness: ke.stiffness,
      damping: ke.damping,
      duration: e
    };
  {
    const u = Math.pow(l, 2) * r;
    return {
      stiffness: u,
      damping: o * 2 * Math.sqrt(r * u),
      duration: e
    };
  }
}
const g2 = 12;
function v2(e, t, n) {
  let r = n;
  for (let i = 1; i < g2; i++)
    r = r - e(r) / t(r);
  return r;
}
function ls(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const y2 = ["duration", "bounce"], b2 = ["stiffness", "damping", "mass"];
function qc(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function x2(e) {
  let t = {
    velocity: ke.velocity,
    stiffness: ke.stiffness,
    damping: ke.damping,
    mass: ke.mass,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!qc(e, b2) && qc(e, y2))
    if (e.visualDuration) {
      const n = e.visualDuration, r = 2 * Math.PI / (n * 1.2), i = r * r, a = 2 * hn(0.05, 1, 1 - (e.bounce || 0)) * Math.sqrt(i);
      t = {
        ...t,
        mass: ke.mass,
        stiffness: i,
        damping: a
      };
    } else {
      const n = m2(e);
      t = {
        ...t,
        ...n,
        mass: ke.mass
      }, t.isResolvedFromDuration = !0;
    }
  return t;
}
function Xr(e = ke.visualDuration, t = ke.bounce) {
  const n = typeof e != "object" ? {
    visualDuration: e,
    keyframes: [0, 1],
    bounce: t
  } : e;
  let { restSpeed: r, restDelta: i } = n;
  const a = n.keyframes[0], o = n.keyframes[n.keyframes.length - 1], s = { done: !1, value: a }, { stiffness: l, damping: u, mass: c, duration: f, velocity: p, isResolvedFromDuration: h } = x2({
    ...n,
    velocity: -/* @__PURE__ */ qt(n.velocity || 0)
  }), m = p || 0, v = u / (2 * Math.sqrt(l * c)), g = o - a, b = /* @__PURE__ */ qt(Math.sqrt(l / c)), y = Math.abs(g) < 5;
  r || (r = y ? ke.restSpeed.granular : ke.restSpeed.default), i || (i = y ? ke.restDelta.granular : ke.restDelta.default);
  let x;
  if (v < 1) {
    const $ = ls(b, v);
    x = (C) => {
      const T = Math.exp(-v * b * C);
      return o - T * ((m + v * b * g) / $ * Math.sin($ * C) + g * Math.cos($ * C));
    };
  } else if (v === 1)
    x = ($) => o - Math.exp(-b * $) * (g + (m + b * g) * $);
  else {
    const $ = b * Math.sqrt(v * v - 1);
    x = (C) => {
      const T = Math.exp(-v * b * C), S = Math.min($ * C, 300);
      return o - T * ((m + v * b * g) * Math.sinh(S) + $ * g * Math.cosh(S)) / $;
    };
  }
  const w = {
    calculatedDuration: h && f || null,
    next: ($) => {
      const C = x($);
      if (h)
        s.done = $ >= f;
      else {
        let T = $ === 0 ? m : 0;
        v < 1 && (T = $ === 0 ? /* @__PURE__ */ Ot(m) : mm(x, $, C));
        const S = Math.abs(T) <= r, N = Math.abs(o - C) <= i;
        s.done = S && N;
      }
      return s.value = s.done ? o : C, s;
    },
    toString: () => {
      const $ = Math.min(Kl(w), ra), C = pm((T) => w.next($ * T).value, $, 30);
      return $ + "ms " + C;
    },
    toTransition: () => {
    }
  };
  return w;
}
Xr.applyToOptions = (e) => {
  const t = hm(e, 100, Xr);
  return e.ease = t.ease, e.duration = /* @__PURE__ */ Ot(t.duration), e.type = "keyframes", e;
};
function us({ keyframes: e, velocity: t = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: i = 10, bounceStiffness: a = 500, modifyTarget: o, min: s, max: l, restDelta: u = 0.5, restSpeed: c }) {
  const f = e[0], p = {
    done: !1,
    value: f
  }, h = (S) => s !== void 0 && S < s || l !== void 0 && S > l, m = (S) => s === void 0 ? l : l === void 0 || Math.abs(s - S) < Math.abs(l - S) ? s : l;
  let v = n * t;
  const g = f + v, b = o === void 0 ? g : o(g);
  b !== g && (v = b - f);
  const y = (S) => -v * Math.exp(-S / r), x = (S) => b + y(S), w = (S) => {
    const N = y(S), k = x(S);
    p.done = Math.abs(N) <= u, p.value = p.done ? b : k;
  };
  let $, C;
  const T = (S) => {
    h(p.value) && ($ = S, C = Xr({
      keyframes: [p.value, m(p.value)],
      velocity: mm(x, S, p.value),
      // TODO: This should be passing * 1000
      damping: i,
      stiffness: a,
      restDelta: u,
      restSpeed: c
    }));
  };
  return T(0), {
    calculatedDuration: null,
    next: (S) => {
      let N = !1;
      return !C && $ === void 0 && (N = !0, w(S), T(S)), $ !== void 0 && S >= $ ? C.next(S - $) : (!N && w(S), p);
    }
  };
}
const ka = /* @__NO_SIDE_EFFECTS__ */ (e, t, n) => {
  const r = t - e;
  return r === 0 ? 1 : (n - e) / r;
};
function $2(e, t, n) {
  const r = [], i = n || Qt.mix || fm, a = e.length - 1;
  for (let o = 0; o < a; o++) {
    let s = i(e[o], e[o + 1]);
    if (t) {
      const l = Array.isArray(t) ? t[o] || yn : t;
      s = Da(l, s);
    }
    r.push(s);
  }
  return r;
}
function Wl(e, t, { clamp: n = !0, ease: r, mixer: i } = {}) {
  const a = e.length;
  if (en(a === t.length, "Both input and output ranges must be the same length"), a === 1)
    return () => t[0];
  if (a === 2 && t[0] === t[1])
    return () => t[1];
  const o = e[0] === e[1];
  e[0] > e[a - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const s = $2(t, r, i), l = s.length, u = (c) => {
    if (o && c < e[0])
      return t[0];
    let f = 0;
    if (l > 1)
      for (; f < e.length - 2 && !(c < e[f + 1]); f++)
        ;
    const p = /* @__PURE__ */ ka(e[f], e[f + 1], c);
    return s[f](p);
  };
  return n ? (c) => u(hn(e[0], e[a - 1], c)) : u;
}
function gm(e, t) {
  const n = e[e.length - 1];
  for (let r = 1; r <= t; r++) {
    const i = /* @__PURE__ */ ka(0, t, r);
    e.push(pi(n, 1, i));
  }
}
function zl(e) {
  const t = [0];
  return gm(t, e.length - 1), t;
}
function w2(e, t) {
  return e.map((n) => n * t);
}
const vm = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, C2 = 1e-7, S2 = 12;
function I2(e, t, n, r, i) {
  let a, o, s = 0;
  do
    o = t + (n - t) / 2, a = vm(o, r, i) - e, a > 0 ? n = o : t = o;
  while (Math.abs(a) > C2 && ++s < S2);
  return o;
}
function hi(e, t, n, r) {
  if (e === t && n === r)
    return yn;
  const i = (a) => I2(a, 0, 1, e, n);
  return (a) => a === 0 || a === 1 ? a : vm(i(a), t, r);
}
const E2 = /* @__PURE__ */ hi(0.42, 0, 1, 1), O2 = /* @__PURE__ */ hi(0, 0, 0.58, 1), ym = /* @__PURE__ */ hi(0.42, 0, 0.58, 1), bm = (e) => Array.isArray(e) && typeof e[0] != "number", xm = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, $m = (e) => (t) => 1 - e(1 - t), wm = /* @__PURE__ */ hi(0.33, 1.53, 0.69, 0.99), Gl = /* @__PURE__ */ $m(wm), Cm = /* @__PURE__ */ xm(Gl), Sm = (e) => (e *= 2) < 1 ? 0.5 * Gl(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), Ul = (e) => 1 - Math.sin(Math.acos(e)), T2 = $m(Ul), Im = xm(Ul), Em = (e) => Array.isArray(e) && typeof e[0] == "number", Yc = {
  linear: yn,
  easeIn: E2,
  easeInOut: ym,
  easeOut: O2,
  circIn: Ul,
  circInOut: Im,
  circOut: T2,
  backIn: Gl,
  backInOut: Cm,
  backOut: wm,
  anticipate: Sm
}, P2 = (e) => typeof e == "string", Xc = (e) => {
  if (Em(e)) {
    en(e.length === 4, "Cubic bezier arrays must contain four numerical values.");
    const [t, n, r, i] = e;
    return hi(t, n, r, i);
  } else if (P2(e))
    return en(Yc[e] !== void 0, `Invalid easing type '${e}'`), Yc[e];
  return e;
};
function N2(e, t) {
  return e.map(() => t || ym).splice(0, e.length - 1);
}
function qn({ duration: e = 300, keyframes: t, times: n, ease: r = "easeInOut" }) {
  const i = bm(r) ? r.map(Xc) : Xc(r), a = {
    done: !1,
    value: t[0]
  }, o = w2(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === t.length ? n : zl(t),
    e
  ), s = Wl(o, t, {
    ease: Array.isArray(i) ? i : N2(t, i)
  });
  return {
    calculatedDuration: e,
    next: (l) => (a.value = s(l), a.done = l >= e, a)
  };
}
const _2 = (e) => e !== null;
function ql(e, { repeat: t, repeatType: n = "loop" }, r, i = 1) {
  const a = e.filter(_2), s = i < 0 || t && n !== "loop" && t % 2 === 1 ? 0 : a.length - 1;
  return !s || r === void 0 ? a[s] : r;
}
const A2 = {
  decay: us,
  inertia: us,
  tween: qn,
  keyframes: qn,
  spring: Xr
};
function Om(e) {
  typeof e.type == "string" && (e.type = A2[e.type]);
}
class Yl {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((t) => {
      this.resolve = t;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(t, n) {
    return this.finished.then(t, n);
  }
}
const R2 = (e) => e / 100;
class Xl extends Yl {
  constructor(t) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.stop = () => {
      var r, i;
      const { motionValue: n } = this.options;
      n && n.updatedAt !== bt.now() && this.tick(bt.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), (i = (r = this.options).onStop) == null || i.call(r));
    }, this.options = t, this.initAnimation(), this.play(), t.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: t } = this;
    Om(t);
    const { type: n = qn, repeat: r = 0, repeatDelay: i = 0, repeatType: a, velocity: o = 0 } = t;
    let { keyframes: s } = t;
    const l = n || qn;
    process.env.NODE_ENV !== "production" && l !== qn && en(s.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${s}`), l !== qn && typeof s[0] != "number" && (this.mixKeyframes = Da(R2, fm(s[0], s[1])), s = [0, 100]);
    const u = l({ ...t, keyframes: s });
    a === "mirror" && (this.mirroredGenerator = l({
      ...t,
      keyframes: [...s].reverse(),
      velocity: -o
    })), u.calculatedDuration === null && (u.calculatedDuration = Kl(u));
    const { calculatedDuration: c } = u;
    this.calculatedDuration = c, this.resolvedDuration = c + i, this.totalDuration = this.resolvedDuration * (r + 1) - i, this.generator = u;
  }
  updateTime(t) {
    const n = Math.round(t - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = n;
  }
  tick(t, n = !1) {
    const { generator: r, totalDuration: i, mixKeyframes: a, mirroredGenerator: o, resolvedDuration: s, calculatedDuration: l } = this;
    if (this.startTime === null)
      return r.next(0);
    const { delay: u = 0, keyframes: c, repeat: f, repeatType: p, repeatDelay: h, type: m, onUpdate: v, finalKeyframe: g } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, t) : this.speed < 0 && (this.startTime = Math.min(t - i / this.speed, this.startTime)), n ? this.currentTime = t : this.updateTime(t);
    const b = this.currentTime - u * (this.playbackSpeed >= 0 ? 1 : -1), y = this.playbackSpeed >= 0 ? b < 0 : b > i;
    this.currentTime = Math.max(b, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = i);
    let x = this.currentTime, w = r;
    if (f) {
      const S = Math.min(this.currentTime, i) / s;
      let N = Math.floor(S), k = S % 1;
      !k && S >= 1 && (k = 1), k === 1 && N--, N = Math.min(N, f + 1), !!(N % 2) && (p === "reverse" ? (k = 1 - k, h && (k -= h / s)) : p === "mirror" && (w = o)), x = hn(0, 1, k) * s;
    }
    const $ = y ? { done: !1, value: c[0] } : w.next(x);
    a && ($.value = a($.value));
    let { done: C } = $;
    !y && l !== null && (C = this.playbackSpeed >= 0 ? this.currentTime >= i : this.currentTime <= 0);
    const T = this.holdTime === null && (this.state === "finished" || this.state === "running" && C);
    return T && m !== us && ($.value = ql(c, this.options, g, this.speed)), v && v($.value), T && this.finish(), $;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(t, n) {
    return this.finished.then(t, n);
  }
  get duration() {
    return /* @__PURE__ */ qt(this.calculatedDuration);
  }
  get time() {
    return /* @__PURE__ */ qt(this.currentTime);
  }
  set time(t) {
    var n;
    t = /* @__PURE__ */ Ot(t), this.currentTime = t, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = t : this.driver && (this.startTime = this.driver.now() - t / this.playbackSpeed), (n = this.driver) == null || n.start(!1);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(t) {
    this.updateTime(bt.now());
    const n = this.playbackSpeed !== t;
    this.playbackSpeed = t, n && (this.time = /* @__PURE__ */ qt(this.currentTime));
  }
  play() {
    var i, a;
    if (this.isStopped)
      return;
    const { driver: t = p2, startTime: n } = this.options;
    this.driver || (this.driver = t((o) => this.tick(o))), (a = (i = this.options).onPlay) == null || a.call(i);
    const r = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = r) : this.holdTime !== null ? this.startTime = r - this.holdTime : this.startTime || (this.startTime = n ?? r), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime(bt.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    var t, n;
    this.notifyFinished(), this.teardown(), this.state = "finished", (n = (t = this.options).onComplete) == null || n.call(t);
  }
  cancel() {
    var t, n;
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), (n = (t = this.options).onCancel) == null || n.call(t);
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(t) {
    return this.startTime = 0, this.tick(t, !0);
  }
  attachTimeline(t) {
    var n;
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), (n = this.driver) == null || n.stop(), t.observe(this);
  }
}
function M2(e) {
  for (let t = 1; t < e.length; t++)
    e[t] ?? (e[t] = e[t - 1]);
}
const Sn = (e) => e * 180 / Math.PI, cs = (e) => {
  const t = Sn(Math.atan2(e[1], e[0]));
  return ds(t);
}, j2 = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: (e) => (Math.abs(e[0]) + Math.abs(e[3])) / 2,
  rotate: cs,
  rotateZ: cs,
  skewX: (e) => Sn(Math.atan(e[1])),
  skewY: (e) => Sn(Math.atan(e[2])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[2])) / 2
}, ds = (e) => (e = e % 360, e < 0 && (e += 360), e), Zc = cs, Jc = (e) => Math.sqrt(e[0] * e[0] + e[1] * e[1]), Qc = (e) => Math.sqrt(e[4] * e[4] + e[5] * e[5]), D2 = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX: Jc,
  scaleY: Qc,
  scale: (e) => (Jc(e) + Qc(e)) / 2,
  rotateX: (e) => ds(Sn(Math.atan2(e[6], e[5]))),
  rotateY: (e) => ds(Sn(Math.atan2(-e[2], e[0]))),
  rotateZ: Zc,
  rotate: Zc,
  skewX: (e) => Sn(Math.atan(e[4])),
  skewY: (e) => Sn(Math.atan(e[1])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[4])) / 2
};
function fs(e) {
  return e.includes("scale") ? 1 : 0;
}
function ps(e, t) {
  if (!e || e === "none")
    return fs(t);
  const n = e.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let r, i;
  if (n)
    r = D2, i = n;
  else {
    const s = e.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    r = j2, i = s;
  }
  if (!i)
    return fs(t);
  const a = r[t], o = i[1].split(",").map(L2);
  return typeof a == "function" ? a(o) : o[a];
}
const k2 = (e, t) => {
  const { transform: n = "none" } = getComputedStyle(e);
  return ps(n, t);
};
function L2(e) {
  return parseFloat(e.trim());
}
const ed = (e) => e === hr || e === he, F2 = /* @__PURE__ */ new Set(["x", "y", "z"]), V2 = fr.filter((e) => !F2.has(e));
function B2(e) {
  const t = [];
  return V2.forEach((n) => {
    const r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t;
}
const On = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: (e, { transform: t }) => ps(t, "x"),
  y: (e, { transform: t }) => ps(t, "y")
};
On.translateX = On.x;
On.translateY = On.y;
const Tn = /* @__PURE__ */ new Set();
let hs = !1, ms = !1, gs = !1;
function Tm() {
  if (ms) {
    const e = Array.from(Tn).filter((r) => r.needsMeasurement), t = new Set(e.map((r) => r.element)), n = /* @__PURE__ */ new Map();
    t.forEach((r) => {
      const i = B2(r);
      i.length && (n.set(r, i), r.render());
    }), e.forEach((r) => r.measureInitialState()), t.forEach((r) => {
      r.render();
      const i = n.get(r);
      i && i.forEach(([a, o]) => {
        var s;
        (s = r.getValue(a)) == null || s.set(o);
      });
    }), e.forEach((r) => r.measureEndState()), e.forEach((r) => {
      r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
    });
  }
  ms = !1, hs = !1, Tn.forEach((e) => e.complete(gs)), Tn.clear();
}
function Pm() {
  Tn.forEach((e) => {
    e.readKeyframes(), e.needsMeasurement && (ms = !0);
  });
}
function H2() {
  gs = !0, Pm(), Tm(), gs = !1;
}
class Zl {
  constructor(t, n, r, i, a, o = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...t], this.onComplete = n, this.name = r, this.motionValue = i, this.element = a, this.isAsync = o;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (Tn.add(this), hs || (hs = !0, et.read(Pm), et.resolveKeyframes(Tm))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, name: n, element: r, motionValue: i } = this;
    if (t[0] === null) {
      const a = i == null ? void 0 : i.get(), o = t[t.length - 1];
      if (a !== void 0)
        t[0] = a;
      else if (r && n) {
        const s = r.readValue(n, o);
        s != null && (t[0] = s);
      }
      t[0] === void 0 && (t[0] = o), i && a === void 0 && i.set(t[0]);
    }
    M2(t);
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete(t = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, t), Tn.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (Tn.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const K2 = (e) => e.startsWith("--");
function W2(e, t, n) {
  K2(t) ? e.style.setProperty(t, n) : e.style[t] = n;
}
// @__NO_SIDE_EFFECTS__
function Jl(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
const Nm = /* @__PURE__ */ Jl(() => window.ScrollTimeline !== void 0), z2 = {};
function G2(e, t) {
  const n = /* @__PURE__ */ Jl(e);
  return () => z2[t] ?? n();
}
const _m = /* @__PURE__ */ G2(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), jr = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`, td = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ jr([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ jr([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ jr([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ jr([0.33, 1.53, 0.69, 0.99])
};
function Am(e, t) {
  if (e)
    return typeof e == "function" ? _m() ? pm(e, t) : "ease-out" : Em(e) ? jr(e) : Array.isArray(e) ? e.map((n) => Am(n, t) || td.easeOut) : td[e];
}
function U2(e, t, n, { delay: r = 0, duration: i = 300, repeat: a = 0, repeatType: o = "loop", ease: s = "easeOut", times: l } = {}, u = void 0) {
  const c = {
    [t]: n
  };
  l && (c.offset = l);
  const f = Am(s, i);
  Array.isArray(f) && (c.easing = f);
  const p = {
    delay: r,
    duration: i,
    easing: Array.isArray(f) ? "linear" : f,
    fill: "both",
    iterations: a + 1,
    direction: o === "reverse" ? "alternate" : "normal"
  };
  return u && (p.pseudoElement = u), e.animate(c, p);
}
function Ql(e) {
  return typeof e == "function" && "applyToOptions" in e;
}
function q2({ type: e, ...t }) {
  return Ql(e) && _m() ? e.applyToOptions(t) : (t.duration ?? (t.duration = 300), t.ease ?? (t.ease = "easeOut"), t);
}
class Y2 extends Yl {
  constructor(t) {
    if (super(), this.finishedTime = null, this.isStopped = !1, !t)
      return;
    const { element: n, name: r, keyframes: i, pseudoElement: a, allowFlatten: o = !1, finalKeyframe: s, onComplete: l } = t;
    this.isPseudoElement = !!a, this.allowFlatten = o, this.options = t, en(typeof t.type != "string", `animateMini doesn't support "type" as a string. Did you mean to import { spring } from "motion"?`);
    const u = q2(t);
    this.animation = U2(n, r, i, u, a), u.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !a) {
        const c = ql(i, this.options, s, this.speed);
        this.updateMotionValue ? this.updateMotionValue(c) : W2(n, r, c), this.animation.cancel();
      }
      l == null || l(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    var t, n;
    (n = (t = this.animation).finish) == null || n.call(t);
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {
    }
  }
  stop() {
    if (this.isStopped)
      return;
    this.isStopped = !0;
    const { state: t } = this;
    t === "idle" || t === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    var t, n;
    this.isPseudoElement || (n = (t = this.animation).commitStyles) == null || n.call(t);
  }
  get duration() {
    var n, r;
    const t = ((r = (n = this.animation.effect) == null ? void 0 : n.getComputedTiming) == null ? void 0 : r.call(n).duration) || 0;
    return /* @__PURE__ */ qt(Number(t));
  }
  get time() {
    return /* @__PURE__ */ qt(Number(this.animation.currentTime) || 0);
  }
  set time(t) {
    this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ Ot(t);
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(t) {
    t < 0 && (this.finishedTime = null), this.animation.playbackRate = t;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return Number(this.animation.startTime);
  }
  set startTime(t) {
    this.animation.startTime = t;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({ timeline: t, observe: n }) {
    var r;
    return this.allowFlatten && ((r = this.animation.effect) == null || r.updateTiming({ easing: "linear" })), this.animation.onfinish = null, t && Nm() ? (this.animation.timeline = t, yn) : n(this);
  }
}
const Rm = {
  anticipate: Sm,
  backInOut: Cm,
  circInOut: Im
};
function X2(e) {
  return e in Rm;
}
function Z2(e) {
  typeof e.ease == "string" && X2(e.ease) && (e.ease = Rm[e.ease]);
}
const nd = 10;
class J2 extends Y2 {
  constructor(t) {
    Z2(t), Om(t), super(t), t.startTime && (this.startTime = t.startTime), this.options = t;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read commited styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(t) {
    const { motionValue: n, onUpdate: r, onComplete: i, element: a, ...o } = this.options;
    if (!n)
      return;
    if (t !== void 0) {
      n.set(t);
      return;
    }
    const s = new Xl({
      ...o,
      autoplay: !1
    }), l = /* @__PURE__ */ Ot(this.finishedTime ?? this.time);
    n.setWithVelocity(s.sample(l - nd).value, s.sample(l).value, nd), s.stop();
  }
}
const rd = (e, t) => t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
(mr.test(e) || e === "0") && // And it contains numbers and/or colors
!e.startsWith("url("));
function Q2(e) {
  const t = e[0];
  if (e.length === 1)
    return !0;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t)
      return !0;
}
function e3(e, t, n, r) {
  const i = e[0];
  if (i === null)
    return !1;
  if (t === "display" || t === "visibility")
    return !0;
  const a = e[e.length - 1], o = rd(i, t), s = rd(a, t);
  return dr(o === s, `You are trying to animate ${t} from "${i}" to "${a}". ${i} is not an animatable value - to enable this animation set ${i} to a value animatable to ${a} via the \`style\` property.`), !o || !s ? !1 : Q2(e) || (n === "spring" || Ql(n)) && r;
}
const t3 = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Could be re-enabled now we have support for linear() easing
  // "background-color"
]), n3 = /* @__PURE__ */ Jl(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function r3(e) {
  var u;
  const { motionValue: t, name: n, repeatDelay: r, repeatType: i, damping: a, type: o } = e;
  if (!El((u = t == null ? void 0 : t.owner) == null ? void 0 : u.current))
    return !1;
  const { onUpdate: s, transformTemplate: l } = t.owner.getProps();
  return n3() && n && t3.has(n) && (n !== "transform" || !l) && /**
   * If we're outputting values to onUpdate then we can't use WAAPI as there's
   * no way to read the value from WAAPI every frame.
   */
  !s && !r && i !== "mirror" && a !== 0 && o !== "inertia";
}
const i3 = 40;
class a3 extends Yl {
  constructor({ autoplay: t = !0, delay: n = 0, type: r = "keyframes", repeat: i = 0, repeatDelay: a = 0, repeatType: o = "loop", keyframes: s, name: l, motionValue: u, element: c, ...f }) {
    var m;
    super(), this.stop = () => {
      var v, g;
      this._animation && (this._animation.stop(), (v = this.stopTimeline) == null || v.call(this)), (g = this.keyframeResolver) == null || g.cancel();
    }, this.createdAt = bt.now();
    const p = {
      autoplay: t,
      delay: n,
      type: r,
      repeat: i,
      repeatDelay: a,
      repeatType: o,
      name: l,
      motionValue: u,
      element: c,
      ...f
    }, h = (c == null ? void 0 : c.KeyframeResolver) || Zl;
    this.keyframeResolver = new h(s, (v, g, b) => this.onKeyframesResolved(v, g, p, !b), l, u, c), (m = this.keyframeResolver) == null || m.scheduleResolve();
  }
  onKeyframesResolved(t, n, r, i) {
    this.keyframeResolver = void 0;
    const { name: a, type: o, velocity: s, delay: l, isHandoff: u, onUpdate: c } = r;
    this.resolvedAt = bt.now(), e3(t, a, o, s) || ((Qt.instantAnimations || !l) && (c == null || c(ql(t, r, n))), t[0] = t[t.length - 1], r.duration = 0, r.repeat = 0);
    const p = {
      startTime: i ? this.resolvedAt ? this.resolvedAt - this.createdAt > i3 ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
      finalKeyframe: n,
      ...r,
      keyframes: t
    }, h = !u && r3(p) ? new J2({
      ...p,
      element: p.motionValue.owner.current
    }) : new Xl(p);
    h.finished.then(() => this.notifyFinished()).catch(yn), this.pendingTimeline && (this.stopTimeline = h.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = h;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(t, n) {
    return this.finished.finally(t).then(() => {
    });
  }
  get animation() {
    var t;
    return this._animation || ((t = this.keyframeResolver) == null || t.resume(), H2()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get time() {
    return this.animation.time;
  }
  set time(t) {
    this.animation.time = t;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(t) {
    this.animation.speed = t;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(t) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(t) : this.pendingTimeline = t, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    var t;
    this._animation && this.animation.cancel(), (t = this.keyframeResolver) == null || t.cancel();
  }
}
const Mm = (e, t, n, r = {}, i, a) => (o) => {
  const s = am(r, e) || {}, l = s.delay || r.delay || 0;
  let { elapsed: u = 0 } = r;
  u = u - /* @__PURE__ */ Ot(l);
  const c = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: t.getVelocity(),
    ...s,
    delay: -u,
    onUpdate: (p) => {
      t.set(p), s.onUpdate && s.onUpdate(p);
    },
    onComplete: () => {
      o(), s.onComplete && s.onComplete();
    },
    name: e,
    motionValue: t,
    element: a ? void 0 : i
  };
  Gb(s) || Object.assign(c, zb(e, c)), c.duration && (c.duration = /* @__PURE__ */ Ot(c.duration)), c.repeatDelay && (c.repeatDelay = /* @__PURE__ */ Ot(c.repeatDelay)), c.from !== void 0 && (c.keyframes[0] = c.from);
  let f = !1;
  if ((c.type === !1 || c.duration === 0 && !c.repeatDelay) && (c.duration = 0, c.delay === 0 && (f = !0)), (Qt.instantAnimations || Qt.skipAnimations) && (f = !0, c.duration = 0, c.delay = 0), c.allowFlatten = !s.type && !s.ease, f && !a && t.get() !== void 0) {
    const p = Vb(c.keyframes, s);
    if (p !== void 0) {
      et.update(() => {
        c.onUpdate(p), c.onComplete();
      });
      return;
    }
  }
  return s.isSync ? new Xl(c) : new a3(c);
}, jm = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...fr
]);
function o3({ protectedKeys: e, needsAnimating: t }, n) {
  const r = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, r;
}
function eu(e, t, { delay: n = 0, transitionOverride: r, type: i } = {}) {
  let { transition: a = e.getDefaultTransition(), transitionEnd: o, ...s } = t;
  r && (a = r);
  const l = [], u = i && e.animationState && e.animationState.getState()[i];
  for (const c in s) {
    const f = e.getValue(c, e.latestValues[c] ?? null), p = s[c];
    if (p === void 0 || u && o3(u, c))
      continue;
    const h = {
      delay: n,
      ...am(a || {}, c)
    }, m = f.get();
    if (m !== void 0 && !f.isAnimating && !Array.isArray(p) && p === m && !h.velocity)
      continue;
    let v = !1;
    if (window.MotionHandoffAnimation) {
      const b = Lb(e);
      if (b) {
        const y = window.MotionHandoffAnimation(b, c, et);
        y !== null && (h.startTime = y, v = !0);
      }
    }
    kb(e, c), f.start(Mm(c, f, p, e.shouldReduceMotion && jm.has(c) ? { type: !1 } : h, e, v));
    const g = f.animation;
    g && l.push(g);
  }
  return o && Promise.all(l).then(() => {
    et.update(() => {
      o && jb(e, o);
    });
  }), l;
}
function vs(e, t, n = {}) {
  var l;
  const r = qr(e, t, n.type === "exit" ? (l = e.presenceContext) == null ? void 0 : l.custom : void 0);
  let { transition: i = e.getDefaultTransition() || {} } = r || {};
  n.transitionOverride && (i = n.transitionOverride);
  const a = r ? () => Promise.all(eu(e, r, n)) : () => Promise.resolve(), o = e.variantChildren && e.variantChildren.size ? (u = 0) => {
    const { delayChildren: c = 0, staggerChildren: f, staggerDirection: p } = i;
    return s3(e, t, c + u, f, p, n);
  } : () => Promise.resolve(), { when: s } = i;
  if (s) {
    const [u, c] = s === "beforeChildren" ? [a, o] : [o, a];
    return u().then(() => c());
  } else
    return Promise.all([a(), o(n.delay)]);
}
function s3(e, t, n = 0, r = 0, i = 1, a) {
  const o = [], s = (e.variantChildren.size - 1) * r, l = i === 1 ? (u = 0) => u * r : (u = 0) => s - u * r;
  return Array.from(e.variantChildren).sort(l3).forEach((u, c) => {
    u.notify("AnimationStart", t), o.push(vs(u, t, {
      ...a,
      delay: n + l(c)
    }).then(() => u.notify("AnimationComplete", t)));
  }), Promise.all(o);
}
function l3(e, t) {
  return e.sortNodePosition(t);
}
function u3(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let r;
  if (Array.isArray(t)) {
    const i = t.map((a) => vs(e, a, n));
    r = Promise.all(i);
  } else if (typeof t == "string")
    r = vs(e, t, n);
  else {
    const i = typeof t == "function" ? qr(e, t, n.custom) : t;
    r = Promise.all(eu(e, i, n));
  }
  return r.then(() => {
    e.notify("AnimationComplete", t);
  });
}
function Dm(e, t) {
  if (!Array.isArray(t))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
const c3 = Nl.length;
function km(e) {
  if (!e)
    return;
  if (!e.isControllingVariants) {
    const n = e.parent ? km(e.parent) || {} : {};
    return e.props.initial !== void 0 && (n.initial = e.props.initial), n;
  }
  const t = {};
  for (let n = 0; n < c3; n++) {
    const r = Nl[n], i = e.props[r];
    (Gr(i) || i === !1) && (t[r] = i);
  }
  return t;
}
const d3 = [...Pl].reverse(), f3 = Pl.length;
function p3(e) {
  return (t) => Promise.all(t.map(({ animation: n, options: r }) => u3(e, n, r)));
}
function h3(e) {
  let t = p3(e), n = id(), r = !0;
  const i = (l) => (u, c) => {
    var p;
    const f = qr(e, c, l === "exit" ? (p = e.presenceContext) == null ? void 0 : p.custom : void 0);
    if (f) {
      const { transition: h, transitionEnd: m, ...v } = f;
      u = { ...u, ...v, ...m };
    }
    return u;
  };
  function a(l) {
    t = l(e);
  }
  function o(l) {
    const { props: u } = e, c = km(e.parent) || {}, f = [], p = /* @__PURE__ */ new Set();
    let h = {}, m = 1 / 0;
    for (let g = 0; g < f3; g++) {
      const b = d3[g], y = n[b], x = u[b] !== void 0 ? u[b] : c[b], w = Gr(x), $ = b === l ? y.isActive : null;
      $ === !1 && (m = g);
      let C = x === c[b] && x !== u[b] && w;
      if (C && r && e.manuallyAnimateOnMount && (C = !1), y.protectedKeys = { ...h }, // If it isn't active and hasn't *just* been set as inactive
      !y.isActive && $ === null || // If we didn't and don't have any defined prop for this animation type
      !x && !y.prevProp || // Or if the prop doesn't define an animation
      Ma(x) || typeof x == "boolean")
        continue;
      const T = m3(y.prevProp, x);
      let S = T || // If we're making this variant active, we want to always make it active
      b === l && y.isActive && !C && w || // If we removed a higher-priority variant (i is in reverse order)
      g > m && w, N = !1;
      const k = Array.isArray(x) ? x : [x];
      let L = k.reduce(i(b), {});
      $ === !1 && (L = {});
      const { prevResolvedValues: _ = {} } = y, B = {
        ..._,
        ...L
      }, A = (I) => {
        S = !0, p.has(I) && (N = !0, p.delete(I)), y.needsAnimating[I] = !0;
        const O = e.getValue(I);
        O && (O.liveStyle = !1);
      };
      for (const I in B) {
        const O = L[I], D = _[I];
        if (h.hasOwnProperty(I))
          continue;
        let E = !1;
        as(O) && as(D) ? E = !Dm(O, D) : E = O !== D, E ? O != null ? A(I) : p.add(I) : O !== void 0 && p.has(I) ? A(I) : y.protectedKeys[I] = !0;
      }
      y.prevProp = x, y.prevResolvedValues = L, y.isActive && (h = { ...h, ...L }), r && e.blockInitialAnimation && (S = !1), S && (!(C && T) || N) && f.push(...k.map((I) => ({
        animation: I,
        options: { type: b }
      })));
    }
    if (p.size) {
      const g = {};
      if (typeof u.initial != "boolean") {
        const b = qr(e, Array.isArray(u.initial) ? u.initial[0] : u.initial);
        b && b.transition && (g.transition = b.transition);
      }
      p.forEach((b) => {
        const y = e.getBaseTarget(b), x = e.getValue(b);
        x && (x.liveStyle = !0), g[b] = y ?? null;
      }), f.push({ animation: g });
    }
    let v = !!f.length;
    return r && (u.initial === !1 || u.initial === u.animate) && !e.manuallyAnimateOnMount && (v = !1), r = !1, v ? t(f) : Promise.resolve();
  }
  function s(l, u) {
    var f;
    if (n[l].isActive === u)
      return Promise.resolve();
    (f = e.variantChildren) == null || f.forEach((p) => {
      var h;
      return (h = p.animationState) == null ? void 0 : h.setActive(l, u);
    }), n[l].isActive = u;
    const c = o(l);
    for (const p in n)
      n[p].protectedKeys = {};
    return c;
  }
  return {
    animateChanges: o,
    setActive: s,
    setAnimateFunction: a,
    getState: () => n,
    reset: () => {
      n = id(), r = !0;
    }
  };
}
function m3(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !Dm(t, e) : !1;
}
function xn(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function id() {
  return {
    animate: xn(!0),
    whileInView: xn(),
    whileHover: xn(),
    whileTap: xn(),
    whileDrag: xn(),
    whileFocus: xn(),
    exit: xn()
  };
}
class gr {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
class g3 extends gr {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = h3(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    Ma(t) && (this.unmountControls = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var t;
    this.node.animationState.reset(), (t = this.unmountControls) == null || t.call(this);
  }
}
let v3 = 0;
class y3 extends gr {
  constructor() {
    super(...arguments), this.id = v3++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: n } = this.node.presenceContext, { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === r)
      return;
    const i = this.node.animationState.setActive("exit", !t);
    n && !t && i.then(() => {
      n(this.id);
    });
  }
  mount() {
    const { register: t, onExitComplete: n } = this.node.presenceContext || {};
    n && n(this.id), t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const b3 = {
  animation: {
    Feature: g3
  },
  exit: {
    Feature: y3
  }
};
function ad(e, t, n, r = { passive: !0 }) {
  return e.addEventListener(t, n, r), () => e.removeEventListener(t, n);
}
const x3 = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1;
function Lm(e) {
  return {
    point: {
      x: e.pageX,
      y: e.pageY
    }
  };
}
function $3({ top: e, left: t, right: n, bottom: r }) {
  return {
    x: { min: t, max: n },
    y: { min: e, max: r }
  };
}
function w3(e, t) {
  if (!t)
    return e;
  const n = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
const od = () => ({ min: 0, max: 0 }), tu = () => ({
  x: od(),
  y: od()
});
function C3(e, t) {
  return $3(w3(e.getBoundingClientRect(), t));
}
const S3 = {
  y: !1
};
function I3() {
  return S3.y;
}
function E3(e, t, n) {
  const r = Ye(e) ? e : jt(e);
  return r.start(Mm("", r, t, n)), r.animation;
}
function nu(e) {
  return Vh(e) && "ownerSVGElement" in e;
}
function O3(e) {
  return nu(e) && e.tagName === "svg";
}
function ru(e, t, n) {
  if (e instanceof EventTarget)
    return [e];
  if (typeof e == "string") {
    let r = document;
    t && (r = t.current);
    const i = (n == null ? void 0 : n[e]) ?? r.querySelectorAll(e);
    return i ? Array.from(i) : [];
  }
  return Array.from(e);
}
function Fm(e, t) {
  const n = ru(e), r = new AbortController(), i = {
    passive: !0,
    ...t,
    signal: r.signal
  };
  return [n, i, () => r.abort()];
}
function sd(e) {
  return !(e.pointerType === "touch" || I3());
}
function T3(e, t, n = {}) {
  const [r, i, a] = Fm(e, n), o = (s) => {
    if (!sd(s))
      return;
    const { target: l } = s, u = t(l, s);
    if (typeof u != "function" || !l)
      return;
    const c = (f) => {
      sd(f) && (u(f), l.removeEventListener("pointerleave", c));
    };
    l.addEventListener("pointerleave", c, i);
  };
  return r.forEach((s) => {
    s.addEventListener("pointerenter", o, i);
  }), a;
}
function ld(e, t, n) {
  const { props: r } = e;
  e.animationState && r.whileHover && e.animationState.setActive("whileHover", n === "Start");
  const i = "onHover" + n, a = r[i];
  a && et.postRender(() => a(t, Lm(t)));
}
class P3 extends gr {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = T3(t, (n, r) => (ld(this.node, r, "Start"), (i) => ld(this.node, i, "End"))));
  }
  unmount() {
  }
}
class N3 extends gr {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = Da(ad(this.node.current, "focus", () => this.onFocus()), ad(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
const Vm = (e, t) => t ? e === t ? !0 : Vm(e, t.parentElement) : !1, _3 = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function A3(e) {
  return _3.has(e.tagName) || e.tabIndex !== -1;
}
const Wi = /* @__PURE__ */ new WeakSet();
function ud(e) {
  return (t) => {
    t.key === "Enter" && e(t);
  };
}
function bo(e, t) {
  e.dispatchEvent(new PointerEvent("pointer" + t, { isPrimary: !0, bubbles: !0 }));
}
const R3 = (e, t) => {
  const n = e.currentTarget;
  if (!n)
    return;
  const r = ud(() => {
    if (Wi.has(n))
      return;
    bo(n, "down");
    const i = ud(() => {
      bo(n, "up");
    }), a = () => bo(n, "cancel");
    n.addEventListener("keyup", i, t), n.addEventListener("blur", a, t);
  });
  n.addEventListener("keydown", r, t), n.addEventListener("blur", () => n.removeEventListener("keydown", r), t);
};
function cd(e) {
  return x3(e) && !0;
}
function M3(e, t, n = {}) {
  const [r, i, a] = Fm(e, n), o = (s) => {
    const l = s.currentTarget;
    if (!cd(s))
      return;
    Wi.add(l);
    const u = t(l, s), c = (h, m) => {
      window.removeEventListener("pointerup", f), window.removeEventListener("pointercancel", p), Wi.has(l) && Wi.delete(l), cd(h) && typeof u == "function" && u(h, { success: m });
    }, f = (h) => {
      c(h, l === window || l === document || n.useGlobalTarget || Vm(l, h.target));
    }, p = (h) => {
      c(h, !1);
    };
    window.addEventListener("pointerup", f, i), window.addEventListener("pointercancel", p, i);
  };
  return r.forEach((s) => {
    (n.useGlobalTarget ? window : s).addEventListener("pointerdown", o, i), El(s) && (s.addEventListener("focus", (u) => R3(u, i)), !A3(s) && !s.hasAttribute("tabindex") && (s.tabIndex = 0));
  }), a;
}
function dd(e, t, n) {
  const { props: r } = e;
  if (e.current instanceof HTMLButtonElement && e.current.disabled)
    return;
  e.animationState && r.whileTap && e.animationState.setActive("whileTap", n === "Start");
  const i = "onTap" + (n === "End" ? "" : n), a = r[i];
  a && et.postRender(() => a(t, Lm(t)));
}
class j3 extends gr {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = M3(t, (n, r) => (dd(this.node, r, "Start"), (i, { success: a }) => dd(this.node, i, a ? "End" : "Cancel")), { useGlobalTarget: this.node.props.globalTapTarget }));
  }
  unmount() {
  }
}
const ys = /* @__PURE__ */ new WeakMap(), xo = /* @__PURE__ */ new WeakMap(), D3 = (e) => {
  const t = ys.get(e.target);
  t && t(e);
}, k3 = (e) => {
  e.forEach(D3);
};
function L3({ root: e, ...t }) {
  const n = e || document;
  xo.has(n) || xo.set(n, {});
  const r = xo.get(n), i = JSON.stringify(t);
  return r[i] || (r[i] = new IntersectionObserver(k3, { root: e, ...t })), r[i];
}
function F3(e, t, n) {
  const r = L3(t);
  return ys.set(e, n), r.observe(e), () => {
    ys.delete(e), r.unobserve(e);
  };
}
const V3 = {
  some: 0,
  all: 1
};
class B3 extends gr {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: t = {} } = this.node.getProps(), { root: n, margin: r, amount: i = "some", once: a } = t, o = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof i == "number" ? i : V3[i]
    }, s = (l) => {
      const { isIntersecting: u } = l;
      if (this.isInView === u || (this.isInView = u, a && !u && this.hasEnteredView))
        return;
      u && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", u);
      const { onViewportEnter: c, onViewportLeave: f } = this.node.getProps(), p = u ? c : f;
      p && p(l);
    };
    return F3(this.node.current, o, s);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(H3(t, n)) && this.startObserver();
  }
  unmount() {
  }
}
function H3({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (n) => e[n] !== t[n];
}
const K3 = {
  inView: {
    Feature: B3
  },
  tap: {
    Feature: j3
  },
  focus: {
    Feature: N3
  },
  hover: {
    Feature: P3
  }
}, bs = { current: null }, Bm = { current: !1 };
function W3() {
  if (Bm.current = !0, !!Cl)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => bs.current = e.matches;
      e.addListener(t), t();
    } else
      bs.current = !1;
}
const Zr = /* @__PURE__ */ new WeakMap();
function z3(e, t, n) {
  for (const r in t) {
    const i = t[r], a = n[r];
    if (Ye(i))
      e.addValue(r, i);
    else if (Ye(a))
      e.addValue(r, jt(i, { owner: e }));
    else if (a !== i)
      if (e.hasValue(r)) {
        const o = e.getValue(r);
        o.liveStyle === !0 ? o.jump(i) : o.hasAnimated || o.set(i);
      } else {
        const o = e.getStaticValue(r);
        e.addValue(r, jt(o !== void 0 ? o : i, { owner: e }));
      }
  }
  for (const r in n)
    t[r] === void 0 && e.removeValue(r);
  return t;
}
const Hm = (e) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e), Km = (e) => /^0[^.\s]+$/u.test(e), G3 = {
  test: (e) => e === "auto",
  parse: (e) => e
}, Wm = (e) => (t) => t.test(e), zm = [hr, he, Jn, cn, lb, sb, G3], fd = (e) => zm.find(Wm(e)), U3 = [...zm, Je, mr], q3 = (e) => U3.find(Wm(e)), Y3 = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function X3(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = n.match(Vl) || [];
  if (!r)
    return e;
  const i = n.replace(r, "");
  let a = Y3.has(t) ? 1 : 0;
  return r !== n && (a *= 100), t + "(" + a + i + ")";
}
const Z3 = /\b([a-z-]*)\(.*?\)/gu, xs = {
  ...mr,
  getAnimatableNone: (e) => {
    const t = e.match(Z3);
    return t ? t.map(X3).join(" ") : e;
  }
}, J3 = {
  ...Rl,
  // Color props
  color: Je,
  backgroundColor: Je,
  outlineColor: Je,
  fill: Je,
  stroke: Je,
  // Border props
  borderColor: Je,
  borderTopColor: Je,
  borderRightColor: Je,
  borderBottomColor: Je,
  borderLeftColor: Je,
  filter: xs,
  WebkitFilter: xs
}, Gm = (e) => J3[e];
function Um(e, t) {
  let n = Gm(e);
  return n !== xs && (n = mr), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const pd = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class qm {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, n, r) {
    return {};
  }
  constructor({ parent: t, props: n, presenceContext: r, reducedMotionConfig: i, blockInitialAnimation: a, visualState: o }, s = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = Zl, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const p = bt.now();
      this.renderScheduledAt < p && (this.renderScheduledAt = p, et.render(this.render, !1, !0));
    };
    const { latestValues: l, renderState: u } = o;
    this.latestValues = l, this.baseTarget = { ...l }, this.initialValues = n.initial ? { ...l } : {}, this.renderState = u, this.parent = t, this.props = n, this.presenceContext = r, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = i, this.options = s, this.blockInitialAnimation = !!a, this.isControllingVariants = ja(n), this.isVariantNode = Kh(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: c, ...f } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const p in f) {
      const h = f[p];
      l[p] !== void 0 && Ye(h) && h.set(l[p], !1);
    }
  }
  mount(t) {
    this.current = t, Zr.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, r) => this.bindToMotionValue(r, n)), Bm.current || W3(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : bs.current, process.env.NODE_ENV !== "production" && Tl(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected."), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    this.projection && this.projection.unmount(), ir(this.notifyUpdate), ir(this.render), this.valueSubscriptions.forEach((t) => t()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this);
    for (const t in this.events)
      this.events[t].clear();
    for (const t in this.features) {
      const n = this.features[t];
      n && (n.unmount(), n.isMounted = !1);
    }
    this.current = null;
  }
  bindToMotionValue(t, n) {
    this.valueSubscriptions.has(t) && this.valueSubscriptions.get(t)();
    const r = pr.has(t);
    r && this.onBindTransform && this.onBindTransform();
    const i = n.on("change", (s) => {
      this.latestValues[t] = s, this.props.onUpdate && et.preRender(this.notifyUpdate), r && this.projection && (this.projection.isTransformDirty = !0);
    }), a = n.on("renderRequest", this.scheduleRender);
    let o;
    window.MotionCheckAppearSync && (o = window.MotionCheckAppearSync(this, t, n)), this.valueSubscriptions.set(t, () => {
      i(), a(), o && o(), n.owner && n.stop();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  updateFeatures() {
    let t = "animation";
    for (t in ar) {
      const n = ar[t];
      if (!n)
        continue;
      const { isEnabled: r, Feature: i } = n;
      if (!this.features[t] && i && r(this.props) && (this.features[t] = new i(this)), this.features[t]) {
        const a = this.features[t];
        a.isMounted ? a.update() : (a.mount(), a.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : tu();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < pd.length; r++) {
      const i = pd[r];
      this.propEventSubscriptions[i] && (this.propEventSubscriptions[i](), delete this.propEventSubscriptions[i]);
      const a = "on" + i, o = t[a];
      o && (this.propEventSubscriptions[i] = this.on(i, o));
    }
    this.prevMotionValues = z3(this, this.scrapeMotionValuesFromProps(t, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, n) {
    const r = this.values.get(t);
    n !== r && (r && this.removeValue(t), this.bindToMotionValue(t, n), this.values.set(t, n), this.latestValues[t] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let r = this.values.get(t);
    return r === void 0 && n !== void 0 && (r = jt(n === null ? void 0 : n, { owner: this }), this.addValue(t, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t, n) {
    let r = this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : this.getBaseTargetFromProps(this.props, t) ?? this.readValueFromInstance(this.current, t, this.options);
    return r != null && (typeof r == "string" && (Hm(r) || Km(r)) ? r = parseFloat(r) : !q3(r) && mr.test(n) && (r = Um(t, n)), this.setBaseTarget(t, Ye(r) ? r.get() : r)), Ye(r) ? r.get() : r;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    var a;
    const { initial: n } = this.props;
    let r;
    if (typeof n == "string" || typeof n == "object") {
      const o = kl(this.props, n, (a = this.presenceContext) == null ? void 0 : a.custom);
      o && (r = o[t]);
    }
    if (n && r !== void 0)
      return r;
    const i = this.getBaseTargetFromProps(this.props, t);
    return i !== void 0 && !Ye(i) ? i : this.initialValues[t] !== void 0 && r === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new im()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
}
const Q3 = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function ex(e) {
  const t = Q3.exec(e);
  if (!t)
    return [,];
  const [, n, r, i] = t;
  return [`--${n ?? r}`, i];
}
const tx = 4;
function Ym(e, t, n = 1) {
  en(n <= tx, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`);
  const [r, i] = ex(e);
  if (!r)
    return;
  const a = window.getComputedStyle(t).getPropertyValue(r);
  if (a) {
    const o = a.trim();
    return Hm(o) ? parseFloat(o) : o;
  }
  return Al(i) ? Ym(i, t, n + 1) : i;
}
function nx(e) {
  return typeof e == "number" ? e === 0 : e !== null ? e === "none" || e === "0" || Km(e) : !0;
}
const rx = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function ix(e, t, n) {
  let r = 0, i;
  for (; r < e.length && !i; ) {
    const a = e[r];
    typeof a == "string" && !rx.has(a) && Yr(a).values.length && (i = e[r]), r++;
  }
  if (i && n)
    for (const a of t)
      e[a] = Um(n, i);
}
class ax extends Zl {
  constructor(t, n, r, i, a) {
    super(t, n, r, i, a, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, element: n, name: r } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let l = 0; l < t.length; l++) {
      let u = t[l];
      if (typeof u == "string" && (u = u.trim(), Al(u))) {
        const c = Ym(u, n.current);
        c !== void 0 && (t[l] = c), l === t.length - 1 && (this.finalKeyframe = u);
      }
    }
    if (this.resolveNoneKeyframes(), !jm.has(r) || t.length !== 2)
      return;
    const [i, a] = t, o = fd(i), s = fd(a);
    if (o !== s)
      if (ed(o) && ed(s))
        for (let l = 0; l < t.length; l++) {
          const u = t[l];
          typeof u == "string" && (t[l] = parseFloat(u));
        }
      else On[r] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: t, name: n } = this, r = [];
    for (let i = 0; i < t.length; i++)
      (t[i] === null || nx(t[i])) && r.push(i);
    r.length && ix(t, r, n);
  }
  measureInitialState() {
    const { element: t, unresolvedKeyframes: n, name: r } = this;
    if (!t || !t.current)
      return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = On[r](t.measureViewportBox(), window.getComputedStyle(t.current)), n[0] = this.measuredOrigin;
    const i = n[n.length - 1];
    i !== void 0 && t.getValue(r, i).jump(i, !1);
  }
  measureEndState() {
    var s;
    const { element: t, name: n, unresolvedKeyframes: r } = this;
    if (!t || !t.current)
      return;
    const i = t.getValue(n);
    i && i.jump(this.measuredOrigin, !1);
    const a = r.length - 1, o = r[a];
    r[a] = On[n](t.measureViewportBox(), window.getComputedStyle(t.current)), o !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = o), (s = this.removedTransforms) != null && s.length && this.removedTransforms.forEach(([l, u]) => {
      t.getValue(l).set(u);
    }), this.resolveNoneKeyframes();
  }
}
class Xm extends qm {
  constructor() {
    super(...arguments), this.KeyframeResolver = ax;
  }
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    return t.style ? t.style[n] : void 0;
  }
  removeValueFromRenderState(t, { vars: n, style: r }) {
    delete n[t], delete r[t];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    Ye(t) && (this.childSubscription = t.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
function Zm(e, { style: t, vars: n }, r, i) {
  Object.assign(e.style, t, i && i.getProjectionStyles(r));
  for (const a in n)
    e.style.setProperty(a, n[a]);
}
function ox(e) {
  return window.getComputedStyle(e);
}
class Jm extends Xm {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = Zm;
  }
  readValueFromInstance(t, n) {
    var r;
    if (pr.has(n))
      return (r = this.projection) != null && r.isProjecting ? fs(n) : k2(t, n);
    {
      const i = ox(t), a = (qh(n) ? i.getPropertyValue(n) : i[n]) || 0;
      return typeof a == "string" ? a.trim() : a;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: n }) {
    return C3(t, n);
  }
  build(t, n, r) {
    Ml(t, n, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return Ll(t, n, r);
  }
}
const Qm = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function sx(e, t, n, r) {
  Zm(e, t, void 0, r);
  for (const i in t.attrs)
    e.setAttribute(Qm.has(i) ? i : _l(i), t.attrs[i]);
}
class eg extends Xm {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = tu;
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if (pr.has(n)) {
      const r = Gm(n);
      return r && r.default || 0;
    }
    return n = Qm.has(n) ? n : _l(n), t.getAttribute(n);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return nm(t, n, r);
  }
  build(t, n, r) {
    Jh(t, n, this.isSVGTag, r.transformTemplate, r.style);
  }
  renderInstance(t, n, r, i) {
    sx(t, n, r, i);
  }
  mount(t) {
    this.isSVGTag = em(t.tagName), super.mount(t);
  }
}
const lx = (e, t) => Dl(e) ? new eg(t) : new Jm(t, {
  allowProjection: e !== Kr
});
function ux(e) {
  return se(() => () => e(), []);
}
const cx = {
  renderer: lx,
  ...b3,
  ...K3
}, dx = 50, hd = () => ({
  current: 0,
  offset: [],
  progress: 0,
  scrollLength: 0,
  targetOffset: 0,
  targetLength: 0,
  containerLength: 0,
  velocity: 0
}), fx = () => ({
  time: 0,
  x: hd(),
  y: hd()
}), px = {
  x: {
    length: "Width",
    position: "Left"
  },
  y: {
    length: "Height",
    position: "Top"
  }
};
function md(e, t, n, r) {
  const i = n[t], { length: a, position: o } = px[t], s = i.current, l = n.time;
  i.current = e[`scroll${o}`], i.scrollLength = e[`scroll${a}`] - e[`client${a}`], i.offset.length = 0, i.offset[0] = 0, i.offset[1] = i.scrollLength, i.progress = /* @__PURE__ */ ka(0, i.scrollLength, i.current);
  const u = r - l;
  i.velocity = u > dx ? 0 : Fl(i.current - s, u);
}
function hx(e, t, n) {
  md(e, "x", t, n), md(e, "y", t, n), t.time = n;
}
function mx(e, t) {
  const n = { x: 0, y: 0 };
  let r = e;
  for (; r && r !== t; )
    if (El(r))
      n.x += r.offsetLeft, n.y += r.offsetTop, r = r.offsetParent;
    else if (r.tagName === "svg") {
      const i = r.getBoundingClientRect();
      r = r.parentElement;
      const a = r.getBoundingClientRect();
      n.x += i.left - a.left, n.y += i.top - a.top;
    } else if (r instanceof SVGGraphicsElement) {
      const { x: i, y: a } = r.getBBox();
      n.x += i, n.y += a;
      let o = null, s = r.parentNode;
      for (; !o; )
        s.tagName === "svg" && (o = s), s = r.parentNode;
      r = o;
    } else
      break;
  return n;
}
const $s = {
  start: 0,
  center: 0.5,
  end: 1
};
function gd(e, t, n = 0) {
  let r = 0;
  if (e in $s && (e = $s[e]), typeof e == "string") {
    const i = parseFloat(e);
    e.endsWith("px") ? r = i : e.endsWith("%") ? e = i / 100 : e.endsWith("vw") ? r = i / 100 * document.documentElement.clientWidth : e.endsWith("vh") ? r = i / 100 * document.documentElement.clientHeight : e = i;
  }
  return typeof e == "number" && (r = t * e), n + r;
}
const gx = [0, 0];
function vx(e, t, n, r) {
  let i = Array.isArray(e) ? e : gx, a = 0, o = 0;
  return typeof e == "number" ? i = [e, e] : typeof e == "string" && (e = e.trim(), e.includes(" ") ? i = e.split(" ") : i = [e, $s[e] ? e : "0"]), a = gd(i[0], n, r), o = gd(i[1], t), a - o;
}
const yx = {
  All: [
    [0, 0],
    [1, 1]
  ]
}, bx = { x: 0, y: 0 };
function xx(e) {
  return "getBBox" in e && e.tagName !== "svg" ? e.getBBox() : { width: e.clientWidth, height: e.clientHeight };
}
function $x(e, t, n) {
  const { offset: r = yx.All } = n, { target: i = e, axis: a = "y" } = n, o = a === "y" ? "height" : "width", s = i !== e ? mx(i, e) : bx, l = i === e ? { width: e.scrollWidth, height: e.scrollHeight } : xx(i), u = {
    width: e.clientWidth,
    height: e.clientHeight
  };
  t[a].offset.length = 0;
  let c = !t[a].interpolate;
  const f = r.length;
  for (let p = 0; p < f; p++) {
    const h = vx(r[p], u[o], l[o], s[a]);
    !c && h !== t[a].interpolatorOffsets[p] && (c = !0), t[a].offset[p] = h;
  }
  c && (t[a].interpolate = Wl(t[a].offset, zl(r), { clamp: !1 }), t[a].interpolatorOffsets = [...t[a].offset]), t[a].progress = hn(0, 1, t[a].interpolate(t[a].current));
}
function wx(e, t = e, n) {
  if (n.x.targetOffset = 0, n.y.targetOffset = 0, t !== e) {
    let r = t;
    for (; r && r !== e; )
      n.x.targetOffset += r.offsetLeft, n.y.targetOffset += r.offsetTop, r = r.offsetParent;
  }
  n.x.targetLength = t === e ? t.scrollWidth : t.clientWidth, n.y.targetLength = t === e ? t.scrollHeight : t.clientHeight, n.x.containerLength = e.clientWidth, n.y.containerLength = e.clientHeight, process.env.NODE_ENV !== "production" && e && t && t !== e && Tl(getComputedStyle(e).position !== "static", "Please ensure that the container has a non-static position, like 'relative', 'fixed', or 'absolute' to ensure scroll offset is calculated correctly.");
}
function Cx(e, t, n, r = {}) {
  return {
    measure: (i) => {
      wx(e, r.target, n), hx(e, n, i), (r.offset || r.target) && $x(e, n, r);
    },
    notify: () => t(n)
  };
}
const zi = /* @__PURE__ */ new WeakMap();
let dn;
const tg = (e, t, n) => (r, i) => i && i[0] ? i[0][e + "Size"] : nu(r) && "getBBox" in r ? r.getBBox()[t] : r[n], Sx = /* @__PURE__ */ tg("inline", "width", "offsetWidth"), Ix = /* @__PURE__ */ tg("block", "height", "offsetHeight");
function Ex({ target: e, borderBoxSize: t }) {
  var n;
  (n = zi.get(e)) == null || n.forEach((r) => {
    r(e, {
      get width() {
        return Sx(e, t);
      },
      get height() {
        return Ix(e, t);
      }
    });
  });
}
function Ox(e) {
  e.forEach(Ex);
}
function Tx() {
  typeof ResizeObserver > "u" || (dn = new ResizeObserver(Ox));
}
function Px(e, t) {
  dn || Tx();
  const n = ru(e);
  return n.forEach((r) => {
    let i = zi.get(r);
    i || (i = /* @__PURE__ */ new Set(), zi.set(r, i)), i.add(t), dn == null || dn.observe(r);
  }), () => {
    n.forEach((r) => {
      const i = zi.get(r);
      i == null || i.delete(t), i != null && i.size || dn == null || dn.unobserve(r);
    });
  };
}
const Gi = /* @__PURE__ */ new Set();
let Yn;
function Nx() {
  Yn = () => {
    const e = {
      get width() {
        return window.innerWidth;
      },
      get height() {
        return window.innerHeight;
      }
    };
    Gi.forEach((t) => t(e));
  }, window.addEventListener("resize", Yn);
}
function _x(e) {
  return Gi.add(e), Yn || Nx(), () => {
    Gi.delete(e), !Gi.size && typeof Yn == "function" && (window.removeEventListener("resize", Yn), Yn = void 0);
  };
}
function Ax(e, t) {
  return typeof e == "function" ? _x(e) : Px(e, t);
}
const Rr = /* @__PURE__ */ new WeakMap(), vd = /* @__PURE__ */ new WeakMap(), $o = /* @__PURE__ */ new WeakMap(), yd = (e) => e === document.scrollingElement ? window : e;
function ng(e, { container: t = document.scrollingElement, ...n } = {}) {
  if (!t)
    return yn;
  let r = $o.get(t);
  r || (r = /* @__PURE__ */ new Set(), $o.set(t, r));
  const i = fx(), a = Cx(t, e, i, n);
  if (r.add(a), !Rr.has(t)) {
    const s = () => {
      for (const f of r)
        f.measure(zr.timestamp);
      et.preUpdate(l);
    }, l = () => {
      for (const f of r)
        f.notify();
    }, u = () => et.read(s);
    Rr.set(t, u);
    const c = yd(t);
    window.addEventListener("resize", u, { passive: !0 }), t !== document.documentElement && vd.set(t, Ax(t, u)), c.addEventListener("scroll", u, { passive: !0 }), u();
  }
  const o = Rr.get(t);
  return et.read(o, !1, !0), () => {
    var u;
    ir(o);
    const s = $o.get(t);
    if (!s || (s.delete(a), s.size))
      return;
    const l = Rr.get(t);
    Rr.delete(t), l && (yd(t).removeEventListener("scroll", l), (u = vd.get(t)) == null || u(), window.removeEventListener("resize", l));
  };
}
const bd = /* @__PURE__ */ new Map();
function Rx(e) {
  const t = { value: 0 }, n = ng((r) => {
    t.value = r[e.axis].progress * 100;
  }, e);
  return { currentTime: t, cancel: n };
}
function rg({ source: e, container: t, ...n }) {
  const { axis: r } = n;
  e && (t = e);
  const i = bd.get(t) ?? /* @__PURE__ */ new Map();
  bd.set(t, i);
  const a = n.target ?? "self", o = i.get(a) ?? {}, s = r + (n.offset ?? []).join(",");
  return o[s] || (o[s] = !n.target && Nm() ? new ScrollTimeline({ source: t, axis: r }) : Rx({ container: t, ...n })), o[s];
}
function ig(e, t) {
  let n;
  const r = () => {
    const { currentTime: i } = t, o = (i === null ? 0 : i.value) / 100;
    n !== o && e(o), n = o;
  };
  return et.preUpdate(r, !0), () => ir(r);
}
function Mx(e, t) {
  const n = rg(t);
  return e.attachTimeline({
    timeline: t.target ? void 0 : n,
    observe: (r) => (r.pause(), ig((i) => {
      r.time = r.duration * i;
    }, n))
  });
}
function jx(e) {
  return e.length === 2;
}
function Dx(e, t) {
  return jx(e) ? ng((n) => {
    e(n[t.axis].progress, n);
  }, t) : ig(e, rg(t));
}
function kx(e, { axis: t = "y", container: n = document.scrollingElement, ...r } = {}) {
  if (!n)
    return yn;
  const i = { axis: t, container: n, ...r };
  return typeof e == "function" ? Dx(e, i) : Mx(e, i);
}
function xd(e, t) {
  dr(!!(!t || t.current), `You have defined a ${e} options but the provided ref is not yet hydrated, probably because it's defined higher up the tree. Try calling useScroll() in the same component as the ref, or setting its \`layoutEffect: false\` option.`);
}
const Lx = () => ({
  scrollX: jt(0),
  scrollY: jt(0),
  scrollXProgress: jt(0),
  scrollYProgress: jt(0)
});
function Fx({ container: e, target: t, layoutEffect: n = !0, ...r } = {}) {
  const i = rr(Lx);
  return (n ? Sl : se)(() => (xd("target", t), xd("container", e), kx((o, { x: s, y: l }) => {
    i.scrollX.set(s.current), i.scrollXProgress.set(s.progress), i.scrollY.set(l.current), i.scrollYProgress.set(l.progress);
  }, {
    ...r,
    container: (e == null ? void 0 : e.current) || void 0,
    target: (t == null ? void 0 : t.current) || void 0
  })), [e, t, JSON.stringify(r.offset)]), i;
}
function Vx(e) {
  const t = rr(() => jt(e)), { isStatic: n } = Xe(Il);
  if (n) {
    const [, r] = ue(e);
    se(() => t.on("change", r), []);
  }
  return t;
}
function ag(e, t) {
  const n = Vx(t()), r = () => n.set(t());
  return r(), Sl(() => {
    const i = () => et.preRender(r, !1, !0), a = e.map((o) => o.on("change", i));
    return () => {
      a.forEach((o) => o()), ir(r);
    };
  }), n;
}
function Bx(e) {
  Lr.current = [], e();
  const t = ag(Lr.current, e);
  return Lr.current = void 0, t;
}
function Hx(...e) {
  const t = !Array.isArray(e[0]), n = t ? 0 : -1, r = e[0 + n], i = e[1 + n], a = e[2 + n], o = e[3 + n], s = Wl(i, a, o);
  return t ? s(r) : s;
}
function $d(e, t, n, r) {
  if (typeof e == "function")
    return Bx(e);
  const i = typeof t == "function" ? t : Hx(t, n, r);
  return Array.isArray(e) ? wd(e, i) : wd([e], ([a]) => i(a));
}
function wd(e, t) {
  const n = rr(() => []);
  return ag(e, () => {
    n.length = 0;
    const r = e.length;
    for (let i = 0; i < r; i++)
      n[i] = e[i].get();
    return t(n);
  });
}
function iu(e) {
  return typeof e == "object" && !Array.isArray(e);
}
function og(e, t, n, r) {
  return typeof e == "string" && iu(t) ? ru(e, n, r) : e instanceof NodeList ? Array.from(e) : Array.isArray(e) ? e : [e];
}
function Kx(e, t, n) {
  return e * (t + 1);
}
function Cd(e, t, n, r) {
  return typeof t == "number" ? t : t.startsWith("-") || t.startsWith("+") ? Math.max(0, e + parseFloat(t)) : t === "<" ? n : r.get(t) ?? e;
}
const Wx = (e, t, n) => {
  const r = t - e;
  return ((n - e) % r + r) % r + e;
};
function sg(e, t) {
  return bm(e) ? e[Wx(0, e.length, t)] : e;
}
function zx(e, t, n) {
  for (let r = 0; r < e.length; r++) {
    const i = e[r];
    i.at > t && i.at < n && (rm(e, i), r--);
  }
}
function Gx(e, t, n, r, i, a) {
  zx(e, i, a);
  for (let o = 0; o < t.length; o++)
    e.push({
      value: t[o],
      at: pi(i, a, r[o]),
      easing: sg(n, o)
    });
}
function Ux(e, t) {
  for (let n = 0; n < e.length; n++)
    e[n] = e[n] / (t + 1);
}
function qx(e, t) {
  return e.at === t.at ? e.value === null ? 1 : t.value === null ? -1 : 0 : e.at - t.at;
}
const Yx = "easeInOut", Xx = 20;
function Zx(e, { defaultTransition: t = {}, ...n } = {}, r, i) {
  const a = t.duration || 0.3, o = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map(), l = {}, u = /* @__PURE__ */ new Map();
  let c = 0, f = 0, p = 0;
  for (let h = 0; h < e.length; h++) {
    const m = e[h];
    if (typeof m == "string") {
      u.set(m, f);
      continue;
    } else if (!Array.isArray(m)) {
      u.set(m.name, Cd(f, m.at, c, u));
      continue;
    }
    let [v, g, b = {}] = m;
    b.at !== void 0 && (f = Cd(f, b.at, c, u));
    let y = 0;
    const x = (w, $, C, T = 0, S = 0) => {
      const N = Jx(w), { delay: k = 0, times: L = zl(N), type: _ = "keyframes", repeat: B, repeatType: A, repeatDelay: q = 0, ...X } = $;
      let { ease: I = t.ease || "easeOut", duration: O } = $;
      const D = typeof k == "function" ? k(T, S) : k, E = N.length, j = Ql(_) ? _ : i == null ? void 0 : i[_];
      if (E <= 2 && j) {
        let W = 100;
        if (E === 2 && t$(N)) {
          const U = N[1] - N[0];
          W = Math.abs(U);
        }
        const G = { ...X };
        O !== void 0 && (G.duration = /* @__PURE__ */ Ot(O));
        const z = hm(G, W, j);
        I = z.ease, O = z.duration;
      }
      O ?? (O = a);
      const F = f + D;
      L.length === 1 && L[0] === 0 && (L[1] = 1);
      const K = L.length - N.length;
      if (K > 0 && gm(L, K), N.length === 1 && N.unshift(null), B) {
        en(B < Xx, "Repeat count too high, must be less than 20"), O = Kx(O, B);
        const W = [...N], G = [...L];
        I = Array.isArray(I) ? [...I] : [I];
        const z = [...I];
        for (let U = 0; U < B; U++) {
          N.push(...W);
          for (let J = 0; J < W.length; J++)
            L.push(G[J] + (U + 1)), I.push(J === 0 ? "linear" : sg(z, J - 1));
        }
        Ux(L, B);
      }
      const H = F + O;
      Gx(C, N, I, L, F, H), y = Math.max(D + O, y), p = Math.max(H, p);
    };
    if (Ye(v)) {
      const w = Sd(v, s);
      x(g, b, Id("default", w));
    } else {
      const w = og(v, g, r, l), $ = w.length;
      for (let C = 0; C < $; C++) {
        g = g, b = b;
        const T = w[C], S = Sd(T, s);
        for (const N in g)
          x(g[N], Qx(b, N), Id(N, S), C, $);
      }
    }
    c = f, f += y;
  }
  return s.forEach((h, m) => {
    for (const v in h) {
      const g = h[v];
      g.sort(qx);
      const b = [], y = [], x = [];
      for (let $ = 0; $ < g.length; $++) {
        const { at: C, value: T, easing: S } = g[$];
        b.push(T), y.push(/* @__PURE__ */ ka(0, p, C)), x.push(S || "easeOut");
      }
      y[0] !== 0 && (y.unshift(0), b.unshift(b[0]), x.unshift(Yx)), y[y.length - 1] !== 1 && (y.push(1), b.push(null)), o.has(m) || o.set(m, {
        keyframes: {},
        transition: {}
      });
      const w = o.get(m);
      w.keyframes[v] = b, w.transition[v] = {
        ...t,
        duration: p,
        ease: x,
        times: y,
        ...n
      };
    }
  }), o;
}
function Sd(e, t) {
  return !t.has(e) && t.set(e, {}), t.get(e);
}
function Id(e, t) {
  return t[e] || (t[e] = []), t[e];
}
function Jx(e) {
  return Array.isArray(e) ? e : [e];
}
function Qx(e, t) {
  return e && e[t] ? {
    ...e,
    ...e[t]
  } : { ...e };
}
const e$ = (e) => typeof e == "number", t$ = (e) => e.every(e$);
function n$(e, t) {
  return e in t;
}
class r$ extends qm {
  constructor() {
    super(...arguments), this.type = "object";
  }
  readValueFromInstance(t, n) {
    if (n$(n, t)) {
      const r = t[n];
      if (typeof r == "string" || typeof r == "number")
        return r;
    }
  }
  getBaseTargetFromProps() {
  }
  removeValueFromRenderState(t, n) {
    delete n.output[t];
  }
  measureInstanceViewportBox() {
    return tu();
  }
  build(t, n) {
    Object.assign(t.output, n);
  }
  renderInstance(t, { output: n }) {
    Object.assign(t, n);
  }
  sortInstanceNodePosition() {
    return 0;
  }
}
function i$(e) {
  const t = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        transform: {},
        transformOrigin: {},
        style: {},
        vars: {},
        attrs: {}
      },
      latestValues: {}
    }
  }, n = nu(e) && !O3(e) ? new eg(t) : new Jm(t);
  n.mount(e), Zr.set(e, n);
}
function a$(e) {
  const t = {
    presenceContext: null,
    props: {},
    visualState: {
      renderState: {
        output: {}
      },
      latestValues: {}
    }
  }, n = new r$(t);
  n.mount(e), Zr.set(e, n);
}
function o$(e, t) {
  return Ye(e) || typeof e == "number" || typeof e == "string" && !iu(t);
}
function lg(e, t, n, r) {
  const i = [];
  if (o$(e, t))
    i.push(E3(e, iu(t) && t.default || t, n && (n.default || n)));
  else {
    const a = og(e, t, r), o = a.length;
    en(!!o, "No valid elements provided.");
    for (let s = 0; s < o; s++) {
      const l = a[s], u = l instanceof Element ? i$ : a$;
      Zr.has(l) || u(l);
      const c = Zr.get(l), f = { ...n };
      "delay" in f && typeof f.delay == "function" && (f.delay = f.delay(s, o)), i.push(...eu(c, { ...t, transition: f }, {}));
    }
  }
  return i;
}
function s$(e, t, n) {
  const r = [];
  return Zx(e, t, n, { spring: Xr }).forEach(({ keyframes: a, transition: o }, s) => {
    r.push(...lg(s, a, o));
  }), r;
}
class l$ {
  constructor(t) {
    this.stop = () => this.runAll("stop"), this.animations = t.filter(Boolean);
  }
  get finished() {
    return Promise.all(this.animations.map((t) => t.finished));
  }
  /**
   * TODO: Filter out cancelled or stopped animations before returning
   */
  getAll(t) {
    return this.animations[0][t];
  }
  setAll(t, n) {
    for (let r = 0; r < this.animations.length; r++)
      this.animations[r][t] = n;
  }
  attachTimeline(t) {
    const n = this.animations.map((r) => r.attachTimeline(t));
    return () => {
      n.forEach((r, i) => {
        r && r(), this.animations[i].stop();
      });
    };
  }
  get time() {
    return this.getAll("time");
  }
  set time(t) {
    this.setAll("time", t);
  }
  get speed() {
    return this.getAll("speed");
  }
  set speed(t) {
    this.setAll("speed", t);
  }
  get state() {
    return this.getAll("state");
  }
  get startTime() {
    return this.getAll("startTime");
  }
  get duration() {
    let t = 0;
    for (let n = 0; n < this.animations.length; n++)
      t = Math.max(t, this.animations[n].duration);
    return t;
  }
  runAll(t) {
    this.animations.forEach((n) => n[t]());
  }
  play() {
    this.runAll("play");
  }
  pause() {
    this.runAll("pause");
  }
  cancel() {
    this.runAll("cancel");
  }
  complete() {
    this.runAll("complete");
  }
}
class u$ extends l$ {
  then(t, n) {
    return this.finished.finally(t).then(() => {
    });
  }
}
function c$(e) {
  return Array.isArray(e) && e.some(Array.isArray);
}
function d$(e) {
  function t(n, r, i) {
    let a = [];
    c$(n) ? a = s$(n, r, e) : a = lg(n, r, i, e);
    const o = new u$(a);
    return e && e.animations.push(o), o;
  }
  return t;
}
function f$() {
  const e = rr(() => ({
    current: null,
    // Will be hydrated by React
    animations: []
  })), t = rr(() => d$(e));
  return ux(() => {
    e.animations.forEach((n) => n.stop());
  }), [e, t];
}
const p$ = ({ sequences: e, options: t, children: n, ...r }) => {
  const [i, a] = f$();
  return se(() => {
    if (!e || !n) return;
    const o = a(e, t);
    return () => o == null ? void 0 : o.stop();
  }, [r, a, n]), /* @__PURE__ */ d.jsx(d.Fragment, { children: n({ ...r, innerRef: i }) });
}, h$ = de("a:flex a:items-center a:justify-center", {
  variants: {
    color: wl("fill")
  },
  defaultVariants: {
    color: "current"
  }
}), m$ = de("a:animate-rotate", {
  variants: {
    size: {
      sm: "a:w-5 a:h-5",
      md: "a:w-6 a:h-6",
      lg: "a:w-10 a:h-10",
      xl: "a:w-20 a:h-20"
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), g$ = ({ size: e, testId: t }) => {
  const n = B1();
  return /* @__PURE__ */ d.jsxs(
    "svg",
    {
      "data-testid": t,
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      className: m$({ size: e }),
      children: [
        /* @__PURE__ */ d.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10s4.477 10 10 10 10-4.477 10-10Zm-2 0a8 8 0 1 0-16 0 8 8 0 0 0 16 0Z",
            fill: `url(#${n}-a)`,
            fillOpacity: "0.5"
          }
        ),
        /* @__PURE__ */ d.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10s4.477 10 10 10 10-4.477 10-10Zm-2 0a8 8 0 1 0-16 0 8 8 0 0 0 16 0Z",
            fill: `url(#${n}-b)`,
            fillOpacity: "0.5"
          }
        ),
        /* @__PURE__ */ d.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10s4.477 10 10 10 10-4.477 10-10Zm-2 0a8 8 0 1 0-16 0 8 8 0 0 0 16 0Z",
            fill: `url(#${n}-c)`,
            fillOpacity: "0.5"
          }
        ),
        /* @__PURE__ */ d.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10s4.477 10 10 10 10-4.477 10-10Zm-2 0a8 8 0 1 0-16 0 8 8 0 0 0 16 0Z",
            fill: `url(#${n}-d)`
          }
        ),
        /* @__PURE__ */ d.jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.776 7.509a1.01 1.01 0 0 1 1.125.887c.066.523.099 1.05.099 1.577C20 10.54 19.55 11 18.995 11c-.554 0-1.004-.46-1.004-1.027 0-.44-.028-.879-.083-1.314a1.023 1.023 0 0 1 .868-1.15Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ d.jsxs("linearGradient", { id: `${n}-a`, x1: "21.875", y1: "21.125", x2: "10", y2: "0", gradientUnits: "userSpaceOnUse", children: [
          /* @__PURE__ */ d.jsx("stop", { stopColor: "currentColor", stopOpacity: "0" }),
          /* @__PURE__ */ d.jsx("stop", { offset: "0", stopColor: "currentColor", stopOpacity: "0" }),
          /* @__PURE__ */ d.jsx("stop", { offset: "1", stopColor: "currentColor" })
        ] }),
        /* @__PURE__ */ d.jsxs("linearGradient", { id: `${n}-b`, x1: "9.5", y1: "10", x2: "9.5", y2: "10.125", gradientUnits: "userSpaceOnUse", children: [
          /* @__PURE__ */ d.jsx("stop", { stopColor: "currentColor" }),
          /* @__PURE__ */ d.jsx("stop", { offset: "1", stopColor: "currentColor", stopOpacity: "0" })
        ] }),
        /* @__PURE__ */ d.jsxs("linearGradient", { id: `${n}-c`, x1: "7.75", y1: "4.75", x2: "14.375", y2: "15.375", gradientUnits: "userSpaceOnUse", children: [
          /* @__PURE__ */ d.jsx("stop", { stopColor: "currentColor" }),
          /* @__PURE__ */ d.jsx("stop", { offset: "1", stopColor: "currentColor", stopOpacity: "0" })
        ] }),
        /* @__PURE__ */ d.jsxs("linearGradient", { id: `${n}-d`, x1: "16.75", y1: "7.625", x2: "17.125", y2: "10.75", gradientUnits: "userSpaceOnUse", children: [
          /* @__PURE__ */ d.jsx("stop", { stopColor: "currentColor" }),
          /* @__PURE__ */ d.jsx("stop", { offset: "1", stopColor: "currentColor", stopOpacity: "0" })
        ] })
      ]
    }
  );
}, ug = ({ color: e, size: t, testId: n }) => /* @__PURE__ */ d.jsx("div", { "data-testid": n, className: Y(h$({ color: e })), children: /* @__PURE__ */ d.jsx(g$, { size: t, testId: Z({ testId: n, suffix: "icon" }) }) }), Le = {
  variants: {
    theme: { neutral: "", branded: "" },
    variant: { primary: "", secondary: "", tertiary: "" },
    inverse: { true: "", false: "" },
    size: { sm: "", md: "", lg: "" }
  },
  focus: "a:focus-visible:outline a:focus-visible:outline-border-focus a:focus-visible:outline-2 a:focus-visible:outline-offset-1",
  // COMPOUND VARIANTS
  primary: [
    // BRANDED
    {
      theme: "branded",
      variant: "primary",
      inverse: !1,
      class: [
        "a:text-content-inverse a:bg-surface-brand",
        "a:[&:not(:disabled)]:hover-pointer:bg-surface-brand-hover",
        "a:disabled:bg-surface-brand-disabled"
      ]
    },
    {
      theme: "branded",
      variant: "primary",
      inverse: !0,
      class: [
        "a:text-content-brand a:bg-surface-neutral",
        "a:[&:not(:disabled)]:hover-pointer:bg-surface-neutral-hover",
        "a:disabled:text-content-brand-disabled a:disabled:bg-surface-neutral-hover"
      ]
    },
    // NEUTRAL
    {
      theme: "neutral",
      variant: "primary",
      inverse: !1,
      class: [
        "a:text-content-inverse a:bg-surface-dark",
        "a:[&:not(:disabled)]:hover-pointer:bg-surface-dark-hover",
        "a:disabled:bg-surface-dark-disabled"
      ]
    },
    {
      theme: "neutral",
      variant: "primary",
      inverse: !0,
      class: [
        "a:text-content-emphasised a:bg-surface-neutral",
        "a:[&:not(:disabled)]:hover-pointer:bg-surface-neutral-hover",
        "a:disabled:text-content-emphasised-disabled a:disabled:bg-surface-neutral-hover"
      ]
    }
  ],
  secondary: [
    // SECONDARY BRANDED
    {
      theme: "branded",
      variant: "secondary",
      inverse: !1,
      class: [
        "a:text-content-brand a:bg-surface-neutral a:border-solid a:border a:border-border-brand",
        "a:[&:not(:disabled)]:hover-pointer:bg-surface-neutral-hover",
        "a:disabled:text-content-brand-disabled a:disabled:border-border-neutral"
      ]
    },
    // SECONDARY NEUTRAL
    {
      theme: "neutral",
      variant: "secondary",
      inverse: !1,
      class: [
        "a:text-content-emphasised a:bg-surface-neutral a:border-solid a:border a:border-border-dark",
        "a:[&:not(:disabled)]:hover-pointer:bg-surface-neutral-hover",
        "a:disabled:text-content-emphasised-disabled a:disabled:bg-surface-neutral a:disabled:border-border-neutral"
      ]
    },
    // SECONDARY BRANDED INVERSED
    {
      theme: "branded",
      variant: "secondary",
      inverse: !0,
      class: [
        "a:text-content-inverse a:bg-surface-opacity-dark a:border a:border-border-inverse",
        "a:[&:not(:disabled)]:hover-pointer:bg-surface-opacity-dark-hover",
        "a:disabled:text-content-neutral-disabled"
      ]
    },
    // SECONDARY NEUTRAL INVERSED
    {
      theme: "neutral",
      variant: "secondary",
      inverse: !0,
      class: [
        "a:text-content-inverse a:bg-surface-opacity-dark a:border a:border-border-inverse",
        "a:[&:not(:disabled)]:hover-pointer:bg-surface-opacity-dark-hover",
        "a:disabled:text-content-neutral-disabled"
      ]
    }
  ],
  tertiary: [
    // TERTIARY BRANDED
    {
      theme: "branded",
      variant: "tertiary",
      inverse: !1,
      class: [
        "a:text-content-brand a:bg-surface-quiet",
        "a:[&:not(:disabled)]:hover-pointer:bg-surface-quiet-hover",
        "a:disabled:text-content-brand-disabled a:disabled:border-border-neutral"
      ]
    },
    // TERTIARY NEUTRAL
    {
      theme: "neutral",
      variant: "tertiary",
      inverse: !1,
      class: [
        "a:text-content-emphasised a:bg-surface-quiet",
        "a:[&:not(:disabled)]:hover-pointer:bg-surface-quiet-hover",
        "a:disabled:text-content-emphasised-disabled"
      ]
    },
    // TERTIARY BRANDED INVERSED
    {
      theme: "branded",
      variant: "tertiary",
      inverse: !0,
      class: [
        "a:text-content-inverse a:bg-surface-opacity-dark",
        "a:[&:not(:disabled)]:hover-pointer:bg-surface-opacity-dark-hover",
        "a:disabled:text-content-neutral-disabled"
      ]
    },
    // TERTIARY NEUTRAL INVERSED
    {
      theme: "neutral",
      variant: "tertiary",
      inverse: !0,
      class: [
        "a:text-content-inverse a:bg-surface-opacity-dark",
        "a:[&:not(:disabled)]:hover-pointer:bg-surface-opacity-dark-hover",
        "a:disabled:text-content-neutral-disabled"
      ]
    }
  ]
}, ws = de(
  ["a:rounded-md a:gap-2 a:text-base a:leading-6 a:font-semibold", Le.focus],
  {
    variants: {
      ...Le.variants
    },
    compoundVariants: [
      ...Le.primary,
      ...Le.secondary,
      ...Le.tertiary,
      { size: "sm", class: "a:px-4" },
      { size: "md", class: "a:px-5" },
      { size: "lg", class: "a:px-6" },
      {
        variant: ["primary", "tertiary"],
        size: "sm",
        class: "a:py-1.5"
      },
      {
        variant: ["primary", "tertiary"],
        size: "md",
        class: "a:py-2.5"
      },
      {
        variant: ["primary", "tertiary"],
        size: "lg",
        class: "a:py-3.5"
      },
      {
        variant: "secondary",
        size: "sm",
        class: "a:py-[5px]"
      },
      {
        variant: "secondary",
        size: "md",
        class: "a:py-[9px]"
      },
      {
        variant: "secondary",
        size: "lg",
        class: "a:py-[13px]"
      }
    ]
  }
), cg = ({
  theme: e = "neutral",
  size: t = "md",
  variant: n = "primary",
  inverse: r = !1,
  ...i
}) => /* @__PURE__ */ d.jsx(
  mi,
  {
    ...i,
    size: t,
    appearance: "basic",
    sizeClassName: Y(ws({ size: t, variant: n })),
    className: Y(ws({ theme: e, variant: n, inverse: r }))
  }
), Cs = de("a:rounded-md", {
  variants: {
    ...Le.variants,
    variant: {
      ...Le.variants.variant,
      plain: "a:[&_[data-component=badge]]:right-auto"
    }
  },
  compoundVariants: [
    ...Le.primary,
    ...Le.secondary,
    ...Le.tertiary,
    {
      variant: ["primary", "secondary"],
      class: Le.focus
    },
    {
      theme: "neutral",
      variant: "plain",
      inverse: !1,
      class: [
        "a:text-content-neutral",
        "a:[&:not(:disabled)]:hover-pointer:bg-surface-quiet",
        "a:disabled:text-content-emphasised-disabled",
        "a:focus:outline-hidden"
      ]
    },
    {
      variant: ["primary", "tertiary", "plain"],
      size: "sm",
      class: "a:p-2"
    },
    {
      variant: ["primary", "tertiary", "plain"],
      size: "md",
      class: "a:p-3"
    },
    {
      variant: ["primary", "tertiary", "plain"],
      size: "lg",
      class: "a:p-4"
    },
    {
      variant: "secondary",
      size: "sm",
      class: "a:p-[7px]"
    },
    {
      variant: "secondary",
      size: "md",
      class: "a:p-[11px]"
    },
    {
      variant: "secondary",
      size: "lg",
      class: "a:p-[15px]"
    },
    {
      variant: "plain",
      size: "sm",
      class: "a:[&_[data-component=badge]]:top-0 a:[&_[data-component=badge]]:left-6"
    },
    {
      variant: "plain",
      size: "md",
      class: "a:[&_[data-component=badge]]:top-1 a:[&_[data-component=badge]]:left-8"
    },
    {
      variant: "plain",
      size: "lg",
      class: "a:[&_[data-component=badge]]:top-2 a:[&_[data-component=badge]]:left-10"
    }
  ]
}), dg = ({
  theme: e = "neutral",
  size: t = "md",
  variant: n = "primary",
  inverse: r = !1,
  icon: i,
  ...a
}) => /* @__PURE__ */ d.jsx(
  mi,
  {
    ...a,
    size: t,
    iconLeft: i,
    appearance: "icon",
    sizeClassName: Y(Cs({ size: t, variant: n })),
    className: Y(Cs({ theme: e, variant: n, inverse: r }))
  }
), Ss = de(
  ["a:rounded-sm a:gap-1 a:[&:not(:disabled)]:hover-pointer:cursor-pointer", Le.focus],
  {
    variants: {
      ...Le.variants
    },
    compoundVariants: [
      // LINK NEUTRAL
      {
        variant: "primary",
        theme: "neutral",
        inverse: !1,
        class: [
          "a:underline a:text-content-neutral",
          "a:[&:not(:disabled)]:hover-pointer:bg-surface-opacity-dark",
          "a:disabled:text-content-neutral-disabled"
        ]
      },
      {
        variant: "primary",
        theme: "neutral",
        inverse: !0,
        class: [
          "a:underline a:text-content-inverse",
          "a:[&:not(:disabled)]:hover-pointer:bg-surface-opacity-dark",
          "a:disabled:text-content-inverse-disabled"
        ]
      },
      {
        variant: "secondary",
        theme: "neutral",
        inverse: !1,
        class: [
          "a:text-content-neutral",
          "a:[&:not(:disabled)]:hover-pointer:bg-surface-opacity-dark",
          "a:disabled:text-content-neutral-disabled"
        ]
      },
      {
        variant: "secondary",
        theme: "neutral",
        inverse: !0,
        class: [
          "a:text-content-inverse",
          "a:[&:not(:disabled)]:hover-pointer:bg-surface-opacity-dark",
          "a:disabled:text-content-inverse-disabled"
        ]
      },
      {
        variant: "tertiary",
        theme: "neutral",
        inverse: !1,
        class: [
          "a:text-content-subtle",
          "a:[&:not(:disabled)]:hover-pointer:bg-surface-opacity-dark",
          "a:disabled:text-content-subtle-disabled"
        ]
      },
      {
        variant: "tertiary",
        theme: "neutral",
        inverse: !0,
        class: [
          "a:text-content-inverse",
          "a:[&:not(:disabled)]:hover-pointer:bg-surface-opacity-dark",
          "a:disabled:text-content-inverse-disabled"
        ]
      },
      // LINK BRANDED
      {
        variant: "primary",
        theme: "branded",
        inverse: !1,
        class: [
          "a:font-semibold a:text-content-brand",
          "a:[&:not(:disabled)]:hover-pointer:bg-surface-opacity-dark",
          "a:disabled:text-content-brand-disabled"
        ]
      },
      {
        variant: "primary",
        theme: "branded",
        inverse: !0,
        class: [
          "a:font-semibold a:text-content-inverse",
          "a:[&:not(:disabled)]:hover-pointer:bg-surface-opacity-dark",
          "a:disabled:text-content-inverse-disabled"
        ]
      },
      {
        variant: "secondary",
        theme: "branded",
        inverse: !1,
        class: [
          "a:underline a:text-content-brand",
          "a:[&:not(:disabled)]:hover-pointer:bg-surface-opacity-dark",
          "a:disabled:text-content-brand-disabled"
        ]
      },
      {
        variant: "secondary",
        theme: "branded",
        inverse: !0,
        class: [
          "a:underline a:text-content-inverse",
          "a:[&:not(:disabled)]:hover-pointer:bg-surface-opacity-dark-hover",
          "a:disabled:text-content-inverse-disabled"
        ]
      },
      {
        variant: "tertiary",
        theme: "branded",
        inverse: !1,
        class: [
          "a:underline a:text-content-brand",
          "a:[&:not(:disabled)]:hover-pointer:bg-surface-opacity-dark",
          "a:disabled:text-content-brand-disabled"
        ]
      },
      {
        variant: "tertiary",
        theme: "branded",
        inverse: !0,
        class: [
          "a:underline a:text-content-inverse",
          "a:[&:not(:disabled)]:hover-pointer:bg-surface-opacity-dark-hover",
          "a:disabled:text-content-inverse-disabled"
        ]
      },
      { size: "sm", class: "a:text-sm a:leading-5" },
      { size: "md", class: "a:text-base a:leading-6" }
    ]
  }
), fg = ({
  theme: e = "neutral",
  size: t = "md",
  variant: n = "primary",
  inverse: r = !1,
  ...i
}) => /* @__PURE__ */ d.jsx(
  mi,
  {
    ...i,
    size: t,
    appearance: "link",
    sizeClassName: Y(Ss({ size: t })),
    className: Y(Ss({ theme: e, variant: n, inverse: r }))
  }
), Is = de(
  [
    "a:rounded-circle a:gap-2 a:[&_[data-component=badge]]:-top-2 a:[&_[data-component=badge]]:top-0",
    Le.focus
  ],
  {
    variants: {
      ...Le.variants
    },
    compoundVariants: [
      ...Le.primary,
      ...Le.secondary,
      // SECONDARY BRANDED
      {
        theme: "branded",
        variant: "secondary",
        inverse: !1,
        class: [
          "a:text-content-brand a:bg-surface-quiet",
          "a:[&:not(:disabled)]:hover-pointer:bg-surface-quiet-hover",
          "a:disabled:text-content-brand-disabled a:disabled:border-border-neutral"
        ]
      },
      // SECONDARY NEUTRAL
      {
        theme: "neutral",
        variant: "secondary",
        inverse: !1,
        class: [
          "a:text-content-emphasised a:bg-surface-quiet",
          "a:[&:not(:disabled)]:hover-pointer:bg-surface-quiet-hover",
          "a:disabled:text-content-emphasised-disabled"
        ]
      },
      { size: "sm", class: "a:py-1 a:px-3 a:text-base a:leading-6" },
      { size: "md", class: "a:py-3 a:px-5 a:text-lg a:leading-7" }
    ]
  }
), pg = ({
  theme: e = "neutral",
  size: t = "md",
  variant: n = "primary",
  inverse: r = !1,
  ...i
}) => /* @__PURE__ */ d.jsx(
  mi,
  {
    ...i,
    size: t,
    appearance: "pill",
    sizeClassName: Y(Is({ size: t })),
    className: Y(Is({ theme: e, variant: n, inverse: r }))
  }
), hg = de(
  [
    "a:relative a:inline-flex a:items-center a:justify-center",
    "a:font-functional",
    "a:disabled:cursor-not-allowed",
    "a:transition-[background-color,color] a:duration-200",
    "a:shrink-0",
    "a:[&_[data-component=badge]]:absolute a:[&_[data-component=badge]]:-top-1 a:[&_[data-component=badge]]:-right-1",
    "a:has-[>[data-component=action-loading-wrapper]]:overflow-hidden",
    "a:has-[>[data-component=action-loading-wrapper]]:[&_[data-component=badge]]:hidden"
  ],
  {
    variants: {
      fullWidth: {
        true: "a:w-full"
      }
    }
  }
), v$ = {
  basic: { md: "md", sm: "sm", lg: "sm" },
  icon: { md: "md", sm: "sm", lg: "sm" },
  link: { md: "md", sm: "sm", lg: "sm" },
  pill: { md: "lg", sm: "sm", lg: "sm" }
};
function mi({
  appearance: e = "basic",
  ariaLabel: t,
  className: n,
  testId: r,
  fullWidth: i,
  iconLeft: a,
  iconRight: o,
  innerRef: s,
  sizeClassName: l,
  state: u,
  ...c
}) {
  const f = v$[e ?? "basic"][c.size ?? "md"], [p, h] = ue(!1), [m, v] = ue(!1), g = p || m, b = Y(hg({ fullWidth: i }), n, !g && l), y = (w) => /* @__PURE__ */ d.jsxs(
    "span",
    {
      "data-component": "action-loading-wrapper",
      className: Y(
        l,
        "a:relative a:inline-flex a:h-full a:translate-y-0 a:items-center a:justify-center a:gap-2 a:transition-transform",
        { "a:translate-y-[100%]": p && m }
      ),
      onTransitionEnd: () => {
        h(($) => $ ? (v(!0), !0) : (m && v(!1), u === "loading" && !$));
      },
      children: [
        /* @__PURE__ */ d.jsx("span", { className: Y("a:absolute a:-top-[100%] a:flex a:h-full"), children: /* @__PURE__ */ d.jsx(ug, { testId: Z({ testId: r, suffix: "spinner" }), size: "sm" }) }),
        w
      ]
    }
  ), x = (w) => /* @__PURE__ */ d.jsxs(Jt, { condition: g, wrapper: y, children: [
    !!a && ("sequences" in a && a.sequences ? /* @__PURE__ */ d.jsx(
      p$,
      {
        size: f,
        testId: Z({ testId: r, suffix: "left-icon" }),
        sequences: a.sequences,
        ...a,
        children: ($) => /* @__PURE__ */ d.jsx($e, { ...$ })
      }
    ) : /* @__PURE__ */ d.jsx($e, { size: f, testId: Z({ testId: r, suffix: "left-icon" }), ...a })),
    w,
    e !== "icon" && !!o && /* @__PURE__ */ d.jsx($e, { size: f, testId: Z({ testId: r, suffix: "right-icon" }), ...o })
  ] });
  if (se(() => {
    h(u === "loading"), u === "loading" && setTimeout(() => v(!0), jy);
  }, [u]), c.as === "link") {
    const { as: w, children: $, ...C } = c;
    return /* @__PURE__ */ d.jsx(
      "a",
      {
        ...C,
        "data-testid": r,
        "aria-label": t,
        className: b,
        ref: s,
        children: x($)
      }
    );
  } else {
    const { as: w, text: $, children: C, ...T } = c;
    return /* @__PURE__ */ d.jsx(
      "button",
      {
        ...T,
        "data-testid": r,
        "aria-label": t,
        className: b,
        disabled: u === "disabled" || u === "loading",
        ref: s,
        type: c.type ?? "button",
        children: x(C ?? $)
      }
    );
  }
}
const BO = ({ appearance: e, fullWidth: t, inverse: n, size: r, theme: i, variant: a }) => {
  const o = hg({ fullWidth: t });
  switch (e) {
    case "basic":
      return Y(o, ws({ inverse: n, size: r, theme: i, variant: a }));
    case "icon":
      return Y(o, Cs({ inverse: n, size: r, theme: i, variant: a }));
    case "link":
      return Y(o, Ss({ inverse: n, size: r, theme: i, variant: a }));
    case "pill":
      return Y(o, Is({ inverse: n, size: r, theme: i, variant: a }));
  }
};
function ct(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.indexOf(r) !== -1) continue;
    n[r] = e[r];
  }
  return n;
}
function me() {
  return me = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, me.apply(null, arguments);
}
function Es(e, t) {
  return Es = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, Es(e, t);
}
function y$(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Es(e, t);
}
var Pi = { exports: {} }, Ni = { exports: {} }, Ce = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ed;
function b$() {
  if (Ed) return Ce;
  Ed = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
  function x($) {
    if (typeof $ == "object" && $ !== null) {
      var C = $.$$typeof;
      switch (C) {
        case t:
          switch ($ = $.type, $) {
            case l:
            case u:
            case r:
            case a:
            case i:
            case f:
              return $;
            default:
              switch ($ = $ && $.$$typeof, $) {
                case s:
                case c:
                case m:
                case h:
                case o:
                  return $;
                default:
                  return C;
              }
          }
        case n:
          return C;
      }
    }
  }
  function w($) {
    return x($) === u;
  }
  return Ce.AsyncMode = l, Ce.ConcurrentMode = u, Ce.ContextConsumer = s, Ce.ContextProvider = o, Ce.Element = t, Ce.ForwardRef = c, Ce.Fragment = r, Ce.Lazy = m, Ce.Memo = h, Ce.Portal = n, Ce.Profiler = a, Ce.StrictMode = i, Ce.Suspense = f, Ce.isAsyncMode = function($) {
    return w($) || x($) === l;
  }, Ce.isConcurrentMode = w, Ce.isContextConsumer = function($) {
    return x($) === s;
  }, Ce.isContextProvider = function($) {
    return x($) === o;
  }, Ce.isElement = function($) {
    return typeof $ == "object" && $ !== null && $.$$typeof === t;
  }, Ce.isForwardRef = function($) {
    return x($) === c;
  }, Ce.isFragment = function($) {
    return x($) === r;
  }, Ce.isLazy = function($) {
    return x($) === m;
  }, Ce.isMemo = function($) {
    return x($) === h;
  }, Ce.isPortal = function($) {
    return x($) === n;
  }, Ce.isProfiler = function($) {
    return x($) === a;
  }, Ce.isStrictMode = function($) {
    return x($) === i;
  }, Ce.isSuspense = function($) {
    return x($) === f;
  }, Ce.isValidElementType = function($) {
    return typeof $ == "string" || typeof $ == "function" || $ === r || $ === u || $ === a || $ === i || $ === f || $ === p || typeof $ == "object" && $ !== null && ($.$$typeof === m || $.$$typeof === h || $.$$typeof === o || $.$$typeof === s || $.$$typeof === c || $.$$typeof === g || $.$$typeof === b || $.$$typeof === y || $.$$typeof === v);
  }, Ce.typeOf = x, Ce;
}
var Se = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Od;
function x$() {
  return Od || (Od = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, h = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
    function x(V) {
      return typeof V == "string" || typeof V == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      V === r || V === u || V === a || V === i || V === f || V === p || typeof V == "object" && V !== null && (V.$$typeof === m || V.$$typeof === h || V.$$typeof === o || V.$$typeof === s || V.$$typeof === c || V.$$typeof === g || V.$$typeof === b || V.$$typeof === y || V.$$typeof === v);
    }
    function w(V) {
      if (typeof V == "object" && V !== null) {
        var le = V.$$typeof;
        switch (le) {
          case t:
            var ee = V.type;
            switch (ee) {
              case l:
              case u:
              case r:
              case a:
              case i:
              case f:
                return ee;
              default:
                var ye = ee && ee.$$typeof;
                switch (ye) {
                  case s:
                  case c:
                  case m:
                  case h:
                  case o:
                    return ye;
                  default:
                    return le;
                }
            }
          case n:
            return le;
        }
      }
    }
    var $ = l, C = u, T = s, S = o, N = t, k = c, L = r, _ = m, B = h, A = n, q = a, X = i, I = f, O = !1;
    function D(V) {
      return O || (O = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), E(V) || w(V) === l;
    }
    function E(V) {
      return w(V) === u;
    }
    function j(V) {
      return w(V) === s;
    }
    function F(V) {
      return w(V) === o;
    }
    function K(V) {
      return typeof V == "object" && V !== null && V.$$typeof === t;
    }
    function H(V) {
      return w(V) === c;
    }
    function W(V) {
      return w(V) === r;
    }
    function G(V) {
      return w(V) === m;
    }
    function z(V) {
      return w(V) === h;
    }
    function U(V) {
      return w(V) === n;
    }
    function J(V) {
      return w(V) === a;
    }
    function ne(V) {
      return w(V) === i;
    }
    function ae(V) {
      return w(V) === f;
    }
    Se.AsyncMode = $, Se.ConcurrentMode = C, Se.ContextConsumer = T, Se.ContextProvider = S, Se.Element = N, Se.ForwardRef = k, Se.Fragment = L, Se.Lazy = _, Se.Memo = B, Se.Portal = A, Se.Profiler = q, Se.StrictMode = X, Se.Suspense = I, Se.isAsyncMode = D, Se.isConcurrentMode = E, Se.isContextConsumer = j, Se.isContextProvider = F, Se.isElement = K, Se.isForwardRef = H, Se.isFragment = W, Se.isLazy = G, Se.isMemo = z, Se.isPortal = U, Se.isProfiler = J, Se.isStrictMode = ne, Se.isSuspense = ae, Se.isValidElementType = x, Se.typeOf = w;
  }()), Se;
}
var Td;
function mg() {
  return Td || (Td = 1, process.env.NODE_ENV === "production" ? Ni.exports = b$() : Ni.exports = x$()), Ni.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var wo, Pd;
function au() {
  if (Pd) return wo;
  Pd = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var o = {}, s = 0; s < 10; s++)
        o["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(o).map(function(c) {
        return o[c];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(c) {
        u[c] = c;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return wo = i() ? Object.assign : function(a, o) {
    for (var s, l = r(a), u, c = 1; c < arguments.length; c++) {
      s = Object(arguments[c]);
      for (var f in s)
        t.call(s, f) && (l[f] = s[f]);
      if (e) {
        u = e(s);
        for (var p = 0; p < u.length; p++)
          n.call(s, u[p]) && (l[u[p]] = s[u[p]]);
      }
    }
    return l;
  }, wo;
}
var Co, Nd;
function ou() {
  if (Nd) return Co;
  Nd = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Co = e, Co;
}
var So, _d;
function gg() {
  return _d || (_d = 1, So = Function.call.bind(Object.prototype.hasOwnProperty)), So;
}
var Io, Ad;
function $$() {
  if (Ad) return Io;
  Ad = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ ou(), n = {}, r = /* @__PURE__ */ gg();
    e = function(a) {
      var o = "Warning: " + a;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function i(a, o, s, l, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var c in a)
        if (r(a, c)) {
          var f;
          try {
            if (typeof a[c] != "function") {
              var p = Error(
                (l || "React class") + ": " + s + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            f = a[c](o, c, l, s, null, t);
          } catch (m) {
            f = m;
          }
          if (f && !(f instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var h = u ? u() : "";
            e(
              "Failed " + s + " type: " + f.message + (h ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Io = i, Io;
}
var Eo, Rd;
function w$() {
  if (Rd) return Eo;
  Rd = 1;
  var e = mg(), t = au(), n = /* @__PURE__ */ ou(), r = /* @__PURE__ */ gg(), i = /* @__PURE__ */ $$(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return Eo = function(s, l) {
    var u = typeof Symbol == "function" && Symbol.iterator, c = "@@iterator";
    function f(E) {
      var j = E && (u && E[u] || E[c]);
      if (typeof j == "function")
        return j;
    }
    var p = "<<anonymous>>", h = {
      array: b("array"),
      bigint: b("bigint"),
      bool: b("boolean"),
      func: b("function"),
      number: b("number"),
      object: b("object"),
      string: b("string"),
      symbol: b("symbol"),
      any: y(),
      arrayOf: x,
      element: w(),
      elementType: $(),
      instanceOf: C,
      node: k(),
      objectOf: S,
      oneOf: T,
      oneOfType: N,
      shape: _,
      exact: B
    };
    function m(E, j) {
      return E === j ? E !== 0 || 1 / E === 1 / j : E !== E && j !== j;
    }
    function v(E, j) {
      this.message = E, this.data = j && typeof j == "object" ? j : {}, this.stack = "";
    }
    v.prototype = Error.prototype;
    function g(E) {
      if (process.env.NODE_ENV !== "production")
        var j = {}, F = 0;
      function K(W, G, z, U, J, ne, ae) {
        if (U = U || p, ne = ne || z, ae !== n) {
          if (l) {
            var V = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw V.name = "Invariant Violation", V;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var le = U + ":" + z;
            !j[le] && // Avoid spamming the console because they are often not actionable except for lib authors
            F < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + ne + "` prop on `" + U + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), j[le] = !0, F++);
          }
        }
        return G[z] == null ? W ? G[z] === null ? new v("The " + J + " `" + ne + "` is marked as required " + ("in `" + U + "`, but its value is `null`.")) : new v("The " + J + " `" + ne + "` is marked as required in " + ("`" + U + "`, but its value is `undefined`.")) : null : E(G, z, U, J, ne);
      }
      var H = K.bind(null, !1);
      return H.isRequired = K.bind(null, !0), H;
    }
    function b(E) {
      function j(F, K, H, W, G, z) {
        var U = F[K], J = X(U);
        if (J !== E) {
          var ne = I(U);
          return new v(
            "Invalid " + W + " `" + G + "` of type " + ("`" + ne + "` supplied to `" + H + "`, expected ") + ("`" + E + "`."),
            { expectedType: E }
          );
        }
        return null;
      }
      return g(j);
    }
    function y() {
      return g(o);
    }
    function x(E) {
      function j(F, K, H, W, G) {
        if (typeof E != "function")
          return new v("Property `" + G + "` of component `" + H + "` has invalid PropType notation inside arrayOf.");
        var z = F[K];
        if (!Array.isArray(z)) {
          var U = X(z);
          return new v("Invalid " + W + " `" + G + "` of type " + ("`" + U + "` supplied to `" + H + "`, expected an array."));
        }
        for (var J = 0; J < z.length; J++) {
          var ne = E(z, J, H, W, G + "[" + J + "]", n);
          if (ne instanceof Error)
            return ne;
        }
        return null;
      }
      return g(j);
    }
    function w() {
      function E(j, F, K, H, W) {
        var G = j[F];
        if (!s(G)) {
          var z = X(G);
          return new v("Invalid " + H + " `" + W + "` of type " + ("`" + z + "` supplied to `" + K + "`, expected a single ReactElement."));
        }
        return null;
      }
      return g(E);
    }
    function $() {
      function E(j, F, K, H, W) {
        var G = j[F];
        if (!e.isValidElementType(G)) {
          var z = X(G);
          return new v("Invalid " + H + " `" + W + "` of type " + ("`" + z + "` supplied to `" + K + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return g(E);
    }
    function C(E) {
      function j(F, K, H, W, G) {
        if (!(F[K] instanceof E)) {
          var z = E.name || p, U = D(F[K]);
          return new v("Invalid " + W + " `" + G + "` of type " + ("`" + U + "` supplied to `" + H + "`, expected ") + ("instance of `" + z + "`."));
        }
        return null;
      }
      return g(j);
    }
    function T(E) {
      if (!Array.isArray(E))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), o;
      function j(F, K, H, W, G) {
        for (var z = F[K], U = 0; U < E.length; U++)
          if (m(z, E[U]))
            return null;
        var J = JSON.stringify(E, function(ae, V) {
          var le = I(V);
          return le === "symbol" ? String(V) : V;
        });
        return new v("Invalid " + W + " `" + G + "` of value `" + String(z) + "` " + ("supplied to `" + H + "`, expected one of " + J + "."));
      }
      return g(j);
    }
    function S(E) {
      function j(F, K, H, W, G) {
        if (typeof E != "function")
          return new v("Property `" + G + "` of component `" + H + "` has invalid PropType notation inside objectOf.");
        var z = F[K], U = X(z);
        if (U !== "object")
          return new v("Invalid " + W + " `" + G + "` of type " + ("`" + U + "` supplied to `" + H + "`, expected an object."));
        for (var J in z)
          if (r(z, J)) {
            var ne = E(z, J, H, W, G + "." + J, n);
            if (ne instanceof Error)
              return ne;
          }
        return null;
      }
      return g(j);
    }
    function N(E) {
      if (!Array.isArray(E))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var j = 0; j < E.length; j++) {
        var F = E[j];
        if (typeof F != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + O(F) + " at index " + j + "."
          ), o;
      }
      function K(H, W, G, z, U) {
        for (var J = [], ne = 0; ne < E.length; ne++) {
          var ae = E[ne], V = ae(H, W, G, z, U, n);
          if (V == null)
            return null;
          V.data && r(V.data, "expectedType") && J.push(V.data.expectedType);
        }
        var le = J.length > 0 ? ", expected one of type [" + J.join(", ") + "]" : "";
        return new v("Invalid " + z + " `" + U + "` supplied to " + ("`" + G + "`" + le + "."));
      }
      return g(K);
    }
    function k() {
      function E(j, F, K, H, W) {
        return A(j[F]) ? null : new v("Invalid " + H + " `" + W + "` supplied to " + ("`" + K + "`, expected a ReactNode."));
      }
      return g(E);
    }
    function L(E, j, F, K, H) {
      return new v(
        (E || "React class") + ": " + j + " type `" + F + "." + K + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + H + "`."
      );
    }
    function _(E) {
      function j(F, K, H, W, G) {
        var z = F[K], U = X(z);
        if (U !== "object")
          return new v("Invalid " + W + " `" + G + "` of type `" + U + "` " + ("supplied to `" + H + "`, expected `object`."));
        for (var J in E) {
          var ne = E[J];
          if (typeof ne != "function")
            return L(H, W, G, J, I(ne));
          var ae = ne(z, J, H, W, G + "." + J, n);
          if (ae)
            return ae;
        }
        return null;
      }
      return g(j);
    }
    function B(E) {
      function j(F, K, H, W, G) {
        var z = F[K], U = X(z);
        if (U !== "object")
          return new v("Invalid " + W + " `" + G + "` of type `" + U + "` " + ("supplied to `" + H + "`, expected `object`."));
        var J = t({}, F[K], E);
        for (var ne in J) {
          var ae = E[ne];
          if (r(E, ne) && typeof ae != "function")
            return L(H, W, G, ne, I(ae));
          if (!ae)
            return new v(
              "Invalid " + W + " `" + G + "` key `" + ne + "` supplied to `" + H + "`.\nBad object: " + JSON.stringify(F[K], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(E), null, "  ")
            );
          var V = ae(z, ne, H, W, G + "." + ne, n);
          if (V)
            return V;
        }
        return null;
      }
      return g(j);
    }
    function A(E) {
      switch (typeof E) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !E;
        case "object":
          if (Array.isArray(E))
            return E.every(A);
          if (E === null || s(E))
            return !0;
          var j = f(E);
          if (j) {
            var F = j.call(E), K;
            if (j !== E.entries) {
              for (; !(K = F.next()).done; )
                if (!A(K.value))
                  return !1;
            } else
              for (; !(K = F.next()).done; ) {
                var H = K.value;
                if (H && !A(H[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function q(E, j) {
      return E === "symbol" ? !0 : j ? j["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && j instanceof Symbol : !1;
    }
    function X(E) {
      var j = typeof E;
      return Array.isArray(E) ? "array" : E instanceof RegExp ? "object" : q(j, E) ? "symbol" : j;
    }
    function I(E) {
      if (typeof E > "u" || E === null)
        return "" + E;
      var j = X(E);
      if (j === "object") {
        if (E instanceof Date)
          return "date";
        if (E instanceof RegExp)
          return "regexp";
      }
      return j;
    }
    function O(E) {
      var j = I(E);
      switch (j) {
        case "array":
        case "object":
          return "an " + j;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + j;
        default:
          return j;
      }
    }
    function D(E) {
      return !E.constructor || !E.constructor.name ? p : E.constructor.name;
    }
    return h.checkPropTypes = i, h.resetWarningCache = i.resetWarningCache, h.PropTypes = h, h;
  }, Eo;
}
var Oo, Md;
function C$() {
  if (Md) return Oo;
  Md = 1;
  var e = /* @__PURE__ */ ou();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Oo = function() {
    function r(o, s, l, u, c, f) {
      if (f !== e) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var a = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, Oo;
}
var jd;
function S$() {
  if (jd) return Pi.exports;
  if (jd = 1, process.env.NODE_ENV !== "production") {
    var e = mg(), t = !0;
    Pi.exports = /* @__PURE__ */ w$()(e.isElement, t);
  } else
    Pi.exports = /* @__PURE__ */ C$()();
  return Pi.exports;
}
var I$ = /* @__PURE__ */ S$();
const R = /* @__PURE__ */ rn(I$);
var _i = { exports: {} }, Ie = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Dd;
function E$() {
  if (Dd) return Ie;
  Dd = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), m;
  m = Symbol.for("react.module.reference");
  function v(g) {
    if (typeof g == "object" && g !== null) {
      var b = g.$$typeof;
      switch (b) {
        case e:
          switch (g = g.type, g) {
            case n:
            case i:
            case r:
            case u:
            case c:
              return g;
            default:
              switch (g = g && g.$$typeof, g) {
                case s:
                case o:
                case l:
                case p:
                case f:
                case a:
                  return g;
                default:
                  return b;
              }
          }
        case t:
          return b;
      }
    }
  }
  return Ie.ContextConsumer = o, Ie.ContextProvider = a, Ie.Element = e, Ie.ForwardRef = l, Ie.Fragment = n, Ie.Lazy = p, Ie.Memo = f, Ie.Portal = t, Ie.Profiler = i, Ie.StrictMode = r, Ie.Suspense = u, Ie.SuspenseList = c, Ie.isAsyncMode = function() {
    return !1;
  }, Ie.isConcurrentMode = function() {
    return !1;
  }, Ie.isContextConsumer = function(g) {
    return v(g) === o;
  }, Ie.isContextProvider = function(g) {
    return v(g) === a;
  }, Ie.isElement = function(g) {
    return typeof g == "object" && g !== null && g.$$typeof === e;
  }, Ie.isForwardRef = function(g) {
    return v(g) === l;
  }, Ie.isFragment = function(g) {
    return v(g) === n;
  }, Ie.isLazy = function(g) {
    return v(g) === p;
  }, Ie.isMemo = function(g) {
    return v(g) === f;
  }, Ie.isPortal = function(g) {
    return v(g) === t;
  }, Ie.isProfiler = function(g) {
    return v(g) === i;
  }, Ie.isStrictMode = function(g) {
    return v(g) === r;
  }, Ie.isSuspense = function(g) {
    return v(g) === u;
  }, Ie.isSuspenseList = function(g) {
    return v(g) === c;
  }, Ie.isValidElementType = function(g) {
    return typeof g == "string" || typeof g == "function" || g === n || g === i || g === r || g === u || g === c || g === h || typeof g == "object" && g !== null && (g.$$typeof === p || g.$$typeof === f || g.$$typeof === a || g.$$typeof === o || g.$$typeof === l || g.$$typeof === m || g.getModuleId !== void 0);
  }, Ie.typeOf = v, Ie;
}
var Ee = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var kd;
function O$() {
  return kd || (kd = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), o = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), m = !1, v = !1, g = !1, b = !1, y = !1, x;
    x = Symbol.for("react.module.reference");
    function w(ee) {
      return !!(typeof ee == "string" || typeof ee == "function" || ee === n || ee === i || y || ee === r || ee === u || ee === c || b || ee === h || m || v || g || typeof ee == "object" && ee !== null && (ee.$$typeof === p || ee.$$typeof === f || ee.$$typeof === a || ee.$$typeof === o || ee.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      ee.$$typeof === x || ee.getModuleId !== void 0));
    }
    function $(ee) {
      if (typeof ee == "object" && ee !== null) {
        var ye = ee.$$typeof;
        switch (ye) {
          case e:
            var ve = ee.type;
            switch (ve) {
              case n:
              case i:
              case r:
              case u:
              case c:
                return ve;
              default:
                var Te = ve && ve.$$typeof;
                switch (Te) {
                  case s:
                  case o:
                  case l:
                  case p:
                  case f:
                  case a:
                    return Te;
                  default:
                    return ye;
                }
            }
          case t:
            return ye;
        }
      }
    }
    var C = o, T = a, S = e, N = l, k = n, L = p, _ = f, B = t, A = i, q = r, X = u, I = c, O = !1, D = !1;
    function E(ee) {
      return O || (O = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function j(ee) {
      return D || (D = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function F(ee) {
      return $(ee) === o;
    }
    function K(ee) {
      return $(ee) === a;
    }
    function H(ee) {
      return typeof ee == "object" && ee !== null && ee.$$typeof === e;
    }
    function W(ee) {
      return $(ee) === l;
    }
    function G(ee) {
      return $(ee) === n;
    }
    function z(ee) {
      return $(ee) === p;
    }
    function U(ee) {
      return $(ee) === f;
    }
    function J(ee) {
      return $(ee) === t;
    }
    function ne(ee) {
      return $(ee) === i;
    }
    function ae(ee) {
      return $(ee) === r;
    }
    function V(ee) {
      return $(ee) === u;
    }
    function le(ee) {
      return $(ee) === c;
    }
    Ee.ContextConsumer = C, Ee.ContextProvider = T, Ee.Element = S, Ee.ForwardRef = N, Ee.Fragment = k, Ee.Lazy = L, Ee.Memo = _, Ee.Portal = B, Ee.Profiler = A, Ee.StrictMode = q, Ee.Suspense = X, Ee.SuspenseList = I, Ee.isAsyncMode = E, Ee.isConcurrentMode = j, Ee.isContextConsumer = F, Ee.isContextProvider = K, Ee.isElement = H, Ee.isForwardRef = W, Ee.isFragment = G, Ee.isLazy = z, Ee.isMemo = U, Ee.isPortal = J, Ee.isProfiler = ne, Ee.isStrictMode = ae, Ee.isSuspense = V, Ee.isSuspenseList = le, Ee.isValidElementType = w, Ee.typeOf = $;
  }()), Ee;
}
var Ld;
function T$() {
  return Ld || (Ld = 1, process.env.NODE_ENV === "production" ? _i.exports = E$() : _i.exports = O$()), _i.exports;
}
var Fd = T$();
const Vd = (e) => typeof e == "object" && e != null && e.nodeType === 1, Bd = (e, t) => (!t || e !== "hidden") && e !== "visible" && e !== "clip", Ai = (e, t) => {
  if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
    const n = getComputedStyle(e, null);
    return Bd(n.overflowY, t) || Bd(n.overflowX, t) || ((r) => {
      const i = ((a) => {
        if (!a.ownerDocument || !a.ownerDocument.defaultView) return null;
        try {
          return a.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(r);
      return !!i && (i.clientHeight < r.scrollHeight || i.clientWidth < r.scrollWidth);
    })(e);
  }
  return !1;
}, Ri = (e, t, n, r, i, a, o, s) => a < e && o > t || a > e && o < t ? 0 : a <= e && s <= n || o >= t && s >= n ? a - e - r : o > t && s < n || a < e && s > n ? o - t + i : 0, P$ = (e) => {
  const t = e.parentElement;
  return t ?? (e.getRootNode().host || null);
}, N$ = (e, t) => {
  var n, r, i, a;
  if (typeof document > "u") return [];
  const { inline: o, boundary: s, skipOverflowHiddenElements: l } = t, u = typeof s == "function" ? s : (B) => B !== s;
  if (!Vd(e)) throw new TypeError("Invalid target");
  const c = document.scrollingElement || document.documentElement, f = [];
  let p = e;
  for (; Vd(p) && u(p); ) {
    if (p = P$(p), p === c) {
      f.push(p);
      break;
    }
    p != null && p === document.body && Ai(p) && !Ai(document.documentElement) || p != null && Ai(p, l) && f.push(p);
  }
  const h = (r = (n = window.visualViewport) == null ? void 0 : n.width) != null ? r : innerWidth, m = (a = (i = window.visualViewport) == null ? void 0 : i.height) != null ? a : innerHeight, { scrollX: v, scrollY: g } = window, { height: b, width: y, top: x, right: w, bottom: $, left: C } = e.getBoundingClientRect(), { top: T, right: S, left: N } = ((B) => {
    const A = window.getComputedStyle(B);
    return { top: parseFloat(A.scrollMarginTop) || 0, right: parseFloat(A.scrollMarginRight) || 0, bottom: parseFloat(A.scrollMarginBottom) || 0, left: parseFloat(A.scrollMarginLeft) || 0 };
  })(e);
  let k = x - T, L = o === "center" ? C + y / 2 - N + S : o === "end" ? w + S : C - N;
  const _ = [];
  for (let B = 0; B < f.length; B++) {
    const A = f[B], { height: q, width: X, top: I, right: O, bottom: D, left: E } = A.getBoundingClientRect();
    if (x >= 0 && C >= 0 && $ <= m && w <= h && (A === c && !Ai(A) || x >= I && $ <= D && C >= E && w <= O)) return _;
    const j = getComputedStyle(A), F = parseInt(j.borderLeftWidth, 10), K = parseInt(j.borderTopWidth, 10), H = parseInt(j.borderRightWidth, 10), W = parseInt(j.borderBottomWidth, 10);
    let G = 0, z = 0;
    const U = "offsetWidth" in A ? A.offsetWidth - A.clientWidth - F - H : 0, J = "offsetHeight" in A ? A.offsetHeight - A.clientHeight - K - W : 0, ne = "offsetWidth" in A ? A.offsetWidth === 0 ? 0 : X / A.offsetWidth : 0, ae = "offsetHeight" in A ? A.offsetHeight === 0 ? 0 : q / A.offsetHeight : 0;
    if (c === A) G = Ri(g, g + m, m, K, W, g + k, g + k + b, b), z = o === "start" ? L : o === "center" ? L - h / 2 : o === "end" ? L - h : Ri(v, v + h, h, F, H, v + L, v + L + y, y), G = Math.max(0, G + g), z = Math.max(0, z + v);
    else {
      G = Ri(I, D, q, K, W + J, k, k + b, b), z = o === "start" ? L - E - F : o === "center" ? L - (E + X / 2) + U / 2 : o === "end" ? L - O + H + U : Ri(E, O, X, F, H + U, L, L + y, y);
      const { scrollLeft: V, scrollTop: le } = A;
      G = ae === 0 ? 0 : Math.max(0, Math.min(le + G / ae, A.scrollHeight - q / ae + J)), z = ne === 0 ? 0 : Math.max(0, Math.min(V + z / ne, A.scrollWidth - X / ne + U)), k += le - G, L += V - z;
    }
    _.push({ el: A, top: G, left: z });
  }
  return _;
};
var or = function() {
  return or = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, or.apply(this, arguments);
};
var _$ = 0;
function Hd(e) {
  return typeof e == "function" ? e : lt;
}
function lt() {
}
function vg(e, t) {
  if (e) {
    var n = N$(e, {
      boundary: t
    });
    n.forEach(function(r) {
      var i = r.el, a = r.top, o = r.left;
      i.scrollTop = a, i.scrollLeft = o;
    });
  }
}
function Kd(e, t, n) {
  var r = e === t || t instanceof n.Node && e.contains && e.contains(t);
  return r;
}
function La(e, t) {
  var n;
  function r() {
    n && clearTimeout(n);
  }
  function i() {
    for (var a = arguments.length, o = new Array(a), s = 0; s < a; s++)
      o[s] = arguments[s];
    r(), n = setTimeout(function() {
      n = null, e.apply(void 0, o);
    }, t);
  }
  return i.cancel = r, i;
}
function _e() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    for (var i = arguments.length, a = new Array(i > 1 ? i - 1 : 0), o = 1; o < i; o++)
      a[o - 1] = arguments[o];
    return t.some(function(s) {
      return s && s.apply(void 0, [r].concat(a)), r.preventDownshiftDefault || r.hasOwnProperty("nativeEvent") && r.nativeEvent.preventDownshiftDefault;
    });
  };
}
function Gt() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    t.forEach(function(i) {
      typeof i == "function" ? i(r) : i && (i.current = r);
    });
  };
}
function yg() {
  return String(_$++);
}
function A$(e) {
  var t = e.isOpen, n = e.resultCount, r = e.previousResultCount;
  return t ? n ? n !== r ? n + " result" + (n === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select." : "" : "No results are available." : "";
}
function Wd(e, t) {
  return e = Array.isArray(e) ? (
    /* istanbul ignore next (preact) */
    e[0]
  ) : e, !e && t ? t : e;
}
function bg(e) {
  return typeof e.type == "string";
}
function xg(e) {
  return e.props;
}
function R$(e, t) {
  console.error('The property "' + t + '" is required in "' + e + '"');
}
var M$ = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
function Mi(e) {
  e === void 0 && (e = {});
  var t = {};
  return M$.forEach(function(n) {
    e.hasOwnProperty(n) && (t[n] = e[n]);
  }), t;
}
function Jr(e, t) {
  return !e || !t ? e : Object.keys(e).reduce(function(n, r) {
    return n[r] = ia(t, r) ? t[r] : e[r], n;
  }, {});
}
function ia(e, t) {
  return e[t] !== void 0;
}
function aa(e) {
  var t = e.key, n = e.keyCode;
  return n >= 37 && n <= 40 && t.indexOf("Arrow") !== 0 ? "Arrow" + t : t;
}
function j$(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Et(e, t, n, r, i) {
  i === void 0 && (i = !1);
  var a = n.length;
  if (a === 0)
    return -1;
  var o = a - 1;
  (typeof e != "number" || e < 0 || e > o) && (e = t > 0 ? -1 : o + 1);
  var s = e + t;
  s < 0 ? s = i ? o : 0 : s > o && (s = i ? 0 : o);
  var l = mn(s, t < 0, n, r, i);
  return l === -1 ? e >= a ? -1 : e : l;
}
function mn(e, t, n, r, i) {
  i === void 0 && (i = !1);
  var a = n.length;
  if (t) {
    for (var o = e; o >= 0; o--)
      if (!r(n[o], o))
        return o;
  } else
    for (var s = e; s < a; s++)
      if (!r(n[s], s))
        return s;
  return i ? mn(t ? a - 1 : 0, t, n, r) : -1;
}
function oa(e, t, n, r) {
  return r === void 0 && (r = !0), n && t.some(function(i) {
    return i && (Kd(i, e, n) || r && Kd(i, n.document.activeElement, n));
  });
}
var su = lt;
process.env.NODE_ENV !== "production" && (su = function(t, n, r) {
  var i = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
  Object.keys(t).forEach(function(a) {
    n[a] !== void 0 && r[a] === void 0 ? console.error('downshift: A component has changed the controlled prop "' + a + '" to be uncontrolled. ' + i) : n[a] === void 0 && r[a] !== void 0 && console.error('downshift: A component has changed the uncontrolled prop "' + a + '" to be controlled. ' + i);
  });
});
var D$ = La(function(e) {
  $g(e).textContent = "";
}, 500);
function $g(e) {
  var t = e.getElementById("a11y-status-message");
  return t || (t = e.createElement("div"), t.setAttribute("id", "a11y-status-message"), t.setAttribute("role", "status"), t.setAttribute("aria-live", "polite"), t.setAttribute("aria-relevant", "additions text"), Object.assign(t.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  }), e.body.appendChild(t), t);
}
function wg(e, t) {
  if (!(!e || !t)) {
    var n = $g(t);
    n.textContent = e, D$(t);
  }
}
function k$(e) {
  var t = e == null ? void 0 : e.getElementById("a11y-status-message");
  t && t.remove();
}
var Cg = process.env.NODE_ENV !== "production" ? "__autocomplete_unknown__" : 0, Sg = process.env.NODE_ENV !== "production" ? "__autocomplete_mouseup__" : 1, Ig = process.env.NODE_ENV !== "production" ? "__autocomplete_item_mouseenter__" : 2, Ui = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_up__" : 3, qi = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_down__" : 4, Eg = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_escape__" : 5, Og = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_enter__" : 6, Tg = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_home__" : 7, Pg = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_end__" : 8, Ng = process.env.NODE_ENV !== "production" ? "__autocomplete_click_item__" : 9, _g = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_input__" : 10, Ag = process.env.NODE_ENV !== "production" ? "__autocomplete_change_input__" : 11, Rg = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_space_button__" : 12, Os = process.env.NODE_ENV !== "production" ? "__autocomplete_click_button__" : 13, Mg = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_button__" : 14, jg = process.env.NODE_ENV !== "production" ? "__autocomplete_controlled_prop_updated_selected_item__" : 15, Dg = process.env.NODE_ENV !== "production" ? "__autocomplete_touchend__" : 16, L$ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blurButton: Mg,
  blurInput: _g,
  changeInput: Ag,
  clickButton: Os,
  clickItem: Ng,
  controlledPropUpdatedSelectedItem: jg,
  itemMouseEnter: Ig,
  keyDownArrowDown: qi,
  keyDownArrowUp: Ui,
  keyDownEnd: Pg,
  keyDownEnter: Og,
  keyDownEscape: Eg,
  keyDownHome: Tg,
  keyDownSpaceButton: Rg,
  mouseUp: Sg,
  touchEnd: Dg,
  unknown: Cg
}), F$ = ["refKey", "ref"], V$ = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"], B$ = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"], H$ = ["refKey", "ref"], K$ = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"], W$ = /* @__PURE__ */ function() {
  var e = /* @__PURE__ */ function(t) {
    function n(i) {
      var a;
      a = t.call(this, i) || this, a.id = a.props.id || "downshift-" + yg(), a.menuId = a.props.menuId || a.id + "-menu", a.labelId = a.props.labelId || a.id + "-label", a.inputId = a.props.inputId || a.id + "-input", a.getItemId = a.props.getItemId || function(y) {
        return a.id + "-item-" + y;
      }, a.items = [], a.itemCount = null, a.previousResultCount = 0, a.timeoutIds = [], a.internalSetTimeout = function(y, x) {
        var w = setTimeout(function() {
          a.timeoutIds = a.timeoutIds.filter(function($) {
            return $ !== w;
          }), y();
        }, x);
        a.timeoutIds.push(w);
      }, a.setItemCount = function(y) {
        a.itemCount = y;
      }, a.unsetItemCount = function() {
        a.itemCount = null;
      }, a.isItemDisabled = function(y, x) {
        var w = a.getItemNodeFromIndex(x);
        return w && w.hasAttribute("disabled");
      }, a.setHighlightedIndex = function(y, x) {
        y === void 0 && (y = a.props.defaultHighlightedIndex), x === void 0 && (x = {}), x = Mi(x), a.internalSetState(me({
          highlightedIndex: y
        }, x));
      }, a.clearSelection = function(y) {
        a.internalSetState({
          selectedItem: null,
          inputValue: "",
          highlightedIndex: a.props.defaultHighlightedIndex,
          isOpen: a.props.defaultIsOpen
        }, y);
      }, a.selectItem = function(y, x, w) {
        x = Mi(x), a.internalSetState(me({
          isOpen: a.props.defaultIsOpen,
          highlightedIndex: a.props.defaultHighlightedIndex,
          selectedItem: y,
          inputValue: a.props.itemToString(y)
        }, x), w);
      }, a.selectItemAtIndex = function(y, x, w) {
        var $ = a.items[y];
        $ != null && a.selectItem($, x, w);
      }, a.selectHighlightedItem = function(y, x) {
        return a.selectItemAtIndex(a.getState().highlightedIndex, y, x);
      }, a.internalSetState = function(y, x) {
        var w, $, C = {}, T = typeof y == "function";
        return !T && y.hasOwnProperty("inputValue") && a.props.onInputValueChange(y.inputValue, me({}, a.getStateAndHelpers(), y)), a.setState(function(S) {
          var N;
          S = a.getState(S);
          var k = T ? y(S) : y;
          k = a.props.stateReducer(S, k), w = k.hasOwnProperty("selectedItem");
          var L = {};
          return w && k.selectedItem !== S.selectedItem && ($ = k.selectedItem), (N = k).type || (N.type = Cg), Object.keys(k).forEach(function(_) {
            S[_] !== k[_] && (C[_] = k[_]), _ !== "type" && (k[_], ia(a.props, _) || (L[_] = k[_]));
          }), T && k.hasOwnProperty("inputValue") && a.props.onInputValueChange(k.inputValue, me({}, a.getStateAndHelpers(), k)), L;
        }, function() {
          Hd(x)();
          var S = Object.keys(C).length > 1;
          S && a.props.onStateChange(C, a.getStateAndHelpers()), w && a.props.onSelect(y.selectedItem, a.getStateAndHelpers()), $ !== void 0 && a.props.onChange($, a.getStateAndHelpers()), a.props.onUserAction(C, a.getStateAndHelpers());
        });
      }, a.rootRef = function(y) {
        return a._rootNode = y;
      }, a.getRootProps = function(y, x) {
        var w, $ = y === void 0 ? {} : y, C = $.refKey, T = C === void 0 ? "ref" : C, S = $.ref, N = ct($, F$), k = x === void 0 ? {} : x, L = k.suppressRefError, _ = L === void 0 ? !1 : L;
        a.getRootProps.called = !0, a.getRootProps.refKey = T, a.getRootProps.suppressRefError = _;
        var B = a.getState(), A = B.isOpen;
        return me((w = {}, w[T] = Gt(S, a.rootRef), w.role = "combobox", w["aria-expanded"] = A, w["aria-haspopup"] = "listbox", w["aria-owns"] = A ? a.menuId : void 0, w["aria-labelledby"] = a.labelId, w), N);
      }, a.keyDownHandlers = {
        ArrowDown: function(x) {
          var w = this;
          if (x.preventDefault(), this.getState().isOpen) {
            var $ = x.shiftKey ? 5 : 1;
            this.moveHighlightedIndex($, {
              type: qi
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: qi
            }, function() {
              var C = w.getItemCount();
              if (C > 0) {
                var T = w.getState(), S = T.highlightedIndex, N = Et(S, 1, {
                  length: C
                }, w.isItemDisabled, !0);
                w.setHighlightedIndex(N, {
                  type: qi
                });
              }
            });
        },
        ArrowUp: function(x) {
          var w = this;
          if (x.preventDefault(), this.getState().isOpen) {
            var $ = x.shiftKey ? -5 : -1;
            this.moveHighlightedIndex($, {
              type: Ui
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: Ui
            }, function() {
              var C = w.getItemCount();
              if (C > 0) {
                var T = w.getState(), S = T.highlightedIndex, N = Et(S, -1, {
                  length: C
                }, w.isItemDisabled, !0);
                w.setHighlightedIndex(N, {
                  type: Ui
                });
              }
            });
        },
        Enter: function(x) {
          if (x.which !== 229) {
            var w = this.getState(), $ = w.isOpen, C = w.highlightedIndex;
            if ($ && C != null) {
              x.preventDefault();
              var T = this.items[C], S = this.getItemNodeFromIndex(C);
              if (T == null || S && S.hasAttribute("disabled"))
                return;
              this.selectHighlightedItem({
                type: Og
              });
            }
          }
        },
        Escape: function(x) {
          x.preventDefault(), this.reset(me({
            type: Eg
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ""
          }));
        }
      }, a.buttonKeyDownHandlers = me({}, a.keyDownHandlers, {
        " ": function(x) {
          x.preventDefault(), this.toggleMenu({
            type: Rg
          });
        }
      }), a.inputKeyDownHandlers = me({}, a.keyDownHandlers, {
        Home: function(x) {
          var w = this.getState(), $ = w.isOpen;
          if ($) {
            x.preventDefault();
            var C = this.getItemCount();
            if (!(C <= 0 || !$)) {
              var T = mn(0, !1, {
                length: C
              }, this.isItemDisabled);
              this.setHighlightedIndex(T, {
                type: Tg
              });
            }
          }
        },
        End: function(x) {
          var w = this.getState(), $ = w.isOpen;
          if ($) {
            x.preventDefault();
            var C = this.getItemCount();
            if (!(C <= 0 || !$)) {
              var T = mn(C - 1, !0, {
                length: C
              }, this.isItemDisabled);
              this.setHighlightedIndex(T, {
                type: Pg
              });
            }
          }
        }
      }), a.getToggleButtonProps = function(y) {
        var x = y === void 0 ? {} : y, w = x.onClick;
        x.onPress;
        var $ = x.onKeyDown, C = x.onKeyUp, T = x.onBlur, S = ct(x, V$), N = a.getState(), k = N.isOpen, L = {
          onClick: _e(w, a.buttonHandleClick),
          onKeyDown: _e($, a.buttonHandleKeyDown),
          onKeyUp: _e(C, a.buttonHandleKeyUp),
          onBlur: _e(T, a.buttonHandleBlur)
        }, _ = S.disabled ? {} : L;
        return me({
          type: "button",
          role: "button",
          "aria-label": k ? "close menu" : "open menu",
          "aria-haspopup": !0,
          "data-toggle": !0
        }, _, S);
      }, a.buttonHandleKeyUp = function(y) {
        y.preventDefault();
      }, a.buttonHandleKeyDown = function(y) {
        var x = aa(y);
        a.buttonKeyDownHandlers[x] && a.buttonKeyDownHandlers[x].call(a, y);
      }, a.buttonHandleClick = function(y) {
        if (y.preventDefault(), a.props.environment) {
          var x = a.props.environment.document, w = x.body, $ = x.activeElement;
          w && w === $ && y.target.focus();
        }
        process.env.NODE_ENV === "test" ? a.toggleMenu({
          type: Os
        }) : a.internalSetTimeout(function() {
          return a.toggleMenu({
            type: Os
          });
        });
      }, a.buttonHandleBlur = function(y) {
        var x = y.target;
        a.internalSetTimeout(function() {
          if (!(a.isMouseDown || !a.props.environment)) {
            var w = a.props.environment.document.activeElement;
            (w == null || w.id !== a.inputId) && w !== x && a.reset({
              type: Mg
            });
          }
        });
      }, a.getLabelProps = function(y) {
        return me({
          htmlFor: a.inputId,
          id: a.labelId
        }, y);
      }, a.getInputProps = function(y) {
        var x = y === void 0 ? {} : y, w = x.onKeyDown, $ = x.onBlur, C = x.onChange, T = x.onInput;
        x.onChangeText;
        var S = ct(x, B$), N, k = {};
        N = "onChange";
        var L = a.getState(), _ = L.inputValue, B = L.isOpen, A = L.highlightedIndex;
        if (!S.disabled) {
          var q;
          k = (q = {}, q[N] = _e(C, T, a.inputHandleChange), q.onKeyDown = _e(w, a.inputHandleKeyDown), q.onBlur = _e($, a.inputHandleBlur), q);
        }
        return me({
          "aria-autocomplete": "list",
          "aria-activedescendant": B && typeof A == "number" && A >= 0 ? a.getItemId(A) : void 0,
          "aria-controls": B ? a.menuId : void 0,
          "aria-labelledby": S && S["aria-label"] ? void 0 : a.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: "off",
          value: _,
          id: a.inputId
        }, k, S);
      }, a.inputHandleKeyDown = function(y) {
        var x = aa(y);
        x && a.inputKeyDownHandlers[x] && a.inputKeyDownHandlers[x].call(a, y);
      }, a.inputHandleChange = function(y) {
        a.internalSetState({
          type: Ag,
          isOpen: !0,
          inputValue: y.target.value,
          highlightedIndex: a.props.defaultHighlightedIndex
        });
      }, a.inputHandleBlur = function() {
        a.internalSetTimeout(function() {
          var y;
          if (!(a.isMouseDown || !a.props.environment)) {
            var x = a.props.environment.document.activeElement, w = (x == null || (y = x.dataset) == null ? void 0 : y.toggle) && a._rootNode && a._rootNode.contains(x);
            w || a.reset({
              type: _g
            });
          }
        });
      }, a.menuRef = function(y) {
        a._menuNode = y;
      }, a.getMenuProps = function(y, x) {
        var w, $ = y === void 0 ? {} : y, C = $.refKey, T = C === void 0 ? "ref" : C, S = $.ref, N = ct($, H$), k = x === void 0 ? {} : x, L = k.suppressRefError, _ = L === void 0 ? !1 : L;
        return a.getMenuProps.called = !0, a.getMenuProps.refKey = T, a.getMenuProps.suppressRefError = _, me((w = {}, w[T] = Gt(S, a.menuRef), w.role = "listbox", w["aria-labelledby"] = N && N["aria-label"] ? void 0 : a.labelId, w.id = a.menuId, w), N);
      }, a.getItemProps = function(y) {
        var x, w = y === void 0 ? {} : y, $ = w.onMouseMove, C = w.onMouseDown, T = w.onClick;
        w.onPress;
        var S = w.index, N = w.item, k = N === void 0 ? process.env.NODE_ENV === "production" ? (
          /* istanbul ignore next */
          void 0
        ) : R$("getItemProps", "item") : N, L = ct(w, K$);
        S === void 0 ? (a.items.push(k), S = a.items.indexOf(k)) : a.items[S] = k;
        var _ = "onClick", B = T, A = (x = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: _e($, function() {
            S !== a.getState().highlightedIndex && (a.setHighlightedIndex(S, {
              type: Ig
            }), a.avoidScrolling = !0, a.internalSetTimeout(function() {
              return a.avoidScrolling = !1;
            }, 250));
          }),
          onMouseDown: _e(C, function(X) {
            X.preventDefault();
          })
        }, x[_] = _e(B, function() {
          a.selectItemAtIndex(S, {
            type: Ng
          });
        }), x), q = L.disabled ? {
          onMouseDown: A.onMouseDown
        } : A;
        return me({
          id: a.getItemId(S),
          role: "option",
          "aria-selected": a.getState().highlightedIndex === S
        }, q, L);
      }, a.clearItems = function() {
        a.items = [];
      }, a.reset = function(y, x) {
        y === void 0 && (y = {}), y = Mi(y), a.internalSetState(function(w) {
          var $ = w.selectedItem;
          return me({
            isOpen: a.props.defaultIsOpen,
            highlightedIndex: a.props.defaultHighlightedIndex,
            inputValue: a.props.itemToString($)
          }, y);
        }, x);
      }, a.toggleMenu = function(y, x) {
        y === void 0 && (y = {}), y = Mi(y), a.internalSetState(function(w) {
          var $ = w.isOpen;
          return me({
            isOpen: !$
          }, $ && {
            highlightedIndex: a.props.defaultHighlightedIndex
          }, y);
        }, function() {
          var w = a.getState(), $ = w.isOpen, C = w.highlightedIndex;
          $ && a.getItemCount() > 0 && typeof C == "number" && a.setHighlightedIndex(C, y), Hd(x)();
        });
      }, a.openMenu = function(y) {
        a.internalSetState({
          isOpen: !0
        }, y);
      }, a.closeMenu = function(y) {
        a.internalSetState({
          isOpen: !1
        }, y);
      }, a.updateStatus = La(function() {
        var y;
        if ((y = a.props) != null && (y = y.environment) != null && y.document) {
          var x = a.getState(), w = a.items[x.highlightedIndex], $ = a.getItemCount(), C = a.props.getA11yStatusMessage(me({
            itemToString: a.props.itemToString,
            previousResultCount: a.previousResultCount,
            resultCount: $,
            highlightedItem: w
          }, x));
          a.previousResultCount = $, wg(C, a.props.environment.document);
        }
      }, 200);
      var o = a.props, s = o.defaultHighlightedIndex, l = o.initialHighlightedIndex, u = l === void 0 ? s : l, c = o.defaultIsOpen, f = o.initialIsOpen, p = f === void 0 ? c : f, h = o.initialInputValue, m = h === void 0 ? "" : h, v = o.initialSelectedItem, g = v === void 0 ? null : v, b = a.getState({
        highlightedIndex: u,
        isOpen: p,
        inputValue: m,
        selectedItem: g
      });
      return b.selectedItem != null && a.props.initialInputValue === void 0 && (b.inputValue = a.props.itemToString(b.selectedItem)), a.state = b, a;
    }
    y$(n, t);
    var r = n.prototype;
    return r.internalClearTimeouts = function() {
      this.timeoutIds.forEach(function(a) {
        clearTimeout(a);
      }), this.timeoutIds = [];
    }, r.getState = function(a) {
      return a === void 0 && (a = this.state), Jr(a, this.props);
    }, r.getItemCount = function() {
      var a = this.items.length;
      return this.itemCount != null ? a = this.itemCount : this.props.itemCount !== void 0 && (a = this.props.itemCount), a;
    }, r.getItemNodeFromIndex = function(a) {
      return this.props.environment ? this.props.environment.document.getElementById(this.getItemId(a)) : null;
    }, r.scrollHighlightedItemIntoView = function() {
      {
        var a = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(a, this._menuNode);
      }
    }, r.moveHighlightedIndex = function(a, o) {
      var s = this.getItemCount(), l = this.getState(), u = l.highlightedIndex;
      if (s > 0) {
        var c = Et(u, a, {
          length: s
        }, this.isItemDisabled, !0);
        this.setHighlightedIndex(c, o);
      }
    }, r.getStateAndHelpers = function() {
      var a = this.getState(), o = a.highlightedIndex, s = a.inputValue, l = a.selectedItem, u = a.isOpen, c = this.props.itemToString, f = this.id, p = this.getRootProps, h = this.getToggleButtonProps, m = this.getLabelProps, v = this.getMenuProps, g = this.getInputProps, b = this.getItemProps, y = this.openMenu, x = this.closeMenu, w = this.toggleMenu, $ = this.selectItem, C = this.selectItemAtIndex, T = this.selectHighlightedItem, S = this.setHighlightedIndex, N = this.clearSelection, k = this.clearItems, L = this.reset, _ = this.setItemCount, B = this.unsetItemCount, A = this.internalSetState;
      return {
        // prop getters
        getRootProps: p,
        getToggleButtonProps: h,
        getLabelProps: m,
        getMenuProps: v,
        getInputProps: g,
        getItemProps: b,
        // actions
        reset: L,
        openMenu: y,
        closeMenu: x,
        toggleMenu: w,
        selectItem: $,
        selectItemAtIndex: C,
        selectHighlightedItem: T,
        setHighlightedIndex: S,
        clearSelection: N,
        clearItems: k,
        setItemCount: _,
        unsetItemCount: B,
        setState: A,
        // props
        itemToString: c,
        // derived
        id: f,
        // state
        highlightedIndex: o,
        inputValue: s,
        isOpen: u,
        selectedItem: l
      };
    }, r.componentDidMount = function() {
      var a = this;
      if (process.env.NODE_ENV !== "production" && this.getMenuProps.called && !this.getMenuProps.suppressRefError && zd(this._menuNode, this.getMenuProps), !this.props.environment)
        this.cleanup = function() {
          a.internalClearTimeouts();
        };
      else {
        var o = function() {
          a.isMouseDown = !0;
        }, s = function(h) {
          a.isMouseDown = !1;
          var m = oa(h.target, [a._rootNode, a._menuNode], a.props.environment);
          !m && a.getState().isOpen && a.reset({
            type: Sg
          }, function() {
            return a.props.onOuterClick(a.getStateAndHelpers());
          });
        }, l = function() {
          a.isTouchMove = !1;
        }, u = function() {
          a.isTouchMove = !0;
        }, c = function(h) {
          var m = oa(h.target, [a._rootNode, a._menuNode], a.props.environment, !1);
          !a.isTouchMove && !m && a.getState().isOpen && a.reset({
            type: Dg
          }, function() {
            return a.props.onOuterClick(a.getStateAndHelpers());
          });
        }, f = this.props.environment;
        f.addEventListener("mousedown", o), f.addEventListener("mouseup", s), f.addEventListener("touchstart", l), f.addEventListener("touchmove", u), f.addEventListener("touchend", c), this.cleanup = function() {
          a.internalClearTimeouts(), a.updateStatus.cancel(), f.removeEventListener("mousedown", o), f.removeEventListener("mouseup", s), f.removeEventListener("touchstart", l), f.removeEventListener("touchmove", u), f.removeEventListener("touchend", c);
        };
      }
    }, r.shouldScroll = function(a, o) {
      var s = this.props.highlightedIndex === void 0 ? this.getState() : this.props, l = s.highlightedIndex, u = o.highlightedIndex === void 0 ? a : o, c = u.highlightedIndex, f = l && this.getState().isOpen && !a.isOpen, p = l !== c;
      return f || p;
    }, r.componentDidUpdate = function(a, o) {
      process.env.NODE_ENV !== "production" && (su(this.state, a, this.props), this.getMenuProps.called && !this.getMenuProps.suppressRefError && zd(this._menuNode, this.getMenuProps)), ia(this.props, "selectedItem") && this.props.selectedItemChanged(a.selectedItem, this.props.selectedItem) && this.internalSetState({
        type: jg,
        inputValue: this.props.itemToString(this.props.selectedItem)
      }), !this.avoidScrolling && this.shouldScroll(o, a) && this.scrollHighlightedItemIntoView(), this.updateStatus();
    }, r.componentWillUnmount = function() {
      this.cleanup();
    }, r.render = function() {
      var a = Wd(this.props.children, lt);
      this.clearItems(), this.getRootProps.called = !1, this.getRootProps.refKey = void 0, this.getRootProps.suppressRefError = void 0, this.getMenuProps.called = !1, this.getMenuProps.refKey = void 0, this.getMenuProps.suppressRefError = void 0, this.getLabelProps.called = !1, this.getInputProps.called = !1;
      var o = Wd(a(this.getStateAndHelpers()));
      if (!o)
        return null;
      if (this.getRootProps.called || this.props.suppressRefError)
        return process.env.NODE_ENV !== "production" && !this.getRootProps.suppressRefError && !this.props.suppressRefError && z$(o, this.getRootProps), o;
      if (bg(o))
        return /* @__PURE__ */ _a(o, this.getRootProps(xg(o)));
      if (process.env.NODE_ENV !== "production")
        throw new Error("downshift: If you return a non-DOM element, you must apply the getRootProps function");
    }, n;
  }(xl);
  return e.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: !1,
    getA11yStatusMessage: A$,
    itemToString: function(n) {
      return n == null ? "" : (process.env.NODE_ENV !== "production" && j$(n) && !n.hasOwnProperty("toString") && console.warn("downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.", "The object that was passed:", n), String(n));
    },
    onStateChange: lt,
    onInputValueChange: lt,
    onUserAction: lt,
    onChange: lt,
    onSelect: lt,
    onOuterClick: lt,
    selectedItemChanged: function(n, r) {
      return n !== r;
    },
    environment: (
      /* istanbul ignore next (ssr) */
      typeof window > "u" ? void 0 : window
    ),
    stateReducer: function(n, r) {
      return r;
    },
    suppressRefError: !1,
    scrollIntoView: vg
  }, e.stateChangeTypes = L$, e;
}();
process.env.NODE_ENV !== "production" && (W$.propTypes = {
  children: R.func,
  defaultHighlightedIndex: R.number,
  defaultIsOpen: R.bool,
  initialHighlightedIndex: R.number,
  initialSelectedItem: R.any,
  initialInputValue: R.string,
  initialIsOpen: R.bool,
  getA11yStatusMessage: R.func,
  itemToString: R.func,
  onChange: R.func,
  onSelect: R.func,
  onStateChange: R.func,
  onInputValueChange: R.func,
  onUserAction: R.func,
  onOuterClick: R.func,
  selectedItemChanged: R.func,
  stateReducer: R.func,
  itemCount: R.number,
  id: R.string,
  environment: R.shape({
    addEventListener: R.func.isRequired,
    removeEventListener: R.func.isRequired,
    document: R.shape({
      createElement: R.func.isRequired,
      getElementById: R.func.isRequired,
      activeElement: R.any.isRequired,
      body: R.any.isRequired
    }).isRequired,
    Node: R.func.isRequired
  }),
  suppressRefError: R.bool,
  scrollIntoView: R.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components
  /* eslint-disable react/no-unused-prop-types */
  selectedItem: R.any,
  isOpen: R.bool,
  inputValue: R.string,
  highlightedIndex: R.number,
  labelId: R.string,
  inputId: R.string,
  menuId: R.string,
  getItemId: R.func
  /* eslint-enable react/no-unused-prop-types */
});
function zd(e, t) {
  var n = t.refKey;
  e || console.error('downshift: The ref prop "' + n + '" from getMenuProps was not applied correctly on your menu element.');
}
function z$(e, t) {
  var n = t.refKey, r = n !== "ref", i = !bg(e);
  i && !r && !Fd.isForwardRef(e) ? console.error("downshift: You returned a non-DOM element. You must specify a refKey in getRootProps") : !i && r && console.error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + n + '"'), !Fd.isForwardRef(e) && !xg(e)[n] && console.error('downshift: You must apply the ref prop "' + n + '" from getRootProps onto your root element.');
}
var kg = {
  highlightedIndex: -1,
  isOpen: !1,
  selectedItem: null,
  inputValue: ""
};
function G$(e, t, n) {
  var r = e.props, i = e.type, a = {};
  Object.keys(t).forEach(function(o) {
    U$(o, e, t, n), n[o] !== t[o] && (a[o] = n[o]);
  }), r.onStateChange && Object.keys(a).length && r.onStateChange(me({
    type: i
  }, a));
}
function U$(e, t, n, r) {
  var i = t.props, a = t.type, o = "on" + lu(e) + "Change";
  i[o] && r[e] !== void 0 && r[e] !== n[e] && i[o](me({
    type: a
  }, r));
}
function q$(e, t) {
  return t.changes;
}
var Gd = La(function(e, t) {
  wg(e, t);
}, 200), Y$ = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? Na : se, Lg = "useId" in te ? function(t) {
  var n = t.id, r = t.labelId, i = t.menuId, a = t.getItemId, o = t.toggleButtonId, s = t.inputId, l = "downshift-" + te.useId();
  n || (n = l);
  var u = ce({
    labelId: r || n + "-label",
    menuId: i || n + "-menu",
    getItemId: a || function(c) {
      return n + "-item-" + c;
    },
    toggleButtonId: o || n + "-toggle-button",
    inputId: s || n + "-input"
  });
  return u.current;
} : function(t) {
  var n = t.id, r = n === void 0 ? "downshift-" + yg() : n, i = t.labelId, a = t.menuId, o = t.getItemId, s = t.toggleButtonId, l = t.inputId, u = ce({
    labelId: i || r + "-label",
    menuId: a || r + "-menu",
    getItemId: o || function(c) {
      return r + "-item-" + c;
    },
    toggleButtonId: s || r + "-toggle-button",
    inputId: l || r + "-input"
  });
  return u.current;
};
function Fg(e, t, n, r) {
  var i, a;
  if (e === void 0) {
    if (t === void 0)
      throw new Error(r);
    i = n[t], a = t;
  } else
    a = t === void 0 ? n.indexOf(e) : t, i = e;
  return [i, a];
}
function X$(e) {
  return /^\S{1}$/.test(e);
}
function lu(e) {
  return "" + e.slice(0, 1).toUpperCase() + e.slice(1);
}
function uu(e) {
  var t = ce(e);
  return t.current = e, t;
}
function Vg(e, t, n, r) {
  var i = ce(), a = ce(), o = ge(function(h, m) {
    a.current = m, h = Jr(h, m.props);
    var v = e(h, m), g = m.props.stateReducer(h, me({}, m, {
      changes: v
    }));
    return g;
  }, [e]), s = H1(o, t, n), l = s[0], u = s[1], c = uu(t), f = ge(function(h) {
    return u(me({
      props: c.current
    }, h));
  }, [c]), p = a.current;
  return se(function() {
    var h = Jr(i.current, p == null ? void 0 : p.props), m = p && i.current && !r(h, l);
    m && G$(p, h, l), i.current = l;
  }, [l, p, r]), [l, f];
}
function Z$(e, t, n, r) {
  var i = Vg(e, t, n, r), a = i[0], o = i[1];
  return [Jr(a, t), o];
}
var Vr = {
  itemToString: function(t) {
    return t ? String(t) : "";
  },
  itemToKey: function(t) {
    return t;
  },
  stateReducer: q$,
  scrollIntoView: vg,
  environment: (
    /* istanbul ignore next (ssr) */
    typeof window > "u" ? void 0 : window
  )
};
function Yt(e, t, n) {
  n === void 0 && (n = kg);
  var r = e["default" + lu(t)];
  return r !== void 0 ? r : n[t];
}
function Qn(e, t, n) {
  n === void 0 && (n = kg);
  var r = e[t];
  if (r !== void 0)
    return r;
  var i = e["initial" + lu(t)];
  return i !== void 0 ? i : Yt(e, t, n);
}
function Bg(e) {
  var t = Qn(e, "selectedItem"), n = Qn(e, "isOpen"), r = J$(e), i = Qn(e, "inputValue");
  return {
    highlightedIndex: r < 0 && t && n ? e.items.findIndex(function(a) {
      return e.itemToKey(a) === e.itemToKey(t);
    }) : r,
    isOpen: n,
    selectedItem: t,
    inputValue: i
  };
}
function Pn(e, t, n) {
  var r = e.items, i = e.initialHighlightedIndex, a = e.defaultHighlightedIndex, o = e.isItemDisabled, s = e.itemToKey, l = t.selectedItem, u = t.highlightedIndex;
  return r.length === 0 ? -1 : i !== void 0 && u === i && !o(r[i], i) ? i : a !== void 0 && !o(r[a], a) ? a : l ? r.findIndex(function(c) {
    return s(l) === s(c);
  }) : n < 0 && !o(r[r.length - 1], r.length - 1) ? r.length - 1 : n > 0 && !o(r[0], 0) ? 0 : -1;
}
function Hg(e, t, n) {
  var r = ce({
    isMouseDown: !1,
    isTouchMove: !1,
    isTouchEnd: !1
  });
  return se(function() {
    if (!e)
      return lt;
    var i = n.map(function(c) {
      return c.current;
    });
    function a() {
      r.current.isTouchEnd = !1, r.current.isMouseDown = !0;
    }
    function o(c) {
      r.current.isMouseDown = !1, oa(c.target, i, e) || t();
    }
    function s() {
      r.current.isTouchEnd = !1, r.current.isTouchMove = !1;
    }
    function l() {
      r.current.isTouchMove = !0;
    }
    function u(c) {
      r.current.isTouchEnd = !0, !r.current.isTouchMove && !oa(c.target, i, e, !1) && t();
    }
    return e.addEventListener("mousedown", a), e.addEventListener("mouseup", o), e.addEventListener("touchstart", s), e.addEventListener("touchmove", l), e.addEventListener("touchend", u), function() {
      e.removeEventListener("mousedown", a), e.removeEventListener("mouseup", o), e.removeEventListener("touchstart", s), e.removeEventListener("touchmove", l), e.removeEventListener("touchend", u);
    };
  }, [n, e, t]), r.current;
}
var cu = function() {
  return lt;
};
process.env.NODE_ENV !== "production" && (cu = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  var i = ce(n.reduce(function(o, s) {
    return o[s] = {}, o;
  }, {}));
  se(function() {
    Object.keys(i.current).forEach(function(o) {
      var s = i.current[o];
      if (!Object.keys(s).length) {
        console.error("downshift: You forgot to call the " + o + " getter function on your component / element.");
        return;
      }
      var l = s.suppressRefError, u = s.refKey, c = s.elementRef;
      l || c != null && c.current || console.error('downshift: The ref prop "' + u + '" from ' + o + " was not applied correctly on your element.");
    });
  }, []);
  var a = ge(function(o, s, l, u) {
    i.current[o] = {
      suppressRefError: s,
      refKey: l,
      elementRef: u
    };
  }, []);
  return a;
});
function Kg(e, t, n, r) {
  r === void 0 && (r = {});
  var i = r.document, a = Fa();
  se(function() {
    if (!(!e || a || !i)) {
      var o = e(t);
      Gd(o, i);
    }
  }, n), se(function() {
    return function() {
      Gd.cancel(), k$(i);
    };
  }, [i]);
}
function Wg(e) {
  var t = e.highlightedIndex, n = e.isOpen, r = e.itemRefs, i = e.getItemNodeFromIndex, a = e.menuElement, o = e.scrollIntoView, s = ce(!0);
  return Y$(function() {
    t < 0 || !n || !Object.keys(r.current).length || (s.current === !1 ? s.current = !0 : o(i(t), a));
  }, [t]), s;
}
var du = lt;
process.env.NODE_ENV !== "production" && (du = function(t) {
  var n = t.props, r = t.state, i = ce(n), a = Fa();
  se(function() {
    a || (su(r, i.current, n), i.current = n);
  }, [r, n, a]);
});
function sa(e, t, n) {
  var r;
  n === void 0 && (n = !0);
  var i = ((r = e.items) == null ? void 0 : r.length) && t >= 0;
  return me({
    isOpen: !1,
    highlightedIndex: -1
  }, i && me({
    selectedItem: e.items[t],
    isOpen: Yt(e, "isOpen"),
    highlightedIndex: Yt(e, "highlightedIndex")
  }, n && {
    inputValue: e.itemToString(e.items[t])
  }));
}
function zg(e, t) {
  return e.isOpen === t.isOpen && e.inputValue === t.inputValue && e.highlightedIndex === t.highlightedIndex && e.selectedItem === t.selectedItem;
}
function Fa() {
  var e = te.useRef(!0);
  return te.useEffect(function() {
    return e.current = !1, function() {
      e.current = !0;
    };
  }, []), e.current;
}
function la(e) {
  var t = Yt(e, "highlightedIndex");
  return t > -1 && e.isItemDisabled(e.items[t], t) ? -1 : t;
}
function J$(e) {
  var t = Qn(e, "highlightedIndex");
  return t > -1 && e.isItemDisabled(e.items[t], t) ? -1 : t;
}
var Yi = {
  environment: R.shape({
    addEventListener: R.func.isRequired,
    removeEventListener: R.func.isRequired,
    document: R.shape({
      createElement: R.func.isRequired,
      getElementById: R.func.isRequired,
      activeElement: R.any.isRequired,
      body: R.any.isRequired
    }).isRequired,
    Node: R.func.isRequired
  }),
  itemToString: R.func,
  itemToKey: R.func,
  stateReducer: R.func
}, Gg = me({}, Yi, {
  getA11yStatusMessage: R.func,
  highlightedIndex: R.number,
  defaultHighlightedIndex: R.number,
  initialHighlightedIndex: R.number,
  isOpen: R.bool,
  defaultIsOpen: R.bool,
  initialIsOpen: R.bool,
  selectedItem: R.any,
  initialSelectedItem: R.any,
  defaultSelectedItem: R.any,
  id: R.string,
  labelId: R.string,
  menuId: R.string,
  getItemId: R.func,
  toggleButtonId: R.string,
  onSelectedItemChange: R.func,
  onHighlightedIndexChange: R.func,
  onStateChange: R.func,
  onIsOpenChange: R.func,
  scrollIntoView: R.func
});
function Ug(e, t, n) {
  var r = t.type, i = t.props, a;
  switch (r) {
    case n.ItemMouseMove:
      a = {
        highlightedIndex: t.disabled ? -1 : t.index
      };
      break;
    case n.MenuMouseLeave:
      a = {
        highlightedIndex: -1
      };
      break;
    case n.ToggleButtonClick:
    case n.FunctionToggleMenu:
      a = {
        isOpen: !e.isOpen,
        highlightedIndex: e.isOpen ? -1 : Pn(i, e, 0)
      };
      break;
    case n.FunctionOpenMenu:
      a = {
        isOpen: !0,
        highlightedIndex: Pn(i, e, 0)
      };
      break;
    case n.FunctionCloseMenu:
      a = {
        isOpen: !1
      };
      break;
    case n.FunctionSetHighlightedIndex:
      a = {
        highlightedIndex: i.isItemDisabled(i.items[t.highlightedIndex], t.highlightedIndex) ? -1 : t.highlightedIndex
      };
      break;
    case n.FunctionSetInputValue:
      a = {
        inputValue: t.inputValue
      };
      break;
    case n.FunctionReset:
      a = {
        highlightedIndex: la(i),
        isOpen: Yt(i, "isOpen"),
        selectedItem: Yt(i, "selectedItem"),
        inputValue: Yt(i, "inputValue")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return me({}, e, a);
}
function Q$(e) {
  for (var t = e.keysSoFar, n = e.highlightedIndex, r = e.items, i = e.itemToString, a = e.isItemDisabled, o = t.toLowerCase(), s = 0; s < r.length; s++) {
    var l = (s + n + (t.length < 2 ? 1 : 0)) % r.length, u = r[l];
    if (u !== void 0 && i(u).toLowerCase().startsWith(o) && !a(u, l))
      return l;
  }
  return n;
}
var ew = or(or({}, Gg), { items: R.array.isRequired, isItemDisabled: R.func }), tw = or(or({}, Vr), { isItemDisabled: function() {
  return !1;
} }), qg = lt;
process.env.NODE_ENV !== "production" && (qg = function(e, t) {
  R.checkPropTypes(ew, e, "prop", t.name);
});
var Xi = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 0, fu = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_arrow_down__" : 1, pu = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_arrow_up__" : 2, ua = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_character__" : 3, hu = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_escape__" : 4, mu = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_home__" : 5, gu = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_end__" : 6, vu = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_enter__" : 7, yu = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_space_button__" : 8, bu = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_page_up__" : 9, xu = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_page_down__" : 10, ca = process.env.NODE_ENV !== "production" ? "__togglebutton_blur__" : 11, Yg = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 12, Xg = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 13, $u = process.env.NODE_ENV !== "production" ? "__item_click__" : 14, Zg = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15, Jg = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16, Qg = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17, e0 = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18, wu = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19, Ts = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20, t0 = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21, n0 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  FunctionCloseMenu: Qg,
  FunctionOpenMenu: Jg,
  FunctionReset: t0,
  FunctionSelectItem: wu,
  FunctionSetHighlightedIndex: e0,
  FunctionSetInputValue: Ts,
  FunctionToggleMenu: Zg,
  ItemClick: $u,
  ItemMouseMove: Xg,
  MenuMouseLeave: Yg,
  ToggleButtonBlur: ca,
  ToggleButtonClick: Xi,
  ToggleButtonKeyDownArrowDown: fu,
  ToggleButtonKeyDownArrowUp: pu,
  ToggleButtonKeyDownCharacter: ua,
  ToggleButtonKeyDownEnd: gu,
  ToggleButtonKeyDownEnter: vu,
  ToggleButtonKeyDownEscape: hu,
  ToggleButtonKeyDownHome: mu,
  ToggleButtonKeyDownPageDown: xu,
  ToggleButtonKeyDownPageUp: bu,
  ToggleButtonKeyDownSpaceButton: yu
});
function nw(e, t) {
  var n, r = t.type, i = t.props, a = t.altKey, o;
  switch (r) {
    case $u:
      o = {
        isOpen: Yt(i, "isOpen"),
        highlightedIndex: la(i),
        selectedItem: i.items[t.index]
      };
      break;
    case ua:
      {
        var s = t.key, l = "" + e.inputValue + s, u = !e.isOpen && e.selectedItem ? i.items.findIndex(function(h) {
          return i.itemToKey(h) === i.itemToKey(e.selectedItem);
        }) : e.highlightedIndex, c = Q$({
          keysSoFar: l,
          highlightedIndex: u,
          items: i.items,
          itemToString: i.itemToString,
          isItemDisabled: i.isItemDisabled
        });
        o = {
          inputValue: l,
          highlightedIndex: c,
          isOpen: !0
        };
      }
      break;
    case fu:
      {
        var f = e.isOpen ? Et(e.highlightedIndex, 1, i.items, i.isItemDisabled) : a && e.selectedItem == null ? -1 : Pn(i, e, 1);
        o = {
          highlightedIndex: f,
          isOpen: !0
        };
      }
      break;
    case pu:
      if (e.isOpen && a)
        o = sa(i, e.highlightedIndex, !1);
      else {
        var p = e.isOpen ? Et(e.highlightedIndex, -1, i.items, i.isItemDisabled) : Pn(i, e, -1);
        o = {
          highlightedIndex: p,
          isOpen: !0
        };
      }
      break;
    // only triggered when menu is open.
    case vu:
    case yu:
      o = sa(i, e.highlightedIndex, !1);
      break;
    case mu:
      o = {
        highlightedIndex: mn(0, !1, i.items, i.isItemDisabled),
        isOpen: !0
      };
      break;
    case gu:
      o = {
        highlightedIndex: mn(i.items.length - 1, !0, i.items, i.isItemDisabled),
        isOpen: !0
      };
      break;
    case bu:
      o = {
        highlightedIndex: Et(e.highlightedIndex, -10, i.items, i.isItemDisabled)
      };
      break;
    case xu:
      o = {
        highlightedIndex: Et(e.highlightedIndex, 10, i.items, i.isItemDisabled)
      };
      break;
    case hu:
      o = {
        isOpen: !1,
        highlightedIndex: -1
      };
      break;
    case ca:
      o = me({
        isOpen: !1,
        highlightedIndex: -1
      }, e.highlightedIndex >= 0 && ((n = i.items) == null ? void 0 : n.length) && {
        selectedItem: i.items[e.highlightedIndex]
      });
      break;
    case wu:
      o = {
        selectedItem: t.selectedItem
      };
      break;
    default:
      return Ug(e, t, n0);
  }
  return me({}, e, o);
}
var rw = ["onClick"], iw = ["onMouseLeave", "refKey", "ref"], aw = ["onBlur", "onClick", "onPress", "onKeyDown", "refKey", "ref"], ow = ["item", "index", "onMouseMove", "onClick", "onMouseDown", "onPress", "refKey", "disabled", "ref"];
gi.stateChangeTypes = n0;
function gi(e) {
  e === void 0 && (e = {}), qg(e, gi);
  var t = me({}, tw, e), n = t.scrollIntoView, r = t.environment, i = t.getA11yStatusMessage, a = Z$(nw, t, Bg, zg), o = a[0], s = a[1], l = o.isOpen, u = o.highlightedIndex, c = o.selectedItem, f = o.inputValue, p = ce(null), h = ce(null), m = ce({}), v = ce(null), g = Lg(t), b = uu({
    state: o,
    props: t
  }), y = ge(function(O) {
    return m.current[g.getItemId(O)];
  }, [g]);
  Kg(i, o, [l, u, c, f], r);
  var x = Wg({
    menuElement: h.current,
    highlightedIndex: u,
    isOpen: l,
    itemRefs: m,
    scrollIntoView: n,
    getItemNodeFromIndex: y
  });
  se(function() {
    return v.current = La(function(O) {
      O({
        type: Ts,
        inputValue: ""
      });
    }, 500), function() {
      v.current.cancel();
    };
  }, []), se(function() {
    f && v.current(s);
  }, [s, f]), du({
    props: t,
    state: o
  }), se(function() {
    var O = Qn(t, "isOpen");
    O && p.current && p.current.focus();
  }, []);
  var w = Hg(r, ge(function() {
    b.current.state.isOpen && s({
      type: ca
    });
  }, [s, b]), _t(function() {
    return [h, p];
  }, [h.current, p.current])), $ = cu("getMenuProps", "getToggleButtonProps");
  se(function() {
    l || (m.current = {});
  }, [l]);
  var C = _t(function() {
    return {
      ArrowDown: function(D) {
        D.preventDefault(), s({
          type: fu,
          altKey: D.altKey
        });
      },
      ArrowUp: function(D) {
        D.preventDefault(), s({
          type: pu,
          altKey: D.altKey
        });
      },
      Home: function(D) {
        D.preventDefault(), s({
          type: mu
        });
      },
      End: function(D) {
        D.preventDefault(), s({
          type: gu
        });
      },
      Escape: function() {
        b.current.state.isOpen && s({
          type: hu
        });
      },
      Enter: function(D) {
        D.preventDefault(), s({
          type: b.current.state.isOpen ? vu : Xi
        });
      },
      PageUp: function(D) {
        b.current.state.isOpen && (D.preventDefault(), s({
          type: bu
        }));
      },
      PageDown: function(D) {
        b.current.state.isOpen && (D.preventDefault(), s({
          type: xu
        }));
      },
      " ": function(D) {
        D.preventDefault();
        var E = b.current.state;
        if (!E.isOpen) {
          s({
            type: Xi
          });
          return;
        }
        E.inputValue ? s({
          type: ua,
          key: " "
        }) : s({
          type: yu
        });
      }
    };
  }, [s, b]), T = ge(function() {
    s({
      type: Zg
    });
  }, [s]), S = ge(function() {
    s({
      type: Qg
    });
  }, [s]), N = ge(function() {
    s({
      type: Jg
    });
  }, [s]), k = ge(function(O) {
    s({
      type: e0,
      highlightedIndex: O
    });
  }, [s]), L = ge(function(O) {
    s({
      type: wu,
      selectedItem: O
    });
  }, [s]), _ = ge(function() {
    s({
      type: t0
    });
  }, [s]), B = ge(function(O) {
    s({
      type: Ts,
      inputValue: O
    });
  }, [s]), A = ge(function(O) {
    var D = O === void 0 ? {} : O, E = D.onClick, j = ct(D, rw), F = function() {
      var H;
      (H = p.current) == null || H.focus();
    };
    return me({
      id: g.labelId,
      htmlFor: g.toggleButtonId,
      onClick: _e(E, F)
    }, j);
  }, [g]), q = ge(function(O, D) {
    var E, j = O === void 0 ? {} : O, F = j.onMouseLeave, K = j.refKey, H = K === void 0 ? "ref" : K, W = j.ref, G = ct(j, iw), z = D === void 0 ? {} : D, U = z.suppressRefError, J = U === void 0 ? !1 : U, ne = function() {
      s({
        type: Yg
      });
    };
    return $("getMenuProps", J, H, h), me((E = {}, E[H] = Gt(W, function(ae) {
      h.current = ae;
    }), E.id = g.menuId, E.role = "listbox", E["aria-labelledby"] = G && G["aria-label"] ? void 0 : "" + g.labelId, E.onMouseLeave = _e(F, ne), E), G);
  }, [s, $, g]), X = ge(function(O, D) {
    var E, j = O === void 0 ? {} : O, F = j.onBlur, K = j.onClick;
    j.onPress;
    var H = j.onKeyDown, W = j.refKey, G = W === void 0 ? "ref" : W, z = j.ref, U = ct(j, aw), J = D === void 0 ? {} : D, ne = J.suppressRefError, ae = ne === void 0 ? !1 : ne, V = b.current.state, le = function() {
      s({
        type: Xi
      });
    }, ee = function() {
      V.isOpen && !w.isMouseDown && s({
        type: ca
      });
    }, ye = function(je) {
      var Ae = aa(je);
      Ae && C[Ae] ? C[Ae](je) : X$(Ae) && s({
        type: ua,
        key: Ae
      });
    }, ve = me((E = {}, E[G] = Gt(z, function(Te) {
      p.current = Te;
    }), E["aria-activedescendant"] = V.isOpen && V.highlightedIndex > -1 ? g.getItemId(V.highlightedIndex) : "", E["aria-controls"] = g.menuId, E["aria-expanded"] = b.current.state.isOpen, E["aria-haspopup"] = "listbox", E["aria-labelledby"] = U && U["aria-label"] ? void 0 : "" + g.labelId, E.id = g.toggleButtonId, E.role = "combobox", E.tabIndex = 0, E.onBlur = _e(F, ee), E), U);
    return U.disabled || (ve.onClick = _e(K, le), ve.onKeyDown = _e(H, ye)), $("getToggleButtonProps", ae, G, p), ve;
  }, [s, g, b, w, $, C]), I = ge(function(O) {
    var D, E = O === void 0 ? {} : O, j = E.item, F = E.index, K = E.onMouseMove, H = E.onClick, W = E.onMouseDown;
    E.onPress;
    var G = E.refKey, z = G === void 0 ? "ref" : G, U = E.disabled, J = E.ref, ne = ct(E, ow);
    U !== void 0 && console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useSelect.');
    var ae = b.current, V = ae.state, le = ae.props, ee = Fg(j, F, le.items, "Pass either item or index to getItemProps!"), ye = ee[0], ve = ee[1], Te = le.isItemDisabled(ye, ve), je = function() {
      w.isTouchEnd || ve === V.highlightedIndex || (x.current = !1, s({
        type: Xg,
        index: ve,
        disabled: Te
      }));
    }, Ae = function() {
      s({
        type: $u,
        index: ve
      });
    }, tt = function($t) {
      return $t.preventDefault();
    }, Ve = me((D = {}, D[z] = Gt(J, function(Ue) {
      Ue && (m.current[g.getItemId(ve)] = Ue);
    }), D["aria-disabled"] = Te, D["aria-selected"] = ye === V.selectedItem, D.id = g.getItemId(ve), D.role = "option", D), ne);
    return Te || (Ve.onClick = _e(H, Ae)), Ve.onMouseMove = _e(K, je), Ve.onMouseDown = _e(W, tt), Ve;
  }, [b, g, w, x, s]);
  return {
    // prop getters.
    getToggleButtonProps: X,
    getLabelProps: A,
    getMenuProps: q,
    getItemProps: I,
    // actions.
    toggleMenu: T,
    openMenu: N,
    closeMenu: S,
    setHighlightedIndex: k,
    selectItem: L,
    reset: _,
    setInputValue: B,
    // state.
    highlightedIndex: u,
    isOpen: l,
    selectedItem: c,
    inputValue: f
  };
}
var Cu = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_down__" : 0, Su = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_up__" : 1, Iu = process.env.NODE_ENV !== "production" ? "__input_keydown_escape__" : 2, Eu = process.env.NODE_ENV !== "production" ? "__input_keydown_home__" : 3, Ou = process.env.NODE_ENV !== "production" ? "__input_keydown_end__" : 4, Tu = process.env.NODE_ENV !== "production" ? "__input_keydown_page_up__" : 5, Pu = process.env.NODE_ENV !== "production" ? "__input_keydown_page_down__" : 6, Nu = process.env.NODE_ENV !== "production" ? "__input_keydown_enter__" : 7, _u = process.env.NODE_ENV !== "production" ? "__input_change__" : 8, da = process.env.NODE_ENV !== "production" ? "__input_blur__" : 9, Au = process.env.NODE_ENV !== "production" ? "__input_click__" : 10, r0 = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 11, i0 = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 12, Ru = process.env.NODE_ENV !== "production" ? "__item_click__" : 13, a0 = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 14, o0 = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15, s0 = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16, l0 = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17, u0 = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18, Mu = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19, c0 = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20, d0 = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21, ju = process.env.NODE_ENV !== "production" ? "__controlled_prop_updated_selected_item__" : 22, f0 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ControlledPropUpdatedSelectedItem: ju,
  FunctionCloseMenu: l0,
  FunctionOpenMenu: s0,
  FunctionReset: d0,
  FunctionSelectItem: Mu,
  FunctionSetHighlightedIndex: u0,
  FunctionSetInputValue: c0,
  FunctionToggleMenu: o0,
  InputBlur: da,
  InputChange: _u,
  InputClick: Au,
  InputKeyDownArrowDown: Cu,
  InputKeyDownArrowUp: Su,
  InputKeyDownEnd: Ou,
  InputKeyDownEnter: Nu,
  InputKeyDownEscape: Iu,
  InputKeyDownHome: Eu,
  InputKeyDownPageDown: Pu,
  InputKeyDownPageUp: Tu,
  ItemClick: Ru,
  ItemMouseMove: i0,
  MenuMouseLeave: r0,
  ToggleButtonClick: a0
});
function sw(e) {
  var t = Bg(e), n = t.selectedItem, r = t.inputValue;
  return r === "" && n && e.defaultInputValue === void 0 && e.initialInputValue === void 0 && e.inputValue === void 0 && (r = e.itemToString(n)), me({}, t, {
    inputValue: r
  });
}
var lw = me({}, Gg, {
  items: R.array.isRequired,
  isItemDisabled: R.func,
  inputValue: R.string,
  defaultInputValue: R.string,
  initialInputValue: R.string,
  inputId: R.string,
  onInputValueChange: R.func
});
function uw(e, t, n, r) {
  var i = ce(), a = Vg(e, t, n, r), o = a[0], s = a[1], l = Fa();
  return se(function() {
    if (ia(t, "selectedItem")) {
      if (!l) {
        var u = t.itemToKey(t.selectedItem) !== t.itemToKey(i.current);
        u && s({
          type: ju,
          inputValue: t.itemToString(t.selectedItem)
        });
      }
      i.current = o.selectedItem === i.current ? t.selectedItem : o.selectedItem;
    }
  }, [o.selectedItem, t.selectedItem]), [Jr(o, t), s];
}
var p0 = lt;
process.env.NODE_ENV !== "production" && (p0 = function(t, n) {
  R.checkPropTypes(lw, t, "prop", n.name);
});
var cw = me({}, Vr, {
  isItemDisabled: function() {
    return !1;
  }
});
function dw(e, t) {
  var n, r = t.type, i = t.props, a = t.altKey, o;
  switch (r) {
    case Ru:
      o = {
        isOpen: Yt(i, "isOpen"),
        highlightedIndex: la(i),
        selectedItem: i.items[t.index],
        inputValue: i.itemToString(i.items[t.index])
      };
      break;
    case Cu:
      e.isOpen ? o = {
        highlightedIndex: Et(e.highlightedIndex, 1, i.items, i.isItemDisabled, !0)
      } : o = {
        highlightedIndex: a && e.selectedItem == null ? -1 : Pn(i, e, 1),
        isOpen: i.items.length >= 0
      };
      break;
    case Su:
      e.isOpen ? a ? o = sa(i, e.highlightedIndex) : o = {
        highlightedIndex: Et(e.highlightedIndex, -1, i.items, i.isItemDisabled, !0)
      } : o = {
        highlightedIndex: Pn(i, e, -1),
        isOpen: i.items.length >= 0
      };
      break;
    case Nu:
      o = sa(i, e.highlightedIndex);
      break;
    case Iu:
      o = me({
        isOpen: !1,
        highlightedIndex: -1
      }, !e.isOpen && {
        selectedItem: null,
        inputValue: ""
      });
      break;
    case Tu:
      o = {
        highlightedIndex: Et(e.highlightedIndex, -10, i.items, i.isItemDisabled, !0)
      };
      break;
    case Pu:
      o = {
        highlightedIndex: Et(e.highlightedIndex, 10, i.items, i.isItemDisabled, !0)
      };
      break;
    case Eu:
      o = {
        highlightedIndex: mn(0, !1, i.items, i.isItemDisabled)
      };
      break;
    case Ou:
      o = {
        highlightedIndex: mn(i.items.length - 1, !0, i.items, i.isItemDisabled)
      };
      break;
    case da:
      o = me({
        isOpen: !1,
        highlightedIndex: -1
      }, e.highlightedIndex >= 0 && ((n = i.items) == null ? void 0 : n.length) && t.selectItem && {
        selectedItem: i.items[e.highlightedIndex],
        inputValue: i.itemToString(i.items[e.highlightedIndex])
      });
      break;
    case _u:
      o = {
        isOpen: !0,
        highlightedIndex: la(i),
        inputValue: t.inputValue
      };
      break;
    case Au:
      o = {
        isOpen: !e.isOpen,
        highlightedIndex: e.isOpen ? -1 : Pn(i, e, 0)
      };
      break;
    case Mu:
      o = {
        selectedItem: t.selectedItem,
        inputValue: i.itemToString(t.selectedItem)
      };
      break;
    case ju:
      o = {
        inputValue: t.inputValue
      };
      break;
    default:
      return Ug(e, t, f0);
  }
  return me({}, e, o);
}
var fw = ["onMouseLeave", "refKey", "ref"], pw = ["item", "index", "refKey", "ref", "onMouseMove", "onMouseDown", "onClick", "onPress", "disabled"], hw = ["onClick", "onPress", "refKey", "ref"], mw = ["onKeyDown", "onChange", "onInput", "onBlur", "onChangeText", "onClick", "refKey", "ref"];
Xn.stateChangeTypes = f0;
function Xn(e) {
  e === void 0 && (e = {}), p0(e, Xn);
  var t = me({}, cw, e), n = t.items, r = t.scrollIntoView, i = t.environment, a = t.getA11yStatusMessage, o = uw(dw, t, sw, zg), s = o[0], l = o[1], u = s.isOpen, c = s.highlightedIndex, f = s.selectedItem, p = s.inputValue, h = ce(null), m = ce({}), v = ce(null), g = ce(null), b = Fa(), y = Lg(t), x = ce(), w = uu({
    state: s,
    props: t
  }), $ = ge(function(F) {
    return m.current[y.getItemId(F)];
  }, [y]);
  Kg(a, s, [u, c, f, p], i);
  var C = Wg({
    menuElement: h.current,
    highlightedIndex: c,
    isOpen: u,
    itemRefs: m,
    scrollIntoView: r,
    getItemNodeFromIndex: $
  });
  du({
    props: t,
    state: s
  }), se(function() {
    var F = Qn(t, "isOpen");
    F && v.current && v.current.focus();
  }, []), se(function() {
    b || (x.current = n.length);
  });
  var T = Hg(i, ge(function() {
    w.current.state.isOpen && l({
      type: da,
      selectItem: !1
    });
  }, [l, w]), _t(function() {
    return [h, g, v];
  }, [h.current, g.current, v.current])), S = cu("getInputProps", "getMenuProps");
  se(function() {
    u || (m.current = {});
  }, [u]), se(function() {
    var F;
    !u || !(i != null && i.document) || !(v != null && (F = v.current) != null && F.focus) || i.document.activeElement !== v.current && v.current.focus();
  }, [u, i]);
  var N = _t(function() {
    return {
      ArrowDown: function(K) {
        K.preventDefault(), l({
          type: Cu,
          altKey: K.altKey
        });
      },
      ArrowUp: function(K) {
        K.preventDefault(), l({
          type: Su,
          altKey: K.altKey
        });
      },
      Home: function(K) {
        w.current.state.isOpen && (K.preventDefault(), l({
          type: Eu
        }));
      },
      End: function(K) {
        w.current.state.isOpen && (K.preventDefault(), l({
          type: Ou
        }));
      },
      Escape: function(K) {
        var H = w.current.state;
        (H.isOpen || H.inputValue || H.selectedItem || H.highlightedIndex > -1) && (K.preventDefault(), l({
          type: Iu
        }));
      },
      Enter: function(K) {
        var H = w.current.state;
        !H.isOpen || K.which === 229 || (K.preventDefault(), l({
          type: Nu
        }));
      },
      PageUp: function(K) {
        w.current.state.isOpen && (K.preventDefault(), l({
          type: Tu
        }));
      },
      PageDown: function(K) {
        w.current.state.isOpen && (K.preventDefault(), l({
          type: Pu
        }));
      }
    };
  }, [l, w]), k = ge(function(F) {
    return me({
      id: y.labelId,
      htmlFor: y.inputId
    }, F);
  }, [y]), L = ge(function(F, K) {
    var H, W = F === void 0 ? {} : F, G = W.onMouseLeave, z = W.refKey, U = z === void 0 ? "ref" : z, J = W.ref, ne = ct(W, fw), ae = K === void 0 ? {} : K, V = ae.suppressRefError, le = V === void 0 ? !1 : V;
    return S("getMenuProps", le, U, h), me((H = {}, H[U] = Gt(J, function(ee) {
      h.current = ee;
    }), H.id = y.menuId, H.role = "listbox", H["aria-labelledby"] = ne && ne["aria-label"] ? void 0 : "" + y.labelId, H.onMouseLeave = _e(G, function() {
      l({
        type: r0
      });
    }), H), ne);
  }, [l, S, y]), _ = ge(function(F) {
    var K, H, W = F === void 0 ? {} : F, G = W.item, z = W.index, U = W.refKey, J = U === void 0 ? "ref" : U, ne = W.ref, ae = W.onMouseMove, V = W.onMouseDown, le = W.onClick;
    W.onPress;
    var ee = W.disabled, ye = ct(W, pw);
    ee !== void 0 && console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useCombobox.');
    var ve = w.current, Te = ve.props, je = ve.state, Ae = Fg(G, z, Te.items, "Pass either item or index to getItemProps!"), tt = Ae[0], Ve = Ae[1], Ue = Te.isItemDisabled(tt, Ve), $t = "onClick", Vt = le, ot = function() {
      T.isTouchEnd || Ve === je.highlightedIndex || (C.current = !1, l({
        type: i0,
        index: Ve,
        disabled: Ue
      }));
    }, gt = function() {
      l({
        type: Ru,
        index: Ve
      });
    }, st = function(on) {
      return on.preventDefault();
    };
    return me((K = {}, K[J] = Gt(ne, function(nt) {
      nt && (m.current[y.getItemId(Ve)] = nt);
    }), K["aria-disabled"] = Ue, K["aria-selected"] = Ve === je.highlightedIndex, K.id = y.getItemId(Ve), K.role = "option", K), !Ue && (H = {}, H[$t] = _e(Vt, gt), H), {
      onMouseMove: _e(ae, ot),
      onMouseDown: _e(V, st)
    }, ye);
  }, [l, y, w, T, C]), B = ge(function(F) {
    var K, H = F === void 0 ? {} : F, W = H.onClick;
    H.onPress;
    var G = H.refKey, z = G === void 0 ? "ref" : G, U = H.ref, J = ct(H, hw), ne = w.current.state, ae = function() {
      l({
        type: a0
      });
    };
    return me((K = {}, K[z] = Gt(U, function(V) {
      g.current = V;
    }), K["aria-controls"] = y.menuId, K["aria-expanded"] = ne.isOpen, K.id = y.toggleButtonId, K.tabIndex = -1, K), !J.disabled && me({}, {
      onClick: _e(W, ae)
    }), J);
  }, [l, w, y]), A = ge(function(F, K) {
    var H, W = F === void 0 ? {} : F, G = W.onKeyDown, z = W.onChange, U = W.onInput, J = W.onBlur;
    W.onChangeText;
    var ne = W.onClick, ae = W.refKey, V = ae === void 0 ? "ref" : ae, le = W.ref, ee = ct(W, mw), ye = K === void 0 ? {} : K, ve = ye.suppressRefError, Te = ve === void 0 ? !1 : ve;
    S("getInputProps", Te, V, v);
    var je = w.current.state, Ae = function(st) {
      var nt = aa(st);
      nt && N[nt] && N[nt](st);
    }, tt = function(st) {
      l({
        type: _u,
        inputValue: st.target.value
      });
    }, Ve = function(st) {
      if (i != null && i.document && je.isOpen && !T.isMouseDown) {
        var nt = st.relatedTarget === null && i.document.activeElement !== i.document.body;
        l({
          type: da,
          selectItem: !nt
        });
      }
    }, Ue = function() {
      l({
        type: Au
      });
    }, $t = "onChange", Vt = {};
    if (!ee.disabled) {
      var ot;
      Vt = (ot = {}, ot[$t] = _e(z, U, tt), ot.onKeyDown = _e(G, Ae), ot.onBlur = _e(J, Ve), ot.onClick = _e(ne, Ue), ot);
    }
    return me((H = {}, H[V] = Gt(le, function(gt) {
      v.current = gt;
    }), H["aria-activedescendant"] = je.isOpen && je.highlightedIndex > -1 ? y.getItemId(je.highlightedIndex) : "", H["aria-autocomplete"] = "list", H["aria-controls"] = y.menuId, H["aria-expanded"] = je.isOpen, H["aria-labelledby"] = ee && ee["aria-label"] ? void 0 : y.labelId, H.autoComplete = "off", H.id = y.inputId, H.role = "combobox", H.value = je.inputValue, H), Vt, ee);
  }, [l, y, i, N, w, T, S]), q = ge(function() {
    l({
      type: o0
    });
  }, [l]), X = ge(function() {
    l({
      type: l0
    });
  }, [l]), I = ge(function() {
    l({
      type: s0
    });
  }, [l]), O = ge(function(F) {
    l({
      type: u0,
      highlightedIndex: F
    });
  }, [l]), D = ge(function(F) {
    l({
      type: Mu,
      selectedItem: F
    });
  }, [l]), E = ge(function(F) {
    l({
      type: c0,
      inputValue: F
    });
  }, [l]), j = ge(function() {
    l({
      type: d0
    });
  }, [l]);
  return {
    // prop getters.
    getItemProps: _,
    getLabelProps: k,
    getMenuProps: L,
    getInputProps: A,
    getToggleButtonProps: B,
    // actions.
    toggleMenu: q,
    openMenu: I,
    closeMenu: X,
    setHighlightedIndex: O,
    setInputValue: E,
    selectItem: D,
    reset: j,
    // state.
    highlightedIndex: c,
    isOpen: u,
    selectedItem: f,
    inputValue: p
  };
}
Yi.stateReducer, Yi.itemToKey, Yi.environment, R.array, R.array, R.array, R.func, R.number, R.number, R.number, R.func, R.func, R.string, R.string;
Vr.itemToKey, Vr.stateReducer, Vr.environment;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
const h0 = ["sm", "md", "lg", "xl", "2xl", "3xl"], It = ["xs", ...h0], gw = h0, vw = [
  "@xs",
  // @container (min-width: 20em /* 320px */)
  "@sm",
  // @container (min-width: 24rem /* 384px */)
  "@md",
  // @container (min-width: 28rem /* 448px */)
  "@lg",
  // @container (min-width: 32rem /* 512px */)
  "@xl",
  // @container (min-width: 36rem /* 576px */)
  "@2xl",
  // @container (min-width: 42rem /* 672px /)
  "@3xl",
  // @container (min-width: 48rem /* 768px */)
  "@4xl",
  // @container (min-width: 56rem /* 896px */)
  "@5xl",
  // @container (min-width: 64rem /* 1024px */)
  "@6xl",
  // @container (min-width: 72rem /* 1152px */)
  "@7xl"
  // @container (min-width: 80rem /* 1280px */)
], HO = vw, KO = ["@lg", "@xl", "@2xl"], Qr = "xs", m0 = "base", yw = (e) => e === Qr || e === m0, bw = (e) => It.reduce((t, n, r) => (typeof e == "object" && (n in e ? t[n] = e[n] : r > 0 && (t[n] = t[It[r - 1]])), t), {}), xw = (e) => !!e && typeof e == "object" && Object.keys(e).some((t) => gw.includes(t)), fe = (e, t, n = "a", r = !1) => {
  if (t == null) return "";
  const i = r ? "!" : "", a = e ? `${n}:${i}${e}` : n;
  if (typeof t == "string" || typeof t == "number")
    return e ? Number(t) < 0 ? `${n}:${i}-${e}-${Math.abs(Number(t))}` : `${n}:${i}${e}-${t}` : Number(t) < 0 ? `${n}:${i}-${Math.abs(Number(t))}` : `${n}:${i}${t}`;
  let o = [];
  if (typeof t == "object" && (Qr in t || m0 in t)) {
    const l = t[Qr] || t.base;
    o = Number(l) < 0 ? [`${n}:${i}-${e}-${Math.abs(Number(l))}`] : [`${a}${a === n ? ":" : "-"}${l}`];
  }
  const s = Object.entries(t).filter(([l]) => !yw(l)).map(
    ([l, u]) => Number(u) < 0 ? e ? `${n}:${l}:${i}-${e}-${Math.abs(Number(u))}` : `${n}:${l}:${i}-${Math.abs(Number(u))}` : e ? `${n}:${l}:${i}${e}-${u}` : `${n}:${l}:${i}${u}`
  );
  return [...o, ...s];
}, ei = (e, t, n) => {
  if (!t) return {};
  if (typeof t == "string" || typeof t == "number")
    return { [`${e}`]: n ? n(t) : t };
  let r = {};
  return typeof t == "object" && Qr in t && (r = {
    [`${e}`]: n ? n(t.xs) : t.xs
  }), {
    ...r,
    ...Object.entries(t).filter(([i]) => i !== Qr).reduce(
      (i, [a, o]) => ({
        ...i,
        [`${e}-${a}`]: n ? n(o) : o
      }),
      {}
    )
  };
};
function $w(e) {
  const t = It.indexOf(e.from), n = It.indexOf(e.until);
  return t === -1 || n === -1 ? [] : It.slice(t, n + 1);
}
function Ud(e) {
  const t = Array.isArray(e) ? e : [e];
  if (!t.length) return "";
  const n = [...t].sort(
    (i, a) => It.indexOf(i) - It.indexOf(a)
  ), r = [];
  return n.includes("xs") ? r.push("a:block") : r.push("a:hidden"), It.forEach((i, a) => {
    if (a === It.length - 1) return;
    const o = n.includes(i), s = n.includes(It[a + 1]);
    if (o !== s) {
      const l = It[a + 1];
      r.push(`a:${l}:${s ? "block" : "hidden"}`);
    }
  }), r.join(" ");
}
const Va = (e) => e ? typeof e != "object" ? `a:flex-${e}` : Object.keys(e).reduce((t, n) => {
  const r = e[n];
  return xw(r) ? [...t, ...fe(n, r)] : [...t, `a:${n}-${r}`];
}, []) : "", g0 = ({
  aspectRatio: e,
  backgroundColor: t,
  borderRadius: n,
  flex: r,
  padding: i,
  paddingBlock: a,
  paddingBlockStart: o,
  paddingBlockEnd: s,
  marginInline: l,
  marginInlineStart: u,
  marginInlineEnd: c,
  paddingInline: f,
  paddingInlineStart: p,
  paddingInlineEnd: h,
  overflow: m,
  shadow: v,
  contentAlign: g,
  position: b,
  display: y,
  top: x,
  opacity: w
}) => [
  fe("aspect", e),
  fe("bg-surface", t),
  fe("content", g),
  fe("rounded", n),
  fe("", b),
  fe("", y),
  fe("top", x),
  fe("p", i),
  fe("py", a),
  fe("pt", o),
  fe("pb", s),
  fe("ms", u ?? l),
  fe("me", c ?? l),
  fe("ps", p ?? f),
  fe("pe", h ?? f),
  fe("overflow", m),
  fe("shadow", v),
  fe("opacity", w),
  Va(r)
], De = ({ id: e, children: t, testId: n, ...r }) => /* @__PURE__ */ d.jsx("div", { id: e, "data-testid": n, className: Y(g0(r)), children: t });
function Ze(e) {
  const t = /^a:(!)?(-)?(m|p)([rtbxsley])?-/;
  return typeof e == "string" ? e.split(" ").filter((n) => t.test(n)) : [];
}
const ww = de("a:flex", {
  variants: {
    hasGap: {
      true: "a:gap-4"
    }
  },
  defaultVariants: {
    hasGap: !1
  }
});
function We({
  children: e,
  testId: t,
  hasGap: n,
  gap: r,
  id: i,
  spacingClasses: a,
  itemsAlign: o,
  direction: s = "col",
  contentAlign: l,
  flex: u
}) {
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      "data-testid": t,
      id: i,
      className: Oe(
        ww({ hasGap: n }),
        Ze(a),
        `a:flex-${s}`,
        fe("gap", r),
        fe("justify", l),
        fe("items", o),
        Va(u)
      ),
      children: e
    }
  );
}
const v0 = Rt({}), Ba = () => Xe(v0);
var qd;
function Ps() {
  return Ps = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ps.apply(null, arguments);
}
var Ha = function(t) {
  return /* @__PURE__ */ M.createElement("svg", Ps({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, t), qd || (qd = /* @__PURE__ */ M.createElement("path", {
    d: "M21 12a.75.75 0 0 1-.75.75H5.56l5.47 5.47a.75.75 0 1 1-1.061 1.06l-6.75-6.75a.75.75 0 0 1 0-1.06l6.75-6.75a.75.75 0 1 1 1.061 1.06l-5.47 5.47h14.69A.75.75 0 0 1 21 12"
  })));
}, Yd;
function Ns() {
  return Ns = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ns.apply(null, arguments);
}
var y0 = function(t) {
  return /* @__PURE__ */ M.createElement("svg", Ns({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, t), Yd || (Yd = /* @__PURE__ */ M.createElement("path", {
    d: "m20.78 12.53-6.75 6.75a.75.75 0 0 1-1.06-1.06l5.47-5.47H3.75a.75.75 0 1 1 0-1.5h14.69l-5.47-5.47a.75.75 0 1 1 1.06-1.06l6.75 6.75a.75.75 0 0 1 0 1.06"
  })));
}, Xd;
function _s() {
  return _s = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _s.apply(null, arguments);
}
var vi = function(t) {
  return /* @__PURE__ */ M.createElement("svg", _s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, t), Xd || (Xd = /* @__PURE__ */ M.createElement("path", {
    d: "m20.031 9.53-7.5 7.5a.75.75 0 0 1-1.061 0l-7.5-7.5a.75.75 0 1 1 1.06-1.06L12 15.44l6.969-6.97a.751.751 0 0 1 1.061 1.06Z"
  })));
}, Zd;
function As() {
  return As = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, As.apply(null, arguments);
}
var b0 = function(t) {
  return /* @__PURE__ */ M.createElement("svg", As({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, t), Zd || (Zd = /* @__PURE__ */ M.createElement("path", {
    d: "M15.53 18.97a.75.75 0 1 1-1.061 1.06l-7.5-7.5a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 1 1 1.061 1.06L8.56 12z"
  })));
}, Jd;
function Rs() {
  return Rs = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Rs.apply(null, arguments);
}
var Cw = function(t) {
  return /* @__PURE__ */ M.createElement("svg", Rs({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, t), Jd || (Jd = /* @__PURE__ */ M.createElement("path", {
    d: "M16.28 9.22a.75.75 0 0 1 0 1.06l-5.25 5.25a.747.747 0 0 1-1.06 0l-2.25-2.25a.75.75 0 1 1 1.06-1.06l1.72 1.72 4.72-4.72a.75.75 0 0 1 1.06 0M21.75 12A9.75 9.75 0 1 1 12 2.25 9.76 9.76 0 0 1 21.75 12m-1.5 0A8.25 8.25 0 1 0 12 20.25 8.26 8.26 0 0 0 20.25 12"
  })));
}, Qd;
function Ms() {
  return Ms = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ms.apply(null, arguments);
}
var Sw = function(t) {
  return /* @__PURE__ */ M.createElement("svg", Ms({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, t), Qd || (Qd = /* @__PURE__ */ M.createElement("path", {
    d: "M19.5 3h-15A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3m-3.22 7.28-5.25 5.25a.747.747 0 0 1-1.06 0l-2.25-2.25a.75.75 0 1 1 1.06-1.06l1.72 1.72 4.72-4.72a.751.751 0 0 1 1.06 1.06"
  })));
}, ef;
function js() {
  return js = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, js.apply(null, arguments);
}
var Ka = function(t) {
  return /* @__PURE__ */ M.createElement("svg", js({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, t), ef || (ef = /* @__PURE__ */ M.createElement("path", {
    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25m0 18A8.25 8.25 0 1 1 20.25 12 8.26 8.26 0 0 1 12 20.25m1.5-3.75a.75.75 0 0 1-.75.75 1.5 1.5 0 0 1-1.5-1.5V12a.75.75 0 1 1 0-1.5 1.5 1.5 0 0 1 1.5 1.5v3.75a.75.75 0 0 1 .75.75m-3-8.625a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0"
  })));
}, tf;
function Ds() {
  return Ds = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ds.apply(null, arguments);
}
var Wa = function(t) {
  return /* @__PURE__ */ M.createElement("svg", Ds({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, t), tf || (tf = /* @__PURE__ */ M.createElement("path", {
    d: "m21.53 20.47-4.693-4.693a8.26 8.26 0 1 0-1.06 1.06l4.693 4.694a.75.75 0 1 0 1.06-1.061M3.75 10.5a6.75 6.75 0 1 1 6.75 6.75 6.76 6.76 0 0 1-6.75-6.75"
  })));
}, nf;
function ks() {
  return ks = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ks.apply(null, arguments);
}
var Iw = function(t) {
  return /* @__PURE__ */ M.createElement("svg", ks({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, t), nf || (nf = /* @__PURE__ */ M.createElement("path", {
    d: "M21 12a.75.75 0 0 1-.75.75H3.75a.75.75 0 1 1 0-1.5h16.5A.75.75 0 0 1 21 12"
  })));
}, rf;
function Ls() {
  return Ls = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ls.apply(null, arguments);
}
var Ew = function(t) {
  return /* @__PURE__ */ M.createElement("svg", Ls({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, t), rf || (rf = /* @__PURE__ */ M.createElement("path", {
    d: "M21 12a.75.75 0 0 1-.75.75h-7.5v7.5a.75.75 0 1 1-1.5 0v-7.5h-7.5a.75.75 0 1 1 0-1.5h7.5v-7.5a.75.75 0 1 1 1.5 0v7.5h7.5A.75.75 0 0 1 21 12"
  })));
}, af, of;
function Fs() {
  return Fs = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Fs.apply(null, arguments);
}
var Ow = function(t) {
  return /* @__PURE__ */ M.createElement("svg", Fs({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, t), af || (af = /* @__PURE__ */ M.createElement("path", {
    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25m0 18A8.25 8.25 0 1 1 20.25 12 8.26 8.26 0 0 1 12 20.25"
  })), of || (of = /* @__PURE__ */ M.createElement("path", {
    d: "M17.25 12a5.25 5.25 0 1 1-10.499 0 5.25 5.25 0 0 1 10.499 0"
  })));
}, sf;
function Vs() {
  return Vs = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Vs.apply(null, arguments);
}
var Tw = function(t) {
  return /* @__PURE__ */ M.createElement("svg", Vs({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, t), sf || (sf = /* @__PURE__ */ M.createElement("path", {
    fillRule: "evenodd",
    d: "M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12",
    clipRule: "evenodd"
  })));
}, lf;
function Bs() {
  return Bs = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Bs.apply(null, arguments);
}
var Pw = function(t) {
  return /* @__PURE__ */ M.createElement("svg", Bs({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, t), lf || (lf = /* @__PURE__ */ M.createElement("path", {
    d: "M19.5 3h-15A1.5 1.5 0 0 0 3 4.5v15A1.5 1.5 0 0 0 4.5 21h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3m0 16.5h-15v-15h15z"
  })));
}, uf;
function Hs() {
  return Hs = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Hs.apply(null, arguments);
}
var x0 = function(t) {
  return /* @__PURE__ */ M.createElement("svg", Hs({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, t), uf || (uf = /* @__PURE__ */ M.createElement("path", {
    d: "M12 2.25A9.75 9.75 0 1 0 21.75 12 9.76 9.76 0 0 0 12 2.25m0 18A8.25 8.25 0 1 1 20.25 12 8.26 8.26 0 0 1 12 20.25m-.75-7.5V7.5a.75.75 0 1 1 1.5 0v5.25a.75.75 0 1 1-1.5 0m1.875 3.375a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"
  })));
}, cf;
function Ks() {
  return Ks = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ks.apply(null, arguments);
}
var Nw = function(t) {
  return /* @__PURE__ */ M.createElement("svg", Ks({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, t), cf || (cf = /* @__PURE__ */ M.createElement("path", {
    d: "M22.2 17.634 14.002 3.396a2.322 2.322 0 0 0-4.004 0L1.8 17.634a2.2 2.2 0 0 0 0 2.223A2.28 2.28 0 0 0 3.802 21h16.396a2.28 2.28 0 0 0 2-1.143 2.2 2.2 0 0 0 .002-2.223m-1.3 1.472a.8.8 0 0 1-.701.394H3.802a.8.8 0 0 1-.702-.394.71.71 0 0 1 0-.723l8.2-14.238a.82.82 0 0 1 1.406 0l8.199 14.238a.71.71 0 0 1-.004.723ZM11.25 13.5V9.75a.75.75 0 1 1 1.5 0v3.75a.75.75 0 0 1-1.5 0m1.875 3.375a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"
  })));
}, df;
function Ws() {
  return Ws = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ws.apply(null, arguments);
}
var bn = function(t) {
  return /* @__PURE__ */ M.createElement("svg", Ws({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, t), df || (df = /* @__PURE__ */ M.createElement("path", {
    d: "M19.281 18.22a.75.75 0 1 1-1.061 1.06L12 13.06l-6.219 6.22a.75.75 0 0 1-1.061-1.06L10.94 12 4.72 5.78a.75.75 0 1 1 1.06-1.06L12 10.94l6.219-6.22a.75.75 0 1 1 1.061 1.06L13.061 12z"
  })));
};
const Pe = ({
  children: e,
  contentAlign: t,
  itemsAlign: n,
  testId: r,
  gap: i,
  direction: a = "row",
  wrap: o = "wrap",
  flex: s
}) => /* @__PURE__ */ d.jsx(
  "div",
  {
    "data-testid": r,
    className: Oe(
      "a:flex",
      `a:flex-${a}`,
      `a:flex-${o}`,
      fe("gap", i),
      fe("justify", t),
      fe("items", n),
      Va(s)
    ),
    children: e
  }
), _w = de("a:m-0", {
  variants: {
    alignment: { start: "a:text-start", center: "a:text-center", end: "a:text-end" },
    variant: {
      headingXL: "a:font-fascia a:text-4xl a:md:text-5xl a:xl:text-6xl a:font-bold",
      headingL: "a:font-fascia a:text-3xl a:md:text-4xl a:xl:text-5xl a:font-bold",
      headingM: "a:font-fascia a:text-4xl a:font-bold",
      headingS: "a:font-fascia a:text-3xl a:font-bold",
      headingXS: "a:font-fascia a:text-2xl a:font-bold",
      title2XL: "a:font-functional a:text-3xl a:font-bold",
      titleXL: "a:font-functional a:text-2xl a:font-bold",
      titleL: "a:font-functional a:text-xl a:font-bold",
      titleM: "a:font-functional a:text-lg a:font-bold",
      titleS: "a:font-functional a:text-base a:font-bold",
      titleXS: "a:font-functional a:text-sm a:font-bold",
      body2XL: "a:font-functional a:text-2xl",
      bodyXL: "a:font-functional a:text-xl",
      bodyL: "a:font-functional a:text-lg",
      bodyM: "a:font-functional a:text-base",
      bodyS: "a:font-functional a:text-sm",
      bodyXS: "a:font-functional a:text-xs",
      inherit: ""
    },
    color: wl("text"),
    truncate: {
      true: "a:truncate"
    },
    strike: {
      true: "a:line-through"
    },
    strong: { true: "", false: "" },
    whiteSpace: {
      normal: "a:whitespace-normal",
      preWrap: "a:whitespace-pre-wrap",
      nowrap: "a:whitespace-nowrap"
    },
    wordBreak: {
      normal: "a:break-normal",
      break: "a:break-words"
    }
  },
  compoundVariants: [
    {
      variant: ["body2XL", "bodyXL", "bodyL", "bodyM", "bodyS", "bodyXS", "inherit"],
      strong: !0,
      className: "a:font-semibold"
    },
    {
      variant: ["bodyXL", "bodyL", "bodyM", "bodyS", "bodyXS", "inherit"],
      strong: !1,
      className: "a:font-normal"
    }
  ],
  defaultVariants: {
    variant: "bodyM",
    strong: !1
  }
}), ie = ({
  alignment: e,
  as: t = "div",
  children: n,
  color: r,
  testId: i,
  lineClamp: a,
  strong: o,
  strike: s,
  truncate: l,
  variant: u,
  whiteSpace: c,
  wordBreak: f
}) => /* @__PURE__ */ d.jsx(
  t,
  {
    "data-testid": i,
    className: Oe(
      !!a && `a:line-clamp-${a}`,
      _w({
        alignment: e,
        truncate: l,
        variant: u,
        color: r,
        strike: s,
        strong: o,
        whiteSpace: c,
        wordBreak: f
      })
    ),
    children: n
  }
), yi = ({ children: e, testId: t }) => /* @__PURE__ */ d.jsxs(Pe, { gap: "1", testId: t, wrap: "nowrap", children: [
  /* @__PURE__ */ d.jsx($e, { source: x0, size: "sm", color: "error" }),
  typeof e == "string" ? /* @__PURE__ */ d.jsx(ie, { as: "span", color: "error", variant: "bodyS", children: e }) : e
] }), Aw = () => {
  const { error: e } = Ba();
  return /* @__PURE__ */ d.jsx(yi, { children: e });
}, Rw = () => {
  const { hint: e, id: t, disabled: n } = Ba();
  return /* @__PURE__ */ d.jsx("span", { id: t, className: Oe("a:text-sm", n ? "a:text-content-subtle" : "a:text-content-neutral"), children: e });
}, za = ({ testId: e, id: t, children: n, htmlFor: r, disabled: i, optionalText: a }) => /* @__PURE__ */ d.jsxs(
  "label",
  {
    id: t,
    htmlFor: r,
    "data-testid": e,
    className: Y("a:truncate a:font-functional a:text-sm a:text-content-emphasised", {
      "a:cursor-not-allowed": i
    }),
    children: [
      /* @__PURE__ */ d.jsx("span", { className: "a:font-semibold", children: n }),
      a && /* @__PURE__ */ d.jsx("span", { className: "a:ps-1", children: a })
    ]
  }
), Mw = () => {
  const { label: e, id: t, labelledBy: n, optionalText: r, disabled: i } = Ba();
  return /* @__PURE__ */ d.jsx(za, { optionalText: r, disabled: i, id: n, htmlFor: t, children: e });
}, Dn = (e) => /* @__PURE__ */ d.jsx(fg, { as: "button", ...e }), jw = () => {
  const { labelAdornment: e } = Ba();
  return e ? /* @__PURE__ */ d.jsx(Dn, { variant: "secondary", size: "sm", text: e.text, onClick: e.onClick }) : null;
}, ff = ({ content: e }) => /* @__PURE__ */ d.jsx("div", { className: "a:flex a:items-center", children: e }), Dw = de("", {
  variants: {
    hidden: {
      true: "a:hidden",
      false: `
        a:flex a:rounded-md a:border a:border-solid a:bg-surface-neutral
        a:has-[:enabled]:hover-pointer:border-border-neutral-hover
        a:focus-within:border-border-active
      `
    },
    adornmentStart: {
      true: "a:ps-1"
    },
    adornmentEnd: {
      true: "a:pe-1"
    },
    disabled: {
      true: "a:cursor-not-allowed a:bg-surface-quiet"
    },
    error: {
      true: "a:border-border-error",
      false: "a:border-border-neutral"
    }
  },
  defaultVariants: {
    hidden: !1,
    adornmentStart: !1,
    adornmentEnd: !1,
    disabled: !1,
    error: !1
  }
}), kw = de("a:w-full", {
  variants: {
    hidden: {
      false: `
        a:flex a:flex-auto a:py-2.5 a:text-content-neutral a:text-base a:placeholder-content-subtle a:outline-hidden a:text-ellipsis a:appearance-none
        a:focus:text-content-neutral
        a:autofill:shadow-none a:autofill:bg-clip-text
      `
    },
    adornmentStart: {
      false: "a:ps-3"
    },
    adornmentEnd: {
      false: "a:pe-3"
    },
    disabled: {
      true: "a:cursor-not-allowed"
    },
    readOnly: {
      true: ""
    }
  },
  compoundVariants: [
    {
      disabled: !0,
      readOnly: !0,
      className: "a:cursor-not-allowed"
    },
    {
      readOnly: !0,
      disabled: !1,
      className: "a:cursor-pointer"
    }
  ],
  defaultVariants: {
    hidden: !1,
    adornmentStart: !1,
    adornmentEnd: !1,
    disabled: !1,
    readOnly: !1
  }
}), Xt = ({
  autoComplete: e = "off",
  adornmentStart: t,
  adornmentEnd: n,
  testId: r = "input",
  id: i,
  innerRef: a,
  outerRef: o,
  name: s = i,
  disabled: l,
  error: u,
  type: c = "text",
  hint: f,
  label: p,
  labelAdornment: h,
  required: m,
  readOnly: v,
  optionalText: g,
  onChange: b,
  onFocus: y,
  onBlur: x,
  onKeyDown: w,
  onKeyUp: $,
  ...C
}) => {
  const T = `${i}-label`, S = `${i}-description`, N = (L) => {
    L.key && L.key === "Unidentified" && k(L), $ == null || $(L);
  }, k = (L) => {
    const _ = new Event("change", { bubbles: !0, cancelable: !0 });
    L.currentTarget.dispatchEvent(_);
  };
  return /* @__PURE__ */ d.jsx(
    v0.Provider,
    {
      value: {
        describedBy: S,
        disabled: l,
        error: u,
        hint: f,
        id: i,
        label: p,
        labelledBy: T,
        optionalText: g,
        labelAdornment: h
      },
      children: /* @__PURE__ */ d.jsxs(We, { gap: "1", children: [
        p && /* @__PURE__ */ d.jsxs(Pe, { contentAlign: "between", wrap: "nowrap", children: [
          /* @__PURE__ */ d.jsx(Mw, {}),
          /* @__PURE__ */ d.jsx(jw, {})
        ] }),
        /* @__PURE__ */ d.jsxs(
          "div",
          {
            ref: o,
            className: Y(
              Dw({
                adornmentStart: !!t,
                adornmentEnd: !!n,
                disabled: l,
                hidden: c === "hidden",
                error: !!u
              })
            ),
            children: [
              t && /* @__PURE__ */ d.jsx(ff, { content: t }),
              /* @__PURE__ */ d.jsx(
                "input",
                {
                  "aria-describedby": f ? S : void 0,
                  "aria-labelledby": T,
                  "aria-invalid": !!u,
                  "aria-required": m,
                  autoComplete: e,
                  "data-testid": r,
                  disabled: l,
                  required: m,
                  type: c,
                  id: i,
                  readOnly: v,
                  name: s,
                  ...C,
                  ref: a,
                  className: Y(
                    kw({
                      adornmentStart: !!t,
                      adornmentEnd: !!n,
                      disabled: l,
                      readOnly: v,
                      hidden: c === "hidden"
                    })
                  ),
                  onChange: b,
                  onFocus: y,
                  onBlur: x,
                  onKeyDown: w,
                  onKeyUp: N
                }
              ),
              n && /* @__PURE__ */ d.jsx(ff, { content: n })
            ]
          }
        ),
        u && typeof u != "boolean" ? /* @__PURE__ */ d.jsx(Aw, {}) : f ? /* @__PURE__ */ d.jsx(Rw, {}) : null
      ] })
    }
  );
};
function pt(e, { bgClass: t = "a:bg-neutral-700", animationClass: n = "a:animate-ripple" } = {}) {
  const r = e.currentTarget, i = document.createElement("span"), a = r.getBoundingClientRect(), o = Math.min(r.offsetWidth, r.offsetHeight), s = o / 2;
  i.style.width = i.style.height = `${o}px`, i.style.left = `${e.clientX - (s + a.left)}px`, i.style.top = `${e.clientY - (s + a.top)}px`, i.classList.add(n, "a:absolute", t, "a:rounded-circle", "a:opacity-0"), i.addEventListener("animationend", () => {
    i.remove();
  }), r.appendChild(i);
}
const pf = ({ content: e }) => /* @__PURE__ */ d.jsx("div", { className: "a:text-content-subtle a:flex a:items-center a:pe-2 a:ps-2", children: e }), Lw = de(
  "a:flex a:items-center a:relative a:overflow-hidden a:py-2 a:pe-1 a:border-0 a:border-s-2 a:border-solid",
  {
    variants: {
      adornmentStart: {
        true: "a:ps-0.5",
        false: "a:ps-2.5"
      },
      isItemDisabled: {
        true: "a:cursor-not-allowed a:text-content-neutral-disabled",
        false: "a:cursor-pointer a:hover:bg-surface-neutral-hover"
      },
      isHighlighted: {
        true: "a:bg-surface-neutral-hover a:[&:not(:hover)]:outline a:[&:not(:hover)]:outline-border-focus a:[&:not(:hover)]:outline-1 a:[&:not(:hover)]:-outline-offset-1"
      },
      isSelected: {
        true: "a:text-content-emphasised a:border-border-active",
        false: "a:border-transparent"
      }
    },
    compoundVariants: [
      {
        isItemDisabled: !1,
        isHighlighted: !1,
        isSelected: !1,
        class: "a:text-content-neutral"
      }
    ],
    defaultVariants: {
      adornmentStart: !1,
      isItemDisabled: !1,
      isHighlighted: !1,
      isSelected: !1
    }
  }
), Fw = ({
  text: e,
  id: t,
  isItemDisabled: n,
  isHighlighted: r,
  isSelected: i,
  innerRef: a,
  adornmentStart: o,
  adornmentEnd: s,
  testId: l,
  ...u
}) => /* @__PURE__ */ d.jsxs(
  "li",
  {
    ...u,
    ref: a,
    "data-testid": l,
    className: Y(
      Lw({ adornmentStart: !!o, isItemDisabled: n, isHighlighted: r, isSelected: i })
    ),
    children: [
      o && /* @__PURE__ */ d.jsx(pf, { content: o }),
      /* @__PURE__ */ d.jsx("div", { className: "a:grow-1", children: /* @__PURE__ */ d.jsx("span", { dangerouslySetInnerHTML: { __html: e } }) }),
      s && /* @__PURE__ */ d.jsx(pf, { content: s })
    ]
  }
), $0 = {
  color: "neutral",
  style: "solid"
}, Vw = de("a:border-bs a:border-be-0", {
  variants: {
    color: {
      neutral: "a:border-neutral-200",
      dark: "a:border-neutral-500"
    },
    orientation: {
      horizontal: "",
      vertical: "a:h-auto a:vertical-lr"
    },
    style: {
      solid: "a:border-solid",
      dashed: "a:border-dashed"
    }
  },
  defaultVariants: $0
}), Bw = de(
  [
    "a:m-0 a:flex a:flex-wrap a:items-center a:justify-items-center a:[&:not(:empty)]:gap-6",
    'a:before:content-[""] a:before:border-bs a:before:border-be-0 a:before:grow',
    'a:after:content-[""] a:after:border-bs a:after:border-be-0 a:after:grow'
  ],
  {
    variants: {
      color: {
        neutral: "a:before:border-neutral-200 a:after:border-neutral-200",
        dark: "a:before:border-neutral-500 a:after:border-neutral-500"
      },
      orientation: {
        horizontal: "",
        vertical: "a:h-auto a:vertical-lr"
      },
      style: {
        solid: "a:before:border-solid a:after:border-solid",
        dashed: "a:before:border-dashed a:after:border-dashed"
      }
    },
    defaultVariants: $0
  }
);
function Du({
  children: e,
  color: t,
  spacingClasses: n,
  orientation: r,
  text: i,
  style: a,
  testId: o,
  textProps: s
}) {
  const l = e || i ? Bw : Vw;
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      className: Y(l({ color: t, orientation: r, style: a }), Ze(n)),
      "data-testid": o,
      role: "separator",
      children: e ?? (i && /* @__PURE__ */ d.jsx(ie, { color: t === "dark" ? void 0 : "subtle", ...s, children: /* @__PURE__ */ d.jsx("span", { className: "a:horizontal-tb", children: i }) }))
    }
  );
}
const w0 = () => /* @__PURE__ */ d.jsx("li", { className: "a:py-2", children: /* @__PURE__ */ d.jsx(Du, {}) }), Dr = (e, t = "__TYPE") => (e == null ? void 0 : e.props) && e.props[t] || typeof (e == null ? void 0 : e.type) == "string" && e.type || (e == null ? void 0 : e.type) && typeof e.type == "symbol" && e.type.toString() === "Symbol(react.fragment)" && "react.fragment" || typeof (e == null ? void 0 : e.type) == "function" && e.type || typeof (e == null ? void 0 : e.type) == "object" && e.type.$$typeof.toString() === "Symbol(react.forward_ref)" && "react.forward_ref" || typeof e == "string" && "string" || typeof e == "function" && "function" || void 0, Hw = (e) => e.map((t) => {
  switch (typeof t) {
    case "string":
      return t;
    case "function":
      return Dr(Wr(t));
    case "object":
    default: {
      const n = Wr(t);
      return Dr(n) === "react.forward_ref" ? Dr(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        n.type.render(n.props, n.ref)
      ) : Dr(t);
    }
  }
}), Kw = (e) => Array.isArray(e) ? e.flat() : Aa.toArray(e).flat(), xt = (e, t, n, { customTypeKey: r = "__TYPE" } = {}) => {
  const i = Hw(Array.isArray(t) ? t : [t]);
  return Kw(e).filter(
    (a) => i.indexOf(Dr(a, r)) !== -1 && (!n || Object.entries(n).every(([o, s]) => a.props[o] === s))
  );
};
function Ga() {
  return typeof window < "u";
}
function vr(e) {
  return C0(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function dt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Ft(e) {
  var t;
  return (t = (C0(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function C0(e) {
  return Ga() ? e instanceof Node || e instanceof dt(e).Node : !1;
}
function Me(e) {
  return Ga() ? e instanceof Element || e instanceof dt(e).Element : !1;
}
function ht(e) {
  return Ga() ? e instanceof HTMLElement || e instanceof dt(e).HTMLElement : !1;
}
function zs(e) {
  return !Ga() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof dt(e).ShadowRoot;
}
function bi(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: i
  } = mt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(i);
}
function Ww(e) {
  return ["table", "td", "th"].includes(vr(e));
}
function Ua(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function ku(e) {
  const t = qa(), n = Me(e) ? mt(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function zw(e) {
  let t = tn(e);
  for (; ht(t) && !gn(t); ) {
    if (ku(t))
      return t;
    if (Ua(t))
      return null;
    t = tn(t);
  }
  return null;
}
function qa() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function gn(e) {
  return ["html", "body", "#document"].includes(vr(e));
}
function mt(e) {
  return dt(e).getComputedStyle(e);
}
function Ya(e) {
  return Me(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function tn(e) {
  if (vr(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    zs(e) && e.host || // Fallback.
    Ft(e)
  );
  return zs(t) ? t.host : t;
}
function S0(e) {
  const t = tn(e);
  return gn(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : ht(t) && bi(t) ? t : S0(t);
}
function pn(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = S0(e), a = i === ((r = e.ownerDocument) == null ? void 0 : r.body), o = dt(i);
  if (a) {
    const s = Gs(o);
    return t.concat(o, o.visualViewport || [], bi(i) ? i : [], s && n ? pn(s) : []);
  }
  return t.concat(i, pn(i, [], n));
}
function Gs(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Gw(e) {
  let t = e.activeElement;
  for (; ((n = t) == null || (n = n.shadowRoot) == null ? void 0 : n.activeElement) != null; ) {
    var n;
    t = t.shadowRoot.activeElement;
  }
  return t;
}
function Nn(e, t) {
  if (!e || !t)
    return !1;
  const n = t.getRootNode == null ? void 0 : t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && zs(n)) {
    let r = t;
    for (; r; ) {
      if (e === r)
        return !0;
      r = r.parentNode || r.host;
    }
  }
  return !1;
}
function Uw() {
  return /apple/i.test(navigator.vendor);
}
function ti(e, t) {
  const n = ["mouse", "pen"];
  return t || n.push("", void 0), n.includes(e);
}
function qw(e) {
  return "nativeEvent" in e;
}
function Yw(e) {
  return e.matches("html,body");
}
function In(e) {
  return (e == null ? void 0 : e.ownerDocument) || document;
}
function To(e, t) {
  if (t == null)
    return !1;
  if ("composedPath" in e)
    return e.composedPath().includes(t);
  const n = e;
  return n.target != null && t.contains(n.target);
}
function zn(e) {
  return "composedPath" in e ? e.composedPath()[0] : e.target;
}
const Xw = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function Zw(e) {
  return ht(e) && e.matches(Xw);
}
const At = Math.min, Qe = Math.max, fa = Math.round, ji = Math.floor, Dt = (e) => ({
  x: e,
  y: e
}), Jw = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Qw = {
  start: "end",
  end: "start"
};
function Us(e, t, n) {
  return Qe(e, At(t, n));
}
function kn(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function kt(e) {
  return e.split("-")[0];
}
function yr(e) {
  return e.split("-")[1];
}
function I0(e) {
  return e === "x" ? "y" : "x";
}
function Lu(e) {
  return e === "y" ? "height" : "width";
}
function vn(e) {
  return ["top", "bottom"].includes(kt(e)) ? "y" : "x";
}
function Fu(e) {
  return I0(vn(e));
}
function e4(e, t, n) {
  n === void 0 && (n = !1);
  const r = yr(e), i = Fu(e), a = Lu(i);
  let o = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (o = pa(o)), [o, pa(o)];
}
function t4(e) {
  const t = pa(e);
  return [qs(e), t, qs(t)];
}
function qs(e) {
  return e.replace(/start|end/g, (t) => Qw[t]);
}
function n4(e, t, n) {
  const r = ["left", "right"], i = ["right", "left"], a = ["top", "bottom"], o = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? i : r : t ? r : i;
    case "left":
    case "right":
      return t ? a : o;
    default:
      return [];
  }
}
function r4(e, t, n, r) {
  const i = yr(e);
  let a = n4(kt(e), n === "start", r);
  return i && (a = a.map((o) => o + "-" + i), t && (a = a.concat(a.map(qs)))), a;
}
function pa(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Jw[t]);
}
function i4(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Vu(e) {
  return typeof e != "number" ? i4(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function sr(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: i
  } = e;
  return {
    width: r,
    height: i,
    top: n,
    left: t,
    right: t + r,
    bottom: n + i,
    x: t,
    y: n
  };
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var a4 = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], Ys = /* @__PURE__ */ a4.join(","), E0 = typeof Element > "u", ni = E0 ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, ha = !E0 && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, ma = function e(t, n) {
  var r;
  n === void 0 && (n = !0);
  var i = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "inert"), a = i === "" || i === "true", o = a || n && t && e(t.parentNode);
  return o;
}, o4 = function(t) {
  var n, r = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return r === "" || r === "true";
}, s4 = function(t, n, r) {
  if (ma(t))
    return [];
  var i = Array.prototype.slice.apply(t.querySelectorAll(Ys));
  return n && ni.call(t, Ys) && i.unshift(t), i = i.filter(r), i;
}, l4 = function e(t, n, r) {
  for (var i = [], a = Array.from(t); a.length; ) {
    var o = a.shift();
    if (!ma(o, !1))
      if (o.tagName === "SLOT") {
        var s = o.assignedElements(), l = s.length ? s : o.children, u = e(l, !0, r);
        r.flatten ? i.push.apply(i, u) : i.push({
          scopeParent: o,
          candidates: u
        });
      } else {
        var c = ni.call(o, Ys);
        c && r.filter(o) && (n || !t.includes(o)) && i.push(o);
        var f = o.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(o), p = !ma(f, !1) && (!r.shadowRootFilter || r.shadowRootFilter(o));
        if (f && p) {
          var h = e(f === !0 ? o.children : f.children, !0, r);
          r.flatten ? i.push.apply(i, h) : i.push({
            scopeParent: o,
            candidates: h
          });
        } else
          a.unshift.apply(a, o.children);
      }
  }
  return i;
}, O0 = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, T0 = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || o4(t)) && !O0(t) ? 0 : t.tabIndex;
}, u4 = function(t, n) {
  var r = T0(t);
  return r < 0 && n && !O0(t) ? 0 : r;
}, c4 = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, P0 = function(t) {
  return t.tagName === "INPUT";
}, d4 = function(t) {
  return P0(t) && t.type === "hidden";
}, f4 = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, p4 = function(t, n) {
  for (var r = 0; r < t.length; r++)
    if (t[r].checked && t[r].form === n)
      return t[r];
}, h4 = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || ha(t), r = function(s) {
    return n.querySelectorAll('input[type="radio"][name="' + s + '"]');
  }, i;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    i = r(window.CSS.escape(t.name));
  else
    try {
      i = r(t.name);
    } catch (o) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", o.message), !1;
    }
  var a = p4(i, t.form);
  return !a || a === t;
}, m4 = function(t) {
  return P0(t) && t.type === "radio";
}, g4 = function(t) {
  return m4(t) && !h4(t);
}, v4 = function(t) {
  var n, r = t && ha(t), i = (n = r) === null || n === void 0 ? void 0 : n.host, a = !1;
  if (r && r !== t) {
    var o, s, l;
    for (a = !!((o = i) !== null && o !== void 0 && (s = o.ownerDocument) !== null && s !== void 0 && s.contains(i) || t != null && (l = t.ownerDocument) !== null && l !== void 0 && l.contains(t)); !a && i; ) {
      var u, c, f;
      r = ha(i), i = (u = r) === null || u === void 0 ? void 0 : u.host, a = !!((c = i) !== null && c !== void 0 && (f = c.ownerDocument) !== null && f !== void 0 && f.contains(i));
    }
  }
  return a;
}, hf = function(t) {
  var n = t.getBoundingClientRect(), r = n.width, i = n.height;
  return r === 0 && i === 0;
}, y4 = function(t, n) {
  var r = n.displayCheck, i = n.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var a = ni.call(t, "details>summary:first-of-type"), o = a ? t.parentElement : t;
  if (ni.call(o, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || r === "legacy-full") {
    if (typeof i == "function") {
      for (var s = t; t; ) {
        var l = t.parentElement, u = ha(t);
        if (l && !l.shadowRoot && i(l) === !0)
          return hf(t);
        t.assignedSlot ? t = t.assignedSlot : !l && u !== t.ownerDocument ? t = u.host : t = l;
      }
      t = s;
    }
    if (v4(t))
      return !t.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return hf(t);
  return !1;
}, b4 = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var i = n.children.item(r);
          if (i.tagName === "LEGEND")
            return ni.call(n, "fieldset[disabled] *") ? !0 : !i.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, x4 = function(t, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  ma(n) || d4(n) || y4(n, t) || // For a details element with a summary, the summary element gets the focus
  f4(n) || b4(n));
}, mf = function(t, n) {
  return !(g4(n) || T0(n) < 0 || !x4(t, n));
}, $4 = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, w4 = function e(t) {
  var n = [], r = [];
  return t.forEach(function(i, a) {
    var o = !!i.scopeParent, s = o ? i.scopeParent : i, l = u4(s, o), u = o ? e(i.candidates) : s;
    l === 0 ? o ? n.push.apply(n, u) : n.push(s) : r.push({
      documentOrder: a,
      tabIndex: l,
      item: i,
      isScope: o,
      content: u
    });
  }), r.sort(c4).reduce(function(i, a) {
    return a.isScope ? i.push.apply(i, a.content) : i.push(a.content), i;
  }, []).concat(n);
}, N0 = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = l4([t], n.includeContainer, {
    filter: mf.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: $4
  }) : r = s4(t, n.includeContainer, mf.bind(null, n)), w4(r);
};
function gf(e, t, n) {
  let {
    reference: r,
    floating: i
  } = e;
  const a = vn(t), o = Fu(t), s = Lu(o), l = kt(t), u = a === "y", c = r.x + r.width / 2 - i.width / 2, f = r.y + r.height / 2 - i.height / 2, p = r[s] / 2 - i[s] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: c,
        y: r.y - i.height
      };
      break;
    case "bottom":
      h = {
        x: c,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      h = {
        x: r.x - i.width,
        y: f
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (yr(t)) {
    case "start":
      h[o] -= p * (n && u ? -1 : 1);
      break;
    case "end":
      h[o] += p * (n && u ? -1 : 1);
      break;
  }
  return h;
}
const C4 = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: a = [],
    platform: o
  } = n, s = a.filter(Boolean), l = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let u = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: c,
    y: f
  } = gf(u, r, l), p = r, h = {}, m = 0;
  for (let v = 0; v < s.length; v++) {
    const {
      name: g,
      fn: b
    } = s[v], {
      x: y,
      y: x,
      data: w,
      reset: $
    } = await b({
      x: c,
      y: f,
      initialPlacement: r,
      placement: p,
      strategy: i,
      middlewareData: h,
      rects: u,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    c = y ?? c, f = x ?? f, h = {
      ...h,
      [g]: {
        ...h[g],
        ...w
      }
    }, $ && m <= 50 && (m++, typeof $ == "object" && ($.placement && (p = $.placement), $.rects && (u = $.rects === !0 ? await o.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : $.rects), {
      x: c,
      y: f
    } = gf(u, p, l)), v = -1);
  }
  return {
    x: c,
    y: f,
    placement: p,
    strategy: i,
    middlewareData: h
  };
};
async function Xa(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: i,
    platform: a,
    rects: o,
    elements: s,
    strategy: l
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: f = "floating",
    altBoundary: p = !1,
    padding: h = 0
  } = kn(t, e), m = Vu(h), g = s[p ? f === "floating" ? "reference" : "floating" : f], b = sr(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(g))) == null || n ? g : g.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: u,
    rootBoundary: c,
    strategy: l
  })), y = f === "floating" ? {
    x: r,
    y: i,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, x = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), w = await (a.isElement == null ? void 0 : a.isElement(x)) ? await (a.getScale == null ? void 0 : a.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, $ = sr(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: y,
    offsetParent: x,
    strategy: l
  }) : y);
  return {
    top: (b.top - $.top + m.top) / w.y,
    bottom: ($.bottom - b.bottom + m.bottom) / w.y,
    left: (b.left - $.left + m.left) / w.x,
    right: ($.right - b.right + m.right) / w.x
  };
}
const S4 = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: i,
      rects: a,
      platform: o,
      elements: s,
      middlewareData: l
    } = t, {
      element: u,
      padding: c = 0
    } = kn(e, t) || {};
    if (u == null)
      return {};
    const f = Vu(c), p = {
      x: n,
      y: r
    }, h = Fu(i), m = Lu(h), v = await o.getDimensions(u), g = h === "y", b = g ? "top" : "left", y = g ? "bottom" : "right", x = g ? "clientHeight" : "clientWidth", w = a.reference[m] + a.reference[h] - p[h] - a.floating[m], $ = p[h] - a.reference[h], C = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(u));
    let T = C ? C[x] : 0;
    (!T || !await (o.isElement == null ? void 0 : o.isElement(C))) && (T = s.floating[x] || a.floating[m]);
    const S = w / 2 - $ / 2, N = T / 2 - v[m] / 2 - 1, k = At(f[b], N), L = At(f[y], N), _ = k, B = T - v[m] - L, A = T / 2 - v[m] / 2 + S, q = Us(_, A, B), X = !l.arrow && yr(i) != null && A !== q && a.reference[m] / 2 - (A < _ ? k : L) - v[m] / 2 < 0, I = X ? A < _ ? A - _ : A - B : 0;
    return {
      [h]: p[h] + I,
      data: {
        [h]: q,
        centerOffset: A - q - I,
        ...X && {
          alignmentOffset: I
        }
      },
      reset: X
    };
  }
}), I4 = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        middlewareData: a,
        rects: o,
        initialPlacement: s,
        platform: l,
        elements: u
      } = t, {
        mainAxis: c = !0,
        crossAxis: f = !0,
        fallbackPlacements: p,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: v = !0,
        ...g
      } = kn(e, t);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const b = kt(i), y = vn(s), x = kt(s) === s, w = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), $ = p || (x || !v ? [pa(s)] : t4(s)), C = m !== "none";
      !p && C && $.push(...r4(s, v, m, w));
      const T = [s, ...$], S = await Xa(t, g), N = [];
      let k = ((r = a.flip) == null ? void 0 : r.overflows) || [];
      if (c && N.push(S[b]), f) {
        const A = e4(i, o, w);
        N.push(S[A[0]], S[A[1]]);
      }
      if (k = [...k, {
        placement: i,
        overflows: N
      }], !N.every((A) => A <= 0)) {
        var L, _;
        const A = (((L = a.flip) == null ? void 0 : L.index) || 0) + 1, q = T[A];
        if (q)
          return {
            data: {
              index: A,
              overflows: k
            },
            reset: {
              placement: q
            }
          };
        let X = (_ = k.filter((I) => I.overflows[0] <= 0).sort((I, O) => I.overflows[1] - O.overflows[1])[0]) == null ? void 0 : _.placement;
        if (!X)
          switch (h) {
            case "bestFit": {
              var B;
              const I = (B = k.filter((O) => {
                if (C) {
                  const D = vn(O.placement);
                  return D === y || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  D === "y";
                }
                return !0;
              }).map((O) => [O.placement, O.overflows.filter((D) => D > 0).reduce((D, E) => D + E, 0)]).sort((O, D) => O[1] - D[1])[0]) == null ? void 0 : B[0];
              I && (X = I);
              break;
            }
            case "initialPlacement":
              X = s;
              break;
          }
        if (i !== X)
          return {
            reset: {
              placement: X
            }
          };
      }
      return {};
    }
  };
};
function _0(e) {
  const t = At(...e.map((a) => a.left)), n = At(...e.map((a) => a.top)), r = Qe(...e.map((a) => a.right)), i = Qe(...e.map((a) => a.bottom));
  return {
    x: t,
    y: n,
    width: r - t,
    height: i - n
  };
}
function E4(e) {
  const t = e.slice().sort((i, a) => i.y - a.y), n = [];
  let r = null;
  for (let i = 0; i < t.length; i++) {
    const a = t[i];
    !r || a.y - r.y > r.height / 2 ? n.push([a]) : n[n.length - 1].push(a), r = a;
  }
  return n.map((i) => sr(_0(i)));
}
const O4 = function(e) {
  return e === void 0 && (e = {}), {
    name: "inline",
    options: e,
    async fn(t) {
      const {
        placement: n,
        elements: r,
        rects: i,
        platform: a,
        strategy: o
      } = t, {
        padding: s = 2,
        x: l,
        y: u
      } = kn(e, t), c = Array.from(await (a.getClientRects == null ? void 0 : a.getClientRects(r.reference)) || []), f = E4(c), p = sr(_0(c)), h = Vu(s);
      function m() {
        if (f.length === 2 && f[0].left > f[1].right && l != null && u != null)
          return f.find((g) => l > g.left - h.left && l < g.right + h.right && u > g.top - h.top && u < g.bottom + h.bottom) || p;
        if (f.length >= 2) {
          if (vn(n) === "y") {
            const k = f[0], L = f[f.length - 1], _ = kt(n) === "top", B = k.top, A = L.bottom, q = _ ? k.left : L.left, X = _ ? k.right : L.right, I = X - q, O = A - B;
            return {
              top: B,
              bottom: A,
              left: q,
              right: X,
              width: I,
              height: O,
              x: q,
              y: B
            };
          }
          const g = kt(n) === "left", b = Qe(...f.map((k) => k.right)), y = At(...f.map((k) => k.left)), x = f.filter((k) => g ? k.left === y : k.right === b), w = x[0].top, $ = x[x.length - 1].bottom, C = y, T = b, S = T - C, N = $ - w;
          return {
            top: w,
            bottom: $,
            left: C,
            right: T,
            width: S,
            height: N,
            x: C,
            y: w
          };
        }
        return p;
      }
      const v = await a.getElementRects({
        reference: {
          getBoundingClientRect: m
        },
        floating: r.floating,
        strategy: o
      });
      return i.reference.x !== v.reference.x || i.reference.y !== v.reference.y || i.reference.width !== v.reference.width || i.reference.height !== v.reference.height ? {
        reset: {
          rects: v
        }
      } : {};
    }
  };
};
async function T4(e, t) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), o = kt(n), s = yr(n), l = vn(n) === "y", u = ["left", "top"].includes(o) ? -1 : 1, c = a && l ? -1 : 1, f = kn(t, e);
  let {
    mainAxis: p,
    crossAxis: h,
    alignmentAxis: m
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return s && typeof m == "number" && (h = s === "end" ? m * -1 : m), l ? {
    x: h * c,
    y: p * u
  } : {
    x: p * u,
    y: h * c
  };
}
const P4 = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: i,
        y: a,
        placement: o,
        middlewareData: s
      } = t, l = await T4(t, e);
      return o === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: i + l.x,
        y: a + l.y,
        data: {
          ...l,
          placement: o
        }
      };
    }
  };
}, N4 = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: i
      } = t, {
        mainAxis: a = !0,
        crossAxis: o = !1,
        limiter: s = {
          fn: (g) => {
            let {
              x: b,
              y
            } = g;
            return {
              x: b,
              y
            };
          }
        },
        ...l
      } = kn(e, t), u = {
        x: n,
        y: r
      }, c = await Xa(t, l), f = vn(kt(i)), p = I0(f);
      let h = u[p], m = u[f];
      if (a) {
        const g = p === "y" ? "top" : "left", b = p === "y" ? "bottom" : "right", y = h + c[g], x = h - c[b];
        h = Us(y, h, x);
      }
      if (o) {
        const g = f === "y" ? "top" : "left", b = f === "y" ? "bottom" : "right", y = m + c[g], x = m - c[b];
        m = Us(y, m, x);
      }
      const v = s.fn({
        ...t,
        [p]: h,
        [f]: m
      });
      return {
        ...v,
        data: {
          x: v.x - n,
          y: v.y - r,
          enabled: {
            [p]: a,
            [f]: o
          }
        }
      };
    }
  };
}, _4 = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        rects: a,
        platform: o,
        elements: s
      } = t, {
        apply: l = () => {
        },
        ...u
      } = kn(e, t), c = await Xa(t, u), f = kt(i), p = yr(i), h = vn(i) === "y", {
        width: m,
        height: v
      } = a.floating;
      let g, b;
      f === "top" || f === "bottom" ? (g = f, b = p === (await (o.isRTL == null ? void 0 : o.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (b = f, g = p === "end" ? "top" : "bottom");
      const y = v - c.top - c.bottom, x = m - c.left - c.right, w = At(v - c[g], y), $ = At(m - c[b], x), C = !t.middlewareData.shift;
      let T = w, S = $;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (S = x), (r = t.middlewareData.shift) != null && r.enabled.y && (T = y), C && !p) {
        const k = Qe(c.left, 0), L = Qe(c.right, 0), _ = Qe(c.top, 0), B = Qe(c.bottom, 0);
        h ? S = m - 2 * (k !== 0 || L !== 0 ? k + L : Qe(c.left, c.right)) : T = v - 2 * (_ !== 0 || B !== 0 ? _ + B : Qe(c.top, c.bottom));
      }
      await l({
        ...t,
        availableWidth: S,
        availableHeight: T
      });
      const N = await o.getDimensions(s.floating);
      return m !== N.width || v !== N.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function A0(e) {
  const t = mt(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const i = ht(e), a = i ? e.offsetWidth : n, o = i ? e.offsetHeight : r, s = fa(n) !== a || fa(r) !== o;
  return s && (n = a, r = o), {
    width: n,
    height: r,
    $: s
  };
}
function Bu(e) {
  return Me(e) ? e : e.contextElement;
}
function er(e) {
  const t = Bu(e);
  if (!ht(t))
    return Dt(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: i,
    $: a
  } = A0(t);
  let o = (a ? fa(n.width) : n.width) / r, s = (a ? fa(n.height) : n.height) / i;
  return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: o,
    y: s
  };
}
const A4 = /* @__PURE__ */ Dt(0);
function R0(e) {
  const t = dt(e);
  return !qa() || !t.visualViewport ? A4 : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function R4(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== dt(e) ? !1 : t;
}
function Rn(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), a = Bu(e);
  let o = Dt(1);
  t && (r ? Me(r) && (o = er(r)) : o = er(e));
  const s = R4(a, n, r) ? R0(a) : Dt(0);
  let l = (i.left + s.x) / o.x, u = (i.top + s.y) / o.y, c = i.width / o.x, f = i.height / o.y;
  if (a) {
    const p = dt(a), h = r && Me(r) ? dt(r) : r;
    let m = p, v = Gs(m);
    for (; v && r && h !== m; ) {
      const g = er(v), b = v.getBoundingClientRect(), y = mt(v), x = b.left + (v.clientLeft + parseFloat(y.paddingLeft)) * g.x, w = b.top + (v.clientTop + parseFloat(y.paddingTop)) * g.y;
      l *= g.x, u *= g.y, c *= g.x, f *= g.y, l += x, u += w, m = dt(v), v = Gs(m);
    }
  }
  return sr({
    width: c,
    height: f,
    x: l,
    y: u
  });
}
function Hu(e, t) {
  const n = Ya(e).scrollLeft;
  return t ? t.left + n : Rn(Ft(e)).left + n;
}
function M0(e, t, n) {
  n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), i = r.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    Hu(e, r)
  )), a = r.top + t.scrollTop;
  return {
    x: i,
    y: a
  };
}
function M4(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: i
  } = e;
  const a = i === "fixed", o = Ft(r), s = t ? Ua(t.floating) : !1;
  if (r === o || s && a)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = Dt(1);
  const c = Dt(0), f = ht(r);
  if ((f || !f && !a) && ((vr(r) !== "body" || bi(o)) && (l = Ya(r)), ht(r))) {
    const h = Rn(r);
    u = er(r), c.x = h.x + r.clientLeft, c.y = h.y + r.clientTop;
  }
  const p = o && !f && !a ? M0(o, l, !0) : Dt(0);
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - l.scrollLeft * u.x + c.x + p.x,
    y: n.y * u.y - l.scrollTop * u.y + c.y + p.y
  };
}
function j4(e) {
  return Array.from(e.getClientRects());
}
function D4(e) {
  const t = Ft(e), n = Ya(e), r = e.ownerDocument.body, i = Qe(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = Qe(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let o = -n.scrollLeft + Hu(e);
  const s = -n.scrollTop;
  return mt(r).direction === "rtl" && (o += Qe(t.clientWidth, r.clientWidth) - i), {
    width: i,
    height: a,
    x: o,
    y: s
  };
}
function k4(e, t) {
  const n = dt(e), r = Ft(e), i = n.visualViewport;
  let a = r.clientWidth, o = r.clientHeight, s = 0, l = 0;
  if (i) {
    a = i.width, o = i.height;
    const u = qa();
    (!u || u && t === "fixed") && (s = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: a,
    height: o,
    x: s,
    y: l
  };
}
function L4(e, t) {
  const n = Rn(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, a = ht(e) ? er(e) : Dt(1), o = e.clientWidth * a.x, s = e.clientHeight * a.y, l = i * a.x, u = r * a.y;
  return {
    width: o,
    height: s,
    x: l,
    y: u
  };
}
function vf(e, t, n) {
  let r;
  if (t === "viewport")
    r = k4(e, n);
  else if (t === "document")
    r = D4(Ft(e));
  else if (Me(t))
    r = L4(t, n);
  else {
    const i = R0(e);
    r = {
      x: t.x - i.x,
      y: t.y - i.y,
      width: t.width,
      height: t.height
    };
  }
  return sr(r);
}
function j0(e, t) {
  const n = tn(e);
  return n === t || !Me(n) || gn(n) ? !1 : mt(n).position === "fixed" || j0(n, t);
}
function F4(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = pn(e, [], !1).filter((s) => Me(s) && vr(s) !== "body"), i = null;
  const a = mt(e).position === "fixed";
  let o = a ? tn(e) : e;
  for (; Me(o) && !gn(o); ) {
    const s = mt(o), l = ku(o);
    !l && s.position === "fixed" && (i = null), (a ? !l && !i : !l && s.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || bi(o) && !l && j0(e, o)) ? r = r.filter((c) => c !== o) : i = s, o = tn(o);
  }
  return t.set(e, r), r;
}
function V4(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = e;
  const o = [...n === "clippingAncestors" ? Ua(t) ? [] : F4(t, this._c) : [].concat(n), r], s = o[0], l = o.reduce((u, c) => {
    const f = vf(t, c, i);
    return u.top = Qe(f.top, u.top), u.right = At(f.right, u.right), u.bottom = At(f.bottom, u.bottom), u.left = Qe(f.left, u.left), u;
  }, vf(t, s, i));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function B4(e) {
  const {
    width: t,
    height: n
  } = A0(e);
  return {
    width: t,
    height: n
  };
}
function H4(e, t, n) {
  const r = ht(t), i = Ft(t), a = n === "fixed", o = Rn(e, !0, a, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Dt(0);
  if (r || !r && !a)
    if ((vr(t) !== "body" || bi(i)) && (s = Ya(t)), r) {
      const p = Rn(t, !0, a, t);
      l.x = p.x + t.clientLeft, l.y = p.y + t.clientTop;
    } else i && (l.x = Hu(i));
  const u = i && !r && !a ? M0(i, s) : Dt(0), c = o.left + s.scrollLeft - l.x - u.x, f = o.top + s.scrollTop - l.y - u.y;
  return {
    x: c,
    y: f,
    width: o.width,
    height: o.height
  };
}
function Po(e) {
  return mt(e).position === "static";
}
function yf(e, t) {
  if (!ht(e) || mt(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Ft(e) === n && (n = n.ownerDocument.body), n;
}
function D0(e, t) {
  const n = dt(e);
  if (Ua(e))
    return n;
  if (!ht(e)) {
    let i = tn(e);
    for (; i && !gn(i); ) {
      if (Me(i) && !Po(i))
        return i;
      i = tn(i);
    }
    return n;
  }
  let r = yf(e, t);
  for (; r && Ww(r) && Po(r); )
    r = yf(r, t);
  return r && gn(r) && Po(r) && !ku(r) ? n : r || zw(e) || n;
}
const K4 = async function(e) {
  const t = this.getOffsetParent || D0, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: H4(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function W4(e) {
  return mt(e).direction === "rtl";
}
const z4 = {
  convertOffsetParentRelativeRectToViewportRelativeRect: M4,
  getDocumentElement: Ft,
  getClippingRect: V4,
  getOffsetParent: D0,
  getElementRects: K4,
  getClientRects: j4,
  getDimensions: B4,
  getScale: er,
  isElement: Me,
  isRTL: W4
};
function k0(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function G4(e, t) {
  let n = null, r;
  const i = Ft(e);
  function a() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function o(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), a();
    const u = e.getBoundingClientRect(), {
      left: c,
      top: f,
      width: p,
      height: h
    } = u;
    if (s || t(), !p || !h)
      return;
    const m = ji(f), v = ji(i.clientWidth - (c + p)), g = ji(i.clientHeight - (f + h)), b = ji(c), x = {
      rootMargin: -m + "px " + -v + "px " + -g + "px " + -b + "px",
      threshold: Qe(0, At(1, l)) || 1
    };
    let w = !0;
    function $(C) {
      const T = C[0].intersectionRatio;
      if (T !== l) {
        if (!w)
          return o();
        T ? o(!1, T) : r = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      T === 1 && !k0(u, e.getBoundingClientRect()) && o(), w = !1;
    }
    try {
      n = new IntersectionObserver($, {
        ...x,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver($, x);
    }
    n.observe(e);
  }
  return o(!0), a;
}
function L0(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: a = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, u = Bu(e), c = i || a ? [...u ? pn(u) : [], ...pn(t)] : [];
  c.forEach((b) => {
    i && b.addEventListener("scroll", n, {
      passive: !0
    }), a && b.addEventListener("resize", n);
  });
  const f = u && s ? G4(u, n) : null;
  let p = -1, h = null;
  o && (h = new ResizeObserver((b) => {
    let [y] = b;
    y && y.target === u && h && (h.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var x;
      (x = h) == null || x.observe(t);
    })), n();
  }), u && !l && h.observe(u), h.observe(t));
  let m, v = l ? Rn(e) : null;
  l && g();
  function g() {
    const b = Rn(e);
    v && !k0(v, b) && n(), v = b, m = requestAnimationFrame(g);
  }
  return n(), () => {
    var b;
    c.forEach((y) => {
      i && y.removeEventListener("scroll", n), a && y.removeEventListener("resize", n);
    }), f == null || f(), (b = h) == null || b.disconnect(), h = null, l && cancelAnimationFrame(m);
  };
}
const U4 = Xa, q4 = P4, Y4 = N4, X4 = I4, Z4 = _4, bf = S4, J4 = O4, Q4 = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: z4,
    ...n
  }, a = {
    ...i.platform,
    _c: r
  };
  return C4(e, t, {
    ...i,
    platform: a
  });
};
var Zi = typeof document < "u" ? Na : se;
function ga(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, i;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!ga(e[r], t[r]))
          return !1;
      return !0;
    }
    if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, i[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const a = i[r];
      if (!(a === "_owner" && e.$$typeof) && !ga(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function F0(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function xf(e, t) {
  const n = F0(e);
  return Math.round(t * n) / n;
}
function No(e) {
  const t = M.useRef(e);
  return Zi(() => {
    t.current = e;
  }), t;
}
function e5(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: i,
    elements: {
      reference: a,
      floating: o
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: u
  } = e, [c, f] = M.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [p, h] = M.useState(r);
  ga(p, r) || h(r);
  const [m, v] = M.useState(null), [g, b] = M.useState(null), y = M.useCallback((O) => {
    O !== C.current && (C.current = O, v(O));
  }, []), x = M.useCallback((O) => {
    O !== T.current && (T.current = O, b(O));
  }, []), w = a || m, $ = o || g, C = M.useRef(null), T = M.useRef(null), S = M.useRef(c), N = l != null, k = No(l), L = No(i), _ = No(u), B = M.useCallback(() => {
    if (!C.current || !T.current)
      return;
    const O = {
      placement: t,
      strategy: n,
      middleware: p
    };
    L.current && (O.platform = L.current), Q4(C.current, T.current, O).then((D) => {
      const E = {
        ...D,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: _.current !== !1
      };
      A.current && !ga(S.current, E) && (S.current = E, Ph.flushSync(() => {
        f(E);
      }));
    });
  }, [p, t, n, L, _]);
  Zi(() => {
    u === !1 && S.current.isPositioned && (S.current.isPositioned = !1, f((O) => ({
      ...O,
      isPositioned: !1
    })));
  }, [u]);
  const A = M.useRef(!1);
  Zi(() => (A.current = !0, () => {
    A.current = !1;
  }), []), Zi(() => {
    if (w && (C.current = w), $ && (T.current = $), w && $) {
      if (k.current)
        return k.current(w, $, B);
      B();
    }
  }, [w, $, B, k, N]);
  const q = M.useMemo(() => ({
    reference: C,
    floating: T,
    setReference: y,
    setFloating: x
  }), [y, x]), X = M.useMemo(() => ({
    reference: w,
    floating: $
  }), [w, $]), I = M.useMemo(() => {
    const O = {
      position: n,
      left: 0,
      top: 0
    };
    if (!X.floating)
      return O;
    const D = xf(X.floating, c.x), E = xf(X.floating, c.y);
    return s ? {
      ...O,
      transform: "translate(" + D + "px, " + E + "px)",
      ...F0(X.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: D,
      top: E
    };
  }, [n, s, X.floating, c.x, c.y]);
  return M.useMemo(() => ({
    ...c,
    update: B,
    refs: q,
    elements: X,
    floatingStyles: I
  }), [c, B, q, X, I]);
}
const t5 = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: i
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? bf({
        element: r.current,
        padding: i
      }).fn(n) : {} : r ? bf({
        element: r,
        padding: i
      }).fn(n) : {};
    }
  };
}, V0 = (e, t) => ({
  ...q4(e),
  options: [e, t]
}), B0 = (e, t) => ({
  ...Y4(e),
  options: [e, t]
}), Ku = (e, t) => ({
  ...X4(e),
  options: [e, t]
}), n5 = (e, t) => ({
  ...Z4(e),
  options: [e, t]
}), r5 = (e, t) => ({
  ...J4(e),
  options: [e, t]
}), H0 = (e, t) => ({
  ...t5(e),
  options: [e, t]
}), K0 = {
  ...M
}, i5 = K0.useInsertionEffect, a5 = i5 || ((e) => e());
function zt(e) {
  const t = M.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return a5(() => {
    t.current = e;
  }), M.useCallback(function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return t.current == null ? void 0 : t.current(...r);
  }, []);
}
var ft = typeof document < "u" ? Na : se;
function va() {
  return va = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, va.apply(this, arguments);
}
let $f = !1, o5 = 0;
const wf = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + o5++
);
function s5() {
  const [e, t] = M.useState(() => $f ? wf() : void 0);
  return ft(() => {
    e == null && t(wf());
  }, []), M.useEffect(() => {
    $f = !0;
  }, []), e;
}
const l5 = K0.useId, Wu = l5 || s5;
let ri;
process.env.NODE_ENV !== "production" && (ri = /* @__PURE__ */ new Set());
function u5() {
  for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  const i = "Floating UI: " + n.join(" ");
  if (!((e = ri) != null && e.has(i))) {
    var a;
    (a = ri) == null || a.add(i), console.warn(i);
  }
}
function c5() {
  for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  const i = "Floating UI: " + n.join(" ");
  if (!((e = ri) != null && e.has(i))) {
    var a;
    (a = ri) == null || a.add(i), console.error(i);
  }
}
const W0 = /* @__PURE__ */ M.forwardRef(function(t, n) {
  const {
    context: {
      placement: r,
      elements: {
        floating: i
      },
      middlewareData: {
        arrow: a,
        shift: o
      }
    },
    width: s = 14,
    height: l = 7,
    tipRadius: u = 0,
    strokeWidth: c = 0,
    staticOffset: f,
    stroke: p,
    d: h,
    style: {
      transform: m,
      ...v
    } = {},
    ...g
  } = t;
  process.env.NODE_ENV !== "production" && (n || u5("The `ref` prop is required for `FloatingArrow`."));
  const b = Wu(), [y, x] = M.useState(!1);
  if (ft(() => {
    if (!i) return;
    mt(i).direction === "rtl" && x(!0);
  }, [i]), !i)
    return null;
  const [w, $] = r.split("-"), C = w === "top" || w === "bottom";
  let T = f;
  (C && o != null && o.x || !C && o != null && o.y) && (T = null);
  const S = c * 2, N = S / 2, k = s / 2 * (u / -8 + 1), L = l / 2 * u / 4, _ = !!h, B = T && $ === "end" ? "bottom" : "top";
  let A = T && $ === "end" ? "right" : "left";
  T && y && (A = $ === "end" ? "left" : "right");
  const q = (a == null ? void 0 : a.x) != null ? T || a.x : "", X = (a == null ? void 0 : a.y) != null ? T || a.y : "", I = h || "M0,0" + (" H" + s) + (" L" + (s - k) + "," + (l - L)) + (" Q" + s / 2 + "," + l + " " + k + "," + (l - L)) + " Z", O = {
    top: _ ? "rotate(180deg)" : "",
    left: _ ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: _ ? "" : "rotate(180deg)",
    right: _ ? "rotate(-90deg)" : "rotate(90deg)"
  }[w];
  return /* @__PURE__ */ M.createElement("svg", va({}, g, {
    "aria-hidden": !0,
    ref: n,
    width: _ ? s : s + S,
    height: s,
    viewBox: "0 0 " + s + " " + (l > s ? l : s),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [A]: q,
      [B]: X,
      [w]: C || _ ? "100%" : "calc(100% - " + S / 2 + "px)",
      transform: [O, m].filter((D) => !!D).join(" "),
      ...v
    }
  }), S > 0 && /* @__PURE__ */ M.createElement("path", {
    clipPath: "url(#" + b + ")",
    fill: "none",
    stroke: p,
    strokeWidth: S + (h ? 0 : 1),
    d: I
  }), /* @__PURE__ */ M.createElement("path", {
    stroke: S && !h ? g.fill : "none",
    d: I
  }), /* @__PURE__ */ M.createElement("clipPath", {
    id: b
  }, /* @__PURE__ */ M.createElement("rect", {
    x: -N,
    y: N * (_ ? -1 : 1),
    width: s + S,
    height: s
  })));
});
function d5() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, n) {
      var r;
      (r = e.get(t)) == null || r.forEach((i) => i(n));
    },
    on(t, n) {
      e.set(t, [...e.get(t) || [], n]);
    },
    off(t, n) {
      var r;
      e.set(t, ((r = e.get(t)) == null ? void 0 : r.filter((i) => i !== n)) || []);
    }
  };
}
const f5 = /* @__PURE__ */ M.createContext(null), p5 = /* @__PURE__ */ M.createContext(null), z0 = () => {
  var e;
  return ((e = M.useContext(f5)) == null ? void 0 : e.id) || null;
}, zu = () => M.useContext(p5);
function Za(e) {
  return "data-floating-ui-" + e;
}
function En(e) {
  const t = ce(e);
  return ft(() => {
    t.current = e;
  }), t;
}
const Cf = /* @__PURE__ */ Za("safe-polygon");
function _o(e, t, n) {
  return n && !ti(n) ? 0 : typeof e == "number" ? e : e == null ? void 0 : e[t];
}
function h5(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    dataRef: i,
    events: a,
    elements: o
  } = e, {
    enabled: s = !0,
    delay: l = 0,
    handleClose: u = null,
    mouseOnly: c = !1,
    restMs: f = 0,
    move: p = !0
  } = t, h = zu(), m = z0(), v = En(u), g = En(l), b = En(n), y = M.useRef(), x = M.useRef(-1), w = M.useRef(), $ = M.useRef(-1), C = M.useRef(!0), T = M.useRef(!1), S = M.useRef(() => {
  }), N = M.useRef(!1), k = M.useCallback(() => {
    var I;
    const O = (I = i.current.openEvent) == null ? void 0 : I.type;
    return (O == null ? void 0 : O.includes("mouse")) && O !== "mousedown";
  }, [i]);
  M.useEffect(() => {
    if (!s) return;
    function I(O) {
      let {
        open: D
      } = O;
      D || (clearTimeout(x.current), clearTimeout($.current), C.current = !0, N.current = !1);
    }
    return a.on("openchange", I), () => {
      a.off("openchange", I);
    };
  }, [s, a]), M.useEffect(() => {
    if (!s || !v.current || !n) return;
    function I(D) {
      k() && r(!1, D, "hover");
    }
    const O = In(o.floating).documentElement;
    return O.addEventListener("mouseleave", I), () => {
      O.removeEventListener("mouseleave", I);
    };
  }, [o.floating, n, r, s, v, k]);
  const L = M.useCallback(function(I, O, D) {
    O === void 0 && (O = !0), D === void 0 && (D = "hover");
    const E = _o(g.current, "close", y.current);
    E && !w.current ? (clearTimeout(x.current), x.current = window.setTimeout(() => r(!1, I, D), E)) : O && (clearTimeout(x.current), r(!1, I, D));
  }, [g, r]), _ = zt(() => {
    S.current(), w.current = void 0;
  }), B = zt(() => {
    if (T.current) {
      const I = In(o.floating).body;
      I.style.pointerEvents = "", I.removeAttribute(Cf), T.current = !1;
    }
  }), A = zt(() => i.current.openEvent ? ["click", "mousedown"].includes(i.current.openEvent.type) : !1);
  M.useEffect(() => {
    if (!s) return;
    function I(j) {
      if (clearTimeout(x.current), C.current = !1, c && !ti(y.current) || f > 0 && !_o(g.current, "open"))
        return;
      const F = _o(g.current, "open", y.current);
      F ? x.current = window.setTimeout(() => {
        b.current || r(!0, j, "hover");
      }, F) : n || r(!0, j, "hover");
    }
    function O(j) {
      if (A()) return;
      S.current();
      const F = In(o.floating);
      if (clearTimeout($.current), N.current = !1, v.current && i.current.floatingContext) {
        n || clearTimeout(x.current), w.current = v.current({
          ...i.current.floatingContext,
          tree: h,
          x: j.clientX,
          y: j.clientY,
          onClose() {
            B(), _(), A() || L(j, !0, "safe-polygon");
          }
        });
        const H = w.current;
        F.addEventListener("mousemove", H), S.current = () => {
          F.removeEventListener("mousemove", H);
        };
        return;
      }
      (y.current === "touch" ? !Nn(o.floating, j.relatedTarget) : !0) && L(j);
    }
    function D(j) {
      A() || i.current.floatingContext && (v.current == null || v.current({
        ...i.current.floatingContext,
        tree: h,
        x: j.clientX,
        y: j.clientY,
        onClose() {
          B(), _(), A() || L(j);
        }
      })(j));
    }
    if (Me(o.domReference)) {
      var E;
      const j = o.domReference;
      return n && j.addEventListener("mouseleave", D), (E = o.floating) == null || E.addEventListener("mouseleave", D), p && j.addEventListener("mousemove", I, {
        once: !0
      }), j.addEventListener("mouseenter", I), j.addEventListener("mouseleave", O), () => {
        var F;
        n && j.removeEventListener("mouseleave", D), (F = o.floating) == null || F.removeEventListener("mouseleave", D), p && j.removeEventListener("mousemove", I), j.removeEventListener("mouseenter", I), j.removeEventListener("mouseleave", O);
      };
    }
  }, [o, s, e, c, f, p, L, _, B, r, n, b, h, g, v, i, A]), ft(() => {
    var I;
    if (s && n && (I = v.current) != null && I.__options.blockPointerEvents && k()) {
      T.current = !0;
      const D = o.floating;
      if (Me(o.domReference) && D) {
        var O;
        const E = In(o.floating).body;
        E.setAttribute(Cf, "");
        const j = o.domReference, F = h == null || (O = h.nodesRef.current.find((K) => K.id === m)) == null || (O = O.context) == null ? void 0 : O.elements.floating;
        return F && (F.style.pointerEvents = ""), E.style.pointerEvents = "none", j.style.pointerEvents = "auto", D.style.pointerEvents = "auto", () => {
          E.style.pointerEvents = "", j.style.pointerEvents = "", D.style.pointerEvents = "";
        };
      }
    }
  }, [s, n, m, o, h, v, k]), ft(() => {
    n || (y.current = void 0, N.current = !1, _(), B());
  }, [n, _, B]), M.useEffect(() => () => {
    _(), clearTimeout(x.current), clearTimeout($.current), B();
  }, [s, o.domReference, _, B]);
  const q = M.useMemo(() => {
    function I(O) {
      y.current = O.pointerType;
    }
    return {
      onPointerDown: I,
      onPointerEnter: I,
      onMouseMove(O) {
        const {
          nativeEvent: D
        } = O;
        function E() {
          !C.current && !b.current && r(!0, D, "hover");
        }
        c && !ti(y.current) || n || f === 0 || N.current && O.movementX ** 2 + O.movementY ** 2 < 2 || (clearTimeout($.current), y.current === "touch" ? E() : (N.current = !0, $.current = window.setTimeout(E, f)));
      }
    };
  }, [c, r, n, b, f]), X = M.useMemo(() => ({
    onMouseEnter() {
      clearTimeout(x.current);
    },
    onMouseLeave(I) {
      A() || L(I.nativeEvent, !1);
    }
  }), [L, A]);
  return M.useMemo(() => s ? {
    reference: q,
    floating: X
  } : {}, [s, q, X]);
}
function Ji(e, t) {
  let n = e.filter((i) => {
    var a;
    return i.parentId === t && ((a = i.context) == null ? void 0 : a.open);
  }), r = n;
  for (; r.length; )
    r = e.filter((i) => {
      var a;
      return (a = r) == null ? void 0 : a.some((o) => {
        var s;
        return i.parentId === o.id && ((s = i.context) == null ? void 0 : s.open);
      });
    }), n = n.concat(r);
  return n;
}
const G0 = () => ({
  getShadowRoot: !0,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function U0(e, t) {
  const n = N0(e, G0());
  t === "prev" && n.reverse();
  const r = n.indexOf(Gw(In(e)));
  return n.slice(r + 1)[0];
}
function m5() {
  return U0(document.body, "next");
}
function g5() {
  return U0(document.body, "prev");
}
function Ao(e, t) {
  const n = t || e.currentTarget, r = e.relatedTarget;
  return !r || !Nn(n, r);
}
function v5(e) {
  N0(e, G0()).forEach((n) => {
    n.dataset.tabindex = n.getAttribute("tabindex") || "", n.setAttribute("tabindex", "-1");
  });
}
function Sf(e) {
  e.querySelectorAll("[data-tabindex]").forEach((n) => {
    const r = n.dataset.tabindex;
    delete n.dataset.tabindex, r ? n.setAttribute("tabindex", r) : n.removeAttribute("tabindex");
  });
}
const q0 = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "fixed",
  whiteSpace: "nowrap",
  width: "1px",
  top: 0,
  left: 0
};
let y5;
function If(e) {
  e.key === "Tab" && (e.target, clearTimeout(y5));
}
const Ef = /* @__PURE__ */ M.forwardRef(function(t, n) {
  const [r, i] = M.useState();
  ft(() => (Uw() && i("button"), document.addEventListener("keydown", If), () => {
    document.removeEventListener("keydown", If);
  }), []);
  const a = {
    ref: n,
    tabIndex: 0,
    // Role is only for VoiceOver
    role: r,
    "aria-hidden": r ? void 0 : !0,
    [Za("focus-guard")]: "",
    style: q0
  };
  return /* @__PURE__ */ M.createElement("span", va({}, t, a));
}), Y0 = /* @__PURE__ */ M.createContext(null), Of = /* @__PURE__ */ Za("portal");
function b5(e) {
  e === void 0 && (e = {});
  const {
    id: t,
    root: n
  } = e, r = Wu(), i = x5(), [a, o] = M.useState(null), s = M.useRef(null);
  return ft(() => () => {
    a == null || a.remove(), queueMicrotask(() => {
      s.current = null;
    });
  }, [a]), ft(() => {
    if (!r || s.current) return;
    const l = t ? document.getElementById(t) : null;
    if (!l) return;
    const u = document.createElement("div");
    u.id = r, u.setAttribute(Of, ""), l.appendChild(u), s.current = u, o(u);
  }, [t, r]), ft(() => {
    if (n === null || !r || s.current) return;
    let l = n || (i == null ? void 0 : i.portalNode);
    l && !Me(l) && (l = l.current), l = l || document.body;
    let u = null;
    t && (u = document.createElement("div"), u.id = t, l.appendChild(u));
    const c = document.createElement("div");
    c.id = r, c.setAttribute(Of, ""), l = u || l, l.appendChild(c), s.current = c, o(c);
  }, [t, n, r, i]), a;
}
function Gu(e) {
  const {
    children: t,
    id: n,
    root: r,
    preserveTabOrder: i = !0
  } = e, a = b5({
    id: n,
    root: r
  }), [o, s] = M.useState(null), l = M.useRef(null), u = M.useRef(null), c = M.useRef(null), f = M.useRef(null), p = o == null ? void 0 : o.modal, h = o == null ? void 0 : o.open, m = (
    // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!o && // Guards are only for non-modal focus management.
    !o.modal && // Don't render if unmount is transitioning.
    o.open && i && !!(r || a)
  );
  return M.useEffect(() => {
    if (!a || !i || p)
      return;
    function v(g) {
      a && Ao(g) && (g.type === "focusin" ? Sf : v5)(a);
    }
    return a.addEventListener("focusin", v, !0), a.addEventListener("focusout", v, !0), () => {
      a.removeEventListener("focusin", v, !0), a.removeEventListener("focusout", v, !0);
    };
  }, [a, i, p]), M.useEffect(() => {
    a && (h || Sf(a));
  }, [h, a]), /* @__PURE__ */ M.createElement(Y0.Provider, {
    value: M.useMemo(() => ({
      preserveTabOrder: i,
      beforeOutsideRef: l,
      afterOutsideRef: u,
      beforeInsideRef: c,
      afterInsideRef: f,
      portalNode: a,
      setFocusManagerState: s
    }), [i, a])
  }, m && a && /* @__PURE__ */ M.createElement(Ef, {
    "data-type": "outside",
    ref: l,
    onFocus: (v) => {
      if (Ao(v, a)) {
        var g;
        (g = c.current) == null || g.focus();
      } else {
        const b = g5() || (o == null ? void 0 : o.refs.domReference.current);
        b == null || b.focus();
      }
    }
  }), m && a && /* @__PURE__ */ M.createElement("span", {
    "aria-owns": a.id,
    style: q0
  }), a && /* @__PURE__ */ Ph.createPortal(t, a), m && a && /* @__PURE__ */ M.createElement(Ef, {
    "data-type": "outside",
    ref: u,
    onFocus: (v) => {
      if (Ao(v, a)) {
        var g;
        (g = f.current) == null || g.focus();
      } else {
        const b = m5() || (o == null ? void 0 : o.refs.domReference.current);
        b == null || b.focus(), o != null && o.closeOnFocusOut && (o == null || o.onOpenChange(!1, v.nativeEvent, "focus-out"));
      }
    }
  }));
}
const x5 = () => M.useContext(Y0), $5 = "data-floating-ui-focusable";
function Tf(e) {
  return ht(e.target) && e.target.tagName === "BUTTON";
}
function Pf(e) {
  return Zw(e);
}
function X0(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    dataRef: i,
    elements: {
      domReference: a
    }
  } = e, {
    enabled: o = !0,
    event: s = "click",
    toggle: l = !0,
    ignoreMouse: u = !1,
    keyboardHandlers: c = !0,
    stickIfOpen: f = !0
  } = t, p = M.useRef(), h = M.useRef(!1), m = M.useMemo(() => ({
    onPointerDown(v) {
      p.current = v.pointerType;
    },
    onMouseDown(v) {
      const g = p.current;
      v.button === 0 && s !== "click" && (ti(g, !0) && u || (n && l && (!(i.current.openEvent && f) || i.current.openEvent.type === "mousedown") ? r(!1, v.nativeEvent, "click") : (v.preventDefault(), r(!0, v.nativeEvent, "click"))));
    },
    onClick(v) {
      const g = p.current;
      if (s === "mousedown" && p.current) {
        p.current = void 0;
        return;
      }
      ti(g, !0) && u || (n && l && (!(i.current.openEvent && f) || i.current.openEvent.type === "click") ? r(!1, v.nativeEvent, "click") : r(!0, v.nativeEvent, "click"));
    },
    onKeyDown(v) {
      p.current = void 0, !(v.defaultPrevented || !c || Tf(v)) && (v.key === " " && !Pf(a) && (v.preventDefault(), h.current = !0), v.key === "Enter" && r(!(n && l), v.nativeEvent, "click"));
    },
    onKeyUp(v) {
      v.defaultPrevented || !c || Tf(v) || Pf(a) || v.key === " " && h.current && (h.current = !1, r(!(n && l), v.nativeEvent, "click"));
    }
  }), [i, a, s, u, c, r, n, f, l]);
  return M.useMemo(() => o ? {
    reference: m
  } : {}, [o, m]);
}
const w5 = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
}, C5 = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
}, Nf = (e) => {
  var t, n;
  return {
    escapeKey: typeof e == "boolean" ? e : (t = e == null ? void 0 : e.escapeKey) != null ? t : !1,
    outsidePress: typeof e == "boolean" ? e : (n = e == null ? void 0 : e.outsidePress) != null ? n : !0
  };
};
function Z0(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    elements: i,
    dataRef: a
  } = e, {
    enabled: o = !0,
    escapeKey: s = !0,
    outsidePress: l = !0,
    outsidePressEvent: u = "pointerdown",
    referencePress: c = !1,
    referencePressEvent: f = "pointerdown",
    ancestorScroll: p = !1,
    bubbles: h,
    capture: m
  } = t, v = zu(), g = zt(typeof l == "function" ? l : () => !1), b = typeof l == "function" ? g : l, y = M.useRef(!1), x = M.useRef(!1), {
    escapeKey: w,
    outsidePress: $
  } = Nf(h), {
    escapeKey: C,
    outsidePress: T
  } = Nf(m), S = M.useRef(!1), N = zt((q) => {
    var X;
    if (!n || !o || !s || q.key !== "Escape" || S.current)
      return;
    const I = (X = a.current.floatingContext) == null ? void 0 : X.nodeId, O = v ? Ji(v.nodesRef.current, I) : [];
    if (!w && (q.stopPropagation(), O.length > 0)) {
      let D = !0;
      if (O.forEach((E) => {
        var j;
        if ((j = E.context) != null && j.open && !E.context.dataRef.current.__escapeKeyBubbles) {
          D = !1;
          return;
        }
      }), !D)
        return;
    }
    r(!1, qw(q) ? q.nativeEvent : q, "escape-key");
  }), k = zt((q) => {
    var X;
    const I = () => {
      var O;
      N(q), (O = zn(q)) == null || O.removeEventListener("keydown", I);
    };
    (X = zn(q)) == null || X.addEventListener("keydown", I);
  }), L = zt((q) => {
    var X;
    const I = y.current;
    y.current = !1;
    const O = x.current;
    if (x.current = !1, u === "click" && O || I || typeof b == "function" && !b(q))
      return;
    const D = zn(q), E = "[" + Za("inert") + "]", j = In(i.floating).querySelectorAll(E);
    let F = Me(D) ? D : null;
    for (; F && !gn(F); ) {
      const G = tn(F);
      if (gn(G) || !Me(G))
        break;
      F = G;
    }
    if (j.length && Me(D) && !Yw(D) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !Nn(D, i.floating) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(j).every((G) => !Nn(F, G)))
      return;
    if (ht(D) && A) {
      const G = D.clientWidth > 0 && D.scrollWidth > D.clientWidth, z = D.clientHeight > 0 && D.scrollHeight > D.clientHeight;
      let U = z && q.offsetX > D.clientWidth;
      if (z && mt(D).direction === "rtl" && (U = q.offsetX <= D.offsetWidth - D.clientWidth), U || G && q.offsetY > D.clientHeight)
        return;
    }
    const K = (X = a.current.floatingContext) == null ? void 0 : X.nodeId, H = v && Ji(v.nodesRef.current, K).some((G) => {
      var z;
      return To(q, (z = G.context) == null ? void 0 : z.elements.floating);
    });
    if (To(q, i.floating) || To(q, i.domReference) || H)
      return;
    const W = v ? Ji(v.nodesRef.current, K) : [];
    if (W.length > 0) {
      let G = !0;
      if (W.forEach((z) => {
        var U;
        if ((U = z.context) != null && U.open && !z.context.dataRef.current.__outsidePressBubbles) {
          G = !1;
          return;
        }
      }), !G)
        return;
    }
    r(!1, q, "outside-press");
  }), _ = zt((q) => {
    var X;
    const I = () => {
      var O;
      L(q), (O = zn(q)) == null || O.removeEventListener(u, I);
    };
    (X = zn(q)) == null || X.addEventListener(u, I);
  });
  M.useEffect(() => {
    if (!n || !o)
      return;
    a.current.__escapeKeyBubbles = w, a.current.__outsidePressBubbles = $;
    let q = -1;
    function X(j) {
      r(!1, j, "ancestor-scroll");
    }
    function I() {
      window.clearTimeout(q), S.current = !0;
    }
    function O() {
      q = window.setTimeout(
        () => {
          S.current = !1;
        },
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        qa() ? 5 : 0
      );
    }
    const D = In(i.floating);
    s && (D.addEventListener("keydown", C ? k : N, C), D.addEventListener("compositionstart", I), D.addEventListener("compositionend", O)), b && D.addEventListener(u, T ? _ : L, T);
    let E = [];
    return p && (Me(i.domReference) && (E = pn(i.domReference)), Me(i.floating) && (E = E.concat(pn(i.floating))), !Me(i.reference) && i.reference && i.reference.contextElement && (E = E.concat(pn(i.reference.contextElement)))), E = E.filter((j) => {
      var F;
      return j !== ((F = D.defaultView) == null ? void 0 : F.visualViewport);
    }), E.forEach((j) => {
      j.addEventListener("scroll", X, {
        passive: !0
      });
    }), () => {
      s && (D.removeEventListener("keydown", C ? k : N, C), D.removeEventListener("compositionstart", I), D.removeEventListener("compositionend", O)), b && D.removeEventListener(u, T ? _ : L, T), E.forEach((j) => {
        j.removeEventListener("scroll", X);
      }), window.clearTimeout(q);
    };
  }, [a, i, s, b, u, n, r, p, o, w, $, N, C, k, L, T, _]), M.useEffect(() => {
    y.current = !1;
  }, [b, u]);
  const B = M.useMemo(() => ({
    onKeyDown: N,
    [w5[f]]: (q) => {
      c && r(!1, q.nativeEvent, "reference-press");
    }
  }), [N, r, c, f]), A = M.useMemo(() => ({
    onKeyDown: N,
    onMouseDown() {
      x.current = !0;
    },
    onMouseUp() {
      x.current = !0;
    },
    [C5[u]]: () => {
      y.current = !0;
    }
  }), [N, u]);
  return M.useMemo(() => o ? {
    reference: B,
    floating: A
  } : {}, [o, B, A]);
}
function S5(e) {
  const {
    open: t = !1,
    onOpenChange: n,
    elements: r
  } = e, i = Wu(), a = M.useRef({}), [o] = M.useState(() => d5()), s = z0() != null;
  if (process.env.NODE_ENV !== "production") {
    const h = r.reference;
    h && !Me(h) && c5("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [l, u] = M.useState(r.reference), c = zt((h, m, v) => {
    a.current.openEvent = h ? m : void 0, o.emit("openchange", {
      open: h,
      event: m,
      reason: v,
      nested: s
    }), n == null || n(h, m, v);
  }), f = M.useMemo(() => ({
    setPositionReference: u
  }), []), p = M.useMemo(() => ({
    reference: l || r.reference || null,
    floating: r.floating || null,
    domReference: r.reference
  }), [l, r.reference, r.floating]);
  return M.useMemo(() => ({
    dataRef: a,
    open: t,
    onOpenChange: c,
    elements: p,
    events: o,
    floatingId: i,
    refs: f
  }), [t, c, p, o, i, f]);
}
function Uu(e) {
  e === void 0 && (e = {});
  const {
    nodeId: t
  } = e, n = S5({
    ...e,
    elements: {
      reference: null,
      floating: null,
      ...e.elements
    }
  }), r = e.rootContext || n, i = r.elements, [a, o] = M.useState(null), [s, l] = M.useState(null), c = (i == null ? void 0 : i.domReference) || a, f = M.useRef(null), p = zu();
  ft(() => {
    c && (f.current = c);
  }, [c]);
  const h = e5({
    ...e,
    elements: {
      ...i,
      ...s && {
        reference: s
      }
    }
  }), m = M.useCallback((x) => {
    const w = Me(x) ? {
      getBoundingClientRect: () => x.getBoundingClientRect(),
      contextElement: x
    } : x;
    l(w), h.refs.setReference(w);
  }, [h.refs]), v = M.useCallback((x) => {
    (Me(x) || x === null) && (f.current = x, o(x)), (Me(h.refs.reference.current) || h.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    x !== null && !Me(x)) && h.refs.setReference(x);
  }, [h.refs]), g = M.useMemo(() => ({
    ...h.refs,
    setReference: v,
    setPositionReference: m,
    domReference: f
  }), [h.refs, v, m]), b = M.useMemo(() => ({
    ...h.elements,
    domReference: c
  }), [h.elements, c]), y = M.useMemo(() => ({
    ...h,
    ...r,
    refs: g,
    elements: b,
    nodeId: t
  }), [h, g, b, t, r]);
  return ft(() => {
    r.dataRef.current.floatingContext = y;
    const x = p == null ? void 0 : p.nodesRef.current.find((w) => w.id === t);
    x && (x.context = y);
  }), M.useMemo(() => ({
    ...h,
    context: y,
    refs: g,
    elements: b
  }), [h, g, b, y]);
}
const _f = "active", Af = "selected";
function Ro(e, t, n) {
  const r = /* @__PURE__ */ new Map(), i = n === "item";
  let a = e;
  if (i && e) {
    const {
      [_f]: o,
      [Af]: s,
      ...l
    } = e;
    a = l;
  }
  return {
    ...n === "floating" && {
      tabIndex: -1,
      [$5]: ""
    },
    ...a,
    ...t.map((o) => {
      const s = o ? o[n] : null;
      return typeof s == "function" ? e ? s(e) : null : s;
    }).concat(e).reduce((o, s) => (s && Object.entries(s).forEach((l) => {
      let [u, c] = l;
      if (!(i && [_f, Af].includes(u)))
        if (u.indexOf("on") === 0) {
          if (r.has(u) || r.set(u, []), typeof c == "function") {
            var f;
            (f = r.get(u)) == null || f.push(c), o[u] = function() {
              for (var p, h = arguments.length, m = new Array(h), v = 0; v < h; v++)
                m[v] = arguments[v];
              return (p = r.get(u)) == null ? void 0 : p.map((g) => g(...m)).find((g) => g !== void 0);
            };
          }
        } else
          o[u] = c;
    }), o), {})
  };
}
function qu(e) {
  e === void 0 && (e = []);
  const t = e.map((s) => s == null ? void 0 : s.reference), n = e.map((s) => s == null ? void 0 : s.floating), r = e.map((s) => s == null ? void 0 : s.item), i = M.useCallback(
    (s) => Ro(s, e, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), a = M.useCallback(
    (s) => Ro(s, e, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n
  ), o = M.useCallback(
    (s) => Ro(s, e, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  );
  return M.useMemo(() => ({
    getReferenceProps: i,
    getFloatingProps: a,
    getItemProps: o
  }), [i, a, o]);
}
const Rf = (e) => e.replace(/[A-Z]+(?![a-z])|[A-Z]/g, (t, n) => (n ? "-" : "") + t.toLowerCase());
function Hn(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function I5(e, t) {
  const [n, r] = M.useState(e);
  return e && !n && r(!0), M.useEffect(() => {
    if (!e && n) {
      const i = setTimeout(() => r(!1), t);
      return () => clearTimeout(i);
    }
  }, [e, n, t]), n;
}
function E5(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    elements: {
      floating: r
    }
  } = e, {
    duration: i = 250
  } = t, o = (typeof i == "number" ? i : i.close) || 0, [s, l] = M.useState("unmounted"), u = I5(n, o);
  return !u && s === "close" && l("unmounted"), ft(() => {
    if (r) {
      if (n) {
        l("initial");
        const c = requestAnimationFrame(() => {
          l("open");
        });
        return () => {
          cancelAnimationFrame(c);
        };
      }
      l("close");
    }
  }, [n, r]), {
    isMounted: u,
    status: s
  };
}
function Yu(e, t) {
  t === void 0 && (t = {});
  const {
    initial: n = {
      opacity: 0
    },
    open: r,
    close: i,
    common: a,
    duration: o = 250
  } = t, s = e.placement, l = s.split("-")[0], u = M.useMemo(() => ({
    side: l,
    placement: s
  }), [l, s]), c = typeof o == "number", f = (c ? o : o.open) || 0, p = (c ? o : o.close) || 0, [h, m] = M.useState(() => ({
    ...Hn(a, u),
    ...Hn(n, u)
  })), {
    isMounted: v,
    status: g
  } = E5(e, {
    duration: o
  }), b = En(n), y = En(r), x = En(i), w = En(a);
  return ft(() => {
    const $ = Hn(b.current, u), C = Hn(x.current, u), T = Hn(w.current, u), S = Hn(y.current, u) || Object.keys($).reduce((N, k) => (N[k] = "", N), {});
    if (g === "initial" && m((N) => ({
      transitionProperty: N.transitionProperty,
      ...T,
      ...$
    })), g === "open" && m({
      transitionProperty: Object.keys(S).map(Rf).join(","),
      transitionDuration: f + "ms",
      ...T,
      ...S
    }), g === "close") {
      const N = C || $;
      m({
        transitionProperty: Object.keys(N).map(Rf).join(","),
        transitionDuration: p + "ms",
        ...T,
        ...N
      });
    }
  }, [p, x, b, y, w, f, g, u]), {
    isMounted: v,
    styles: h
  };
}
function Mf(e, t) {
  const [n, r] = e;
  let i = !1;
  const a = t.length;
  for (let o = 0, s = a - 1; o < a; s = o++) {
    const [l, u] = t[o] || [0, 0], [c, f] = t[s] || [0, 0];
    u >= r != f >= r && n <= (c - l) * (r - u) / (f - u) + l && (i = !i);
  }
  return i;
}
function O5(e, t) {
  return e[0] >= t.x && e[0] <= t.x + t.width && e[1] >= t.y && e[1] <= t.y + t.height;
}
function T5(e) {
  e === void 0 && (e = {});
  const {
    buffer: t = 0.5,
    blockPointerEvents: n = !1,
    requireIntent: r = !0
  } = e;
  let i, a = !1, o = null, s = null, l = performance.now();
  function u(f, p) {
    const h = performance.now(), m = h - l;
    if (o === null || s === null || m === 0)
      return o = f, s = p, l = h, null;
    const v = f - o, g = p - s, y = Math.sqrt(v * v + g * g) / m;
    return o = f, s = p, l = h, y;
  }
  const c = (f) => {
    let {
      x: p,
      y: h,
      placement: m,
      elements: v,
      onClose: g,
      nodeId: b,
      tree: y
    } = f;
    return function(w) {
      function $() {
        clearTimeout(i), g();
      }
      if (clearTimeout(i), !v.domReference || !v.floating || m == null || p == null || h == null)
        return;
      const {
        clientX: C,
        clientY: T
      } = w, S = [C, T], N = zn(w), k = w.type === "mouseleave", L = Nn(v.floating, N), _ = Nn(v.domReference, N), B = v.domReference.getBoundingClientRect(), A = v.floating.getBoundingClientRect(), q = m.split("-")[0], X = p > A.right - A.width / 2, I = h > A.bottom - A.height / 2, O = O5(S, B), D = A.width > B.width, E = A.height > B.height, j = (D ? B : A).left, F = (D ? B : A).right, K = (E ? B : A).top, H = (E ? B : A).bottom;
      if (L && (a = !0, !k))
        return;
      if (_ && (a = !1), _ && !k) {
        a = !0;
        return;
      }
      if (k && Me(w.relatedTarget) && Nn(v.floating, w.relatedTarget) || y && Ji(y.nodesRef.current, b).some((z) => {
        let {
          context: U
        } = z;
        return U == null ? void 0 : U.open;
      }))
        return;
      if (q === "top" && h >= B.bottom - 1 || q === "bottom" && h <= B.top + 1 || q === "left" && p >= B.right - 1 || q === "right" && p <= B.left + 1)
        return $();
      let W = [];
      switch (q) {
        case "top":
          W = [[j, B.top + 1], [j, A.bottom - 1], [F, A.bottom - 1], [F, B.top + 1]];
          break;
        case "bottom":
          W = [[j, A.top + 1], [j, B.bottom - 1], [F, B.bottom - 1], [F, A.top + 1]];
          break;
        case "left":
          W = [[A.right - 1, H], [A.right - 1, K], [B.left + 1, K], [B.left + 1, H]];
          break;
        case "right":
          W = [[B.right - 1, H], [B.right - 1, K], [A.left + 1, K], [A.left + 1, H]];
          break;
      }
      function G(z) {
        let [U, J] = z;
        switch (q) {
          case "top": {
            const ne = [D ? U + t / 2 : X ? U + t * 4 : U - t * 4, J + t + 1], ae = [D ? U - t / 2 : X ? U + t * 4 : U - t * 4, J + t + 1], V = [[A.left, X || D ? A.bottom - t : A.top], [A.right, X ? D ? A.bottom - t : A.top : A.bottom - t]];
            return [ne, ae, ...V];
          }
          case "bottom": {
            const ne = [D ? U + t / 2 : X ? U + t * 4 : U - t * 4, J - t], ae = [D ? U - t / 2 : X ? U + t * 4 : U - t * 4, J - t], V = [[A.left, X || D ? A.top + t : A.bottom], [A.right, X ? D ? A.top + t : A.bottom : A.top + t]];
            return [ne, ae, ...V];
          }
          case "left": {
            const ne = [U + t + 1, E ? J + t / 2 : I ? J + t * 4 : J - t * 4], ae = [U + t + 1, E ? J - t / 2 : I ? J + t * 4 : J - t * 4];
            return [...[[I || E ? A.right - t : A.left, A.top], [I ? E ? A.right - t : A.left : A.right - t, A.bottom]], ne, ae];
          }
          case "right": {
            const ne = [U - t, E ? J + t / 2 : I ? J + t * 4 : J - t * 4], ae = [U - t, E ? J - t / 2 : I ? J + t * 4 : J - t * 4], V = [[I || E ? A.left + t : A.right, A.top], [I ? E ? A.left + t : A.right : A.left + t, A.bottom]];
            return [ne, ae, ...V];
          }
        }
      }
      if (!Mf([C, T], W)) {
        if (a && !O)
          return $();
        if (!k && r) {
          const z = u(w.clientX, w.clientY);
          if (z !== null && z < 0.1)
            return $();
        }
        Mf([C, T], G([p, h])) ? !a && r && (i = window.setTimeout($, 40)) : $();
      }
    };
  };
  return c.__options = {
    blockPointerEvents: n
  }, c;
}
const Tt = ({
  testId: e,
  isOpen: t = !1,
  innerRef: n,
  children: r,
  setFloating: i,
  getFloatingProps: a,
  floatingStyles: o,
  transitionStyles: s,
  isMounted: l
}) => /* @__PURE__ */ d.jsx(d.Fragment, { children: t && l && /* @__PURE__ */ d.jsx(Gu, { children: /* @__PURE__ */ d.jsx(
  "div",
  {
    ref: i,
    style: { ...o },
    ...a({
      className: "a:z-popover a:top-0 a:w-full"
    }),
    children: /* @__PURE__ */ d.jsx(
      "ul",
      {
        "data-testid": e,
        ref: n,
        style: { ...s },
        className: "a:my-1 a:max-h-80 a:list-none a:overflow-y-auto a:bg-white a:px-0 a:py-2 a:shadow-lg",
        children: xt(r, [Tt.Item, w0])
      }
    )
  }
) }) });
Tt.Item = Fw;
Tt.Divider = w0;
const Xu = ({ isOpen: e, elements: t }) => {
  const { refs: n, floatingStyles: r, context: i } = Uu({
    placement: "bottom-start",
    open: e,
    middleware: [
      n5({
        apply({ rects: c, elements: f }) {
          Object.assign(f.floating.style, {
            width: `${c.reference.width}px`
          });
        }
      }),
      Ku()
    ],
    elements: t
  }), { getReferenceProps: a, getFloatingProps: o } = qu(), { isMounted: s, styles: l } = Yu(i, { duration: 100 });
  return {
    refs: n,
    getReferenceProps: a,
    getDropdownProps: () => ({
      setFloating: n.setFloating,
      getFloatingProps: o,
      isMounted: s,
      floatingStyles: r,
      transitionStyles: l
    })
  };
}, P5 = (e, t) => {
  const n = new RegExp(t.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"), "gi");
  return t ? e.replace(n, "<strong>$&</strong>") : e;
}, WO = ({
  id: e,
  input: t,
  items: n = [],
  initialSelectedItem: r,
  onChange: i,
  testId: a,
  defaultIsOpen: o,
  onSelect: s,
  onSelectedItemChange: l,
  isLoading: u
}) => {
  const c = (C) => {
    switch (C.type) {
      case Xn.stateChangeTypes.InputChange:
        i == null || i(C.inputValue || "");
        break;
      case Xn.stateChangeTypes.ItemClick:
      case Xn.stateChangeTypes.InputKeyDownEnter:
        C != null && C.selectedItem && (l == null || l(C.selectedItem)), (C != null && C.selectedItem || b) && (s == null || s((C == null ? void 0 : C.selectedItem) || b));
        break;
    }
  }, {
    getInputProps: f,
    getItemProps: p,
    getMenuProps: h,
    isOpen: m,
    inputValue: v,
    highlightedIndex: g,
    selectedItem: b
  } = Xn({
    id: e,
    initialSelectedItem: r,
    inputValue: t.value || "",
    items: n,
    defaultIsOpen: o,
    onStateChange: c,
    isItemDisabled: (C) => !!C.isItemDisabled,
    itemToString: (C) => C ? C.text : ""
  }), { getDropdownProps: y, getReferenceProps: x, refs: w } = Xu({ isOpen: m }), $ = f({ refKey: "innerRef", id: e });
  return /* @__PURE__ */ d.jsxs("div", { "data-testid": a, className: "a:relative", children: [
    /* @__PURE__ */ d.jsx(
      Xt,
      {
        testId: Z({ testId: a, suffix: "input" }),
        ...t,
        ...x(),
        ...$,
        onBlur: (C) => {
          var T, S;
          (T = $ == null ? void 0 : $.onBlur) == null || T.call($, C), (S = t == null ? void 0 : t.onBlur) == null || S.call(t, C);
        },
        outerRef: w.setReference,
        adornmentEnd: u ? /* @__PURE__ */ d.jsx(De, { paddingInline: "2", children: /* @__PURE__ */ d.jsx(ug, { testId: Z({ testId: a, suffix: "loading" }) }) }) : null
      }
    ),
    /* @__PURE__ */ d.jsx(
      Tt,
      {
        testId: Z({ testId: a, suffix: "dropdown" }),
        ...y(),
        isOpen: m && !u && n.length > 0,
        ...h({ refKey: "innerRef" }, { suppressRefError: !0 }),
        children: n.map((C, T) => /* @__PURE__ */ d.jsx(
          Tt.Item,
          {
            ...p({
              key: C.id,
              index: T,
              item: C,
              refKey: "innerRef",
              ...C,
              id: String(C.id),
              isHighlighted: g === T,
              isSelected: b === C,
              text: P5(C.text, v || ""),
              testId: Z({ testId: a, suffix: `dropdown-item-${T}` }),
              ...!C.isItemDisabled && { onMouseDown: pt }
            })
          }
        ))
      }
    )
  ] });
};
function J0(e, t, n, r) {
  return e.split(new RegExp(`(${t.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&")})`, "gi")).filter(Boolean).map(
    (a) => a.toLowerCase() === (t == null ? void 0 : t.toLowerCase()) ? /* @__PURE__ */ d.jsx("mark", { className: Y(`a:bg-transparent ${n}`), "data-testid": `${r}-highlight`, children: a }, a) : a
  );
}
const N5 = de("a:fixed a:inset-0 a:animate-backdrop-fade-in a:bg-surface-dark a:opacity-40", {
  variants: {
    zIndex: {
      default: "a:z-overlay",
      overlay: "a:z-overlay",
      bottomsheet: "a:z-bottomsheet",
      modal: "a:z-modal",
      sticky: "a:z-sticky"
    }
  },
  defaultVariants: {
    zIndex: "default"
  }
}), br = ({ testId: e, onClick: t, backdropRef: n, offsetTop: r, zIndex: i }) => {
  const a = ce(null), o = n || a, s = () => {
    var l, u;
    t(), (l = o.current) == null || l.classList.remove("a:animate-backdrop-fade-in"), (u = o.current) == null || u.classList.add("a:animate-backdrop-fade-out");
  };
  return se(() => {
    var l;
    return (l = o.current) == null || l.addEventListener("click", s), () => {
      var u;
      (u = o.current) == null || u.removeEventListener("click", s);
    };
  }, []), /* @__PURE__ */ d.jsx(
    "div",
    {
      ref: o,
      "data-testid": e,
      style: { top: r },
      className: Oe(N5({ zIndex: i }))
    }
  );
};
function Zu({
  callback: e,
  role: t,
  addTabIndex: n
}) {
  return {
    role: t,
    tabIndex: n ? 0 : void 0,
    onClick: e,
    onKeyDown: (r) => {
      (r.code === "Enter" || r.code === "Space") && e(r);
    }
  };
}
const _5 = de(
  "a:relative a:flex a:cursor-pointer a:gap-1 a:overflow-hidden a:rounded-t a:px-1 a:hover:bg-surface-neutral-hover a:focus-visible:rounded a:focus-visible:border a:focus-visible:border-neutral-600 a:focus-visible:outline-hidden a:focus-visible:ring-0",
  {
    variants: {
      iconAlignment: {
        start: "a:items-start",
        center: "a:items-center",
        end: "a:items-end"
      },
      state: {
        enabled: "a:bg-white",
        selected: "a:bg-neutral-100"
      }
    },
    defaultVariants: {
      iconAlignment: "center"
    }
  }
);
function ya({
  testId: e,
  strong: t = !1,
  icon: n,
  iconAlignment: r,
  text: i,
  id: a,
  onClick: o,
  spacingClasses: s,
  hasDivider: l = !0,
  slim: u = !1,
  state: c,
  truncate: f = !0
}) {
  const p = (h) => {
    pt(h), o && o(h);
  };
  return /* @__PURE__ */ d.jsxs(
    "div",
    {
      id: a,
      className: Oe(
        Ze(s),
        _5({ iconAlignment: r, state: c }),
        l ? "a:border-0 a:border-b a:border-solid a:border-neutral-300" : "",
        u ? "" : "a:py-4"
      ),
      "data-testid": e,
      ...Zu({ callback: p, role: "listitem", addTabIndex: !0 }),
      children: [
        n && /* @__PURE__ */ d.jsx($e, { ...n, size: "sm" }),
        /* @__PURE__ */ d.jsx(ie, { variant: "bodyM", strong: t, truncate: f, as: "span", children: i })
      ]
    }
  );
}
const A5 = (e, t) => {
  let n;
  return (...r) => {
    clearTimeout(n), n = setTimeout(() => e(...r), t);
  };
}, Q0 = {
  top: !0,
  bottom: !1,
  left: !0,
  right: !1
}, R5 = 100, M5 = 250, j5 = (e, t) => {
  const n = e.getBoundingClientRect(), r = t.getBoundingClientRect();
  return !n || !r ? Q0 : {
    top: n.top >= r.top,
    bottom: Math.floor(n.bottom) <= Math.floor(r.bottom),
    left: n.left >= Math.abs(r.right - r.width),
    right: Math.floor(n.right) <= Math.floor(r.right)
  };
}, ev = (e, t) => {
  const [n, r] = ue(Q0), i = (s, l) => {
    if (!s.current || !l.current)
      return;
    const u = j5(s.current, l.current);
    r(
      (c) => u.left === c.left && u.right === c.right && u.top === c.top && u.bottom === c.bottom ? c : u
    );
  }, a = () => {
    let s = !1;
    return () => {
      s || (s = !0, setTimeout(() => {
        s = !1, i(e, t);
      }, M5));
    };
  }, o = A5(() => {
    i(e, t);
  }, R5);
  return se(() => {
    var l;
    if (!e.current || !t.current)
      return;
    const s = new ResizeObserver(o);
    return e.current && s.observe(e.current), (l = t.current) == null || l.addEventListener("scroll", a(), { passive: !0 }), window.addEventListener("resize", o), () => {
      var u;
      e.current && s.unobserve(e.current), (u = t.current) == null || u.removeEventListener("scroll", a()), window.removeEventListener("resize", o);
    };
  }, [e, t]), { arrivedState: n };
}, D5 = de("a:w-full a:h-full", {
  variants: {
    horizontal: {
      true: "a:flex-row a:whitespace-nowrap",
      false: "a:flex-col"
    },
    clipped: {
      true: 'a:relative a:overflow-clip a:after:content-[""] a:after:absolute a:after:pointer-events-none',
      false: ""
    },
    gradient: {
      true: `
        a:before:transition-width a:before:duration-100 a:before:content-[""] a:before:absolute a:before:pointer-events-none a:before:z-10
        a:after:transition-width a:after:duration-100 a:after:content-[""] a:after:absolute a:after:pointer-events-none a:after:z-10`,
      false: ""
    },
    scrollbarHidden: {
      true: "a:scrollbar-hidden",
      false: ""
    }
  },
  compoundVariants: [
    {
      horizontal: !0,
      scrollbarHidden: !1,
      class: "a:pb-5"
    },
    {
      horizontal: !1,
      scrollbarHidden: !1,
      class: "a:pe-5"
    },
    {
      horizontal: !0,
      clipped: !1,
      class: "a:overflow-x-scroll"
    },
    {
      horizontal: !1,
      clipped: !1,
      class: "a:overflow-y-scroll"
    },
    {
      horizontal: !0,
      clipped: !0,
      class: "a:after:top-0 a:after:right-0 a:after:w-5 a:after:h-full a:after:bg-scrollable-clipped-to-l"
    },
    {
      horizontal: !1,
      clipped: !0,
      class: "a:after:bottom-0 a:after:right-0 a:after:w-full a:after:h-5 a:after:bg-scrollable-clipped-to-t"
    },
    {
      horizontal: !0,
      clipped: !1,
      gradient: !0,
      class: `
        a:before:top-0 a:before:h-full a:after:top-0 a:after:h-full
       a:before:left-0 a:before:bg-scrollable-clipped-to-r
        a:after:right-0 a:after:bg-scrollable-clipped-to-l`
    },
    {
      horizontal: !1,
      clipped: !1,
      gradient: !0,
      class: `
        a:before:w-full a:before:left-0 a:before:right-0 a:after:w-full a:after:left-0 a:after:right-0
        a:before:top-0 a:before:bg-scrollable-clipped-to-b
        a:after:bottom-0 a:after:bg-scrollable-clipped-to-t`
    }
  ],
  defaultVariants: {
    horizontal: !0,
    clipped: !1,
    scrollbarHidden: !1
  }
}), k5 = (e, t) => {
  const { top: n, bottom: r, left: i, right: a } = t;
  return e ? [i ? "a:before:w-0" : "a:before:w-5", a ? "a:after:w-0" : "a:after:w-5"] : [n ? "a:before:h-0" : "a:before:h-5", r ? "a:after:h-0" : "a:after:h-5"];
};
function L5({
  children: e,
  height: t,
  horizontal: n = !0,
  id: r,
  onScroll: i,
  spacingClasses: a,
  testId: o = "scrollable",
  clipped: s,
  gradient: l = !1,
  scrollbarHidden: u
}) {
  const c = ce(null), f = ce(null), { arrivedState: p } = ev(c, f);
  return /* @__PURE__ */ d.jsx(
    Jt,
    {
      condition: l,
      wrapper: (h) => /* @__PURE__ */ d.jsxs("div", { className: Y("a:relative", { "a:inline": !n }), children: [
        " ",
        h
      ] }),
      children: /* @__PURE__ */ d.jsx(
        "div",
        {
          ref: f,
          id: r,
          "data-testid": o,
          className: Y(
            D5({ horizontal: n, clipped: s, gradient: l, scrollbarHidden: u }),
            Ze(a),
            k5(n, p)
          ),
          onScroll: i,
          style: { maxHeight: t },
          children: /* @__PURE__ */ d.jsx(
            Jt,
            {
              condition: l,
              wrapper: (h) => /* @__PURE__ */ d.jsx("div", { ref: c, className: Y("a:inline-flex"), children: h }),
              children: e
            }
          )
        }
      )
    }
  );
}
const tv = ({
  adornmentEnd: e,
  adornmentStart: t,
  autoComplete: n,
  autoFocus: r,
  autoSearch: i = !1,
  testId: a,
  error: o,
  hasAdornmentStart: s = !0,
  hint: l,
  id: u,
  innerRef: c,
  label: f,
  name: p,
  onBlur: h,
  onChange: m,
  onClear: v,
  onFocus: g,
  placeholder: b,
  value: y,
  wrapperClassName: x
}) => {
  const [w, $] = ue(y || "");
  se(() => {
    $(y || "");
  }, [y]);
  const C = (_) => {
    h == null || h(_.target.value);
  }, T = (_) => {
    $(_.target.value), i && m && m(_.target.value);
  }, S = (_) => {
    w.length > 0 && m && (_.type === "keydown" ? _.key === "Enter" && m(w, !0) : m(w));
  }, N = (_) => {
    $(""), m == null || m(""), v == null || v(_);
  }, k = /* @__PURE__ */ d.jsx(
    "button",
    {
      className: Y("a:px-2", { "a:cursor-default": i }),
      "aria-label": "search icon",
      onClick: i ? void 0 : S,
      children: /* @__PURE__ */ d.jsx($e, { source: Wa, size: "sm", color: "current" })
    }
  ), L = /* @__PURE__ */ d.jsx(
    "button",
    {
      className: Y("a:px-2", { "a:cursor-default": !N }),
      onClick: N,
      type: "button",
      children: /* @__PURE__ */ d.jsx($e, { source: bn, size: "sm", color: "current" })
    }
  );
  return /* @__PURE__ */ d.jsx("div", { className: `a:relative ${x ?? ""}`, children: /* @__PURE__ */ d.jsx(
    Xt,
    {
      adornmentEnd: w.length > 0 && L || e,
      adornmentStart: s && (t || k),
      autoComplete: n,
      autoFocus: r,
      testId: a,
      error: o,
      id: u,
      innerRef: c,
      hint: l,
      label: f,
      name: p,
      onBlur: C,
      onChange: T,
      onFocus: g,
      onKeyDown: S,
      placeholder: b,
      value: w
    }
  ) });
};
function zO({
  autoFocus: e,
  testId: t = "autocomplete",
  debounceTime: n = 300,
  hasBackdrop: r,
  isOpen: i,
  label: a,
  onSearch: o,
  onValue: s,
  options: l,
  placeholder: u,
  scrollHeight: c = 300,
  spacingClasses: f,
  threshold: p = 0
}) {
  const [h, m] = ue(""), [v, g] = ue({ label: "" }), [b, y] = ue(i), [x, w] = ue(!1), [$, C] = ue([]), T = ce(null), S = (I, O) => (D) => {
    T.current && clearTimeout(T.current), T.current = setTimeout(() => {
      I(D);
    }, O);
  }, N = () => {
    m((v == null ? void 0 : v.label) || ""), y(!1), C([]);
  }, k = (I) => {
    y(!0), m(I), I || (g({ label: "" }), s == null || s({ label: "" })), I.length >= p && _(I);
  }, _ = S((I) => {
    if (o)
      o(I);
    else {
      const O = I && l.filter((D) => D.label.toLowerCase().includes(I.toLowerCase())) || [];
      C(O);
    }
  }, n), B = (I) => {
    g(I), s == null || s(I);
  }, A = () => {
    w(!1);
  }, q = () => {
    w(!0);
  }, X = (I) => {
    x || B(I);
  };
  return se(() => {
    b && C(l);
  }, [l]), /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
    r && b && $.length > 0 && /* @__PURE__ */ d.jsx(br, { testId: "bottomsheet-overlay", onClick: () => y(!1) }),
    /* @__PURE__ */ d.jsxs(
      "div",
      {
        className: Y(
          "a:relative",
          { "a:z-bottomsheet": r && b && $.length > 0 },
          Ze(f)
        ),
        "data-testid": `${t}-container`,
        children: [
          /* @__PURE__ */ d.jsx(
            tv,
            {
              autoFocus: i || e,
              autoSearch: !0,
              autoComplete: "off",
              id: "autocomplete-search",
              label: a,
              onBlur: N,
              onChange: k,
              placeholder: u,
              value: h
            }
          ),
          b && $.length > 0 && /* @__PURE__ */ d.jsx(
            "div",
            {
              "data-testid": `${t}-list`,
              role: "list",
              className: "a:absolute a:mt-[-5px] a:w-full a:overflow-hidden a:rounded-b-md a:border-x a:border-b a:border-t a:border-solid a:border-x-border-active a:border-b-border-active a:border-t-border-neutral a:bg-surface-neutral",
              children: /* @__PURE__ */ d.jsx(L5, { horizontal: !1, height: c, spacingClasses: "a:!pe-0 a:!ps-0", children: $.map((I, O) => /* @__PURE__ */ d.jsx(
                "div",
                {
                  onMouseDown: () => B(I),
                  onTouchStart: A,
                  onTouchMove: q,
                  onTouchEnd: () => X(I),
                  children: /* @__PURE__ */ d.jsx(
                    ya,
                    {
                      strong: !0,
                      text: J0(
                        I.label,
                        h,
                        "a:font-normal",
                        `${t}-list-item-${O}-text`
                      ),
                      hasDivider: !1,
                      spacingClasses: I.icon ? "a:ps-[12px]" : "a:ps-[40px]",
                      icon: I.icon
                    }
                  )
                },
                `${t}-list-item-${O}`
              )) })
            }
          )
        ]
      }
    )
  ] });
}
const F5 = de(
  "a:inline-flex a:gap-1 a:items-center a:justify-center a:rounded-circle a:font-functional a:border a:overflow-hidden a:border-border-inverse",
  {
    variants: {
      size: {
        sm: "a:text-xs a:h-4 a:min-w-[14px]",
        md: "a:text-base a:h-6 a:min-w-6"
      },
      color: {
        branded: "a:bg-surface-brand a:text-content-inverse",
        neutral: "a:bg-surface-quiet a:text-content-emphasised",
        dark: "a:bg-surface-dark a:text-content-inverse",
        error: "a:bg-surface-error-bg a:text-content-error",
        informative: "a:bg-surface-informative-bg a:text-content-informative",
        success: "a:bg-surface-success-bg a:text-content-success",
        warning: "a:bg-surface-warning-bg a:text-content-warning"
      },
      isNumeric: {
        true: "a:font-semibold",
        false: ""
      }
    },
    defaultVariants: {
      size: "md",
      color: "neutral"
    },
    compoundVariants: [
      {
        isNumeric: !0,
        size: ["sm", "md"],
        class: "a:px-1"
      },
      {
        isNumeric: !1,
        size: "sm",
        class: "a:px-1"
      },
      {
        isNumeric: !1,
        size: "md",
        class: "a:px-2"
      }
    ]
  }
);
function Ju({ color: e, size: t, max: n = 99, children: r, testId: i }) {
  return /* @__PURE__ */ d.jsx(
    "span",
    {
      "data-component": "badge",
      "data-testid": i,
      className: F5({ color: e, size: t, isNumeric: !isNaN(Number(r)) }),
      role: "status",
      children: !isNaN(Number(r)) && Number(r) > n ? `${n}+` : r
    }
  );
}
const nv = (e) => /* @__PURE__ */ d.jsx(cg, { as: "button", ...e }), GO = nv, V5 = de("a:h-full a:transition-width a:ease-out", {
  variants: {
    color: {
      default: "a:bg-surface-dark",
      inverse: "a:bg-content-subtle",
      warning: "a:bg-content-warning",
      error: "a:bg-content-error",
      success: "a:bg-content-success",
      informative: "a:bg-content-informative",
      sustainability: "a:bg-content-sustainability"
    }
  },
  defaultVariants: {
    color: "default"
  }
}), B5 = ({
  progress: e,
  testId: t,
  spacingClasses: n,
  color: r,
  direction: i = "asc"
}) => {
  const [a, o] = ue(i === "asc" ? 0 : 100);
  return se(() => {
    setTimeout(() => {
      o(i === "asc" ? e : 100 - e);
    }, Ry);
  }, [e, i]), /* @__PURE__ */ d.jsx(d.Fragment, { children: /* @__PURE__ */ d.jsx(
    "div",
    {
      "data-testid": t,
      className: Oe("a:relative a:h-[3px] a:w-full a:bg-surface-neutral", Ze(n)),
      children: /* @__PURE__ */ d.jsx(
        "div",
        {
          className: Y(V5({ color: r })),
          style: {
            width: `${a > 100 ? 100 : a < 0 ? 0 : a}%`
          }
        }
      )
    }
  ) });
}, Ja = (e = "", t = "") => `${e}${Math.random().toString().slice(2, 8)}${t}`, H5 = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1)}`, xi = ({
  testId: e,
  id: t = Ja("tooltip-"),
  children: n = /* @__PURE__ */ d.jsx($e, { source: Ka, size: "sm" }),
  hasCloseBtn: r = !0,
  text: i,
  placement: a = "bottom-start",
  strategy: o = "absolute",
  spacingClasses: s
}) => {
  const l = ce(null), [u, c] = ue(!1), {
    floatingStyles: f,
    refs: { setReference: p, setFloating: h },
    context: m
  } = Uu({
    open: u,
    placement: a,
    strategy: o,
    onOpenChange: c,
    middleware: [
      V0(8),
      r5(),
      Ku(),
      B0(),
      H0({
        element: l,
        padding: 16
      })
    ],
    whileElementsMounted: L0
  }), { isMounted: v, styles: g } = Yu(m, { duration: 100 }), b = X0(m), y = h5(m, {
    move: !1,
    restMs: 100,
    handleClose: T5()
  }), { getReferenceProps: x, getFloatingProps: w } = qu([b, y]), $ = () => c(!1);
  return Z0(m), /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
    /* @__PURE__ */ d.jsx(
      "span",
      {
        "aria-controls": t,
        "aria-expanded": u,
        "data-testid": Z({ testId: e, suffix: "trigger" }),
        id: `${t}-trigger`,
        ref: p,
        ...x(),
        className: Y("a:inline-block a:cursor-pointer a:align-middle", Ze(s)),
        children: n
      }
    ),
    v && /* @__PURE__ */ d.jsx(Gu, { children: /* @__PURE__ */ d.jsxs(
      "div",
      {
        ref: h,
        "aria-labelledby": `${t}-trigger`,
        id: t,
        "data-testid": e,
        className: "a:top-4 a:z-tooltip a:w-max a:max-w-tooltip a:rounded a:bg-surface-dark a:text-content-inverse",
        style: { ...f, ...g },
        ...w(),
        children: [
          /* @__PURE__ */ d.jsx(W0, { ref: l, "aria-hidden": "true", context: m, className: "a:fill-surface-dark" }),
          /* @__PURE__ */ d.jsxs("div", { className: Y("a:relative a:flex a:justify-between a:p-3"), children: [
            /* @__PURE__ */ d.jsx(ie, { variant: "bodyS", as: "span", testId: Z({ testId: e, suffix: "text" }), children: i }),
            r && /* @__PURE__ */ d.jsx(
              "button",
              {
                "aria-hidden": "true",
                "aria-label": "Close",
                className: Y("a:flex a:cursor-pointer a:pl-1 a:text-content-inverse"),
                "data-testid": Z({ testId: e, suffix: "close-button" }),
                onClick: $,
                children: /* @__PURE__ */ d.jsx($e, { source: bn, size: "sm" })
              }
            )
          ] })
        ]
      }
    ) })
  ] });
}, K5 = {
  default: "a:animate-slide-down",
  topRight: "a:animate-slide-out-left-right"
}, W5 = (e) => {
  switch (e) {
    case "warning":
      return Nw;
    case "error":
      return x0;
    case "success":
      return Cw;
    default:
      return Ka;
  }
}, z5 = (e) => !(e === "neutral" || e === "light"), G5 = (e) => e === "primary" || e === "dark", U5 = (e) => {
  switch (e) {
    case "neutral":
    case "light":
      return "default";
    case "primary":
    case "dark":
      return "inverse";
    default:
      return e;
  }
}, q5 = (e) => {
  switch (e) {
    case "light":
      return "neutral";
    case "primary":
    case "dark":
      return "inverse";
    default:
      return e;
  }
}, Y5 = de("a:flex a:flex-col a:m-0 a:text-neutral-900 a:p-4", {
  variants: {
    status: {
      primary: "a:bg-surface-brand",
      dark: "a:bg-surface-dark",
      neutral: "a:bg-surface-quiet",
      light: "a:bg-surface-neutral",
      sustainability: "a:bg-surface-sustainability-bg",
      error: "a:bg-surface-error-bg a:rounded",
      warning: "a:bg-surface-warning-bg a:rounded",
      success: "a:bg-surface-success-bg a:rounded",
      informative: "a:bg-surface-informative-bg a:rounded"
    },
    isSticky: {
      true: "a:fixed a:z-snackbar a:m-5 a:shadow-xs"
    },
    stickyLocation: {
      default: "a:bottom-0 a:inset-x-0",
      // Bottom location
      top: "a:top-0 a:inset-x-0",
      topRight: "a:top-0 a:right-0"
    },
    animation: {
      default: "a:animate-slide-up",
      topRight: "a:animate-slide-in-right-left"
    },
    width: {
      full: "a:w-auto",
      "1/2": "a:w-1/2",
      "1/3": "a:w-2/6"
    }
  },
  defaultVariants: {
    status: "primary",
    isSticky: !1
  }
}), UO = ({
  testId: e,
  onCloseClick: t,
  hasCloseBtn: n,
  spacingClasses: r,
  status: i,
  isSticky: a,
  icon: o,
  hideIcon: s,
  text: l,
  tooltip: u,
  progress: c,
  progressDurationInMs: f,
  stickyLocation: p = a ? "default" : null,
  animation: h = a ? "default" : null,
  width: m,
  title: v,
  ctaPrimary: g,
  ctaSecondary: b,
  resetTimer: y = !0
}) => {
  const x = ce(null), w = q5(i), $ = ce(0), C = ce(0), [T, S] = ue(0), N = v ? "0.5" : "0", k = () => {
    var _, B, A;
    (B = x.current) == null || B.classList.remove(
      Array.from((_ = x.current) == null ? void 0 : _.classList).find((q) => q.startsWith("a:animate-"))
    );
    const L = K5[h ?? "default"];
    (A = x.current) == null || A.classList.add(L);
  };
  return se(() => {
    if (f) {
      y ? ($.current = 0, C.current = 0, S(0)) : ($.current = C.current * (f / 100), S(C.current));
      const L = setInterval(() => {
        $.current += Dc;
        const _ = $.current / f * 100;
        if (C.current = _, S(_), $.current >= f) {
          clearInterval(L), setTimeout(() => {
            k(), t == null || t();
          }, My);
          return;
        }
      }, Dc);
      return () => {
        clearInterval(L);
      };
    }
  }, [y, f, t, h]), /* @__PURE__ */ d.jsx(
    "div",
    {
      role: "note",
      ref: x,
      "data-testid": e,
      className: Y(
        Y5({
          status: i,
          isSticky: a,
          animation: h,
          stickyLocation: p,
          width: m
        }),
        Ze(r)
      ),
      children: /* @__PURE__ */ d.jsxs(We, { gap: "4", children: [
        /* @__PURE__ */ d.jsxs(Pe, { gap: "2", wrap: "nowrap", children: [
          !s && /* @__PURE__ */ d.jsx(De, { paddingBlockStart: N, children: /* @__PURE__ */ d.jsx($e, { source: (o == null ? void 0 : o.source) || W5(i), color: w }) }),
          /* @__PURE__ */ d.jsxs("div", { className: "a:flex a:min-w-0 a:grow-1 a:flex-col", children: [
            v && /* @__PURE__ */ d.jsx(
              ie,
              {
                as: "span",
                alignment: "start",
                variant: "titleL",
                whiteSpace: "preWrap",
                wordBreak: "break",
                testId: Z({ testId: e, suffix: "title" }),
                color: w,
                children: v
              }
            ),
            /* @__PURE__ */ d.jsxs(
              ie,
              {
                alignment: "start",
                variant: "bodyM",
                whiteSpace: "preWrap",
                wordBreak: "break",
                testId: Z({ testId: e, suffix: "text" }),
                color: w,
                children: [
                  l,
                  u && /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
                    " ",
                    /* @__PURE__ */ d.jsx(
                      xi,
                      {
                        testId: Z({ testId: e, suffix: "text-tooltip" }),
                        spacingClasses: "a:pb-0.5",
                        ...u,
                        children: /* @__PURE__ */ d.jsx($e, { size: "sm", source: Ka, color: w })
                      }
                    )
                  ] })
                ]
              }
            )
          ] }),
          n && /* @__PURE__ */ d.jsx(De, { paddingBlockStart: N, children: /* @__PURE__ */ d.jsx(
            "div",
            {
              "data-testid": Z({ testId: e, suffix: "close-button" }),
              className: "a:cursor-pointer",
              onClick: t,
              children: /* @__PURE__ */ d.jsx($e, { source: bn, color: w })
            }
          ) })
        ] }),
        (g || b) && /* @__PURE__ */ d.jsxs("div", { className: "a:flex a:flex-wrap a:gap-x-4 a:gap-y-2", children: [
          g && /* @__PURE__ */ d.jsx(nv, { ...g, variant: "primary", inverse: z5(i) }),
          b && /* @__PURE__ */ d.jsx(Dn, { ...b, variant: "secondary", inverse: G5(i) })
        ] }),
        (f || c) && /* @__PURE__ */ d.jsx(
          B5,
          {
            progress: c || T,
            testId: Z({ testId: e, suffix: "progress-bar" }),
            direction: c ? "asc" : "desc",
            color: U5(i)
          }
        )
      ] })
    }
  );
};
function jf() {
  const [e, t] = ue(null);
  return [ge((r) => {
    t(r);
  }, []), { current: e }];
}
const it = (e) => /* @__PURE__ */ d.jsx(dg, { as: "button", ...e }), rv = (e) => /* @__PURE__ */ d.jsx(pg, { as: "button", ...e }), X5 = de(
  "a:fixed a:bottom-0 a:left-0 a:right-0 a:z-modal a:flex a:max-h-bottom-sheet a:animate-slide-up a:flex-col a:rounded-t-[20px] a:border-b-0 a:bg-white",
  {
    variants: {
      padding: {
        default: "a:pb-10 a:pt-2",
        slim: "a:pb-8 a:pt-1",
        none: "a:pt-1"
      },
      fullHeightOnScroll: {
        true: "a:transition-all a:duration-300"
      }
    }
  }
), Z5 = de("", {
  variants: {
    padding: {
      default: "a:pe-6 a:ps-6",
      slim: "a:pe-5 a:ps-5",
      none: "a:pe-5 a:ps-5"
    }
  }
}), Qu = ({
  peekContent: e,
  children: t,
  testId: n,
  id: r,
  isOpen: i = !1,
  hasBackBtn: a = !1,
  hasCloseBtn: o = !0,
  onBack: s,
  onClose: l,
  padding: u = "default",
  container: c,
  fullHeightOnScroll: f
}) => {
  const [p, h] = ue(i), m = ce(null), [v, g] = jf(), [b, y] = jf(), { arrivedState: x } = ev(g, y), [w, $] = ue(!1), C = u === "slim" || u === "none";
  se(() => (h((N) => (N && !i && T(), i)), () => {
    w && $(!1);
  }), [i]), se(() => {
    x.top || $(!0);
  }, [x.top]);
  const T = () => {
    var N, k;
    (N = m.current) == null || N.classList.remove("a:animate-slide-up"), (k = m.current) == null || k.classList.add("a:animate-slide-down"), setTimeout(() => {
      h(!1), l == null || l();
    }, _y);
  }, S = () => /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
    /* @__PURE__ */ d.jsx(br, { testId: Z({ testId: n, suffix: "overlay" }), onClick: T, zIndex: "modal" }),
    /* @__PURE__ */ d.jsxs(
      "div",
      {
        ref: m,
        "data-testid": n,
        id: r,
        className: Oe(X5({ padding: u, fullHeightOnScroll: f }), {
          "a:max-h-dvh": f && w
        }),
        children: [
          (a || o) && /* @__PURE__ */ d.jsxs(
            "div",
            {
              className: Y("a:flex a:w-full", C ? "a:ps-1 a:pe-1" : "a:ps-2 a:pe-2", {
                "a:justify-between": a && o,
                "a:justify-end": !a && o
              }),
              children: [
                a && /* @__PURE__ */ d.jsx(
                  it,
                  {
                    onClick: s,
                    variant: "plain",
                    icon: { size: "sm", source: b0 },
                    testId: Z({ testId: n, suffix: "back-button" })
                  }
                ),
                o && /* @__PURE__ */ d.jsx(
                  it,
                  {
                    onClick: T,
                    variant: "plain",
                    icon: { size: "sm", source: e ? vi : bn },
                    testId: Z({ testId: n, suffix: e ? "slide-button" : "close-button" })
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ d.jsx("div", { ref: b, className: Oe(Z5({ padding: u }), "a:overflow-y-auto"), children: /* @__PURE__ */ d.jsx("div", { "data-testid": Z({ testId: n, suffix: "content" }), ref: v, children: t }) })
        ]
      }
    )
  ] });
  return /* @__PURE__ */ d.jsxs("div", { className: "a:relative", children: [
    !p && e && /* @__PURE__ */ d.jsx(
      "div",
      {
        className: Y(
          "a:fixed a:bottom-0 a:left-0 a:right-0 a:z-bottomsheet a:animate-slide-up a:overflow-auto a:rounded-t-[20px] a:border-b-0 a:p-6 a:shadow-xs a:bg-white"
        ),
        children: e
      }
    ),
    p && (c ? di(S(), c) : S())
  ] });
}, J5 = {
  theme: {
    extend: {
      screens: {
        sm: "640px",
        md: "768px",
        lg: "1024px",
        xl: "1280px",
        "2xl": "1536px",
        "3xl": "1920px"
      }
    }
  }
};
var Eh, Oh;
const Ke = ((Oh = (Eh = J5.theme) == null ? void 0 : Eh.extend) == null ? void 0 : Oh.screens) || {}, Mt = (e) => `(min-width: ${e})`, Kt = (e) => `(max-width: ${parseInt(e) - 1}px)`, yt = (e, t = {}) => {
  const n = e.replace(/^@media( ?)/m, ""), r = typeof window < "u" && typeof window.matchMedia < "u", { defaultMatches: i = !1, isSsr: a = !1, ssrMatchMedia: o = null } = t, [s, l] = ue(() => !a && r ? window.matchMedia(n).matches : o ? o(n).matches : i);
  return se(() => {
    if (!r)
      return;
    const u = window.matchMedia(n);
    l(u.matches);
    const c = (f) => l(f.matches);
    return u.addEventListener("change", c), () => u.removeEventListener("change", c);
  }, [n, r]), s;
}, qO = (e) => yt(Mt(Ke.xl), e), YO = (e) => yt(Mt(Ke.lg), e), XO = (e) => yt(Kt(Ke.md), e), ZO = () => window.matchMedia(Kt(Ke.md)).matches, JO = () => window.matchMedia(Mt(Ke.lg)).matches, QO = () => /iPhone|iPad|iPod/i.test(navigator.userAgent), iv = () => {
  const e = {
    isXs: yt(Kt(Ke.sm)),
    isSm: yt(`${Mt(Ke.sm)} and ${Kt(Ke.md)}`),
    isMd: yt(`${Mt(Ke.md)} and ${Kt(Ke.lg)}`),
    isLg: yt(`${Mt(Ke.lg)} and ${Kt(Ke.xl)}`),
    isXl: yt(`${Mt(Ke.xl)} and ${Kt(Ke["2xl"])}`),
    is2xl: yt(`${Mt(Ke["2xl"])} and ${Kt(Ke["3xl"])}`),
    is3xl: yt(Mt(Ke["3xl"])),
    active: "xs"
  };
  return e.isXs && (e.active = "xs"), e.isSm && (e.active = "sm"), e.isMd && (e.active = "md"), e.isLg && (e.active = "lg"), e.isXl && (e.active = "xl"), e.is2xl && (e.active = "2xl"), e.is3xl && (e.active = "3xl"), e;
}, ba = ({ at: e, from: t, until: n, children: r }) => {
  if (e && (t || n))
    throw new Error("You can not use `at` with `from` or `until`");
  const i = typeof window < "u" && typeof window.matchMedia < "u", a = yt(Mt(t ? Ke[t] : Ke.sm)), o = yt(Kt(n ? Ke[n] : Ke["2xl"])), { active: s } = iv();
  return i ? t && n ? a && o ? /* @__PURE__ */ d.jsx(d.Fragment, { children: r }) : null : t ? a ? /* @__PURE__ */ d.jsx(d.Fragment, { children: r }) : null : n ? o ? /* @__PURE__ */ d.jsx(d.Fragment, { children: r }) : null : e ? (Array.isArray(e) ? e : [e]).includes(s) ? /* @__PURE__ */ d.jsx(d.Fragment, { children: r }) : null : /* @__PURE__ */ d.jsx(d.Fragment, { children: r }) : t && n ? /* @__PURE__ */ d.jsx("div", { className: Ud($w({ from: t, until: n })), children: r }) : t ? /* @__PURE__ */ d.jsx("div", { className: `a:hidden a:${t}:block`, children: r }) : n ? /* @__PURE__ */ d.jsx("div", { className: `a:max-${n}:block a:${n}:hidden`, children: r }) : e ? /* @__PURE__ */ d.jsx("div", { className: Ud(e), children: r }) : /* @__PURE__ */ d.jsx(d.Fragment, { children: r });
};
function Q5(e) {
  const t = /^a:(-)?(col|row|grid)-/;
  return typeof e == "string" ? e.split(" ").filter((n) => t.test(n)) : [];
}
const e9 = ({
  testId: e,
  align: t,
  justify: n,
  span: r,
  offset: i,
  rowSpan: a,
  rowOffset: o,
  order: s,
  display: l,
  children: u,
  gap: c,
  ...f
}) => /* @__PURE__ */ d.jsx(
  "div",
  {
    "data-testid": e,
    className: Y(
      fe("", l),
      fe("col-span", r),
      fe("col-start", i),
      fe("row-span", a),
      fe("order", s),
      fe("self", t),
      fe("justify-self", n),
      fe("row-start", o),
      fe("gap", c),
      g0(f)
    ),
    children: u
  }
), ut = ({
  as: e = "div",
  children: t,
  gridClasses: n,
  spacingClasses: r,
  align: i,
  id: a,
  testId: o,
  gap: s = 4,
  columns: l = 1,
  gapX: u,
  gapY: c,
  fullWidth: f,
  fullHeight: p,
  isQueryContainer: h
}) => Wr(
  e,
  {
    id: a,
    "data-testid": o,
    className: Y(
      "a:grid",
      fe("items", i),
      Ze(r),
      fe("grid-cols", l),
      Q5(n),
      u && fe("gap-x", u),
      c && fe("gap-y", c),
      !(u && c) && fe("gap", s),
      {
        "a:w-full": f,
        "a:h-full": p,
        "a:@container": h
      }
    )
  },
  t
);
ut.Cell = e9;
const eT = ({ id: e, spacingClasses: t, testId: n = "card", title: r, subtitle: i, info: a, date: o, onClick: s }) => {
  const l = (u) => {
    pt(u), s && s(u);
  };
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      id: e,
      "data-testid": n,
      ...Zu({ callback: l, role: "group", addTabIndex: !0 }),
      className: Y(
        Ze(t),
        "a:relative a:cursor-pointer a:items-center a:overflow-hidden a:rounded-lg a:border a:border-solid a:border-neutral-300 a:bg-white a:pb-2 a:pe-5 a:ps-5 a:pt-2 a:focus-visible:border-neutral-600 a:focus-visible:outline-hidden a:focus-visible:ring-0 a:active:border-neutral-600 a:sm:hover:bg-neutral-50"
      ),
      children: /* @__PURE__ */ d.jsxs(ut, { columns: 2, children: [
        /* @__PURE__ */ d.jsxs("div", { children: [
          /* @__PURE__ */ d.jsx(
            ie,
            {
              variant: r.variant ?? "titleS",
              as: "h2",
              testId: `${n}-title`,
              color: r.color ?? "neutral",
              truncate: !0,
              children: r.text
            }
          ),
          /* @__PURE__ */ d.jsx(
            ie,
            {
              variant: i.variant ?? "bodyM",
              as: "p",
              testId: `${n}-subtitle`,
              color: i.color ?? "subtle",
              truncate: !0,
              children: i.text
            }
          )
        ] }),
        /* @__PURE__ */ d.jsxs("div", { className: "a:grid a:grid-cols-2 a:items-center", children: [
          /* @__PURE__ */ d.jsx(De, { paddingInlineEnd: "4", children: /* @__PURE__ */ d.jsx(
            ie,
            {
              variant: a.variant ?? "bodyM",
              as: "p",
              testId: `${n}-info`,
              color: a.color ?? "neutral",
              truncate: !0,
              children: a.text
            }
          ) }),
          /* @__PURE__ */ d.jsx("span", { className: "a:flex a:items-center", children: /* @__PURE__ */ d.jsx(
            ie,
            {
              variant: o.variant ?? "bodyS",
              as: "p",
              testId: `${n}-date`,
              color: o.color ?? "neutral",
              truncate: !0,
              children: o.text
            }
          ) })
        ] })
      ] })
    }
  );
};
function t9(e) {
  const t = /^((min-|max-)?)(h|w)-?(.*)/;
  return typeof e == "string" ? e.split(" ").filter((n) => t.test(n)) : [];
}
const n9 = (e) => /* @__PURE__ */ M.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 80, height: 80, viewBox: "0 0 80 80", ...e }, /* @__PURE__ */ M.createElement("path", { fill: "url(#spinner_svg__a)", fillOpacity: 0.2, fillRule: "evenodd", d: "M80 40C80 17.909 62.091 0 40 0S0 17.909 0 40s17.909 40 40 40 40-17.909 40-40m-8 0C72 22.327 57.673 8 40 8S8 22.327 8 40s14.327 32 32 32 32-14.327 32-32", clipRule: "evenodd" }), /* @__PURE__ */ M.createElement("path", { fill: "url(#spinner_svg__b)", fillOpacity: 0.5, fillRule: "evenodd", d: "M80 40C80 17.909 62.091 0 40 0S0 17.909 0 40s17.909 40 40 40 40-17.909 40-40m-8 0C72 22.327 57.673 8 40 8S8 22.327 8 40s14.327 32 32 32 32-14.327 32-32", clipRule: "evenodd" }), /* @__PURE__ */ M.createElement("path", { fill: "url(#spinner_svg__c)", fillOpacity: 0.95, fillRule: "evenodd", d: "M80 40C80 17.909 62.091 0 40 0S0 17.909 0 40s17.909 40 40 40 40-17.909 40-40m-8 0C72 22.327 57.673 8 40 8S8 22.327 8 40s14.327 32 32 32 32-14.327 32-32", clipRule: "evenodd" }), /* @__PURE__ */ M.createElement("path", { fill: "url(#spinner_svg__d)", fillOpacity: 0.74, fillRule: "evenodd", d: "M80 40C80 17.909 62.091 0 40 0S0 17.909 0 40s17.909 40 40 40 40-17.909 40-40m-8 0C72 22.327 57.673 8 40 8S8 22.327 8 40s14.327 32 32 32 32-14.327 32-32", clipRule: "evenodd" }), /* @__PURE__ */ M.createElement("path", { fillRule: "evenodd", d: "M75.104 30.034c2.2-.29 4.215 1.299 4.5 3.55.263 2.091.396 4.198.396 6.308C80 42.16 78.2 44 75.98 44s-4.018-1.84-4.018-4.108c0-1.758-.11-3.514-.33-5.257-.284-2.25 1.27-4.31 3.471-4.6", clipRule: "evenodd" }), /* @__PURE__ */ M.createElement("defs", null, /* @__PURE__ */ M.createElement("linearGradient", { id: "spinner_svg__a", x1: 87.5, x2: 40, y1: 84.5, y2: 0, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ M.createElement("stop", { stopColor: "currentColor", stopOpacity: 0 }), /* @__PURE__ */ M.createElement("stop", { offset: 0, stopColor: "currentColor", stopOpacity: 0 }), /* @__PURE__ */ M.createElement("stop", { offset: 1, stopColor: "currentColor" })), /* @__PURE__ */ M.createElement("linearGradient", { id: "spinner_svg__b", x1: 31, x2: 57.5, y1: 6, y2: 61.5, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ M.createElement("stop", { stopColor: "currentColor" }), /* @__PURE__ */ M.createElement("stop", { offset: 1, stopColor: "currentColor", stopOpacity: 0 })), /* @__PURE__ */ M.createElement("linearGradient", { id: "spinner_svg__c", x1: 71.5, x2: 70.5, y1: 32.5, y2: 36.5, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ M.createElement("stop", { stopColor: "currentColor" }), /* @__PURE__ */ M.createElement("stop", { offset: 1, stopColor: "currentColor", stopOpacity: 0 })), /* @__PURE__ */ M.createElement("linearGradient", { id: "spinner_svg__d", x1: 20, x2: 37, y1: 28, y2: 43, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ M.createElement("stop", { stopColor: "currentColor" }), /* @__PURE__ */ M.createElement("stop", { offset: 0.647, stopColor: "currentColor", stopOpacity: 0 })))), r9 = de("a:z-overlay a:w-full a:flex a:items-center a:justify-center", {
  variants: {
    backgroundColor: { light: "a:bg-white", dark: "a:bg-neutral-900" },
    fitContainer: { false: "a:fixed a:inset-0" },
    opacity: { 40: "a:opacity-40", 80: "a:opacity-80", 90: "a:opacity-90" }
  },
  defaultVariants: {
    backgroundColor: "light",
    fitContainer: !1,
    opacity: 80
  }
}), i9 = de("a:animate-rotate", {
  variants: {
    size: { default: "a:w-20 a:h-20", small: "a:w-6 a:h-6" }
  },
  defaultVariants: {
    size: "default"
  }
}), a9 = ({ backgroundColor: e, fitContainer: t, opacity: n, size: r, testId: i }) => /* @__PURE__ */ d.jsx("div", { "data-testid": i, className: r9({ backgroundColor: e, fitContainer: t, opacity: n }), children: /* @__PURE__ */ d.jsx(n9, { className: i9({ size: r }) }) }), Df = de("a:bg-surface-quiet a:relative a:flex a:overflow-hidden a:rounded a:shrink-0", {
  variants: {
    ratio: {
      "3/4": "a:aspect-3/4",
      square: "a:aspect-square",
      auto: "a:aspect-auto",
      circle: "a:aspect-square a:rounded-circle"
    },
    dimensions: {
      slider: "a:max-h-slider-item a:w-slider-item a:min-w-slider-item",
      avatar: "a:w-20",
      logo: "a:w-10"
    },
    border: {
      none: "",
      neutral: "a:border-solid a:border-2 a:border-neutral-300"
    },
    objectFit: {
      cover: "a:object-cover",
      contain: "a:object-contain"
    }
  },
  defaultVariants: {
    ratio: "3/4",
    border: "none",
    objectFit: "cover"
  }
}), av = ({
  overlayIcon: e,
  imageSrc: t,
  isLoading: n,
  onOverlayIconClick: r,
  testId: i,
  ratio: a,
  sizeClasses: o,
  dimensions: s,
  border: l,
  objectFit: u
}) => /* @__PURE__ */ d.jsxs(
  "div",
  {
    "data-testid": i,
    className: Oe(
      Df({ ratio: a, dimensions: s, border: l, objectFit: u }),
      t9(Y(o)) ?? "a:w-full"
    ),
    children: [
      n && /* @__PURE__ */ d.jsx(a9, { fitContainer: !0, size: "small", opacity: 40 }),
      t && /* @__PURE__ */ d.jsx("img", { src: t, alt: "Thumbnail", className: Oe("a:h-full a:w-full", Df({ objectFit: u })) }),
      e && /* @__PURE__ */ d.jsxs(
        "button",
        {
          type: "button",
          "data-testid": Z({ testId: i, suffix: "overlay-icon" }),
          onClick: r,
          className: "a:absolute a:inset-0 a:flex a:w-full a:items-center a:justify-center a:text-white",
          children: [
            /* @__PURE__ */ d.jsx("div", { className: "a:absolute a:h-full a:w-full a:bg-surface-dark a:opacity-20" }),
            /* @__PURE__ */ d.jsx($e, { source: e, color: "inverse" })
          ]
        }
      )
    ]
  }
), o9 = de("a:pb-4 a:pt-5", {
  variants: {
    hasDivider: {
      true: "a:border-solid a:border-0 a:border-b a:border-neutral-300"
    },
    fullClick: {
      true: "a:relative a:overflow-hidden a:cursor-pointer a:w-full a:hover:bg-neutral-50 a:focus-visible:rounded a:focus-visible:border a:focus-visible:border-neutral-600 a:focus-visible:outline-hidden a:focus-visible:ring-0"
    }
  },
  defaultVariants: {
    hasDivider: !0,
    fullClick: !1
  }
});
var s9 = /* @__PURE__ */ ((e) => (e.IMAGE = "image", e.ICON = "icon", e))(s9 || {});
function tT({
  testId: e = "cart-item",
  title: t,
  highlight: n,
  itemNumber: r,
  status: i,
  services: a,
  footer: o,
  id: s,
  resource: l,
  hasDivider: u = !0,
  ...c
}) {
  var m, v, g, b, y;
  const f = (x) => {
    pt(x), c != null && c.fullClickCallback && c.fullClickCallback(x);
  }, p = (a == null ? void 0 : a.map((x) => typeof x == "string" ? { name: x } : x)) || [], h = /* @__PURE__ */ d.jsx(d.Fragment, { children: l.type === "image" ? /* @__PURE__ */ d.jsx(
    av,
    {
      testId: `${e}-thumbnail`,
      imageSrc: l.src,
      overlayIcon: l.overlayIcon,
      onOverlayIconClick: l.onOverlayIconClick,
      ratio: "square"
    }
  ) : /* @__PURE__ */ d.jsx("div", { className: Y("a:flex a:h-20 a:items-center a:justify-center a:bg-neutral-100"), children: l.icon && /* @__PURE__ */ d.jsx($e, { source: l.icon, size: "xl" }) }) });
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      className: Oe(o9({ hasDivider: u, fullClick: !!c.fullClickCallback })),
      id: s,
      "data-testid": e,
      role: "listitem",
      ...c.fullClickCallback && {
        onClick: f,
        type: "button",
        "aria:hidden": "true"
      },
      children: /* @__PURE__ */ d.jsxs(ut, { columns: "cart-item-content", gap: 0, children: [
        h,
        /* @__PURE__ */ d.jsxs("div", { className: Y("a:mb-2 a:ml-4 a:inline-block a:overflow-hidden"), children: [
          /* @__PURE__ */ d.jsxs("div", { className: Y("a:mb-2 a:flex a:justify-between"), children: [
            /* @__PURE__ */ d.jsx(ie, { variant: "titleL", as: "h1", testId: `${e}-title`, truncate: !0, strong: !(n != null && n.text), children: n != null && n.text ? J0(t, n.text, (n == null ? void 0 : n.class) || "a:text-neutral-500", e) : t }),
            c.cta && /* @__PURE__ */ d.jsx(
              rv,
              {
                variant: "secondary",
                size: "sm",
                text: (m = c.cta) == null ? void 0 : m.text,
                onClick: (v = c.cta) == null ? void 0 : v.onClick,
                iconRight: (g = c.cta) == null ? void 0 : g.icon,
                testId: `${e}-cta`
              }
            )
          ] }),
          /* @__PURE__ */ d.jsx(ie, { variant: "bodyM", as: "h4", testId: `${e}-item-number`, children: r }),
          i && /* @__PURE__ */ d.jsx(
            ie,
            {
              variant: i.variant || "bodyM",
              as: "h5",
              color: i.color || "subtle",
              testId: `${e}-status`,
              children: i.text
            }
          )
        ] }),
        p == null ? void 0 : p.map((x, w) => /* @__PURE__ */ d.jsxs(Kr, { children: [
          /* @__PURE__ */ d.jsx("div", { className: Y("a:mb-1 a:flex a:items-center a:justify-end"), children: x.status === "added" && /* @__PURE__ */ d.jsx(Ju, { children: x.statusLabel || "New" }) }),
          /* @__PURE__ */ d.jsxs("div", { className: Y("a:mb-1 a:ml-4 a:flex a:items-center a:justify-between a:overflow-hidden"), children: [
            /* @__PURE__ */ d.jsx(
              ie,
              {
                variant: "bodyM",
                color: x.color || "subtle",
                testId: `${e}-service-${w}`,
                truncate: !0,
                strike: x.status === "removed",
                children: x.name
              }
            ),
            x.price && /* @__PURE__ */ d.jsx("span", { className: "a:ms-1 a:shrink-0", children: /* @__PURE__ */ d.jsx(
              ie,
              {
                variant: "bodyM",
                color: "subtle",
                testId: `${e}-service-${w}`,
                strike: x.status === "removed",
                alignment: "end",
                children: x.price
              }
            ) })
          ] })
        ] }, `${e}-service-${w}`)),
        c.ctaFooter && /* @__PURE__ */ d.jsx(De, { paddingBlockStart: "4", children: /* @__PURE__ */ d.jsx(
          Dn,
          {
            size: "sm",
            text: (b = c.ctaFooter) == null ? void 0 : b.text,
            onClick: (y = c.ctaFooter) == null ? void 0 : y.onClick,
            testId: `${e}-ctaFooter`
          }
        ) }),
        o && (o == null ? void 0 : o.length) > 0 && /* @__PURE__ */ d.jsx(ut, { columns: "cart-item-total", gap: "2", gridClasses: "a:col-start-2", spacingClasses: "a:mt-4 a:ml-4", children: o.map((x, w) => /* @__PURE__ */ d.jsx(
          ie,
          {
            variant: x.variant,
            color: x.color,
            strike: x.isStriked,
            testId: `${e}-footer-${w}`,
            children: x.text
          },
          `${e}-footer-${w}`
        )) })
      ] })
    }
  );
}
function ov({ children: e, align: t, direction: n, flex: r, gap: i, id: a, justify: o, testId: s, wrap: l }) {
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      id: a,
      "data-testid": s,
      className: Y(
        "a:flex",
        fe("flex", n),
        fe("flex", l),
        fe("gap", i),
        fe("justify", o),
        fe("items", t),
        Va(r)
      ),
      children: e
    }
  );
}
const l9 = ({
  testId: e = "cart-item-resource",
  type: t,
  src: n,
  icon: r,
  overlayIcon: i,
  objectFit: a,
  onOverlayIconClick: o
}) => typeof t != "string" ? null : /* @__PURE__ */ d.jsxs("section", { className: "a:max-w-[88px] a:shrink-0", children: [
  t === "image" && n && /* @__PURE__ */ d.jsx(
    av,
    {
      imageSrc: n,
      overlayIcon: i,
      onOverlayIconClick: o,
      testId: `${e}-thumbnail`,
      objectFit: a
    }
  ),
  t === "icon" && r && /* @__PURE__ */ d.jsx("div", { className: Y("a:flex a:h-[88px] a:w-[88px] a:items-center a:justify-center a:bg-neutral-100"), children: /* @__PURE__ */ d.jsx($e, { ...r, size: r.size || "lg", testId: `${e}-icon` }) })
] }), u9 = ({ item: e, testId: t }) => /* @__PURE__ */ d.jsxs(Pe, { gap: "2", itemsAlign: "start", contentAlign: "between", wrap: "nowrap", testId: t, children: [
  /* @__PURE__ */ d.jsxs(ov, { gap: "2", children: [
    /* @__PURE__ */ d.jsx(ie, { color: "subtle", strike: e.status === "removed", testId: `${t}-name`, children: e.name }),
    e.status === "added" && /* @__PURE__ */ d.jsx(Ju, { color: "informative", testId: `${t}-new`, children: e.statusLabel || "New" })
  ] }),
  e.price && /* @__PURE__ */ d.jsx(ie, { color: "subtle", whiteSpace: "nowrap", strike: e.status === "removed", testId: `${t}-price`, children: e.price })
] }), c9 = (e, t) => t ? t.onClick ? /* @__PURE__ */ d.jsx(De, { children: /* @__PURE__ */ d.jsx(Dn, { text: t.text, onClick: t.onClick, testId: `${e}-link` }) }) : /* @__PURE__ */ d.jsx(ie, { color: "neutral", truncate: !0, testId: `${e}-link-text`, children: t.text }) : null, nT = ({
  children: e,
  ctaPrimary: t,
  ctaSecondary: n,
  testId: r = "cart-item",
  hasDivider: i,
  info: a,
  link: o,
  list: s = [],
  resource: l,
  subtitle: u,
  subtotal: c,
  title: f,
  total: p,
  renderListItem: h
}) => /* @__PURE__ */ d.jsxs(We, { gap: "5", testId: r, children: [
  /* @__PURE__ */ d.jsxs(Pe, { gap: "4", itemsAlign: "start", wrap: "nowrap", children: [
    /* @__PURE__ */ d.jsx(l9, { ...l, testId: r }),
    /* @__PURE__ */ d.jsx(De, { flex: { grow: 1 }, overflow: "hidden", children: /* @__PURE__ */ d.jsxs(We, { children: [
      /* @__PURE__ */ d.jsxs(De, { paddingBlockEnd: "2", children: [
        /* @__PURE__ */ d.jsxs(Pe, { gap: "2", contentAlign: "between", wrap: "nowrap", children: [
          f && /* @__PURE__ */ d.jsx(ie, { variant: "titleL", truncate: !0, testId: `${r}-title`, children: f }),
          t && /* @__PURE__ */ d.jsx(rv, { testId: `${r}-cta-primary`, ...t, variant: "secondary", size: "sm" })
        ] }),
        u && /* @__PURE__ */ d.jsx(ie, { variant: "bodyL", truncate: !0, testId: `${r}-subtitle`, children: u })
      ] }),
      c9(r, o),
      a && /* @__PURE__ */ d.jsx(ie, { ...a, color: a.color || "subtle", truncate: !0, testId: `${r}-info`, children: a.children })
    ] }) })
  ] }),
  e,
  s.length > 0 && /* @__PURE__ */ d.jsx(We, { gap: "2", children: s.map(
    (m, v) => h ? h(m) : /* @__PURE__ */ d.jsx(u9, { testId: `${r}-service-${v}`, item: m }, `${r}-service-${v}`)
  ) }),
  /* @__PURE__ */ d.jsxs(
    Pe,
    {
      gap: "5",
      itemsAlign: "center",
      contentAlign: n && (c || p) ? "between" : n ? "start" : "end",
      children: [
        n && /* @__PURE__ */ d.jsx(Dn, { ...n, testId: `${r}-cta-secondary` }),
        /* @__PURE__ */ d.jsxs(Pe, { gap: "5", contentAlign: "end", children: [
          c && /* @__PURE__ */ d.jsx(ie, { ...c, color: c.color || "subtle", testId: `${r}-subtotal`, children: c.children }),
          p && /* @__PURE__ */ d.jsx(ie, { ...p, testId: `${r}-total`, children: p.children })
        ] })
      ]
    }
  ),
  i && /* @__PURE__ */ d.jsx(Du, { testId: `${r}-divider` })
] }), d9 = de("a:grid", {
  variants: {
    size: {
      xs: "",
      sm: ""
    },
    label: {
      true: ""
    }
  },
  compoundVariants: [
    {
      size: "xs",
      label: !0,
      class: "a:pt-1"
    },
    {
      size: "sm",
      label: !0,
      class: "a:pt-0.5"
    }
  ]
}), kf = de("", {
  variants: {
    type: {
      checkbox: "a:rounded",
      radio: "a:rounded-circle"
    }
  }
}), f9 = {
  sm: "bodyM",
  xs: "bodyS"
}, Lf = {
  checkbox: {
    unchecked: Pw,
    checked: Sw
  },
  radio: {
    unchecked: Tw,
    checked: Ow
  }
}, sv = ({ type: e, label: t, id: n, size: r = "sm", disabled: i, error: a, testId: o, ...s }) => /* @__PURE__ */ d.jsxs(We, { gap: r === "sm" ? "2" : "1", children: [
  /* @__PURE__ */ d.jsxs(Pe, { testId: o, wrap: "nowrap", children: [
    /* @__PURE__ */ d.jsxs("div", { className: d9({ size: r, label: !!t }), children: [
      /* @__PURE__ */ d.jsx(
        "input",
        {
          className: Y(
            "a:z-1 a:peer a:col-span-full a:row-span-full a:appearance-none a:opacity-0",
            "a:cursor-pointer a:disabled:cursor-not-allowed"
          ),
          id: n,
          type: e,
          disabled: i,
          "aria-errormessage": a ? `${n}-error` : void 0,
          "data-testid": Z({ testId: o, suffix: "input" }),
          ...s
        }
      ),
      /* @__PURE__ */ d.jsx(
        $e,
        {
          className: Y(
            kf({ type: e }),
            "a:col-span-full a:row-span-full a:block",
            { "a:text-content-subtle": !a },
            { "a:text-content-error": !!a },
            "a:peer-checked:hidden",
            "a:peer-focus-visible:outline-offset a:peer-focus-visible:text-content-subtle-hover a:peer-focus-visible:outline a:peer-focus-visible:outline-2 a:peer-focus-visible:outline-border-focus",
            "a:peer-hover:text-content-subtle-hover",
            "a:peer-disabled:text-content-subtle-disabled",
            "a:peer-required:text-content-error a:peer-invalid:text-content-error"
          ),
          size: r,
          source: Lf[e].unchecked
        }
      ),
      /* @__PURE__ */ d.jsx(
        $e,
        {
          className: Y(
            kf({ type: e }),
            "a:col-span-full a:row-span-full a:hidden",
            { "a:text-content-brand": !a },
            { "a:text-content-error": !!a },
            "a:peer-checked:block",
            "a:peer-focus-visible:outline-offset a:peer-focus-visible:text-content-brand-hover a:peer-focus-visible:outline a:peer-focus-visible:outline-2 a:peer-focus-visible:outline-border-focus",
            "a:peer-hover:text-content-brand-hover",
            "a:peer-disabled:text-content-brand-disabled",
            "a:peer-required:text-content-error a:peer-invalid:text-content-error"
          ),
          size: r,
          source: Lf[e].checked
        }
      )
    ] }),
    t && /* @__PURE__ */ d.jsx(
      "label",
      {
        htmlFor: n,
        className: Y("a:pl-1", {
          "a:cursor-pointer": !i,
          "a:cursor-not-allowed": i
        }),
        "data-testid": Z({ testId: o, suffix: "label" }),
        children: /* @__PURE__ */ d.jsx(ie, { as: "span", color: i ? "neutral-disabled" : void 0, variant: f9[r], children: t })
      }
    )
  ] }),
  a && typeof a != "boolean" && /* @__PURE__ */ d.jsx(yi, { children: a })
] }), lv = (e) => /* @__PURE__ */ d.jsx(sv, { ...e, type: "checkbox" }), p9 = de(
  ["a:relative a:flex a:gap-2 a:justify-center a:items-center a:overflow-hidden", Le.focus],
  {
    variants: {
      variant: {
        primary: "a:border a:border-solid",
        secondary: ""
      },
      size: {
        sm: "a:h-8",
        md: "a:h-11"
      },
      state: {
        resting: "",
        disabled: "a:cursor-not-allowed a:text-content-neutral-disabled",
        activated: "a:border-border-active a:bg-surface-active-bg",
        error: "a:border-border-error"
      },
      rounded: {
        true: "a:rounded-circle a:px-3",
        false: "a:rounded-md a:px-2"
      }
    },
    compoundVariants: [
      {
        variant: ["primary", "secondary"],
        state: "resting",
        class: "a:text-content-neutral a:hover:text-content-neutral-hover"
      },
      {
        state: ["resting", "activated"],
        class: "a:cursor-pointer"
      },
      {
        variant: "primary",
        state: "resting",
        class: "a:bg-surface-neutral a:border-border-neutral a:hover:bg-surface-neutral-hover"
      },
      {
        variant: "primary",
        state: "activated",
        class: "a:border-border-active"
      },
      {
        variant: "primary",
        state: "disabled",
        class: "a:border-border-neutral"
      },
      {
        variant: "secondary",
        state: ["resting", "disabled"],
        class: "a:bg-surface-quiet"
      },
      {
        variant: "secondary",
        state: "resting",
        class: "a:hover:bg-surface-quiet-hover"
      }
    ]
  }
), rT = ({ content: e }) => /* @__PURE__ */ d.jsx("div", { className: "a:flex a:items-center", children: e }), iT = ({
  testId: e,
  id: t,
  iconLeft: n,
  iconRight: r,
  variant: i = "primary",
  size: a = "sm",
  state: o = "resting",
  text: s,
  count: l,
  rounded: u = !1,
  strikethrough: c,
  onClick: f
}) => {
  const p = (h) => {
    o !== "disabled" && (pt(h), f == null || f(h));
  };
  return /* @__PURE__ */ d.jsxs(
    "button",
    {
      id: t,
      "data-testid": e,
      tabIndex: 0,
      className: p9({ variant: i, size: a, state: o, rounded: u }),
      onClick: p,
      children: [
        !!n && /* @__PURE__ */ d.jsx($e, { size: "xs", testId: Z({ testId: e, suffix: "left-icon" }), ...n }),
        /* @__PURE__ */ d.jsxs(Pe, { gap: "1", itemsAlign: "center", children: [
          /* @__PURE__ */ d.jsx(ie, { strike: c, children: s }),
          l && /* @__PURE__ */ d.jsx(
            "div",
            {
              className: Y(
                "a:flex a:h-fit a:items-center a:rounded-circle a:border a:border-solid a:border-border-inverse",
                {
                  "a:opacity-50": o === "disabled"
                }
              ),
              children: /* @__PURE__ */ d.jsx(Ju, { color: "branded", size: "sm", children: String(l) })
            }
          )
        ] }),
        !!r && /* @__PURE__ */ d.jsx($e, { size: "xs", testId: Z({ testId: e, suffix: "right-icon" }), ...r })
      ]
    }
  );
}, h9 = ({ children: e, id: t, testId: n, isOpen: r }) => /* @__PURE__ */ d.jsx(
  "div",
  {
    id: t,
    "data-testid": n,
    className: `a:grid a:transition-[grid-template-rows] a:duration-200 a:ease-in-out ${r ? "a:grid-rows-[1fr]" : "a:grid-rows-[0fr]"}`,
    children: /* @__PURE__ */ d.jsx("div", { className: "a:overflow-hidden", children: e })
  }
), m9 = ({
  children: e,
  tag: t,
  testId: n,
  ...r
}) => Wr(t || "button", { "data-testid": n, ...r }, e), g9 = {
  open: void 0,
  id: Ja("collapsible-")
}, v9 = ({ open: e, id: t } = g9) => {
  const [n, r] = ue(e), i = () => {
    r((u) => !u);
  }, a = (u) => {
    u.key === "Enter" && (u.preventDefault(), i());
  }, o = {
    onClick: i,
    onKeyDown: a,
    tabIndex: 0,
    "aria-expanded": !!n,
    "aria-controls": `${t}-content`,
    type: "button"
  }, s = {
    id: `${t}-content`,
    isOpen: n
  };
  return {
    isOpen: n,
    handleToggle: i,
    handleKeyDown: a,
    toggleProps: o,
    contentProps: s,
    iconClasses: `a:ml-2 a:transition-transform a:duration-200 ${n ? "a:rotate-180 a:transform" : ""}`
  };
}, y9 = de("a:flex", {
  variants: {
    buttonAlignment: { start: "a:justify-between", center: "a:justify-center" }
  },
  defaultVariants: {
    buttonAlignment: "start"
  }
});
var b9 = /* @__PURE__ */ ((e) => (e.ABOVE = "above", e.BELOW = "below", e))(b9 || {});
const aT = ({
  buttonAlignment: e,
  children: t,
  testId: n,
  header: r,
  iconName: i = "chevron-down",
  hideChevron: a = !i,
  onClick: o,
  position: s = "below",
  spacingClasses: l
}) => {
  const { iconClasses: u, handleToggle: c, toggleProps: f, contentProps: p } = v9(), h = () => {
    c(), o == null || o();
  }, m = () => /* @__PURE__ */ d.jsx(h9, { testId: Z({ testId: n, suffix: "content" }), ...p, children: /* @__PURE__ */ d.jsx("div", { className: s === "above" ? "a:mb-5" : "a:mt-5", children: t }) });
  return /* @__PURE__ */ d.jsxs(
    "div",
    {
      className: Y("a:flex a:w-full a:flex-col a:overflow-hidden", Ze(l)),
      "data-testid": n,
      children: [
        s === "above" && m(),
        /* @__PURE__ */ d.jsxs(
          m9,
          {
            ...f,
            onClick: h,
            className: y9({ buttonAlignment: e }),
            tag: "button",
            children: [
              /* @__PURE__ */ d.jsx("div", { className: "a:flex a:items-center", children: r }),
              !a && /* @__PURE__ */ d.jsx("div", { children: /* @__PURE__ */ d.jsx("div", { className: u, children: /* @__PURE__ */ d.jsx($e, { source: vi, size: "md" }) }) })
            ]
          }
        ),
        s === "below" && m()
      ]
    }
  );
}, oT = ({
  backgroundColor: e = "quiet-3",
  borderRadius: t = "sm",
  date: n,
  info: r,
  message: i,
  name: a,
  testId: o = "comment"
}) => /* @__PURE__ */ d.jsx(
  "div",
  {
    role: "group",
    "data-testid": o,
    className: Oe(
      "a:p-5",
      fe("bg-surface", e),
      fe("rounded", t)
    ),
    children: /* @__PURE__ */ d.jsxs(We, { gap: "2", children: [
      /* @__PURE__ */ d.jsxs(Pe, { gap: "2", contentAlign: "between", children: [
        /* @__PURE__ */ d.jsx(
          ie,
          {
            variant: a.variant ?? "bodyM",
            strong: a.strong,
            as: "h2",
            testId: `${o}-name`,
            color: a.color ?? "emphasised",
            truncate: !0,
            children: a.text
          }
        ),
        (n == null ? void 0 : n.text) && /* @__PURE__ */ d.jsx(De, { flex: { shrink: 0 }, children: /* @__PURE__ */ d.jsx(
          ie,
          {
            variant: n.variant ?? "bodyM",
            strong: n.strong,
            as: "p",
            testId: `${o}-date`,
            color: n.color ?? "neutral",
            children: n.text
          }
        ) })
      ] }),
      /* @__PURE__ */ d.jsx(
        ie,
        {
          variant: i.variant ?? "bodyM",
          strong: i.strong,
          as: "p",
          testId: `${o}-message`,
          color: i.color ?? "emphasised",
          whiteSpace: "preWrap",
          wordBreak: "break",
          children: i.text
        }
      ),
      (r == null ? void 0 : r.text) && /* @__PURE__ */ d.jsx(
        ie,
        {
          variant: r.variant ?? "bodyM",
          strong: r.strong,
          as: "p",
          testId: `${o}-info`,
          color: r.color ?? "subtle",
          children: r.text
        }
      )
    ] })
  }
), x9 = ({ width: e = "content", children: t }) => /* @__PURE__ */ d.jsx("div", { className: Y(fe("grid", e, "a", !0)), children: t }), sT = ({ column: e = "content", withGrid: t = !0, children: n }) => t ? /* @__PURE__ */ d.jsx("div", { className: "a:grid-container a:w-full", children: /* @__PURE__ */ d.jsx(x9, { width: e, children: n }) }) : /* @__PURE__ */ d.jsx("div", { className: "a:container a:mx-auto", children: n });
function $9({ testId: e, max: t, spacingClasses: n, value: r }) {
  return /* @__PURE__ */ d.jsx("span", { className: Oe(Ze(n)), role: "presentation", "data-testid": e, children: t - r });
}
const w9 = ["-", "+", "e", "E"], Mo = (e) => e.target.value.replace(/\D/g, "").slice(0, e.target.maxLength), lT = ({
  label: e,
  disabled: t,
  error: n,
  hint: r,
  name: i,
  id: a,
  optionalText: o,
  testId: s,
  placeholder: l = { day: "DD", month: "MM", year: "YYYY" },
  defaultValue: u = { day: "", month: "", year: "" },
  onChange: c,
  onBlur: f,
  onComponentBlur: p
}) => {
  const h = ce(null), m = ce(null), v = ce(null), [g, b] = ue(u.day), [y, x] = ue(u.month), [w, $] = ue(u.year), C = (_, B, A) => c({ day: _, month: B, year: A }), T = (_) => {
    var A;
    const B = Mo(_);
    B.length === _.target.maxLength && ((A = m.current) == null || A.focus()), b(B), C(B, y, w);
  }, S = (_) => {
    var A;
    const B = Mo(_);
    B.length === _.target.maxLength && ((A = v.current) == null || A.focus()), x(B), C(g, B, w);
  }, N = (_) => {
    const B = Mo(_);
    $(B), C(g, y, B);
  }, k = (_) => {
    var B, A;
    (_.key === "Backspace" || _.key === "Delete") && (_.target === m.current && y.length === 0 && ((B = h.current) == null || B.focus(), _.preventDefault()), _.target === v.current && w.length === 0 && ((A = m.current) == null || A.focus(), _.preventDefault())), w9.includes(_.key) && _.preventDefault();
  }, L = (_) => {
    p && setTimeout(() => {
      [h.current, m.current, v.current].includes(document.activeElement) || p(_);
    }, 0), f == null || f(_);
  };
  return /* @__PURE__ */ d.jsxs(We, { gap: "1", testId: s, children: [
    e && /* @__PURE__ */ d.jsx(za, { optionalText: o, children: e }),
    /* @__PURE__ */ d.jsxs(ut, { columns: 3, gapX: 4, children: [
      /* @__PURE__ */ d.jsx(ut.Cell, { children: /* @__PURE__ */ d.jsx(
        Xt,
        {
          innerRef: h,
          id: `${a}-day`,
          name: `${i}-day`,
          testId: Z({ testId: s, suffix: "day" }),
          placeholder: l.day,
          type: "number",
          pattern: "[0-9]*",
          maxLength: 2,
          value: g,
          onChange: T,
          onKeyDown: k,
          disabled: t,
          error: !!n,
          onBlur: f || p ? L : void 0
        }
      ) }),
      /* @__PURE__ */ d.jsx(ut.Cell, { children: /* @__PURE__ */ d.jsx(
        Xt,
        {
          innerRef: m,
          id: `${a}-month`,
          name: `${i}-month`,
          testId: Z({ testId: s, suffix: "month" }),
          placeholder: l.month,
          type: "number",
          pattern: "[0-9]*",
          maxLength: 2,
          value: y,
          onChange: S,
          onKeyDown: k,
          disabled: t,
          error: !!n,
          onBlur: f || p ? L : void 0
        }
      ) }),
      /* @__PURE__ */ d.jsx(ut.Cell, { children: /* @__PURE__ */ d.jsx(
        Xt,
        {
          innerRef: v,
          id: `${a}-year`,
          name: `${i}-year`,
          testId: Z({ testId: s, suffix: "year" }),
          placeholder: l.year,
          type: "number",
          pattern: "[0-9]*",
          maxLength: 4,
          value: w,
          onChange: N,
          onKeyDown: k,
          disabled: t,
          error: !!n,
          onBlur: f || p ? L : void 0
        }
      ) })
    ] }),
    n ? /* @__PURE__ */ d.jsx(yi, { children: n }) : r ? /* @__PURE__ */ d.jsx(ie, { as: "span", variant: "bodyS", color: t ? "subtle" : "neutral", children: r }) : null
  ] });
}, C9 = de("a:flex a:left-0 a:right-0 a:top-0 a:items-center a:w-full a:z-header a:p-2 a:bg-white", {
  variants: {
    hasShadow: {
      true: "a:shadow-xs"
    },
    height: {
      16: "a:h-16",
      20: "a:h-20",
      24: "a:h-24"
    },
    position: {
      relative: "a:relative",
      fixed: "a:fixed"
    }
  },
  defaultVariants: {
    hasShadow: !1,
    height: 20,
    position: "relative"
  }
});
function uT({ children: e, testId: t, hasShadow: n, height: r, position: i }) {
  return /* @__PURE__ */ d.jsx(
    "header",
    {
      className: Y(
        C9({
          hasShadow: n,
          height: r,
          position: i
        })
      ),
      "data-testid": t,
      children: e
    }
  );
}
var Di = {}, ki = {}, Ff;
function S9() {
  if (Ff) return ki;
  Ff = 1, Object.defineProperty(ki, "__esModule", {
    value: !0
  });
  var e = {
    update: function() {
      typeof window < "u" && typeof window.matchMedia == "function" && (e.hover = window.matchMedia("(hover: hover)").matches, e.none = window.matchMedia("(hover: none)").matches || window.matchMedia("(hover: on-demand)").matches, e.anyHover = window.matchMedia("(any-hover: hover)").matches, e.anyNone = window.matchMedia("(any-hover: none)").matches || window.matchMedia("(any-hover: on-demand)").matches);
    }
  };
  return e.update(), ki.default = e, ki;
}
var Li = {}, Vf;
function I9() {
  if (Vf) return Li;
  Vf = 1, Object.defineProperty(Li, "__esModule", {
    value: !0
  });
  var e = {
    update: function() {
      typeof window < "u" && typeof window.matchMedia == "function" && (e.fine = window.matchMedia("(pointer: fine)").matches, e.coarse = window.matchMedia("(pointer: coarse)").matches, e.none = window.matchMedia("(pointer: none)").matches, e.anyFine = window.matchMedia("(any-pointer: fine)").matches, e.anyCoarse = window.matchMedia("(any-pointer: coarse)").matches, e.anyNone = window.matchMedia("(any-pointer: none)").matches);
    }
  };
  return e.update(), Li.default = e, Li;
}
var Fi = {}, Bf;
function E9() {
  if (Bf) return Fi;
  Bf = 1, Object.defineProperty(Fi, "__esModule", {
    value: !0
  });
  var e = {
    update: function() {
      typeof window < "u" && (e.hasSupport = "ontouchstart" in window, e.browserSupportsApi = !!window.TouchEvent);
    }
  };
  return e.update(), Fi.default = e, Fi;
}
var Vi = {}, Hf;
function O9() {
  if (Hf) return Vi;
  Hf = 1, Object.defineProperty(Vi, "__esModule", {
    value: !0
  });
  var e = {
    update: function() {
      if (typeof window < "u" && typeof window.addEventListener == "function") {
        var n = !1, r = Object.defineProperty({}, "passive", {
          get: function() {
            n = !0;
          }
        }), i = function() {
        };
        window.addEventListener("testPassiveEventSupport", i, r), window.removeEventListener("testPassiveEventSupport", i, r), e.hasSupport = n;
      }
    }
  };
  return e.update(), Vi.default = e, Vi;
}
var Kf;
function T9() {
  if (Kf) return Di;
  Kf = 1, Object.defineProperty(Di, "__esModule", {
    value: !0
  });
  var e = S9(), t = l(e), n = I9(), r = l(n), i = E9(), a = l(i), o = O9(), s = l(o);
  function l(f) {
    return f && f.__esModule ? f : { default: f };
  }
  function u(f, p, h, m) {
    return f && (p || h) ? "hybrid" : f && Object.keys(m.detectHover).filter(function(v) {
      return v !== "update";
    }).every(function(v) {
      return m.detectHover[v] === !1;
    }) && Object.keys(m.detectPointer).filter(function(v) {
      return v !== "update";
    }).every(function(v) {
      return m.detectPointer[v] === !1;
    }) ? window.navigator && /android/.test(window.navigator.userAgent.toLowerCase()) ? "touchOnly" : "hybrid" : f ? "touchOnly" : "mouseOnly";
  }
  var c = {
    state: {
      detectHover: t.default,
      detectPointer: r.default,
      detectTouchEvents: a.default,
      detectPassiveEvents: s.default
    },
    update: function() {
      c.state.detectHover.update(), c.state.detectPointer.update(), c.state.detectTouchEvents.update(), c.state.detectPassiveEvents.update(), c.updateOnlyOwnProperties();
    },
    updateOnlyOwnProperties: function() {
      if (typeof window < "u") {
        c.passiveEvents = c.state.detectPassiveEvents.hasSupport || !1, c.hasTouch = c.state.detectTouchEvents.hasSupport || !1, c.deviceType = u(c.hasTouch, c.state.detectHover.anyHover, c.state.detectPointer.anyFine, c.state), c.hasMouse = c.deviceType !== "touchOnly", c.primaryInput = c.deviceType === "mouseOnly" && "mouse" || c.deviceType === "touchOnly" && "touch" || // deviceType is hybrid:
        c.state.detectHover.hover && "mouse" || c.state.detectHover.none && "touch" || // if there's no support for hover media queries but detectIt determined it's
        // a hybrid  device, then assume it's a mouse first device
        "mouse";
        var p = /windows/.test(window.navigator.userAgent.toLowerCase()) && /chrome/.test(window.navigator.userAgent.toLowerCase()) && parseInt(/Chrome\/([0-9.]+)/.exec(navigator.userAgent)[1], 10) >= 59;
        p && c.hasTouch && (c.deviceType = "hybrid", c.hasMouse = !0, c.primaryInput = "mouse");
      }
    }
  };
  return c.updateOnlyOwnProperties(), Di.default = c, Di;
}
var P9 = T9();
const N9 = /* @__PURE__ */ rn(P9);
var _9 = au();
const Ge = /* @__PURE__ */ rn(_9);
var Bi = { exports: {} }, jo, Wf;
function ec() {
  if (Wf) return jo;
  Wf = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  var t = function() {
  };
  return t.thatReturns = e, t.thatReturnsFalse = e(!1), t.thatReturnsTrue = e(!0), t.thatReturnsNull = e(null), t.thatReturnsThis = function() {
    return this;
  }, t.thatReturnsArgument = function(n) {
    return n;
  }, jo = t, jo;
}
var Do, zf;
function tc() {
  if (zf) return Do;
  zf = 1;
  var e = function(r) {
  };
  process.env.NODE_ENV !== "production" && (e = function(r) {
    if (r === void 0)
      throw new Error("invariant requires an error message argument");
  });
  function t(n, r, i, a, o, s, l, u) {
    if (e(r), !n) {
      var c;
      if (r === void 0)
        c = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
      else {
        var f = [i, a, o, s, l, u], p = 0;
        c = new Error(r.replace(/%s/g, function() {
          return f[p++];
        })), c.name = "Invariant Violation";
      }
      throw c.framesToPop = 1, c;
    }
  }
  return Do = t, Do;
}
var ko, Gf;
function uv() {
  if (Gf) return ko;
  Gf = 1;
  var e = ec(), t = e;
  if (process.env.NODE_ENV !== "production") {
    var n = function(i) {
      for (var a = arguments.length, o = Array(a > 1 ? a - 1 : 0), s = 1; s < a; s++)
        o[s - 1] = arguments[s];
      var l = 0, u = "Warning: " + i.replace(/%s/g, function() {
        return o[l++];
      });
      typeof console < "u" && console.error(u);
      try {
        throw new Error(u);
      } catch {
      }
    };
    t = function(i, a) {
      if (a === void 0)
        throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
      if (a.indexOf("Failed Composite propType: ") !== 0 && !i) {
        for (var o = arguments.length, s = Array(o > 2 ? o - 2 : 0), l = 2; l < o; l++)
          s[l - 2] = arguments[l];
        n.apply(void 0, [a].concat(s));
      }
    };
  }
  return ko = t, ko;
}
var Lo, Uf;
function nc() {
  if (Uf) return Lo;
  Uf = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Lo = e, Lo;
}
var Fo, qf;
function A9() {
  if (qf) return Fo;
  if (qf = 1, process.env.NODE_ENV !== "production")
    var e = tc(), t = uv(), n = nc(), r = {};
  function i(a, o, s, l, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var c in a)
        if (a.hasOwnProperty(c)) {
          var f;
          try {
            e(typeof a[c] == "function", "%s: %s type `%s` is invalid; it must be a function, usually from the `prop-types` package, but received `%s`.", l || "React class", s, c, typeof a[c]), f = a[c](o, c, l, s, null, n);
          } catch (h) {
            f = h;
          }
          if (t(!f || f instanceof Error, "%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", l || "React class", s, c, typeof f), f instanceof Error && !(f.message in r)) {
            r[f.message] = !0;
            var p = u ? u() : "";
            t(!1, "Failed %s type: %s%s", s, f.message, p ?? "");
          }
        }
    }
  }
  return Fo = i, Fo;
}
var Vo, Yf;
function R9() {
  if (Yf) return Vo;
  Yf = 1;
  var e = ec(), t = tc(), n = uv(), r = au(), i = nc(), a = A9();
  return Vo = function(o, s) {
    var l = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function c(I) {
      var O = I && (l && I[l] || I[u]);
      if (typeof O == "function")
        return O;
    }
    var f = "<<anonymous>>", p = {
      array: g("array"),
      bool: g("boolean"),
      func: g("function"),
      number: g("number"),
      object: g("object"),
      string: g("string"),
      symbol: g("symbol"),
      any: b(),
      arrayOf: y,
      element: x(),
      instanceOf: w,
      node: S(),
      objectOf: C,
      oneOf: $,
      oneOfType: T,
      shape: N,
      exact: k
    };
    function h(I, O) {
      return I === O ? I !== 0 || 1 / I === 1 / O : I !== I && O !== O;
    }
    function m(I) {
      this.message = I, this.stack = "";
    }
    m.prototype = Error.prototype;
    function v(I) {
      if (process.env.NODE_ENV !== "production")
        var O = {}, D = 0;
      function E(F, K, H, W, G, z, U) {
        if (W = W || f, z = z || H, U !== i) {
          if (s)
            t(
              !1,
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
          else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var J = W + ":" + H;
            !O[J] && // Avoid spamming the console because they are often not actionable except for lib authors
            D < 3 && (n(
              !1,
              "You are manually calling a React.PropTypes validation function for the `%s` prop on `%s`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.",
              z,
              W
            ), O[J] = !0, D++);
          }
        }
        return K[H] == null ? F ? K[H] === null ? new m("The " + G + " `" + z + "` is marked as required " + ("in `" + W + "`, but its value is `null`.")) : new m("The " + G + " `" + z + "` is marked as required in " + ("`" + W + "`, but its value is `undefined`.")) : null : I(K, H, W, G, z);
      }
      var j = E.bind(null, !1);
      return j.isRequired = E.bind(null, !0), j;
    }
    function g(I) {
      function O(D, E, j, F, K, H) {
        var W = D[E], G = B(W);
        if (G !== I) {
          var z = A(W);
          return new m("Invalid " + F + " `" + K + "` of type " + ("`" + z + "` supplied to `" + j + "`, expected ") + ("`" + I + "`."));
        }
        return null;
      }
      return v(O);
    }
    function b() {
      return v(e.thatReturnsNull);
    }
    function y(I) {
      function O(D, E, j, F, K) {
        if (typeof I != "function")
          return new m("Property `" + K + "` of component `" + j + "` has invalid PropType notation inside arrayOf.");
        var H = D[E];
        if (!Array.isArray(H)) {
          var W = B(H);
          return new m("Invalid " + F + " `" + K + "` of type " + ("`" + W + "` supplied to `" + j + "`, expected an array."));
        }
        for (var G = 0; G < H.length; G++) {
          var z = I(H, G, j, F, K + "[" + G + "]", i);
          if (z instanceof Error)
            return z;
        }
        return null;
      }
      return v(O);
    }
    function x() {
      function I(O, D, E, j, F) {
        var K = O[D];
        if (!o(K)) {
          var H = B(K);
          return new m("Invalid " + j + " `" + F + "` of type " + ("`" + H + "` supplied to `" + E + "`, expected a single ReactElement."));
        }
        return null;
      }
      return v(I);
    }
    function w(I) {
      function O(D, E, j, F, K) {
        if (!(D[E] instanceof I)) {
          var H = I.name || f, W = X(D[E]);
          return new m("Invalid " + F + " `" + K + "` of type " + ("`" + W + "` supplied to `" + j + "`, expected ") + ("instance of `" + H + "`."));
        }
        return null;
      }
      return v(O);
    }
    function $(I) {
      if (!Array.isArray(I))
        return process.env.NODE_ENV !== "production" && n(!1, "Invalid argument supplied to oneOf, expected an instance of array."), e.thatReturnsNull;
      function O(D, E, j, F, K) {
        for (var H = D[E], W = 0; W < I.length; W++)
          if (h(H, I[W]))
            return null;
        var G = JSON.stringify(I);
        return new m("Invalid " + F + " `" + K + "` of value `" + H + "` " + ("supplied to `" + j + "`, expected one of " + G + "."));
      }
      return v(O);
    }
    function C(I) {
      function O(D, E, j, F, K) {
        if (typeof I != "function")
          return new m("Property `" + K + "` of component `" + j + "` has invalid PropType notation inside objectOf.");
        var H = D[E], W = B(H);
        if (W !== "object")
          return new m("Invalid " + F + " `" + K + "` of type " + ("`" + W + "` supplied to `" + j + "`, expected an object."));
        for (var G in H)
          if (H.hasOwnProperty(G)) {
            var z = I(H, G, j, F, K + "." + G, i);
            if (z instanceof Error)
              return z;
          }
        return null;
      }
      return v(O);
    }
    function T(I) {
      if (!Array.isArray(I))
        return process.env.NODE_ENV !== "production" && n(!1, "Invalid argument supplied to oneOfType, expected an instance of array."), e.thatReturnsNull;
      for (var O = 0; O < I.length; O++) {
        var D = I[O];
        if (typeof D != "function")
          return n(
            !1,
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received %s at index %s.",
            q(D),
            O
          ), e.thatReturnsNull;
      }
      function E(j, F, K, H, W) {
        for (var G = 0; G < I.length; G++) {
          var z = I[G];
          if (z(j, F, K, H, W, i) == null)
            return null;
        }
        return new m("Invalid " + H + " `" + W + "` supplied to " + ("`" + K + "`."));
      }
      return v(E);
    }
    function S() {
      function I(O, D, E, j, F) {
        return L(O[D]) ? null : new m("Invalid " + j + " `" + F + "` supplied to " + ("`" + E + "`, expected a ReactNode."));
      }
      return v(I);
    }
    function N(I) {
      function O(D, E, j, F, K) {
        var H = D[E], W = B(H);
        if (W !== "object")
          return new m("Invalid " + F + " `" + K + "` of type `" + W + "` " + ("supplied to `" + j + "`, expected `object`."));
        for (var G in I) {
          var z = I[G];
          if (z) {
            var U = z(H, G, j, F, K + "." + G, i);
            if (U)
              return U;
          }
        }
        return null;
      }
      return v(O);
    }
    function k(I) {
      function O(D, E, j, F, K) {
        var H = D[E], W = B(H);
        if (W !== "object")
          return new m("Invalid " + F + " `" + K + "` of type `" + W + "` " + ("supplied to `" + j + "`, expected `object`."));
        var G = r({}, D[E], I);
        for (var z in G) {
          var U = I[z];
          if (!U)
            return new m(
              "Invalid " + F + " `" + K + "` key `" + z + "` supplied to `" + j + "`.\nBad object: " + JSON.stringify(D[E], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(I), null, "  ")
            );
          var J = U(H, z, j, F, K + "." + z, i);
          if (J)
            return J;
        }
        return null;
      }
      return v(O);
    }
    function L(I) {
      switch (typeof I) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !I;
        case "object":
          if (Array.isArray(I))
            return I.every(L);
          if (I === null || o(I))
            return !0;
          var O = c(I);
          if (O) {
            var D = O.call(I), E;
            if (O !== I.entries) {
              for (; !(E = D.next()).done; )
                if (!L(E.value))
                  return !1;
            } else
              for (; !(E = D.next()).done; ) {
                var j = E.value;
                if (j && !L(j[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function _(I, O) {
      return I === "symbol" || O["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && O instanceof Symbol;
    }
    function B(I) {
      var O = typeof I;
      return Array.isArray(I) ? "array" : I instanceof RegExp ? "object" : _(O, I) ? "symbol" : O;
    }
    function A(I) {
      if (typeof I > "u" || I === null)
        return "" + I;
      var O = B(I);
      if (O === "object") {
        if (I instanceof Date)
          return "date";
        if (I instanceof RegExp)
          return "regexp";
      }
      return O;
    }
    function q(I) {
      var O = A(I);
      switch (O) {
        case "array":
        case "object":
          return "an " + O;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + O;
        default:
          return O;
      }
    }
    function X(I) {
      return !I.constructor || !I.constructor.name ? f : I.constructor.name;
    }
    return p.checkPropTypes = a, p.PropTypes = p, p;
  }, Vo;
}
var Bo, Xf;
function M9() {
  if (Xf) return Bo;
  Xf = 1;
  var e = ec(), t = tc(), n = nc();
  return Bo = function() {
    function r(o, s, l, u, c, f) {
      f !== n && t(
        !1,
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var a = {
      array: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i
    };
    return a.checkPropTypes = e, a.PropTypes = a, a;
  }, Bo;
}
var Zf;
function j9() {
  if (Zf) return Bi.exports;
  if (Zf = 1, process.env.NODE_ENV !== "production") {
    var e = typeof Symbol == "function" && Symbol.for && Symbol.for("react.element") || 60103, t = function(r) {
      return typeof r == "object" && r !== null && r.$$typeof === e;
    }, n = !0;
    Bi.exports = R9()(t, n);
  } else
    Bi.exports = M9()();
  return Bi.exports;
}
var D9 = j9();
const re = /* @__PURE__ */ rn(D9);
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
var Ho, Jf;
function k9() {
  return Jf || (Jf = 1, Ho = function(t) {
    return t != null && typeof t == "object" && Array.isArray(t) === !1;
  }), Ho;
}
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
var Ko, Qf;
function L9() {
  if (Qf) return Ko;
  Qf = 1;
  var e = k9();
  function t(n) {
    return e(n) === !0 && Object.prototype.toString.call(n) === "[object Object]";
  }
  return Ko = function(r) {
    var i, a;
    return !(t(r) === !1 || (i = r.constructor, typeof i != "function") || (a = i.prototype, t(a) === !1) || a.hasOwnProperty("isPrototypeOf") === !1);
  }, Ko;
}
/*!
 * is-extendable <https://github.com/jonschlinkert/is-extendable>
 *
 * Copyright (c) 2015-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
var Wo, ep;
function F9() {
  if (ep) return Wo;
  ep = 1;
  var e = L9();
  return Wo = function(n) {
    return e(n) || typeof n == "function" || Array.isArray(n);
  }, Wo;
}
/*!
 * object.omit <https://github.com/jonschlinkert/object.omit>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
var zo, tp;
function V9() {
  if (tp) return zo;
  tp = 1;
  var e = F9();
  return zo = function(n, r, i) {
    if (!e(n)) return {};
    typeof r == "function" && (i = r, r = []), typeof r == "string" && (r = [r]);
    for (var a = typeof i == "function", o = Object.keys(n), s = {}, l = 0; l < o.length; l++) {
      var u = o[l], c = n[u];
      (!r || r.indexOf(u) === -1 && (!a || i(c, u, n))) && (s[u] = c);
    }
    return s;
  }, zo;
}
var B9 = V9();
const H9 = /* @__PURE__ */ rn(B9);
var K9 = /* @__PURE__ */ function() {
  function e(t, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
  }
  return function(t, n, r) {
    return n && e(t.prototype, n), r && e(t, r), t;
  };
}();
function W9(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
var z9 = function() {
  function e(t) {
    W9(this, e), this.el = t;
  }
  return K9(e, [{
    key: "getDocumentRelativeElementOffset",
    value: function(n) {
      var r = this.getRootOfEl(n), i = r.getBoundingClientRect(), a = i.left, o = i.top, s = n.getBoundingClientRect(), l = s.left, u = s.top;
      return {
        x: Math.abs(a) + l,
        y: Math.abs(o) + u
      };
    }
  }, {
    key: "getRootOfEl",
    value: function(n) {
      return n.parentElement ? this.getRootOfEl(n.parentElement) : n;
    }
  }, {
    key: "getComputedElementRelativeCursorPosition",
    value: function(n, r) {
      this.lastEvent = n;
      var i = this.getDocumentRelativeCursorPosition(n), a = i.x, o = i.y, s = r.x, l = r.y;
      return {
        x: Math.round(a - s),
        y: Math.round(o - l)
      };
    }
  }, {
    key: "getDocumentRelativeCursorPosition",
    value: function(n) {
      return {
        x: n.pageX,
        y: n.pageY
      };
    }
  }, {
    key: "getCursorPosition",
    value: function(n) {
      return this.getComputedElementRelativeCursorPosition(n, this.documentRelativeElementOffset);
    }
  }, {
    key: "documentRelativeElementOffset",
    get: function() {
      return this.elementOffset || (this.elementOffset = this.getDocumentRelativeElementOffset(this.el)), this.elementOffset;
    }
  }]), e;
}();
function $n(e, t, n, r) {
  return e.addEventListener(t, n, r), {
    removeEventListener: function() {
      e.removeEventListener(t, n, r);
    }
  };
}
var np = "pressEvent", G9 = "mouseEmulation", rp = "setHovering", ip = "unsetHovering";
const Go = function() {
};
var U9 = /* @__PURE__ */ function() {
  function e(t, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
  }
  return function(t, n, r) {
    return n && e(t.prototype, n), r && e(t, r), t;
  };
}();
function q9(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Y9(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function X9(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var Qa = function(e) {
  X9(t, e);
  function t(n) {
    q9(this, t);
    var r = Y9(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, n));
    return Z9.call(r), r.state = {
      detectedEnvironment: {
        isMouseDetected: !1,
        isTouchDetected: !1
      },
      elementDimensions: {
        width: 0,
        height: 0
      },
      isActive: !1,
      isPositionOutside: !0,
      position: {
        x: 0,
        y: 0
      }
    }, r.shouldGuardAgainstMouseEmulationByDevices = !1, r.eventListeners = [], r.timers = [], r.elementOffset = {
      x: 0,
      y: 0
    }, r.onTouchStart = r.onTouchStart.bind(r), r.onTouchMove = r.onTouchMove.bind(r), r.onTouchEnd = r.onTouchEnd.bind(r), r.onTouchCancel = r.onTouchCancel.bind(r), r.onMouseEnter = r.onMouseEnter.bind(r), r.onMouseMove = r.onMouseMove.bind(r), r.onMouseLeave = r.onMouseLeave.bind(r), r;
  }
  return U9(t, [{
    key: "onTouchStart",
    value: function(r) {
      this.init(), this.onTouchDetected(), this.setShouldGuardAgainstMouseEmulationByDevices();
      var i = this.core.getCursorPosition(this.getTouchEvent(r));
      if (this.setPositionState(i), this.props.isActivatedOnTouch) {
        r.preventDefault(), this.activate();
        return;
      }
      this.initPressEventCriteria(i), this.setPressEventTimer();
    }
  }, {
    key: "onTouchMove",
    value: function(r) {
      if (this.isCoreReady) {
        var i = this.core.getCursorPosition(this.getTouchEvent(r));
        if (!this.state.isActive) {
          this.setPressEventCriteria(i);
          return;
        }
        this.setPositionState(i), r.preventDefault(), this.props.shouldStopTouchMovePropagation && r.stopPropagation();
      }
    }
  }, {
    key: "onTouchEnd",
    value: function() {
      this.deactivate(), this.unsetShouldGuardAgainstMouseEmulationByDevices();
    }
  }, {
    key: "onTouchCancel",
    value: function() {
      this.deactivate(), this.unsetShouldGuardAgainstMouseEmulationByDevices();
    }
  }, {
    key: "onMouseEnter",
    value: function(r) {
      this.shouldGuardAgainstMouseEmulationByDevices || (this.init(), this.onMouseDetected(), this.setPositionState(this.core.getCursorPosition(r)), this.clearActivationTimers(), this.schedulActivation(this.props.hoverDelayInMs));
    }
  }, {
    key: "onMouseMove",
    value: function(r) {
      this.isCoreReady && this.setPositionState(this.core.getCursorPosition(r));
    }
  }, {
    key: "onMouseLeave",
    value: function() {
      this.clearActivationTimers(), this.scheduleDeactivation(this.props.hoverOffDelayInMs), this.setState({ isPositionOutside: !0 });
    }
  }, {
    key: "onTouchDetected",
    value: function() {
      var r = {
        isTouchDetected: !0,
        isMouseDetected: !1
      };
      this.setState({ detectedEnvironment: r }), this.props.onDetectedEnvironmentChanged(r);
    }
  }, {
    key: "onMouseDetected",
    value: function() {
      var r = {
        isTouchDetected: !1,
        isMouseDetected: !0
      };
      this.setState({ detectedEnvironment: r }), this.props.onDetectedEnvironmentChanged(r);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      this.props.isEnabled && this.enable();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function(r) {
      var i = r.isEnabled, a = this.props.isEnabled, o = a !== i;
      o && (i ? this.enable() : this.disable());
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.clearTimers(), this.disable();
    }
  }, {
    key: "enable",
    value: function() {
      this.addEventListeners();
    }
  }, {
    key: "disable",
    value: function() {
      this.removeEventListeners();
    }
  }, {
    key: "init",
    value: function() {
      this.core = new z9(this.el), this.setElementDimensionsState(this.getElementDimensions(this.el));
    }
  }, {
    key: "reset",
    value: function() {
      var r = this.core;
      r = r === void 0 ? {} : r;
      var i = r.lastEvent;
      this.init(), i && this.setPositionState(this.core.getCursorPosition(i));
    }
  }, {
    key: "activate",
    value: function() {
      this.setState({ isActive: !0 }), this.props.onActivationChanged({ isActive: !0 });
    }
  }, {
    key: "deactivate",
    value: function() {
      var r = this;
      this.clearTimer(np), this.setState({ isActive: !1 }, function() {
        var i = r.state, a = i.isPositionOutside, o = i.position;
        r.props.onPositionChanged({
          isPositionOutside: a,
          position: o
        }), r.props.onActivationChanged({ isActive: !1 });
      });
    }
  }, {
    key: "setPositionState",
    value: function(r) {
      var i = this.getIsPositionOutside(r);
      this.setState({
        isPositionOutside: i,
        position: r
      }, this.onPositionChanged);
    }
  }, {
    key: "setElementDimensionsState",
    value: function(r) {
      this.setState({
        elementDimensions: r
      });
    }
  }, {
    key: "schedulActivation",
    value: function(r) {
      var i = this, a = setTimeout(function() {
        i.activate();
      }, r);
      this.timers.push({
        id: a,
        name: rp
      });
    }
  }, {
    key: "scheduleDeactivation",
    value: function(r) {
      var i = this, a = setTimeout(function() {
        i.deactivate();
      }, r);
      this.timers.push({
        id: a,
        name: ip
      });
    }
  }, {
    key: "clearActivationTimers",
    value: function() {
      this.clearTimer(rp), this.clearTimer(ip);
    }
  }, {
    key: "setPressEventTimer",
    value: function() {
      var r = this, i = this.props, a = i.pressDuration, o = i.pressMoveThreshold;
      this.timers.push({
        name: np,
        id: setTimeout(function() {
          Math.abs(r.currentElTop - r.initialElTop) < o && r.activate();
        }, a)
      });
    }
  }, {
    key: "setPressEventCriteria",
    value: function(r) {
      this.currentElTop = r.y;
    }
  }, {
    key: "initPressEventCriteria",
    value: function(r) {
      var i = r.y;
      this.initialElTop = i, this.currentElTop = i;
    }
  }, {
    key: "setShouldGuardAgainstMouseEmulationByDevices",
    value: function() {
      this.shouldGuardAgainstMouseEmulationByDevices = !0;
    }
  }, {
    key: "unsetShouldGuardAgainstMouseEmulationByDevices",
    value: function() {
      var r = this;
      this.timers.push({
        name: G9,
        id: setTimeout(function() {
          r.shouldGuardAgainstMouseEmulationByDevices = !1;
        }, 0)
      });
    }
  }, {
    key: "clearTimers",
    value: function() {
      for (var r = this.timers; r.length; ) {
        var i = r.pop();
        clearTimeout(i.id);
      }
    }
  }, {
    key: "clearTimer",
    value: function(r) {
      this.timers.forEach(function(i) {
        i.name === r && clearTimeout(i.id);
      });
    }
  }, {
    key: "getElementDimensions",
    value: function(r) {
      var i = r.getBoundingClientRect(), a = i.width, o = i.height;
      return {
        width: a,
        height: o
      };
    }
  }, {
    key: "getIsPositionOutside",
    value: function(r) {
      var i = r.x, a = r.y, o = this.state.elementDimensions, s = o.width, l = o.height, u = i < 0 || a < 0 || i > s || a > l;
      return u;
    }
  }, {
    key: "getTouchEvent",
    value: function(r) {
      return r.touches[0];
    }
  }, {
    key: "getIsReactComponent",
    value: function(r) {
      return typeof r.type == "function";
    }
  }, {
    key: "shouldDecorateChild",
    value: function(r) {
      return !!r && this.getIsReactComponent(r) && this.props.shouldDecorateChildren;
    }
  }, {
    key: "decorateChild",
    value: function(r, i) {
      return _a(r, i);
    }
  }, {
    key: "decorateChildren",
    value: function(r, i) {
      var a = this;
      return Aa.map(r, function(o) {
        return a.shouldDecorateChild(o) ? a.decorateChild(o, i) : o;
      });
    }
  }, {
    key: "addEventListeners",
    value: function() {
      this.eventListeners.push($n(this.el, "touchstart", this.onTouchStart, { passive: !1 }), $n(this.el, "touchmove", this.onTouchMove, { passive: !1 }), $n(this.el, "touchend", this.onTouchEnd), $n(this.el, "touchcancel", this.onTouchCancel), $n(this.el, "mouseenter", this.onMouseEnter), $n(this.el, "mousemove", this.onMouseMove), $n(this.el, "mouseleave", this.onMouseLeave));
    }
  }, {
    key: "removeEventListeners",
    value: function() {
      for (; this.eventListeners.length; )
        this.eventListeners.pop().removeEventListener();
    }
  }, {
    key: "getPassThroughProps",
    value: function() {
      var r = Object.keys(this.constructor.propTypes);
      return H9(this.props, r);
    }
  }, {
    key: "render",
    value: function() {
      var r = this, i = this.props, a = i.children, o = i.className, s = i.mapChildProps, l = i.style, u = Ge({}, s(this.state), this.getPassThroughProps());
      return te.createElement(
        "div",
        {
          className: o,
          ref: function(f) {
            return r.el = f;
          },
          style: Ge({}, l, {
            WebkitUserSelect: "none"
          })
        },
        this.decorateChildren(a, u)
      );
    }
  }, {
    key: "isCoreReady",
    get: function() {
      return !!this.core;
    }
  }]), t;
}(te.Component);
Qa.displayName = "ReactCursorPosition";
Qa.propTypes = {
  children: R.any,
  className: R.string,
  hoverDelayInMs: R.number,
  hoverOffDelayInMs: R.number,
  isActivatedOnTouch: R.bool,
  isEnabled: R.bool,
  mapChildProps: R.func,
  onActivationChanged: R.func,
  onPositionChanged: R.func,
  onDetectedEnvironmentChanged: R.func,
  pressDuration: R.number,
  pressMoveThreshold: R.number,
  shouldDecorateChildren: R.bool,
  shouldStopTouchMovePropagation: R.bool,
  style: R.object
};
Qa.defaultProps = {
  isActivatedOnTouch: !1,
  isEnabled: !0,
  hoverDelayInMs: 0,
  hoverOffDelayInMs: 0,
  mapChildProps: function(t) {
    return t;
  },
  onActivationChanged: Go,
  onPositionChanged: Go,
  onDetectedEnvironmentChanged: Go,
  pressDuration: 500,
  pressMoveThreshold: 5,
  shouldDecorateChildren: !0,
  shouldStopTouchMovePropagation: !1
};
var Z9 = function() {
  var t = this;
  this.onPositionChanged = function() {
    var n = t.props.onPositionChanged;
    n(t.state);
  };
}, Uo, ap;
function J9() {
  if (ap) return Uo;
  ap = 1, Uo = e;
  function e(t, n, r) {
    return n < r ? t < n ? n : t > r ? r : t : t < r ? r : t > n ? n : t;
  }
  return Uo;
}
var Q9 = J9();
const Lt = /* @__PURE__ */ rn(Q9);
function e8(e, t) {
  return cv(e, t);
}
function t8(e, t) {
  return {
    x: e.width / t.width,
    y: e.height / t.height
  };
}
function n8(e, t) {
  return cv(e, {
    width: t.width - e.width,
    height: t.height - e.height
  });
}
function cv(e, t) {
  return {
    x: t.width / e.width,
    y: t.height / e.height
  };
}
function dv(e, t) {
  return {
    x: (t.width - e.width) * -1,
    y: (t.height - e.height) * -1
  };
}
function fv() {
  return {
    x: 0,
    y: 0
  };
}
function r8(e) {
  var t = e.containerDimensions, n = e.cursorOffset, r = e.largeImage, i = e.position, a = e.smallImage, o = a8(i, n), s = e8(a, r), l = {
    x: Math.round(o.x * s.x) * -1,
    y: Math.round(o.y * s.y) * -1
  }, u = dv(t, r), c = fv();
  return pv(l, u, c);
}
function i8(e) {
  var t = e.containerDimensions, n = e.largeImage, r = e.position, i = dv(t, n), a = fv(), o = n8(t, n), s = {
    x: Math.round(r.x * o.x) * -1,
    y: Math.round(r.y * o.y) * -1
  };
  return pv(s, i, a);
}
function pv(e, t, n) {
  return {
    x: Lt(e.x, t.x, n.x),
    y: Lt(e.y, t.y, n.y)
  };
}
function a8(e, t) {
  return {
    x: e.x - t.x,
    y: e.y - t.y
  };
}
var qo, op;
function o8() {
  return op || (op = 1, qo = function(t, n) {
    return function(r) {
      var i = n(r) ? t.isRequired : t;
      return i.apply(this, arguments);
    };
  }), qo;
}
var s8 = o8();
const sp = /* @__PURE__ */ rn(s8);
var hv = {
  alt: re.string,
  src: re.string.isRequired,
  srcSet: re.string,
  sizes: re.string,
  onLoad: re.func,
  onError: re.func
}, mv = re.shape(Ge({}, hv, {
  width: re.number.isRequired,
  height: re.number.isRequired
})), gv = re.shape(Ge({}, hv, {
  isFluidWidth: re.bool,
  width: sp(re.number, function(e) {
    return !e.isFluidWidth;
  }),
  height: sp(re.number, function(e) {
    return !e.isFluidWidth;
  })
})), lp = {
  mouse: "mouse",
  touch: "touch"
}, Br = {
  over: "over",
  beside: "beside"
}, l8 = re.oneOf([Br.beside, Br.over]), u8 = re.shape({
  width: re.oneOfType([re.number, re.string]),
  height: re.oneOfType([re.number, re.string])
}), c8 = re.shape({
  width: re.number,
  height: re.number
});
function xa() {
}
const $a = re.shape({
  x: re.number.isRequired,
  y: re.number.isRequired
});
var Yo, up;
function d8() {
  return up || (up = 1, Yo = function e(t, n) {
    if (t === n) return !0;
    var r = Array.isArray(t), i = Array.isArray(n), a;
    if (r && i) {
      if (t.length != n.length) return !1;
      for (a = 0; a < t.length; a++)
        if (!e(t[a], n[a])) return !1;
      return !0;
    }
    if (r != i) return !1;
    if (t && n && typeof t == "object" && typeof n == "object") {
      var o = Object.keys(t);
      if (o.length !== Object.keys(n).length) return !1;
      var s = t instanceof Date, l = n instanceof Date;
      if (s && l) return t.getTime() == n.getTime();
      if (s != l) return !1;
      var u = t instanceof RegExp, c = n instanceof RegExp;
      if (u && c) return t.toString() == n.toString();
      if (u != c) return !1;
      for (a = 0; a < o.length; a++)
        if (!Object.prototype.hasOwnProperty.call(n, o[a])) return !1;
      for (a = 0; a < o.length; a++)
        if (!e(t[o[a]], n[o[a]])) return !1;
      return !0;
    }
    return !1;
  }), Yo;
}
var f8 = d8();
const p8 = /* @__PURE__ */ rn(f8);
function h8(e, t) {
  var n = e.isFluidWidth, r = e.width, i = e.height, a = {
    width: "auto",
    height: "auto",
    fontSize: "0px",
    position: "relative"
  }, o = {
    width: r + "px",
    height: i + "px",
    position: "relative"
  }, s = n ? a : o, l = Ge({ cursor: "crosshair" }, t, s);
  return l;
}
function m8(e, t) {
  var n = e.isFluidWidth, r = e.width, i = e.height, a = {
    width: "100%",
    height: "auto",
    display: "block",
    pointerEvents: "none"
  }, o = {
    width: r + "px",
    height: i + "px",
    pointerEvents: "none"
  }, s = n ? a : o, l = Ge({}, t, s);
  return l;
}
function g8(e, t) {
  var n = {
    overflow: "hidden"
  };
  if (t)
    return n;
  var r = {
    position: "absolute",
    top: "0px"
  };
  return e ? Ge(n, r, { left: "0px" }) : Ge(n, r, {
    left: "100%",
    marginLeft: "10px",
    border: "1px solid #d6d6d6"
  });
}
function v8(e) {
  var t = e.containerDimensions, n = e.fadeDurationInMs, r = e.isTransitionActive;
  return {
    width: t.width,
    height: t.height,
    opacity: r ? 1 : 0,
    transition: "opacity " + n + "ms ease-in",
    pointerEvents: "none"
  };
}
var y8 = {};
function b8(e) {
  var t = y8, n = t.params, r = n === void 0 ? {} : n, i = t.compositStyle;
  if (p8(r, e))
    return i;
  var a = e.containerDimensions, o = e.containerStyle, s = e.fadeDurationInMs, l = e.isTransitionActive, u = e.isInPlaceMode, c = e.isPortalRendered, f = g8(u, c), p = v8({
    containerDimensions: a,
    fadeDurationInMs: s,
    isTransitionActive: l
  });
  return t.compositStyle = Ge({}, f, o, p), t.params = e, t.compositStyle;
}
function x8(e) {
  var t = e.imageCoordinates, n = e.imageStyle, r = e.largeImage, i = "translate(" + t.x + "px, " + t.y + "px)", a = {
    width: r.width,
    height: r.height,
    transform: i,
    WebkitTransform: i,
    msTransform: i,
    pointerEvents: "none"
  }, o = Ge({}, n, a);
  return o;
}
var $8 = /* @__PURE__ */ function() {
  function e(t, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
  }
  return function(t, n, r) {
    return n && e(t.prototype, n), r && e(t, r), t;
  };
}();
function w8(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function C8(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function S8(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var ii = function(e) {
  S8(t, e);
  function t(n) {
    w8(this, t);
    var r = C8(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, n));
    return r.state = {
      isTransitionEntering: !1,
      isTransitionActive: !1,
      isTransitionLeaving: !1,
      isTransitionDone: !1
    }, r.timers = [], r;
  }
  return $8(t, [{
    key: "componentWillReceiveProps",
    value: function(r) {
      this.scheduleCssTransition(r);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.timers.forEach(function(r) {
        clearTimeout(r);
      });
    }
  }, {
    key: "scheduleCssTransition",
    value: function(r) {
      var i = this, a = this.props, o = a.fadeDurationInMs, s = a.isActive, l = a.isPositionOutside, u = s !== r.isActive, c = l !== r.isPositionOutside;
      !u && !c || (r.isActive && !r.isPositionOutside ? (this.setState({
        isTrainsitionDone: !1,
        isTransitionEntering: !0
      }), this.timers.push(setTimeout(function() {
        i.setState({
          isTransitionEntering: !1,
          isTransitionActive: !0
        });
      }, 0))) : (this.setState({
        isTransitionLeaving: !0,
        isTransitionActive: !1
      }), this.timers.push(setTimeout(function() {
        i.setState({
          isTransitionDone: !0,
          isTransitionLeaving: !1
        });
      }, o))));
    }
  }, {
    key: "getImageCoordinates",
    value: function() {
      var r = this.props, i = r.cursorOffset, a = r.largeImage, o = r.containerDimensions, s = r.position, l = r.smallImage, u = r.isInPlaceMode;
      return u ? i8({
        containerDimensions: o,
        largeImage: a,
        position: s
      }) : r8({
        containerDimensions: o,
        cursorOffset: i,
        largeImage: a,
        position: s,
        smallImage: l
      });
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.containerClassName, a = r.imageClassName, o = r.isLazyLoaded, s = r.largeImage, l = r.largeImage, u = l.alt, c = u === void 0 ? "" : u, f = l.onLoad, p = f === void 0 ? xa : f, h = l.onError, m = h === void 0 ? xa : h, v = te.createElement(
        "div",
        {
          className: i,
          style: this.containerStyle
        },
        te.createElement("img", {
          alt: c,
          className: a,
          src: s.src,
          srcSet: s.srcSet,
          sizes: s.sizes,
          style: this.imageStyle,
          onLoad: p,
          onError: m
        })
      );
      return o ? this.isVisible ? v : null : v;
    }
  }, {
    key: "isVisible",
    get: function() {
      var r = this.state, i = r.isTransitionEntering, a = r.isTransitionActive, o = r.isTransitionLeaving;
      return i || a || o;
    }
  }, {
    key: "containerStyle",
    get: function() {
      var r = this.props, i = r.containerStyle, a = r.containerDimensions, o = r.fadeDurationInMs, s = r.isPortalRendered, l = r.isInPlaceMode, u = this.state.isTransitionActive;
      return b8({
        containerDimensions: a,
        containerStyle: i,
        fadeDurationInMs: o,
        isTransitionActive: u,
        isInPlaceMode: l,
        isPortalRendered: s
      });
    }
  }, {
    key: "imageStyle",
    get: function() {
      var r = this.props, i = r.imageStyle, a = r.largeImage;
      return x8({
        imageCoordinates: this.getImageCoordinates(),
        imageStyle: i,
        largeImage: a
      });
    }
  }]), t;
}(te.Component);
ii.displayName = "EnlargedImage";
ii.defaultProps = {
  fadeDurationInMs: 0,
  isLazyLoaded: !0
};
ii.propTypes = {
  containerClassName: re.string,
  containerStyle: re.object,
  cursorOffset: $a,
  position: $a,
  fadeDurationInMs: re.number,
  imageClassName: re.string,
  imageStyle: re.object,
  isActive: re.bool,
  isLazyLoaded: re.bool,
  largeImage: mv,
  containerDimensions: c8,
  isPortalRendered: re.bool,
  isInPlaceMode: re.bool
};
var I8 = /* @__PURE__ */ function() {
  function e(t, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
  }
  return function(t, n, r) {
    return n && e(t.prototype, n), r && e(t, r), t;
  };
}();
function E8(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function cp(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function O8(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var vv = function(e) {
  O8(t, e);
  function t() {
    var n, r, i, a;
    E8(this, t);
    for (var o = arguments.length, s = Array(o), l = 0; l < o; l++)
      s[l] = arguments[l];
    return a = (r = (i = cp(this, (n = t.__proto__ || Object.getPrototypeOf(t)).call.apply(n, [this].concat(s))), i), i.state = { isMounted: !1 }, r), cp(i, a);
  }
  return I8(t, [{
    key: "componentDidMount",
    value: function() {
      if (this.setState({ isMounted: !0 }), this.isPortalRendered) {
        var r = this.props.portalId;
        this.portalElement = document.getElementById(r);
      }
    }
  }, {
    key: "render",
    value: function() {
      if (!this.isMounted)
        return null;
      var r = this.compositProps;
      return this.isPortalRendered ? W1.createPortal(te.createElement(ii, r), this.portalElement) : te.createElement(ii, r);
    }
  }, {
    key: "isPortalIdImplemented",
    get: function() {
      return !!this.props.portalId;
    }
  }, {
    key: "isPortalRendered",
    get: function() {
      var r = this.props, i = r.isPortalEnabledForTouch, a = r.isTouchDetected;
      return this.isPortalIdImplemented ? !!(!a || i) : !1;
    }
  }, {
    key: "isMounted",
    get: function() {
      return this.state.isMounted;
    }
  }, {
    key: "compositProps",
    get: function() {
      return Ge({}, this.props, { isPortalRendered: this.isPortalRendered });
    }
  }]), t;
}(xl);
vv.propTypes = {
  isPortalEnabledForTouch: re.bool.isRequired,
  isTouchDetected: re.bool.isRequired,
  portalId: re.string
};
var xr = function(t) {
  var n = t.fadeDurationInMs, r = t.isActive, i = t.isPositionOutside, a = t.style, o = {
    width: "auto",
    height: "auto",
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto",
    display: "block"
  }, s = {
    position: "absolute",
    opacity: r && !i ? 1 : 0,
    transition: "opacity " + n + "ms ease-in"
  }, l = Ge({}, o, a, s);
  return te.createElement("div", { style: l });
};
xr.propTypes = {
  style: re.object,
  fadeDurationInMs: re.number,
  isActive: re.bool,
  translateX: re.number,
  translateY: re.number,
  userStyle: re.object
};
xr.defaultProps = {
  isActive: !1,
  fadeDurationInMs: 0,
  translateX: 0,
  translateY: 0
};
const $r = {
  cursorOffset: $a,
  fadeDurationInMs: re.number,
  isActive: re.bool,
  isPositionOutside: re.bool,
  position: $a,
  smallImage: gv,
  style: re.object
};
var yv = function(t) {
  var n = t.cursorOffset, r = t.position, i = t.fadeDurationInMs, a = t.isActive, o = t.isPositionOutside, s = t.smallImage, l = t.style, u = n.y * 2, c = s.height - u, f = Lt(r.y - n.y, 0, c), p = {
    height: f + "px",
    width: "100%",
    top: "0px"
  };
  return te.createElement(xr, {
    fadeDurationInMs: i,
    isActive: a,
    isPositionOutside: o,
    style: Ge({}, l, p)
  });
};
yv.propTypes = $r;
var bv = function(t) {
  var n = t.cursorOffset, r = t.position, i = t.fadeDurationInMs, a = t.isActive, o = t.isPositionOutside, s = t.smallImage, l = t.style, u = n.y * 2, c = n.x * 2, f = s.height - u, p = s.width - c, h = u, m = Lt(r.x - n.x, 0, p), v = Lt(r.y - n.y, 0, f), g = {
    height: h + "px",
    width: m + "px",
    top: v + "px",
    left: "0px"
  };
  return te.createElement(xr, {
    fadeDurationInMs: i,
    isActive: a,
    isPositionOutside: o,
    style: Ge({}, l, g)
  });
};
bv.propTypes = $r;
var xv = function(t) {
  var n = t.cursorOffset, r = t.position, i = t.fadeDurationInMs, a = t.isActive, o = t.isPositionOutside, s = t.smallImage, l = t.style, u = n.y * 2, c = n.x * 2, f = s.height - u, p = s.width - c, h = u, m = Lt(s.width - r.x - n.x, 0, p), v = Lt(r.y - n.y, 0, f), g = {
    height: h + "px",
    width: m + "px",
    top: v + "px",
    right: "0px"
  };
  return te.createElement(xr, {
    fadeDurationInMs: i,
    isActive: a,
    isPositionOutside: o,
    style: Ge({}, l, g)
  });
};
xv.propTypes = $r;
var $v = function(t) {
  var n = t.cursorOffset, r = t.position, i = t.fadeDurationInMs, a = t.isActive, o = t.isPositionOutside, s = t.smallImage, l = t.style, u = n.y * 2, c = s.height - r.y - n.y, f = s.height - u, p = Lt(c, 0, f), h = r.y + n.y, m = Math.max(h, u), v = {
    height: p + "px",
    width: "100%",
    top: m + "px"
  };
  return te.createElement(xr, {
    fadeDurationInMs: i,
    isActive: a,
    isPositionOutside: o,
    style: Ge({}, l, v)
  });
};
$v.propTypes = $r;
function wv(e) {
  var t = e.style, n = Ge({ backgroundColor: "rgba(0,0,0,.4)" }, t), r = Ge({}, e, { style: n });
  return te.createElement(
    "div",
    null,
    te.createElement(yv, r),
    te.createElement(bv, r),
    te.createElement(xv, r),
    te.createElement($v, r)
  );
}
wv.propTypes = $r;
const T8 = "data:image/gif;base64,R0lGODlhZABkAPABAHOf4fj48yH5BAEAAAEALAAAAABkAGQAAAL+jI+py+0PowOB2oqvznz7Dn5iSI7SiabqWrbj68bwTLL2jUv0Lvf8X8sJhzmg0Yc8mojM5kmZjEKPzqp1MZVqs7Cr98rdisOXr7lJHquz57YwDV8j3XRb/C7v1vcovD8PwicY8VcISDGY2GDIKKf4mNAoKQZZeXg5aQk5yRml+dgZ2vOpKGraQpp4uhqYKsgKi+H6iln7N8sXG4u7p2s7ykvnyxos/DuMWtyGfKq8fAwd5nzGHN067VUtiv2lbV3GDfY9DhQu7p1pXoU+rr5ODk/j7sSePk9Ub33PlN+4jx8v4JJ/RQQa3EDwzcGFiBLi6AfN4UOGCyXegGjIoh0fisQ0rsD4y+NHjgZFqgB5y2Qfks1UPmEZ0OVLlIcKAAA7";
var P8 = /* @__PURE__ */ function() {
  function e(t, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
  }
  return function(t, n, r) {
    return n && e(t.prototype, n), r && e(t, r), t;
  };
}();
function N8(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _8(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function A8(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var rc = function(e) {
  A8(t, e);
  function t() {
    return N8(this, t), _8(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
  }
  return P8(t, [{
    key: "render",
    value: function() {
      return te.createElement("div", { style: this.compositStyle });
    }
  }, {
    key: "dimensions",
    get: function() {
      var r = this.props.cursorOffset, i = r.x, a = r.y;
      return {
        width: i * 2,
        height: a * 2
      };
    }
  }, {
    key: "positionOffset",
    get: function() {
      var r = this.props, i = r.cursorOffset, a = i.x, o = i.y, s = r.position, l = s.x, u = s.y, c = r.smallImage, f = c.height, p = c.width, h = this.dimensions, m = h.width, v = h.height, g = u - o, b = l - a, y = f - v, x = p - m, w = 0;
      return {
        top: Lt(g, w, y),
        left: Lt(b, w, x)
      };
    }
  }, {
    key: "defaultStyle",
    get: function() {
      var r = this.props.fadeDurationInMs;
      return {
        transition: "opacity " + r + "ms ease-in",
        backgroundImage: "url(" + T8 + ")"
      };
    }
  }, {
    key: "userSpecifiedStyle",
    get: function() {
      var r = this.props.style;
      return r;
    }
  }, {
    key: "isVisible",
    get: function() {
      var r = this.props, i = r.isActive, a = r.isPositionOutside;
      return i && !a;
    }
  }, {
    key: "priorityStyle",
    get: function() {
      var r = this.dimensions, i = r.width, a = r.height, o = this.positionOffset, s = o.top, l = o.left;
      return {
        position: "absolute",
        top: s + "px",
        left: l + "px",
        width: i + "px",
        height: a + "px",
        opacity: this.isVisible ? 1 : 0
      };
    }
  }, {
    key: "compositStyle",
    get: function() {
      return Ge(this.defaultStyle, this.userSpecifiedStyle, this.priorityStyle);
    }
  }]), t;
}(xl);
rc.propTypes = $r;
rc.defaultProps = {
  style: {}
};
var R8 = /* @__PURE__ */ function() {
  function e(t, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
  }
  return function(t, n, r) {
    return n && e(t.prototype, n), r && e(t, r), t;
  };
}();
function M8(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function j8(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function D8(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var ic = function(e) {
  D8(t, e);
  function t(n) {
    M8(this, t);
    var r = j8(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, n));
    return r.hasShown = !1, r;
  }
  return R8(t, [{
    key: "setHasShown",
    value: function() {
      this.hasShown = !0;
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.children, a = r.isActive, o = r.shouldHideAfterFirstActivation, s = this.hasShown, l = !a && (!s || !o);
      return a && !s && this.setHasShown(), l ? i : null;
    }
  }]), t;
}(te.Component);
ic.propTypes = {
  children: re.element,
  isActive: re.bool,
  shouldHideAfterFirstActivation: re.bool
};
ic.defaultProps = {
  shouldHideAfterFirstActivation: !0
};
function ac(e) {
  var t = e.isTouchDetected, n = e.hintTextMouse, r = e.hintTextTouch;
  return te.createElement(
    "div",
    { style: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      position: "absolute",
      bottom: "25px"
    } },
    te.createElement(
      "div",
      { style: {
        display: "flex",
        alignItems: "center",
        padding: "5px 10px",
        backgroundColor: "#333",
        borderRadius: "10px",
        opacity: "0.90"
      } },
      te.createElement("img", {
        style: {
          width: "25px",
          height: "25px"
        },
        src: "data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQ5MC4yIDQ5MC4yIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0OTAuMiA0OTAuMjsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTJweCIgaGVpZ2h0PSI1MTJweCI+CjxnPgoJPGc+CgkJPHBhdGggZD0iTTQxOC41LDQxOC41Yzk1LjYtOTUuNiw5NS42LTI1MS4yLDAtMzQ2LjhzLTI1MS4yLTk1LjYtMzQ2LjgsMHMtOTUuNiwyNTEuMiwwLDM0Ni44UzMyMi45LDUxNC4xLDQxOC41LDQxOC41eiBNODksODkgICAgYzg2LjEtODYuMSwyMjYuMS04Ni4xLDMxMi4yLDBzODYuMSwyMjYuMSwwLDMxMi4ycy0yMjYuMSw4Ni4xLTMxMi4yLDBTMywxNzUuMSw4OSw4OXoiIGZpbGw9IiNGRkZGRkYiLz4KCQk8cGF0aCBkPSJNMjQ1LjEsMzM2LjljMy40LDAsNi40LTEuNCw4LjctMy42YzIuMi0yLjIsMy42LTUuMywzLjYtOC43di02Ny4zaDY3LjNjMy40LDAsNi40LTEuNCw4LjctMy42YzIuMi0yLjIsMy42LTUuMywzLjYtOC43ICAgIGMwLTYuOC01LjUtMTIuMy0xMi4yLTEyLjJoLTY3LjN2LTY3LjNjMC02LjgtNS41LTEyLjMtMTIuMi0xMi4yYy02LjgsMC0xMi4zLDUuNS0xMi4yLDEyLjJ2NjcuM2gtNjcuM2MtNi44LDAtMTIuMyw1LjUtMTIuMiwxMi4yICAgIGMwLDYuOCw1LjUsMTIuMywxMi4yLDEyLjJoNjcuM3Y2Ny4zQzIzMi44LDMzMS40LDIzOC4zLDMzNi45LDI0NS4xLDMzNi45eiIgZmlsbD0iI0ZGRkZGRiIvPgoJPC9nPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=",
        alt: ""
      }),
      te.createElement(
        "span",
        { style: {
          padding: "2px 0 0 5px",
          fontFamily: "Arial, sans-serif",
          fontSize: "14px",
          color: "white"
        } },
        t ? r : n
      )
    )
  );
}
ac.displayName = "DefaultHint";
ac.propTypes = {
  isTouchDetected: re.bool,
  hintTextMouse: re.string,
  hintTextTouch: re.string
};
function k8(e, t, n) {
  var r = t8(e, t);
  return {
    x: dp(n.width, r.x),
    y: dp(n.height, r.y)
  };
}
function dp(e, t) {
  return Math.round(e * t / 2);
}
function L8(e) {
  return typeof e == "string" && /^\d+%$/.test(e);
}
function F8(e) {
  return parseInt(e) / 100;
}
function fp(e) {
  var t = e.containerDimension, n = e.smallImageDimension, r = e.isInPlaceMode;
  return r ? n : L8(t) ? n * F8(t) : t;
}
var V8 = /* @__PURE__ */ function() {
  function e(t, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
  }
  return function(t, n, r) {
    return n && e(t.prototype, n), r && e(t, r), t;
  };
}();
function B8(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function H8(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function K8(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var oc = function(e) {
  K8(t, e);
  function t(n) {
    B8(this, t);
    var r = H8(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, n)), i = N9.primaryInput, a = lp.mouse, o = lp.touch;
    return r.state = {
      smallImageWidth: 0,
      smallImageHeight: 0,
      detectedInputType: {
        isMouseDeteced: i === a,
        isTouchDetected: i === o
      }
    }, r.onSmallImageLoad = r.onSmallImageLoad.bind(r), r.setSmallImageDimensionState = r.setSmallImageDimensionState.bind(r), r.onDetectedInputTypeChanged = r.onDetectedInputTypeChanged.bind(r), r;
  }
  return V8(t, [{
    key: "componentDidMount",
    value: function() {
      var r = this.props.smallImage.isFluidWidth;
      r && (this.setSmallImageDimensionState(), window.addEventListener("resize", this.setSmallImageDimensionState));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      window.removeEventListener("resize", this.setSmallImageDimensionState);
    }
  }, {
    key: "onSmallImageLoad",
    value: function(r) {
      var i = this.props.smallImage, a = i.onLoad, o = a === void 0 ? xa : a, s = i.isFluidWidth;
      o(r), s && this.setSmallImageDimensionState();
    }
  }, {
    key: "onDetectedInputTypeChanged",
    value: function(r) {
      this.setState({
        detectedInputType: r
      });
    }
  }, {
    key: "setSmallImageDimensionState",
    value: function() {
      var r = this.smallImageEl, i = r.offsetWidth, a = r.offsetHeight;
      this.setState({
        smallImageWidth: i,
        smallImageHeight: a
      });
    }
  }, {
    key: "render",
    value: function() {
      var r = this, i = this.props, a = i.className, o = i.style, s = i.hoverDelayInMs, l = i.hoverOffDelayInMs, u = i.isActivatedOnTouch, c = i.pressDuration, f = i.pressMoveThreshold, p = i.smallImage.onError, h = p === void 0 ? xa : p, m = i.imageClassName, v = i.imageStyle, g = i.lensStyle, b = i.largeImage, y = i.enlargedImageContainerClassName, x = i.enlargedImageContainerStyle, w = i.enlargedImageClassName, $ = i.enlargedImageStyle, C = i.enlargedImagePortalId, T = i.isEnlargedImagePortalEnabledForTouch, S = i.fadeDurationInMs, N = i.hintComponent, k = i.isHintEnabled, L = i.hintTextMouse, _ = i.hintTextTouch, B = i.shouldHideHintAfterFirstActivation, A = this.smallImage, q = this.state.detectedInputType.isTouchDetected, X = k8(A, b, this.enlargedImageContainerDimensions), I = this.lensComponent;
      return te.createElement(
        Qa,
        {
          className: a,
          hoverDelayInMs: s,
          hoverOffDelayInMs: l,
          isActivatedOnTouch: u,
          onDetectedInputTypeChanged: this.onDetectedInputTypeChanged,
          pressDuration: c,
          pressMoveThreshold: f,
          shouldStopTouchMovePropagation: !0,
          style: h8(A, o)
        },
        te.createElement("img", {
          src: A.src,
          srcSet: A.srcSet,
          sizes: A.sizes,
          alt: A.alt,
          className: m,
          style: m8(A, v),
          ref: function(D) {
            return r.smallImageEl = D;
          },
          onLoad: this.onSmallImageLoad,
          onError: h
        }),
        k && te.createElement(
          ic,
          {
            shouldHideAfterFirstActivation: B
          },
          te.createElement(N, {
            isTouchDetected: q,
            hintTextMouse: L,
            hintTextTouch: _
          })
        ),
        this.shouldShowLens && te.createElement(I, {
          cursorOffset: X,
          fadeDurationInMs: S,
          smallImage: A,
          style: g
        }),
        te.createElement(vv, {
          containerClassName: y,
          containerDimensions: this.enlargedImageContainerDimensions,
          containerStyle: x,
          cursorOffset: X,
          fadeDurationInMs: S,
          imageClassName: w,
          imageStyle: $,
          largeImage: b,
          smallImage: A,
          portalId: C,
          isPortalEnabledForTouch: T,
          isTouchDetected: this.isTouchDetected,
          isInPlaceMode: this.isInPlaceMode
        })
      );
    }
  }, {
    key: "smallImage",
    get: function() {
      var r = this.props, i = r.smallImage, a = r.smallImage.isFluidWidth;
      if (!a)
        return i;
      var o = this.state, s = o.smallImageWidth, l = o.smallImageHeight;
      return Ge({}, i, {
        width: s,
        height: l
      });
    }
  }, {
    key: "enlargedImagePlacement",
    get: function() {
      var r = this.props.enlargedImagePosition, i = this.state.detectedInputType.isTouchDetected, a = i ? Br.over : Br.beside;
      return r || a;
    }
  }, {
    key: "isInPlaceMode",
    get: function() {
      var r = Br.over;
      return this.enlargedImagePlacement === r;
    }
  }, {
    key: "enlargedImageContainerDimensions",
    get: function() {
      var r = this.props.enlargedImageContainerDimensions, i = r.width, a = r.height, o = this.smallImage, s = o.width, l = o.height, u = this.isInPlaceMode;
      return {
        width: fp({
          containerDimension: i,
          smallImageDimension: s,
          isInPlaceMode: u
        }),
        height: fp({
          containerDimension: a,
          smallImageDimension: l,
          isInPlaceMode: u
        })
      };
    }
  }, {
    key: "isTouchDetected",
    get: function() {
      var r = this.state.detectedInputType.isTouchDetected;
      return r;
    }
  }, {
    key: "shouldShowLens",
    get: function() {
      return !this.isInPlaceMode && !this.isTouchDetected;
    }
  }, {
    key: "lensComponent",
    get: function() {
      var r = this.props, i = r.shouldUsePositiveSpaceLens, a = r.lensComponent;
      return a || (i ? rc : wv);
    }
  }]), t;
}(te.Component);
oc.propTypes = {
  className: re.string,
  style: re.object,
  hoverDelayInMs: re.number,
  hoverOffDelayInMs: re.number,
  fadeDurationInMs: re.number,
  pressDuration: re.number,
  pressMoveThreshold: re.number,
  isActivatedOnTouch: re.bool,
  imageClassName: re.string,
  imageStyle: re.object,
  lensStyle: re.object,
  lensComponent: re.func,
  shouldUsePositiveSpaceLens: re.bool,
  smallImage: gv,
  largeImage: mv,
  enlargedImageContainerClassName: re.string,
  enlargedImageContainerStyle: re.object,
  enlargedImageClassName: re.string,
  enlargedImageStyle: re.object,
  enlargedImageContainerDimensions: u8,
  enlargedImagePosition: l8,
  enlargedImagePortalId: re.string,
  isEnlargedImagePortalEnabledForTouch: re.bool,
  hintComponent: re.func,
  hintTextMouse: re.string,
  hintTextTouch: re.string,
  isHintEnabled: re.bool,
  shouldHideHintAfterFirstActivation: re.bool
};
oc.defaultProps = {
  enlargedImageContainerDimensions: {
    width: "100%",
    height: "100%"
  },
  isEnlargedImagePortalEnabledForTouch: !1,
  fadeDurationInMs: 300,
  hintComponent: ac,
  shouldHideHintAfterFirstActivation: !0,
  isHintEnabled: !1,
  hintTextMouse: "Hover to Zoom",
  hintTextTouch: "Long-Touch to Zoom",
  hoverDelayInMs: 250,
  hoverOffDelayInMs: 150,
  shouldUsePositiveSpaceLens: !1
};
const W8 = de("", {
  variants: {
    asCircle: {
      true: "a:rounded-circle"
    },
    asCover: {
      true: "a:object-cover a:min-w-full a:min-h-full"
    }
  },
  defaultVariants: {
    asCircle: !1,
    asCover: !1
  }
}), pp = (e, t) => {
  const n = e.parentElement.style;
  n.backgroundSize = "cover", n.backgroundPosition = "center center", e.style.display = "none", n.backgroundImage = `url(${t})`;
}, z8 = (e) => new IntersectionObserver(
  (t) => {
    t.map((n) => {
      n.isIntersecting && e(n.target);
    });
  },
  { rootMargin: "500px" }
), lr = ({
  alt: e,
  sourceSet: t,
  source: n,
  lazyLoad: r,
  onError: i,
  testId: a,
  isBackgroundImage: o,
  className: s,
  ...l
}) => {
  const u = ce(null), c = t ? t.map(({ source: f, descriptor: p }) => `${f} ${p}`).join(",") : null;
  return se(() => {
    if (!o || !u.current)
      return;
    const f = r && "IntersectionObserver" in window, p = u.current, h = n.replace(/([()'"\s])/g, "\\$1"), m = z8((v) => {
      pp(v, h), m.unobserve(v);
    });
    return f ? m.observe(p) : pp(p, h), () => {
      f && m.unobserve(p);
    };
  }, [o, r, n]), /* @__PURE__ */ d.jsx(
    "img",
    {
      alt: e,
      src: n,
      ...c ? { srcSet: c } : {},
      loading: r ? "lazy" : void 0,
      className: Y(W8(l), s),
      onError: i,
      "data-testid": a,
      ...l
    }
  );
};
lr.displayName = "Image";
const G8 = () => "ontouchstart" in document.documentElement, cT = ({ alt: e, config: t, onClick: n }) => {
  const [r, i] = ue(!1), a = {
    ...t,
    enlargedImagePosition: "over",
    smallImage: {
      ...t.smallImage,
      alt: e,
      isFluidWidth: !0
    },
    enlargedImageClassName: "a:max-w-none"
  };
  se(() => {
    i(G8());
  }, []);
  const o = () => /* @__PURE__ */ d.jsx(lr, { source: a.largeImage.src, alt: e }), s = () => /* @__PURE__ */ d.jsx(oc, { ...a });
  return /* @__PURE__ */ d.jsx("div", { className: "a:flex a:*:cursor-zoom-in!", onClick: n, children: r ? o() : s() });
}, U8 = ({ children: e, testId: t }) => /* @__PURE__ */ d.jsx(
  "div",
  {
    "data-testid": t,
    className: Y(
      "a:order-1 a:bg-surface-neutral a:px-5",
      "a:md:px-6",
      "a:lg:order-2 a:lg:row-start-1 a:lg:row-end-2 a:lg:px-6 a:lg:pb-10 a:lg:pt-14",
      "a:xl:px-28"
    ),
    children: e
  }
), q8 = ({
  children: e,
  testId: t
}) => /* @__PURE__ */ d.jsx(
  "div",
  {
    "data-testid": t,
    className: Y(
      "a:order-2 a:bg-surface-neutral a:px-5",
      "a:md:px-6",
      "a:lg:order-1 a:lg:row-start-1 a:lg:row-end-3 a:lg:bg-surface-quiet-3 a:lg:px-6 a:lg:py-8",
      "a:xl:px-14"
    ),
    children: e
  }
), Cv = Rt(null), Y8 = () => Xe(Cv), X8 = ({ children: e, testId: t }) => {
  const n = Y8(), [r, i] = ue(null);
  se(() => {
    i((n == null ? void 0 : n.current) || null);
  }, [n]);
  const a = /* @__PURE__ */ d.jsx(
    "div",
    {
      "data-testid": t,
      className: Y(
        "a:sticky a:bottom-0 a:order-3 a:shadow-[0px_-10px_30px_0px_#0A0A0A1A]",
        "a:lg:row-start-2 a:lg:row-end-3 a:lg:shadow-[0px_-10px_30px_0px_#A0A0A01A]",
        'a:lg:before:absolute a:lg:before:h-full a:lg:before:w-[calc((100vw-1400px)/2+4px)] a:lg:before:content-[""]',
        "a:lg:before:right-1 a:lg:before:top-0 a:lg:before:translate-x-full",
        "a:lg:before:-z-[1] a:lg:before:bg-surface-neutral a:lg:before:shadow-[0px_-10px_30px_0px_#A0A0A01A]"
      ),
      children: /* @__PURE__ */ d.jsx("div", { className: Y("a:h-full a:w-full a:bg-surface-neutral a:px-5 a:py-2 a:lg:px-6 a:xl:px-8"), children: e })
    }
  );
  return r ? di(a, r) : a;
}, sc = ({
  children: e,
  testId: t
}) => {
  const n = ce(null);
  return /* @__PURE__ */ d.jsx(Cv.Provider, { value: n, children: /* @__PURE__ */ d.jsx("div", { "data-testid": t, className: "a:flex a:w-full a:justify-center a:pt-12 a:lg:pt-0", children: /* @__PURE__ */ d.jsx(
    "div",
    {
      ref: n,
      className: Y(
        "a:relative a:grid a:max-w-[1400px] a:grow a:gap-y-10",
        "a:lg:grid-cols-[1fr_2fr] a:lg:grid-rows-1 a:lg:gap-y-0",
        'a:lg:before:absolute a:lg:before:h-full a:lg:before:content-[""]',
        "a:lg:before:left-1 a:lg:before:top-0 a:lg:before:h-full a:lg:before:w-[calc((100vw-1400px)/2+4px)]",
        "a:lg:before:-translate-x-full a:lg:before:bg-surface-quiet-3"
      ),
      children: e
    }
  ) }) });
};
sc.Main = U8;
sc.Overview = q8;
sc.Sticky = X8;
const dT = (e) => /* @__PURE__ */ d.jsx(cg, { as: "link", ...e }), fT = (e) => /* @__PURE__ */ d.jsx(dg, { as: "link", ...e }), Xs = (e) => /* @__PURE__ */ d.jsx(fg, { as: "link", ...e }), pT = (e) => /* @__PURE__ */ d.jsx(pg, { as: "link", ...e }), Sv = Rt({}), Iv = () => Xe(Sv), Z8 = de("menu-item-wrapper", {
  variants: {
    spacing: {
      s: "a:mb-1",
      m: "a:mb-4",
      l: "a:mb-10"
    }
  },
  defaultVariants: {
    spacing: "s"
  }
}), J8 = 50, Ev = ({
  testId: e,
  verticalInnerSpacing: t = !0,
  horizontalInnerSpacing: n = !0,
  spacing: r = "s",
  children: i,
  position: a,
  subLevel: o,
  levelId: s = "",
  href: l,
  onClick: u
}) => {
  const { onSelectLevel: c } = Iv(), f = a !== void 0, p = (m) => {
    pt(m), setTimeout(() => {
      o && c(s), u == null || u(m);
    }, J8);
  }, h = Y({
    "a:py-1": t,
    "a:px-2": n
  });
  return i ? /* @__PURE__ */ d.jsxs("div", { "data-testid": e, className: Y(Z8({ spacing: r })), children: [
    /* @__PURE__ */ d.jsx(
      "div",
      {
        className: Y("menu-item a:overflow-hidden a:px-5 a:will-change-[left,transform,opacity] a:md:px-10", {
          "a:relative a:animate-menu-item-waterfall a:opacity-0": f
        }),
        style: f ? { left: `-${a * 2}px` } : void 0,
        children: typeof i == "function" ? /* @__PURE__ */ d.jsx("div", { className: h, children: i({
          openSubLevel: () => {
            o && c(s);
          }
        }) }) : o || u ? /* @__PURE__ */ d.jsx(
          "button",
          {
            className: Y("a:no-tap-highlight a:w-full a:text-left", h),
            onClick: p,
            children: i
          }
        ) : l ? /* @__PURE__ */ d.jsx(
          "a",
          {
            className: Y("a:no-tap-highlight a:block a:w-full", h),
            href: l,
            onClick: p,
            children: i
          }
        ) : /* @__PURE__ */ d.jsx("div", { className: h, children: i })
      }
    ),
    o
  ] }) : null;
}, Q8 = (e, t) => Y(
  "a:[&>.menu-item-wrapper_.menu-item]:transition-all",
  "a:[&>.menu-item-wrapper_.menu-item]:duration-[300ms]",
  "a:[&>.menu-item-wrapper_.menu-item]:ease-in-out",
  {
    "a:pointer-events-none a:invisible": !e && !t,
    "a:[&>.menu-item-wrapper_.menu-item]:translate-x-0": e,
    "a:[&>.menu-item-wrapper_.menu-item]:translate-x-[30%]": !e && !t,
    "a:[&>.menu-item-wrapper_.menu-item]:opacity-0": !e && !t,
    "a:[&>.menu-item-wrapper_.menu-item]:-translate-x-full": t
  }
), e6 = ({
  testId: e,
  children: t,
  rootLevel: n,
  backBtnLabel: r,
  id: i,
  analyticsBannerId: a
}) => {
  const { getIsActive: o, getIsPrev: s, onBackBtnClick: l } = Iv(), u = o(i), c = s(i), f = Q8(u, c), p = typeof t == "function" ? t({ isActive: u }) : t;
  return /* @__PURE__ */ d.jsx(
    "section",
    {
      "data-testid": e,
      "data-analytics-bannerid": a,
      className: Y("a:absolute a:bottom-0 a:left-0 a:top-0 a:flex a:w-full a:flex-col a:overflow-hidden", {
        "a:menu-level-active": u,
        "a:pointer-events-none a:invisible": !u && !c
      }),
      children: /* @__PURE__ */ d.jsxs(
        "div",
        {
          className: Y("a:flex-auto a:py-8 a:md:py-12", f, {
            "a:overflow-hidden": !u,
            "a:overflow-y-auto a:overflow-x-hidden": u
          }),
          children: [
            !n && /* @__PURE__ */ d.jsx(Ev, { testId: Z({ testId: e, suffix: "back-button" }), spacing: "l", onClick: l, children: /* @__PURE__ */ d.jsxs(Pe, { gap: "3", itemsAlign: "center", children: [
              /* @__PURE__ */ d.jsx($e, { source: Ha, size: "xs", inline: !0 }),
              /* @__PURE__ */ d.jsx(ie, { variant: "bodyS", color: "subtle", as: "span", children: r })
            ] }) }),
            Aa.map(p, (h, m) => h ? _a(h, {
              ...h.props,
              ...n && { position: m }
            }) : null)
          ]
        }
      )
    }
  );
}, lc = ({
  autoSearch: e,
  input: t,
  value: n,
  onChange: r,
  onClear: i
}) => {
  const [a, o] = ue(n || "");
  se(() => {
    o(n || "");
  }, [n]);
  const s = (p) => {
    o(p.target.value), e && r && r(p.target.value);
  }, l = (p) => {
    a.length <= 0 || (p.type !== "keydown" || p.key === "Enter") && (r == null || r(a, p.key === "Enter"));
  }, u = (p) => {
    o(""), r == null || r(""), i == null || i(p);
  }, c = t.adornmentStart === null ? null : (
    // if inputProps.adornmentStart is null then adornmentStart will not be shown
    /* @__PURE__ */ d.jsx(De, { paddingInlineEnd: "1", children: t.adornmentStart || /* @__PURE__ */ d.jsx(
      it,
      {
        testId: t.testId ? `${t.testId}_search` : void 0,
        variant: "plain",
        size: "sm",
        icon: { source: Wa },
        onClick: l
      }
    ) })
  ), f = /* @__PURE__ */ d.jsx(
    it,
    {
      testId: t.testId ? `${t.testId}_clear` : void 0,
      variant: "plain",
      size: "sm",
      icon: { source: bn },
      onClick: u
    }
  );
  return /* @__PURE__ */ d.jsx(
    Xt,
    {
      ...t,
      value: a,
      onChange: s,
      onKeyDown: l,
      adornmentStart: c,
      adornmentEnd: a.length > 0 ? f : t.adornmentEnd
    }
  );
}, t6 = 300, n6 = ({
  initialMetrics: e,
  onBackButtonClick: t,
  children: n,
  testId: r,
  inputRef: i,
  placeholder: a,
  onChange: o,
  value: s
}) => {
  const [l, u] = ue(!1);
  se(() => {
    u(!0);
  }, []);
  const c = (f) => {
    f.stopPropagation(), u(!1), setTimeout(() => {
      t();
    }, t6);
  };
  return /* @__PURE__ */ d.jsxs(
    "div",
    {
      "data-testid": r,
      className: Y(
        "a:fixed a:inset-0 a:z-modal a:flex a:flex-col a:transition-[background-color] a:duration-300 a:ease-in-out",
        { "a:bg-white": l }
      ),
      children: [
        /* @__PURE__ */ d.jsx(
          "div",
          {
            className: Y("a:relative a:transition-all a:duration-300 a:ease-in-out", {
              "a:px-7 a:pb-4 a:pt-8 a:md:px-12 a:md:pt-9": l
            }),
            style: l ? { top: 0, width: "100%", left: 0 } : e,
            children: /* @__PURE__ */ d.jsx(
              lc,
              {
                input: {
                  id: "menu-search-bar-field",
                  testId: Z({ testId: r, suffix: "field" }),
                  autoFocus: !0,
                  innerRef: i,
                  placeholder: a,
                  adornmentStart: l ? /* @__PURE__ */ d.jsx(
                    it,
                    {
                      testId: Z({ testId: r, suffix: "back-button" }),
                      variant: "plain",
                      size: "sm",
                      icon: { source: Ha },
                      onClick: c
                    }
                  ) : null,
                  adornmentEnd: /* @__PURE__ */ d.jsx(De, { padding: "2", children: /* @__PURE__ */ d.jsx($e, { size: "sm", source: Wa }) })
                },
                autoSearch: !0,
                onClear: (f) => f.stopPropagation(),
                value: s,
                onChange: o
              }
            )
          }
        ),
        n && /* @__PURE__ */ d.jsx(
          "div",
          {
            "data-testid": Z({ testId: r, suffix: "result" }),
            className: Y("a:overflow-y-auto a:px-7 a:pb-8 a:transition-opacity a:duration-150 a:md:px-12", {
              "a:opacity-1 a:delay-150": l,
              "a:opacity-0": !l
            }),
            children: n
          }
        )
      ]
    }
  );
}, r6 = ({
  placeholder: e,
  children: t,
  onChange: n,
  testId: r,
  value: i = "",
  searchBarInputRef: a
}) => {
  const [o, s] = ue(!1), [l, u] = ue(), c = ce(null), [f, p] = ue(i);
  se(() => {
    p(i || "");
  }, [i]);
  const h = (v) => {
    s(v), c.current && u(c.current.getBoundingClientRect());
  }, m = (v, g) => {
    p(v), n == null || n(v, g);
  };
  return /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
    /* @__PURE__ */ d.jsx("div", { className: o ? "a:opacity-0" : void 0, ref: c, children: /* @__PURE__ */ d.jsx(
      lc,
      {
        input: {
          id: "menu-search",
          testId: Z({ testId: r, suffix: "field" }),
          onFocus: o ? void 0 : () => h(!0),
          placeholder: e,
          adornmentStart: null,
          adornmentEnd: /* @__PURE__ */ d.jsx(
            it,
            {
              testId: Z({ testId: r, suffix: "toggle" }),
              variant: "plain",
              size: "sm",
              icon: { source: Wa },
              onClick: () => h(!0)
            }
          )
        },
        value: f,
        onChange: m,
        onClear: (v) => v.stopPropagation()
      }
    ) }),
    o && di(
      /* @__PURE__ */ d.jsx(
        n6,
        {
          testId: Z({ testId: r, suffix: "bar" }),
          inputRef: a,
          value: f,
          onChange: m,
          placeholder: e,
          onBackButtonClick: () => h(!1),
          initialMetrics: {
            top: l.top,
            width: l.width,
            left: l.left
          },
          children: t
        }
      ),
      document.querySelector(".a\\:menu")
    )
  ] });
}, i6 = 200, eo = ({
  testId: e,
  children: t,
  isOpen: n = !1,
  onClose: r,
  offsetTop: i = "0px",
  defaultLevel: a,
  width: o
}) => {
  const [s, l] = ue(n), [u, c] = ue([]), f = ce(null), p = ce(null), h = xt(t, eo.Level), m = () => {
    var g, b, y, x;
    (g = p.current) == null || g.classList.remove("a:animate-menu-slide-in-left"), (b = p.current) == null || b.classList.add("a:animate-menu-slide-out-left"), (y = f.current) == null || y.classList.remove("a:animate-backdrop-fade-in"), (x = f.current) == null || x.classList.add("a:animate-backdrop-fade-out"), setTimeout(() => {
      l(!1), r == null || r();
    }, i6);
  };
  if (se(() => {
    n !== s && (n ? l(n) : m());
  }, [n]), se(() => {
    s && c(Array.isArray(a) ? a : [a]);
  }, [s]), !s || !u.length)
    return null;
  const v = {
    getIsActive: (g) => u.at(-1) === g,
    getIsPrev: (g) => u.includes(g) && u.at(-1) !== g,
    onSelectLevel: (g) => c([...u, g]),
    onBackBtnClick: () => c(u.slice(0, -1))
  };
  return /* @__PURE__ */ d.jsxs("div", { className: "a:menu", children: [
    /* @__PURE__ */ d.jsx(
      br,
      {
        testId: Z({ testId: e, suffix: "overlay" }),
        onClick: m,
        offsetTop: i,
        backdropRef: f
      }
    ),
    /* @__PURE__ */ d.jsx(
      "nav",
      {
        "data-testid": e,
        ref: p,
        style: { top: i, maxWidth: o },
        className: Y(
          "a:fixed a:bottom-0 a:left-0 a:z-sidebar a:w-full a:overflow-hidden a:bg-white",
          "a:animate-menu-slide-in-left",
          'a:before:block a:before:h-[15px] a:before:-translate-y-full a:before:shadow-xl a:before:content-[""]'
        ),
        children: /* @__PURE__ */ d.jsx(Sv.Provider, { value: v, children: h })
      }
    )
  ] });
};
eo.Level = e6;
eo.Item = Ev;
eo.Search = r6;
const a6 = (e) => /* @__PURE__ */ M.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ M.createElement("path", { stroke: "currentColor", d: "M4 6h16" }), /* @__PURE__ */ M.createElement("path", { stroke: "currentColor", d: "M4 12h16" }), /* @__PURE__ */ M.createElement("path", { stroke: "currentColor", d: "M4 18h16" })), Xo = { at: 0 }, hp = "50% 50%", hT = ({ isOpen: e, ...t }) => /* @__PURE__ */ d.jsx(
  it,
  {
    variant: "plain",
    ...t,
    icon: {
      sequences: [
        ["path:first-of-type", { y: e ? 6 : 0, rotate: e ? 45 : 0, transformOrigin: hp }, Xo],
        ["path:nth-of-type(2)", { opacity: e ? 0 : 1 }, Xo],
        ["path:last-of-type", { y: e ? -6 : 0, rotate: e ? -45 : 0, transformOrigin: hp }, Xo]
      ],
      options: { type: "spring", stiffness: 400, damping: 30 },
      source: a6
    }
  }
), o6 = de(
  "a:relative a:flex a:flex-col a:z-modal a:mx-auto a:max-h-modal a:max-w-modal a:animate-fade-in a:overflow-auto a:rounded-xl a:bg-white a:shadow-xs",
  {
    variants: {
      isFullWidth: {
        true: "a:w-full"
      },
      hasCloseBtn: {
        true: "a:pt-3",
        false: ""
      },
      hasBackBtn: {
        true: "a:pt-3",
        false: ""
      }
    },
    compoundVariants: [
      {
        hasBackBtn: !1,
        hasCloseBtn: !1,
        className: "a:pt-7"
      }
    ]
  }
), mT = ({
  children: e,
  testId: t,
  isOpen: n,
  onClose: r,
  onBack: i,
  hasBackBtn: a = !1,
  hasCloseBtn: o = !0,
  isFullWidth: s,
  customWidth: l
}) => {
  const [u, c] = ue(n || !1), f = ce(null), p = () => {
    var m, v;
    (m = f.current) == null || m.classList.remove("a:animate-fade-in"), (v = f.current) == null || v.classList.add("a:animate-fade-out"), setTimeout(() => {
      c(!1), r && r();
    }, 200);
  };
  se(() => {
    c(n || !1);
  }, [n]);
  const h = /* @__PURE__ */ d.jsxs(
    "div",
    {
      className: Y(
        "a:fixed a:inset-0 a:z-modal a:flex a:items-center a:justify-center a:outline-hidden a:focus:outline-hidden"
      ),
      children: [
        /* @__PURE__ */ d.jsx(br, { testId: Z({ testId: t, suffix: "overlay" }), onClick: p }),
        /* @__PURE__ */ d.jsxs(
          "div",
          {
            ref: f,
            "data-testid": t,
            className: Oe(o6({ isFullWidth: s, hasCloseBtn: o, hasBackBtn: a })),
            style: {
              width: l || ""
            },
            children: [
              (a || o) && /* @__PURE__ */ d.jsxs(
                "div",
                {
                  className: Y("a:flex a:w-full a:ps-3 a:pe-3", {
                    "a:justify-between": a && o,
                    "a:justify-end": !a && o
                  }),
                  children: [
                    a && /* @__PURE__ */ d.jsx(
                      it,
                      {
                        onClick: i,
                        variant: "plain",
                        icon: { size: "sm", source: b0 },
                        testId: Z({ testId: t, suffix: "back-button" })
                      }
                    ),
                    o && /* @__PURE__ */ d.jsx(
                      it,
                      {
                        onClick: p,
                        variant: "plain",
                        icon: { size: "sm", source: bn },
                        testId: Z({ testId: t, suffix: "close-button" })
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ d.jsx("div", { className: Y("a:overflow-y-auto a:ps-7 a:pe-7 a:pb-7"), children: e })
            ]
          }
        )
      ]
    }
  );
  return /* @__PURE__ */ d.jsx(d.Fragment, { children: u ? di(h, document.body) : !1 });
}, s6 = de(
  "a:relative a:flex a:items-start a:text-left a:w-full a:overflow-hidden a:rounded a:border a:border-neutral-300 a:p-5 a:md:hover:bg-neutral-50 a:focus-visible:rounded a:focus-visible:border a:focus-visible:border-neutral-800 a:focus-visible:outline-hidden a:focus-visible:ring-0",
  {
    variants: {
      state: {
        enabled: "a:bg-white",
        selected: "a:bg-neutral-100"
      },
      disable: {
        true: "a:opacity-40 a:cursor-not-allowed",
        false: "a:cursor-pointer"
      },
      display: {
        row: "a:flex-row a:gap-2",
        col: "a:flex-col"
      }
    },
    defaultVariants: {
      state: "enabled",
      display: "col",
      disable: !1
    }
  }
);
function mp({
  testId: e,
  hasCheckbox: t,
  icon: n,
  title: r,
  subtitle: i,
  body: a,
  id: o,
  onClick: s,
  spacingClasses: l,
  state: u,
  disable: c,
  hint: f,
  display: p,
  actionInfo: h,
  imageSrc: m,
  endContent: v
}) {
  const g = (w) => {
    c || (pt(w), s && s(w));
  }, b = h ? "div" : "button", y = m || null, x = o || "option-card-checkbox";
  return /* @__PURE__ */ d.jsx(d.Fragment, { children: /* @__PURE__ */ d.jsxs(
    b,
    {
      id: o,
      className: Oe(
        s6({ state: u, display: p, disable: c }),
        l,
        h ? "a:border-solid a:pb-16" : ""
      ),
      "data-testid": e,
      tabIndex: 0,
      onClick: g,
      type: "button",
      children: [
        n ? /* @__PURE__ */ d.jsx(De, { paddingBlockEnd: "10", children: /* @__PURE__ */ d.jsx($e, { ...n, size: "xl", color: "current" }) }) : !n && y && /* @__PURE__ */ d.jsx(y, { className: "a:mb-5 a:h-14", alt: "Image Icon" }),
        /* @__PURE__ */ d.jsxs("section", { className: "a:flex a:w-full a:flex-row", children: [
          t && p !== "row" && /* @__PURE__ */ d.jsx(
            lv,
            {
              id: x,
              title: `${x}-title`,
              "aria-label": r,
              checked: u === "selected",
              readOnly: !0
            }
          ),
          /* @__PURE__ */ d.jsxs("div", { className: "a:flex a:w-full a:items-center a:justify-between", children: [
            /* @__PURE__ */ d.jsxs("div", { children: [
              /* @__PURE__ */ d.jsx(ie, { variant: "titleS", as: "h3", children: r }),
              i && /* @__PURE__ */ d.jsx(ie, { variant: "bodyM", as: "h4", color: i.color, testId: i.testId, children: i.text }),
              Array.isArray(a) && a.length > 0 && /* @__PURE__ */ d.jsx("div", { className: "a:flex a:gap-2", children: a.map((w, $) => /* @__PURE__ */ d.jsx(
                ie,
                {
                  variant: "bodyM",
                  color: w.color,
                  strike: w.isStriked,
                  testId: w.testId,
                  children: w.text
                },
                $
              )) }),
              f && /* @__PURE__ */ d.jsx(De, { paddingBlockStart: "5", children: /* @__PURE__ */ d.jsx(ie, { variant: "bodyS", color: f.color, strike: f.isStriked, testId: f.testId, children: f.text }) })
            ] }),
            v && /* @__PURE__ */ d.jsx("div", { className: "a:ps-3", children: v })
          ] })
        ] }),
        h && /* @__PURE__ */ d.jsx("div", { className: "a:absolute a:bottom-5", children: /* @__PURE__ */ d.jsx(
          Dn,
          {
            variant: "primary",
            theme: "neutral",
            onClick: h.onClick,
            testId: Z({ testId: e, suffix: "action-info" }),
            text: h.text
          }
        ) })
      ]
    }
  ) });
}
const gp = de(
  ["a:w-9 a:h-9 a:rounded-md a:gap-2 a:text-base a:leading-6 a:font-semibold", Le.focus],
  {
    variants: {
      ...Le.variants,
      variant: {
        ...Le.variants.variant,
        plain: "a:bg-white"
      },
      interactive: {
        true: "",
        false: "a:cursor-default"
      }
    },
    compoundVariants: [
      ...Le.primary,
      ...Le.tertiary,
      {
        theme: "branded",
        variant: "plain",
        class: ["a:text-content-brand", "a:disabled:text-content-emphasised-disabled", "a:focus:outline-hidden"]
      },
      {
        theme: "branded",
        variant: "plain",
        interactive: !0,
        class: "a:[&:not(:disabled)]:hover-pointer:bg-surface-quiet"
      }
    ]
  }
), Ov = ({
  theme: e = "neutral",
  variant: t = "primary",
  inverse: n = !1,
  interactive: r = !0,
  ...i
}) => /* @__PURE__ */ d.jsx(
  mi,
  {
    ...i,
    size: "sm",
    appearance: "basic",
    sizeClassName: Y(gp({ variant: t, theme: e })),
    className: Y(gp({ theme: e, variant: t, inverse: n, interactive: r }))
  }
), l6 = (e) => /* @__PURE__ */ d.jsx(Ov, { as: "button", ...e }), u6 = (e) => /* @__PURE__ */ d.jsx(Ov, { as: "link", ...e }), Gn = ({ is: e, isHiddenOnMobile: t = !1, ...n }) => /* @__PURE__ */ d.jsx(
  Jt,
  {
    condition: t,
    wrapper: (r) => /* @__PURE__ */ d.jsx("div", { className: "a:hidden a:sm:block", children: r }),
    children: e === "button" ? /* @__PURE__ */ d.jsx(l6, { ...n }) : /* @__PURE__ */ d.jsx(u6, { ...n })
  }
), Zo = "?", c6 = "&", d6 = (e) => {
  if (e.includes(Zo)) {
    if (e[e.length - 1] !== Zo)
      return c6;
  } else
    return Zo;
  return "";
}, vp = ({ testId: e }) => /* @__PURE__ */ d.jsx(
  Gn,
  {
    testId: Z({ testId: e, suffix: "dots" }),
    is: "button",
    variant: "plain",
    theme: "branded",
    interactive: !1,
    text: "..."
  }
), gT = ({ testId: e, baseUrl: t, currentPage: n = 0, onPageChange: r, totalPages: i }) => {
  const a = i - 1;
  let o = [], s = !1, l = !1;
  i > 2 && (n === 0 ? o = [n, n + 1, n + 2] : n === 1 ? o = [n, n + 1, n + 2] : n === a ? o = [n - 2, n - 1, n] : n === a - 1 ? o = [n - 1, n] : o = [n - 1, n, n + 1], o = o.filter((h) => h > 0 && h < a), o[0] !== 1 && (l = !0), o[o.length - 1] !== a - 1 && (s = !0));
  const u = (h) => h === n, c = (h) => !t || u(h) ? "" : `${t}${d6(t)}page=${h}`, f = (h, m) => {
    m && m.preventDefault(), u(h) || r == null || r(h);
  }, p = (h, m) => {
    const v = {
      theme: "branded",
      ariaLabel: m ? `${H5(m)} page` : `Page ${h + 1}`,
      rel: m
    };
    return u(h) ? {
      ...v,
      is: "button",
      variant: "primary",
      interactive: !1,
      text: `${h + 1}`,
      "aria-current": !0,
      testId: Z({ testId: e, suffix: "item-current" })
    } : {
      ...v,
      is: "link",
      variant: m ? "tertiary" : "plain",
      onClick: (g) => f(h, g),
      href: c(h),
      testId: Z({ testId: e, suffix: `item${m ? `-${m}` : ""}` })
    };
  };
  return /* @__PURE__ */ d.jsx("nav", { role: "navigation", "aria-label": "Pagination Navigation", children: /* @__PURE__ */ d.jsxs(Pe, { wrap: "nowrap", gap: "1", testId: e, children: [
    n > 0 && /* @__PURE__ */ d.jsx(Gn, { ...p(n - 1, "prev"), iconLeft: { source: Ha } }),
    /* @__PURE__ */ d.jsx(Gn, { ...p(0), children: "1" }),
    l && /* @__PURE__ */ d.jsx(vp, { testId: e }),
    o.map((h, m) => /* @__PURE__ */ d.jsx(
      Gn,
      {
        ...p(h),
        isHiddenOnMobile: m === 0 && l && n < a || m === o.length - 1 && s && n > 0,
        children: h + 1
      },
      h
    )),
    s && /* @__PURE__ */ d.jsx(vp, { testId: e }),
    i > 1 && /* @__PURE__ */ d.jsx(Gn, { ...p(a), children: a + 1 }),
    n < a && /* @__PURE__ */ d.jsx(Gn, { ...p(n + 1, "next"), iconRight: { source: y0 } })
  ] }) });
}, f6 = /* @__PURE__ */ Tb("div"), p6 = (e = !1) => {
  const [t, n] = ue(e);
  return se(() => {
    n(!0);
  }, []), t;
}, h6 = 272, vT = ({ testId: e, imageProps: t, height: n, scrollOptions: r }) => {
  const i = ce(null), { scrollYProgress: a } = Fx({
    offset: ["start start", "end start"],
    ...r,
    target: i
  }), { active: o } = iv(), s = p6(), l = bw(n), u = $d(
    a,
    [0, 1],
    [l[o], l[o] - h6]
  ), c = $d(a, [0, 1], ["0", "0.6"]);
  return /* @__PURE__ */ d.jsx(By, { features: cx, children: /* @__PURE__ */ d.jsx(
    f6,
    {
      "data-testid": e,
      className: Y(
        "a:relative a:z-0 a:w-full a:overflow-hidden",
        'a:before:absolute a:before:z-10 a:before:h-full a:before:w-full a:before:bg-surface-dark a:before:opacity-[var(--tw-bg-opacity)] a:before:content-[""]'
      ),
      style: {
        ...ei("--parallax-image-height", n, (f) => `${f}px`),
        "--tw-bg-opacity": c,
        height: s ? u : void 0
      },
      ref: i,
      children: /* @__PURE__ */ d.jsx(
        lr,
        {
          ...t,
          asCover: !0,
          className: Y("a:object-top", {
            "a:h-[var(--parallax-image-height)]": typeof n == "number" && n || typeof n == "object" && n.xs,
            "a:sm:h-[var(--parallax-image-height-sm)]": typeof n == "object" && n.sm,
            "a:md:h-[var(--parallax-image-height-md)]": typeof n == "object" && n.md,
            "a:lg:h-[var(--parallax-image-height-lg)]": typeof n == "object" && n.lg,
            "a:xl:h-[var(--parallax-image-height-xl)]": typeof n == "object" && n.xl,
            "a:2xl:h-[var(--parallax-image-height-2xl)]": typeof n == "object" && n["2xl"],
            "a:3xl:h-[var(--parallax-image-height-3xl)]": typeof n == "object" && n["3xl"]
          })
        }
      )
    }
  ) });
}, Tv = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "(?:01\\d|[24-689])\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]]], BL: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}", [6, 7, 8, 9, 10, 11]], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[0135-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-5]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}", [8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["3"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-359]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[59]"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-468]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|[579]\\d|63)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
var Jo = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var yp;
function m6() {
  return yp || (yp = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function n() {
        for (var a = "", o = 0; o < arguments.length; o++) {
          var s = arguments[o];
          s && (a = i(a, r(s)));
        }
        return a;
      }
      function r(a) {
        if (typeof a == "string" || typeof a == "number")
          return a;
        if (typeof a != "object")
          return "";
        if (Array.isArray(a))
          return n.apply(null, a);
        if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]"))
          return a.toString();
        var o = "";
        for (var s in a)
          t.call(a, s) && a[s] && (o = i(o, s));
        return o;
      }
      function i(a, o) {
        return o ? a ? a + " " + o : a + o : a;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  }(Jo)), Jo.exports;
}
var g6 = m6();
const wa = /* @__PURE__ */ rn(g6);
function v6(e, t, n) {
  switch (n) {
    case "Backspace":
      t > 0 && (e = e.slice(0, t - 1) + e.slice(t), t--);
      break;
    case "Delete":
      e = e.slice(0, t) + e.slice(t + 1);
      break;
  }
  return {
    value: e,
    caret: t
  };
}
function y6(e, t, n) {
  for (var r = {}, i = "", a = 0, o = 0; o < e.length; ) {
    var s = n(e[o], i, r);
    s !== void 0 && (i += s, t !== void 0 && (t === o ? a = i.length - 1 : t > o && (a = i.length))), o++;
  }
  t === void 0 && (a = i.length);
  var l = {
    value: i,
    caret: a
  };
  return l;
}
function b6(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = x6(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function x6(e, t) {
  if (e) {
    if (typeof e == "string") return bp(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return bp(e, t);
  }
}
function bp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Zs(e, t) {
  for (var n = 0, r = b6(t.split("")), i; !(i = r()).done; ) {
    var a = i.value;
    a === e && n++;
  }
  return n;
}
function $6(e, t) {
  for (var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "x", r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : " ", i = e.length, a = Zs("(", e), o = Zs(")", e), s = a - o; s > 0 && i < t.length; )
    e += t[i].replace(n, r), t[i] === ")" && s--, i++;
  return e;
}
function w6(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = C6(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function C6(e, t) {
  if (e) {
    if (typeof e == "string") return xp(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return xp(e, t);
  }
}
function xp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function S6(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "x", n = arguments.length > 2 ? arguments[2] : void 0;
  if (!e)
    return function(i) {
      return {
        text: i
      };
    };
  var r = Zs(t, e);
  return function(i) {
    if (!i)
      return {
        text: "",
        template: e
      };
    for (var a = 0, o = "", s = w6(e.split("")), l; !(l = s()).done; ) {
      var u = l.value;
      if (u !== t) {
        o += u;
        continue;
      }
      if (o += i[a], a++, a === i.length && i.length < r)
        break;
    }
    return n && (o = $6(o, e)), {
      text: o,
      template: e
    };
  };
}
function I6(e, t, n) {
  typeof n == "string" && (n = S6(n));
  var r = n(e) || {}, i = r.text, a = r.template;
  if (i === void 0 && (i = e), a)
    if (t === void 0)
      t = i.length;
    else {
      for (var o = 0, s = !1, l = -1; o < i.length && o < a.length; ) {
        if (i[o] !== a[o]) {
          if (t === 0) {
            s = !0, t = o;
            break;
          }
          l = o, t--;
        }
        o++;
      }
      s || (t = l + 1);
    }
  return {
    text: i,
    caret: t
  };
}
function E6(e) {
  return e.hasAttribute("readonly");
}
function O6(e) {
  if (e.selectionStart !== e.selectionEnd)
    return {
      start: e.selectionStart,
      end: e.selectionEnd
    };
}
var $p = {
  Backspace: 8,
  Delete: 46
};
function T6(e) {
  switch (e.keyCode) {
    case $p.Backspace:
      return "Backspace";
    case $p.Delete:
      return "Delete";
  }
}
function P6(e) {
  return e.selectionStart;
}
function Pv(e, t) {
  t !== void 0 && (N6() ? setTimeout(function() {
    return e.setSelectionRange(t, t);
  }, 0) : e.setSelectionRange(t, t));
}
function N6() {
  if (typeof navigator < "u")
    return _6.test(navigator.userAgent);
}
var _6 = /Android/i;
function A6(e, t, n, r, i) {
  Js(t, n, r, void 0, i);
}
function R6(e, t, n, r, i) {
  if (!E6(t)) {
    var a = T6(e);
    switch (a) {
      case "Delete":
      case "Backspace":
        e.preventDefault();
        var o = O6(t);
        return o ? (M6(t, o), Js(t, n, r, void 0, i)) : Js(t, n, r, a, i);
    }
  }
}
function M6(e, t) {
  var n = e.value;
  n = n.slice(0, t.start) + n.slice(t.end), e.value = n, Pv(e, t.start);
}
function Js(e, t, n, r, i) {
  var a = y6(e.value, P6(e), t), o = a.value, s = a.caret;
  if (r) {
    var l = v6(o, s, r);
    o = l.value, s = l.caret;
  }
  var u = I6(o, s, n), c = u.text;
  s = u.caret, e.value = c, Pv(e, s), i && i(o);
}
var j6 = ["ref", "parse", "format", "value", "defaultValue", "controlled", "onChange", "onKeyDown"];
function wp(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Kn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? wp(Object(n), !0).forEach(function(r) {
      D6(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : wp(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function D6(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function k6(e, t) {
  if (e == null) return {};
  var n = L6(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function L6(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function F6(e) {
  var t = e.ref, n = e.parse, r = e.format, i = e.value, a = e.defaultValue, o = e.controlled, s = o === void 0 ? !0 : o, l = e.onChange, u = e.onKeyDown, c = k6(e, j6), f = ce(), p = ge(function(g) {
    f.current = g, t && (typeof t == "function" ? t(g) : t.current = g);
  }, [t]), h = ge(function(g) {
    return A6(g, f.current, n, r, l);
  }, [f, n, r, l]), m = ge(function(g) {
    if (u && u(g), !g.defaultPrevented)
      return R6(g, f.current, n, r, l);
  }, [f, n, r, l, u]), v = Kn(Kn({}, c), {}, {
    ref: p,
    onChange: h,
    onKeyDown: m
  });
  return s ? Kn(Kn({}, v), {}, {
    value: r(Cp(i) ? "" : i).text
  }) : Kn(Kn({}, v), {}, {
    defaultValue: r(Cp(a) ? "" : a).text
  });
}
function Cp(e) {
  return e == null;
}
var V6 = ["inputComponent", "parse", "format", "value", "defaultValue", "onChange", "controlled", "onKeyDown", "type"];
function Sp(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function B6(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Sp(Object(n), !0).forEach(function(r) {
      H6(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Sp(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function H6(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function K6(e, t) {
  if (e == null) return {};
  var n = W6(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function W6(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function Ca(e, t) {
  var n = e.inputComponent, r = n === void 0 ? "input" : n, i = e.parse, a = e.format, o = e.value, s = e.defaultValue, l = e.onChange, u = e.controlled, c = e.onKeyDown, f = e.type, p = f === void 0 ? "text" : f, h = K6(e, V6), m = F6(B6({
    ref: t,
    parse: i,
    format: a,
    value: o,
    defaultValue: s,
    onChange: l,
    controlled: u,
    onKeyDown: c,
    type: p
  }, h));
  return /* @__PURE__ */ te.createElement(r, m);
}
Ca = /* @__PURE__ */ te.forwardRef(Ca);
Ca.propTypes = {
  // Parses a single characher of `<input/>` text.
  parse: R.func.isRequired,
  // Formats `value` into `<input/>` text.
  format: R.func.isRequired,
  // Renders `<input/>` by default.
  inputComponent: R.elementType,
  // `<input/>` `type` attribute.
  type: R.string,
  // Is parsed from <input/> text.
  value: R.string,
  // An initial value for an "uncontrolled" <input/>.
  defaultValue: R.string,
  // This handler is called each time `<input/>` text is changed.
  onChange: R.func,
  // Whether this input should be "controlled" or "uncontrolled".
  // The default value is `true` meaning "uncontrolled".
  controlled: R.bool,
  // Passthrough
  onKeyDown: R.func,
  onCut: R.func,
  onPaste: R.func
};
function Ip(e, t) {
  e = e.split("-"), t = t.split("-");
  for (var n = e[0].split("."), r = t[0].split("."), i = 0; i < 3; i++) {
    var a = Number(n[i]), o = Number(r[i]);
    if (a > o) return 1;
    if (o > a) return -1;
    if (!isNaN(a) && isNaN(o)) return 1;
    if (isNaN(a) && !isNaN(o)) return -1;
  }
  return e[1] && t[1] ? e[1] > t[1] ? 1 : e[1] < t[1] ? -1 : 0 : !e[1] && t[1] ? 1 : e[1] && !t[1] ? -1 : 0;
}
var z6 = {}.constructor;
function _n(e) {
  return e != null && e.constructor === z6;
}
function Qs(e) {
  "@babel/helpers - typeof";
  return Qs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Qs(e);
}
function to(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function G6(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function no(e, t, n) {
  return t && G6(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var U6 = "1.2.0", q6 = "1.7.35", Ep = " ext. ", Y6 = /^\d+$/, qe = /* @__PURE__ */ function() {
  function e(t) {
    to(this, e), Nv(t), this.metadata = t, Av.call(this, t);
  }
  return no(e, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(n) {
        return n !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(n) {
      return this.metadata.countries[n];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(n) {
      return this.getCountryMetadata(n) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(n) {
      if (this.getCountryCodesForCallingCode(n))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[n])
          return !0;
      } else {
        var r = this.countryCallingCodes()[n];
        if (r && r.length === 1 && r[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(n) {
      return this.nonGeographic() ? !!this.nonGeographic()[n] : !this.getCountryCodesForCallingCode(n);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(n, r) {
      if (n && Y6.test(n) && (r = n, n = null), n && n !== "001") {
        if (!this.hasCountry(n))
          throw new Error("Unknown country: ".concat(n));
        this.numberingPlan = new Op(this.getCountryMetadata(n), this);
      } else if (r) {
        if (!this.hasCallingCode(r))
          throw new Error("Unknown calling code: ".concat(r));
        this.numberingPlan = new Op(this.getNumberingPlanMetadata(r), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(n) {
      var r = this.countryCallingCodes()[n];
      if (r)
        return r.length === 1 && r[0].length === 3 ? void 0 : r;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(n) {
      var r = this.getCountryCodesForCallingCode(n);
      if (r)
        return r[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(n) {
      var r = this.getCountryCodeForCallingCode(n);
      if (r)
        return this.getCountryMetadata(r);
      if (this.nonGeographic()) {
        var i = this.nonGeographic()[n];
        if (i)
          return i;
      } else {
        var a = this.countryCallingCodes()[n];
        if (a && a.length === 1 && a[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(n) {
      return this.numberingPlan.type(n);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), e;
}(), Op = /* @__PURE__ */ function() {
  function e(t, n) {
    to(this, e), this.globalMetadataObject = n, this.metadata = t, Av.call(this, n.metadata);
  }
  return no(e, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(n) {
      return n[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var n = this, r = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return r.map(function(i) {
        return new X6(i, n);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(n) {
      return n[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(n) {
      if (this.hasTypes() && Tp(this.types(), n))
        return new J6(Tp(this.types(), n), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? Ep : this.metadata[13] || Ep;
    }
  }]), e;
}(), X6 = /* @__PURE__ */ function() {
  function e(t, n) {
    to(this, e), this._format = t, this.metadata = n;
  }
  return no(e, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !Z6.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), e;
}(), Z6 = /^\(?\$1\)?$/, J6 = /* @__PURE__ */ function() {
  function e(t, n) {
    to(this, e), this.type = t, this.metadata = n;
  }
  return no(e, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), e;
}();
function Tp(e, t) {
  switch (t) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
function Nv(e) {
  if (!e)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!_n(e) || !_n(e.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(_n(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + Q6(e) + ": " + e, "."));
}
var Q6 = function(t) {
  return Qs(t);
};
function an(e, t) {
  if (t = new qe(t), t.hasCountry(e))
    return t.country(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function _v(e, t) {
  return t.countries.hasOwnProperty(e);
}
function Av(e) {
  var t = e.version;
  typeof t == "number" ? (this.v1 = t === 1, this.v2 = t === 2, this.v3 = t === 3, this.v4 = t === 4) : t ? Ip(t, U6) === -1 ? this.v2 = !0 : Ip(t, q6) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
function ro(e, t) {
  return e7(e, void 0, t);
}
function e7(e, t, n) {
  var r = n.type(t), i = r && r.possibleLengths() || n.possibleLengths();
  if (!i)
    return "IS_POSSIBLE";
  var a = e.length, o = i[0];
  return o === a ? "IS_POSSIBLE" : o > a ? "TOO_SHORT" : i[i.length - 1] < a ? "TOO_LONG" : i.indexOf(a, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function t7(e, t, n) {
  if (t === void 0 && (t = {}), n = new qe(n), t.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    n.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!n.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      n.country(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      n.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (n.possibleLengths())
    return Rv(e.phone || e.nationalNumber, n);
  if (e.countryCallingCode && n.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function Rv(e, t) {
  switch (ro(e, t)) {
    case "IS_POSSIBLE":
      return !0;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational
    default:
      return !1;
  }
}
function nn(e, t) {
  return e = e || "", new RegExp("^(?:" + t + ")$").test(e);
}
function n7(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = r7(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function r7(e, t) {
  if (e) {
    if (typeof e == "string") return Pp(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Pp(e, t);
  }
}
function Pp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var i7 = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function uc(e, t, n) {
  if (t = t || {}, !(!e.country && !e.countryCallingCode)) {
    n = new qe(n), n.selectNumberingPlan(e.country, e.countryCallingCode);
    var r = t.v2 ? e.nationalNumber : e.phone;
    if (nn(r, n.nationalNumberPattern())) {
      if (Qo(r, "FIXED_LINE", n))
        return n.type("MOBILE") && n.type("MOBILE").pattern() === "" || !n.type("MOBILE") || Qo(r, "MOBILE", n) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var i = n7(i7), a; !(a = i()).done; ) {
        var o = a.value;
        if (Qo(r, o, n))
          return o;
      }
    }
  }
}
function Qo(e, t, n) {
  return t = n.type(t), !t || !t.pattern() || t.possibleLengths() && t.possibleLengths().indexOf(e.length) < 0 ? !1 : nn(e, t.pattern());
}
function a7(e, t, n) {
  if (t = t || {}, n = new qe(n), n.selectNumberingPlan(e.country, e.countryCallingCode), n.hasTypes())
    return uc(e, t, n.metadata) !== void 0;
  var r = t.v2 ? e.nationalNumber : e.phone;
  return nn(r, n.nationalNumberPattern());
}
function o7(e, t, n) {
  var r = new qe(n), i = r.getCountryCodesForCallingCode(e);
  return i ? i.filter(function(a) {
    return s7(t, a, n);
  }) : [];
}
function s7(e, t, n) {
  var r = new qe(n);
  return r.selectNumberingPlan(t), r.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
var cc = 2, l7 = 17, u7 = 3, at = "0-9０-９٠-٩۰-۹", c7 = "-‐-―−ー－", d7 = "／/", f7 = "．.", p7 = "  ­​⁠　", h7 = "()（）［］\\[\\]", m7 = "~⁓∼～", Pt = "".concat(c7).concat(d7).concat(f7).concat(p7).concat(h7).concat(m7), io = "+＋", g7 = new RegExp("([" + at + "])");
function Mv(e, t, n, r) {
  if (t) {
    var i = new qe(r);
    i.selectNumberingPlan(t, n);
    var a = new RegExp(i.IDDPrefix());
    if (e.search(a) === 0) {
      e = e.slice(e.match(a)[0].length);
      var o = e.match(g7);
      if (!(o && o[1] != null && o[1].length > 0 && o[1] === "0"))
        return e;
    }
  }
}
function el(e, t) {
  if (e && t.numberingPlan.nationalPrefixForParsing()) {
    var n = new RegExp("^(?:" + t.numberingPlan.nationalPrefixForParsing() + ")"), r = n.exec(e);
    if (r) {
      var i, a, o = r.length - 1, s = o > 0 && r[o];
      if (t.nationalPrefixTransformRule() && s)
        i = e.replace(n, t.nationalPrefixTransformRule()), o > 1 && (a = r[1]);
      else {
        var l = r[0];
        i = e.slice(l.length), s && (a = r[1]);
      }
      var u;
      if (s) {
        var c = e.indexOf(r[1]), f = e.slice(0, c);
        f === t.numberingPlan.nationalPrefix() && (u = t.numberingPlan.nationalPrefix());
      } else
        u = r[0];
      return {
        nationalNumber: i,
        nationalPrefix: u,
        carrierCode: a
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function tl(e, t) {
  var n = el(e, t), r = n.carrierCode, i = n.nationalNumber;
  if (i !== e) {
    if (!v7(e, i, t))
      return {
        nationalNumber: e
      };
    if (t.possibleLengths() && !y7(i, t))
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: i,
    carrierCode: r
  };
}
function v7(e, t, n) {
  return !(nn(e, n.nationalNumberPattern()) && !nn(t, n.nationalNumberPattern()));
}
function y7(e, t) {
  switch (ro(e, t)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function jv(e, t, n, r) {
  var i = t ? an(t, r) : n;
  if (e.indexOf(i) === 0) {
    r = new qe(r), r.selectNumberingPlan(t, n);
    var a = e.slice(i.length), o = tl(a, r), s = o.nationalNumber, l = tl(e, r), u = l.nationalNumber;
    if (!nn(u, r.nationalNumberPattern()) && nn(s, r.nationalNumberPattern()) || ro(u, r) === "TOO_LONG")
      return {
        countryCallingCode: i,
        number: a
      };
  }
  return {
    number: e
  };
}
function dc(e, t, n, r) {
  if (!e)
    return {};
  var i;
  if (e[0] !== "+") {
    var a = Mv(e, t, n, r);
    if (a && a !== e)
      i = !0, e = "+" + a;
    else {
      if (t || n) {
        var o = jv(e, t, n, r), s = o.countryCallingCode, l = o.number;
        if (s)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: s,
            number: l
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: e
      };
    }
  }
  if (e[1] === "0")
    return {};
  r = new qe(r);
  for (var u = 2; u - 1 <= u7 && u <= e.length; ) {
    var c = e.slice(1, u);
    if (r.hasCallingCode(c))
      return r.selectNumberingPlan(c), {
        countryCallingCodeSource: i ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: c,
        number: e.slice(u)
      };
    u++;
  }
  return {};
}
function Dv(e) {
  return e.replace(new RegExp("[".concat(Pt, "]+"), "g"), " ").trim();
}
var kv = /(\$\d)/;
function Lv(e, t, n) {
  var r = n.useInternationalFormat, i = n.withNationalPrefix;
  n.carrierCode, n.metadata;
  var a = e.replace(new RegExp(t.pattern()), r ? t.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    i && t.nationalPrefixFormattingRule() ? t.format().replace(kv, t.nationalPrefixFormattingRule()) : t.format()
  ));
  return r ? Dv(a) : a;
}
var b7 = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function x7(e, t, n) {
  var r = new qe(n);
  if (r.selectNumberingPlan(e, t), r.defaultIDDPrefix())
    return r.defaultIDDPrefix();
  if (b7.test(r.IDDPrefix()))
    return r.IDDPrefix();
}
var $7 = ";ext=", Wn = function(t) {
  return "([".concat(at, "]{1,").concat(t, "})");
};
function Fv(e) {
  var t = "20", n = "15", r = "9", i = "6", a = "[  \\t,]*", o = "[:\\.．]?[  \\t,-]*", s = "#?", l = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", u = "(?:[xｘ#＃~～]|int|ｉｎｔ)", c = "[- ]+", f = "[  \\t]*", p = "(?:,{2}|;)", h = $7 + Wn(t), m = a + l + o + Wn(t) + s, v = a + u + o + Wn(r) + s, g = c + Wn(i) + "#", b = f + p + o + Wn(n) + s, y = f + "(?:,)+" + o + Wn(r) + s;
  return h + "|" + m + "|" + v + "|" + g + "|" + b + "|" + y;
}
var w7 = "[" + at + "]{" + cc + "}", C7 = "[" + io + "]{0,1}(?:[" + Pt + "]*[" + at + "]){3,}[" + Pt + at + "]*", S7 = new RegExp("^[" + io + "]{0,1}(?:[" + Pt + "]*[" + at + "]){1,2}$", "i"), I7 = C7 + // Phone number extensions
"(?:" + Fv() + ")?", E7 = new RegExp(
  // Either a short two-digit-only phone number
  "^" + w7 + "$|^" + I7 + "$",
  "i"
);
function O7(e) {
  return e.length >= cc && E7.test(e);
}
function T7(e) {
  return S7.test(e);
}
function P7(e) {
  var t = e.number, n = e.ext;
  if (!t)
    return "";
  if (t[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(t).concat(n ? ";ext=" + n : "");
}
function N7(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = _7(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _7(e, t) {
  if (e) {
    if (typeof e == "string") return Np(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Np(e, t);
  }
}
function Np(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function _p(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ap(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? _p(Object(n), !0).forEach(function(r) {
      A7(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : _p(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function A7(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var Rp = {
  formatExtension: function(t, n, r) {
    return "".concat(t).concat(r.ext()).concat(n);
  }
};
function R7(e, t, n, r) {
  if (n ? n = Ap(Ap({}, Rp), n) : n = Rp, r = new qe(r), e.country && e.country !== "001") {
    if (!r.hasCountry(e.country))
      throw new Error("Unknown country: ".concat(e.country));
    r.country(e.country);
  } else if (e.countryCallingCode)
    r.selectNumberingPlan(e.countryCallingCode);
  else return e.phone || "";
  var i = r.countryCallingCode(), a = n.v2 ? e.nationalNumber : e.phone, o;
  switch (t) {
    case "NATIONAL":
      return a ? (o = Sa(a, e.carrierCode, "NATIONAL", r, n), es(o, e.ext, r, n.formatExtension)) : "";
    case "INTERNATIONAL":
      return a ? (o = Sa(a, null, "INTERNATIONAL", r, n), o = "+".concat(i, " ").concat(o), es(o, e.ext, r, n.formatExtension)) : "+".concat(i);
    case "E.164":
      return "+".concat(i).concat(a);
    case "RFC3966":
      return P7({
        number: "+".concat(i).concat(a),
        ext: e.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?
    case "IDD":
      if (!n.fromCountry)
        return;
      var s = j7(a, e.carrierCode, i, n.fromCountry, r);
      return es(s, e.ext, r, n.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(t, '"'));
  }
}
function Sa(e, t, n, r, i) {
  var a = M7(r.formats(), e);
  return a ? Lv(e, a, {
    useInternationalFormat: n === "INTERNATIONAL",
    withNationalPrefix: !(a.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && i && i.nationalPrefix === !1),
    carrierCode: t,
    metadata: r
  }) : e;
}
function M7(e, t) {
  for (var n = N7(e), r; !(r = n()).done; ) {
    var i = r.value;
    if (i.leadingDigitsPatterns().length > 0) {
      var a = i.leadingDigitsPatterns()[i.leadingDigitsPatterns().length - 1];
      if (t.search(a) !== 0)
        continue;
    }
    if (nn(t, i.pattern()))
      return i;
  }
}
function es(e, t, n, r) {
  return t ? r(e, t, n) : e;
}
function j7(e, t, n, r, i) {
  var a = an(r, i.metadata);
  if (a === n) {
    var o = Sa(e, t, "NATIONAL", i);
    return n === "1" ? n + " " + o : o;
  }
  var s = x7(r, void 0, i.metadata);
  if (s)
    return "".concat(s, " ").concat(n, " ").concat(Sa(e, null, "INTERNATIONAL", i));
}
function Mp(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function jp(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Mp(Object(n), !0).forEach(function(r) {
      D7(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Mp(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function D7(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function k7(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function L7(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function F7(e, t, n) {
  return t && L7(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Vv = /* @__PURE__ */ function() {
  function e(t, n, r) {
    if (k7(this, e), !t)
      throw new TypeError("First argument is required");
    if (typeof t != "string")
      throw new TypeError("First argument must be a string");
    if (typeof t == "string") {
      if (t[0] === "+" && !n)
        throw new TypeError("`metadata` argument not passed");
      if (_n(n) && _n(n.countries)) {
        r = n;
        var i = t;
        if (!H7.test(i))
          throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
        var a = dc(i, void 0, void 0, r), o = a.countryCallingCode, s = a.number;
        if (n = s, t = o, !n)
          throw new Error("Invalid `number` argument passed: too short");
      }
    }
    if (!n)
      throw new TypeError("`nationalNumber` argument is required");
    if (typeof n != "string")
      throw new TypeError("`nationalNumber` argument must be a string");
    Nv(r);
    var l = B7(t, r), u = l.country, c = l.countryCallingCode;
    this.country = u, this.countryCallingCode = c, this.nationalNumber = n, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return r;
    };
  }
  return F7(e, [{
    key: "setExt",
    value: function(n) {
      this.ext = n;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : o7(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return t7(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return a7(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var n = new qe(this.getMetadata());
      return n.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(n) {
      return this.number === n.number && this.ext === n.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return uc(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(n, r) {
      return R7(this, n, r ? jp(jp({}, r), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(n) {
      return this.format("NATIONAL", n);
    }
  }, {
    key: "formatInternational",
    value: function(n) {
      return this.format("INTERNATIONAL", n);
    }
  }, {
    key: "getURI",
    value: function(n) {
      return this.format("RFC3966", n);
    }
  }]), e;
}(), V7 = function(t) {
  return /^[A-Z]{2}$/.test(t);
};
function B7(e, t) {
  var n, r, i = new qe(t);
  return V7(e) ? (n = e, i.selectNumberingPlan(n), r = i.countryCallingCode()) : r = e, {
    country: n,
    countryCallingCode: r
  };
}
var H7 = /^\+\d+$/;
function nl(e) {
  "@babel/helpers - typeof";
  return nl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, nl(e);
}
function K7(e, t, n) {
  return Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function W7(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function z7(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && ai(e, t);
}
function G7(e) {
  var t = Hv();
  return function() {
    var r = oi(e), i;
    if (t) {
      var a = oi(this).constructor;
      i = Reflect.construct(r, arguments, a);
    } else
      i = r.apply(this, arguments);
    return U7(this, i);
  };
}
function U7(e, t) {
  if (t && (nl(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Bv(e);
}
function Bv(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function rl(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return rl = function(r) {
    if (r === null || !q7(r)) return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(r)) return t.get(r);
      t.set(r, i);
    }
    function i() {
      return Qi(r, arguments, oi(this).constructor);
    }
    return i.prototype = Object.create(r.prototype, { constructor: { value: i, enumerable: !1, writable: !0, configurable: !0 } }), ai(i, r);
  }, rl(e);
}
function Qi(e, t, n) {
  return Hv() ? Qi = Reflect.construct : Qi = function(i, a, o) {
    var s = [null];
    s.push.apply(s, a);
    var l = Function.bind.apply(i, s), u = new l();
    return o && ai(u, o.prototype), u;
  }, Qi.apply(null, arguments);
}
function Hv() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function q7(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function ai(e, t) {
  return ai = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, ai(e, t);
}
function oi(e) {
  return oi = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, oi(e);
}
var Wt = /* @__PURE__ */ function(e) {
  z7(n, e);
  var t = G7(n);
  function n(r) {
    var i;
    return W7(this, n), i = t.call(this, r), Object.setPrototypeOf(Bv(i), n.prototype), i.name = i.constructor.name, i;
  }
  return K7(n);
}(/* @__PURE__ */ rl(Error)), Dp = new RegExp("(?:" + Fv() + ")$", "i");
function Y7(e) {
  var t = e.search(Dp);
  if (t < 0)
    return {};
  for (var n = e.slice(0, t), r = e.match(Dp), i = 1; i < r.length; ) {
    if (r[i])
      return {
        number: n,
        ext: r[i]
      };
    i++;
  }
}
function X7(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Z7(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Z7(e, t) {
  if (e) {
    if (typeof e == "string") return kp(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return kp(e, t);
  }
}
function kp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var J7 = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function Kv(e) {
  return J7[e];
}
function Ia(e) {
  for (var t = "", n = X7(e.split("")), r; !(r = n()).done; ) {
    var i = r.value, a = Kv(i);
    a && (t += a);
  }
  return t;
}
function Q7(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = eC(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function eC(e, t) {
  if (e) {
    if (typeof e == "string") return Lp(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Lp(e, t);
  }
}
function Lp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function il(e) {
  for (var t = "", n = Q7(e.split("")), r; !(r = n()).done; ) {
    var i = r.value;
    t += Wv(i, t) || "";
  }
  return t;
}
function Wv(e, t, n) {
  if (e === "+") {
    if (t) {
      typeof n == "function" && n("end");
      return;
    }
    return "+";
  }
  return Kv(e);
}
function tC(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = nC(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function nC(e, t) {
  if (e) {
    if (typeof e == "string") return Fp(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Fp(e, t);
  }
}
function Fp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function zv(e, t) {
  var n = t.countries;
  t.defaultCountry;
  var r = t.metadata;
  r = new qe(r);
  for (var i = tC(n), a; !(a = i()).done; ) {
    var o = a.value;
    if (r.country(o), r.leadingDigits()) {
      if (e && e.search(r.leadingDigits()) === 0)
        return o;
    } else if (uc({
      phone: e,
      country: o
    }, void 0, r.metadata))
      return o;
  }
}
function Gv(e, t) {
  var n = t.nationalNumber, r = t.defaultCountry, i = t.metadata, a = i.getCountryCodesForCallingCode(e);
  if (a)
    return a.length === 1 ? a[0] : zv(n, {
      countries: a,
      defaultCountry: r,
      metadata: i.metadata
    });
}
var Uv = "+", rC = "[\\-\\.\\(\\)]?", Vp = "([" + at + "]|" + rC + ")", iC = "^\\" + Uv + Vp + "*[" + at + "]" + Vp + "*$", aC = new RegExp(iC, "g"), al = at, oC = "[" + al + "]+((\\-)*[" + al + "])*", sC = "a-zA-Z", lC = "[" + sC + "]+((\\-)*[" + al + "])*", uC = "^(" + oC + "\\.)*" + lC + "\\.?$", cC = new RegExp(uC, "g"), Bp = "tel:", ol = ";phone-context=", dC = ";isub=";
function fC(e) {
  var t = e.indexOf(ol);
  if (t < 0)
    return null;
  var n = t + ol.length;
  if (n >= e.length)
    return "";
  var r = e.indexOf(";", n);
  return r >= 0 ? e.substring(n, r) : e.substring(n);
}
function pC(e) {
  return e === null ? !0 : e.length === 0 ? !1 : aC.test(e) || cC.test(e);
}
function hC(e, t) {
  var n = t.extractFormattedPhoneNumber, r = fC(e);
  if (!pC(r))
    throw new Wt("NOT_A_NUMBER");
  var i;
  if (r === null)
    i = n(e) || "";
  else {
    i = "", r.charAt(0) === Uv && (i += r);
    var a = e.indexOf(Bp), o;
    a >= 0 ? o = a + Bp.length : o = 0;
    var s = e.indexOf(ol);
    i += e.substring(o, s);
  }
  var l = i.indexOf(dC);
  if (l > 0 && (i = i.substring(0, l)), i !== "")
    return i;
}
var mC = 250, gC = new RegExp("[" + io + at + "]"), vC = new RegExp("[^" + at + "#]+$");
function yC(e, t, n) {
  if (t = t || {}, n = new qe(n), t.defaultCountry && !n.hasCountry(t.defaultCountry))
    throw t.v2 ? new Wt("INVALID_COUNTRY") : new Error("Unknown country: ".concat(t.defaultCountry));
  var r = xC(e, t.v2, t.extract), i = r.number, a = r.ext, o = r.error;
  if (!i) {
    if (t.v2)
      throw o === "TOO_SHORT" ? new Wt("TOO_SHORT") : new Wt("NOT_A_NUMBER");
    return {};
  }
  var s = wC(i, t.defaultCountry, t.defaultCallingCode, n), l = s.country, u = s.nationalNumber, c = s.countryCallingCode, f = s.countryCallingCodeSource, p = s.carrierCode;
  if (!n.hasSelectedNumberingPlan()) {
    if (t.v2)
      throw new Wt("INVALID_COUNTRY");
    return {};
  }
  if (!u || u.length < cc) {
    if (t.v2)
      throw new Wt("TOO_SHORT");
    return {};
  }
  if (u.length > l7) {
    if (t.v2)
      throw new Wt("TOO_LONG");
    return {};
  }
  if (t.v2) {
    var h = new Vv(c, u, n.metadata);
    return l && (h.country = l), p && (h.carrierCode = p), a && (h.ext = a), h.__countryCallingCodeSource = f, h;
  }
  var m = (t.extended ? n.hasSelectedNumberingPlan() : l) ? nn(u, n.nationalNumberPattern()) : !1;
  return t.extended ? {
    country: l,
    countryCallingCode: c,
    carrierCode: p,
    valid: m,
    possible: m ? !0 : !!(t.extended === !0 && n.possibleLengths() && Rv(u, n)),
    phone: u,
    ext: a
  } : m ? $C(l, u, a) : {};
}
function bC(e, t, n) {
  if (e) {
    if (e.length > mC) {
      if (n)
        throw new Wt("TOO_LONG");
      return;
    }
    if (t === !1)
      return e;
    var r = e.search(gC);
    if (!(r < 0))
      return e.slice(r).replace(vC, "");
  }
}
function xC(e, t, n) {
  var r = hC(e, {
    extractFormattedPhoneNumber: function(o) {
      return bC(o, n, t);
    }
  });
  if (!r)
    return {};
  if (!O7(r))
    return T7(r) ? {
      error: "TOO_SHORT"
    } : {};
  var i = Y7(r);
  return i.ext ? i : {
    number: r
  };
}
function $C(e, t, n) {
  var r = {
    country: e,
    phone: t
  };
  return n && (r.ext = n), r;
}
function wC(e, t, n, r) {
  var i = dc(il(e), t, n, r.metadata), a = i.countryCallingCodeSource, o = i.countryCallingCode, s = i.number, l;
  if (o)
    r.selectNumberingPlan(o);
  else if (s && (t || n))
    r.selectNumberingPlan(t, n), t && (l = t), o = n || an(t, r.metadata);
  else return {};
  if (!s)
    return {
      countryCallingCodeSource: a,
      countryCallingCode: o
    };
  var u = tl(il(s), r), c = u.nationalNumber, f = u.carrierCode, p = Gv(o, {
    nationalNumber: c,
    defaultCountry: t,
    metadata: r
  });
  return p && (l = p, p === "001" || r.country(l)), {
    country: l,
    countryCallingCode: o,
    countryCallingCodeSource: a,
    nationalNumber: c,
    carrierCode: f
  };
}
function Hp(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Kp(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Hp(Object(n), !0).forEach(function(r) {
      CC(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Hp(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function CC(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function SC(e, t, n) {
  return yC(e, Kp(Kp({}, t), {}, {
    v2: !0
  }), n);
}
function Wp(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function IC(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Wp(Object(n), !0).forEach(function(r) {
      EC(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Wp(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function EC(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function OC(e, t) {
  return _C(e) || NC(e, t) || PC(e, t) || TC();
}
function TC() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function PC(e, t) {
  if (e) {
    if (typeof e == "string") return zp(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return zp(e, t);
  }
}
function zp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function NC(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], i = !0, a = !1, o, s;
    try {
      for (n = n.call(e); !(i = (o = n.next()).done) && (r.push(o.value), !(t && r.length === t)); i = !0)
        ;
    } catch (l) {
      a = !0, s = l;
    } finally {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (a) throw s;
      }
    }
    return r;
  }
}
function _C(e) {
  if (Array.isArray(e)) return e;
}
function qv(e) {
  var t = Array.prototype.slice.call(e), n = OC(t, 4), r = n[0], i = n[1], a = n[2], o = n[3], s, l, u;
  if (typeof r == "string")
    s = r;
  else throw new TypeError("A text for parsing must be a string.");
  if (!i || typeof i == "string")
    o ? (l = a, u = o) : (l = void 0, u = a), i && (l = IC({
      defaultCountry: i
    }, l));
  else if (_n(i))
    a ? (l = i, u = a) : u = i;
  else throw new Error("Invalid second argument: ".concat(i));
  return {
    text: s,
    options: l,
    metadata: u
  };
}
function Gp(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Up(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Gp(Object(n), !0).forEach(function(r) {
      AC(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Gp(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function AC(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Yv(e, t, n) {
  t && t.defaultCountry && !_v(t.defaultCountry, n) && (t = Up(Up({}, t), {}, {
    defaultCountry: void 0
  }));
  try {
    return SC(e, t, n);
  } catch (r) {
    if (!(r instanceof Wt)) throw r;
  }
}
function Xv() {
  var e = qv(arguments), t = e.text, n = e.options, r = e.metadata;
  return Yv(t, n, r);
}
function qp(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Yp(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? qp(Object(n), !0).forEach(function(r) {
      RC(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : qp(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function RC(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function MC() {
  var e = qv(arguments), t = e.text, n = e.options, r = e.metadata;
  n = Yp(Yp({}, n), {}, {
    extract: !1
  });
  var i = Yv(t, n, r);
  return i && i.isPossible() || !1;
}
function jC(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function DC(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function kC(e, t, n) {
  return t && DC(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var LC = /* @__PURE__ */ function() {
  function e(t) {
    var n = t.onCountryChange, r = t.onCallingCodeChange;
    jC(this, e), this.onCountryChange = n, this.onCallingCodeChange = r;
  }
  return kC(e, [{
    key: "reset",
    value: function(n) {
      var r = n.country, i = n.callingCode;
      this.international = !1, this.missingPlus = !1, this.IDDPrefix = void 0, this.callingCode = void 0, this.digits = "", this.resetNationalSignificantNumber(), this.initCountryAndCallingCode(r, i);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function() {
      this.nationalSignificantNumber = this.getNationalDigits(), this.nationalSignificantNumberMatchesInput = !0, this.nationalPrefix = void 0, this.carrierCode = void 0, this.complexPrefixBeforeNationalSignificantNumber = void 0;
    }
  }, {
    key: "update",
    value: function(n) {
      for (var r = 0, i = Object.keys(n); r < i.length; r++) {
        var a = i[r];
        this[a] = n[a];
      }
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function(n, r) {
      this.setCountry(n), this.setCallingCode(r);
    }
  }, {
    key: "setCountry",
    value: function(n) {
      this.country = n, this.onCountryChange(n);
    }
  }, {
    key: "setCallingCode",
    value: function(n) {
      this.callingCode = n, this.onCallingCodeChange(n, this.country);
    }
  }, {
    key: "startInternationalNumber",
    value: function(n, r) {
      this.international = !0, this.initCountryAndCallingCode(n, r);
    }
  }, {
    key: "appendDigits",
    value: function(n) {
      this.digits += n;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function(n) {
      this.nationalSignificantNumber += n;
    }
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */
  }, {
    key: "getNationalDigits",
    value: function() {
      return this.international ? this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0)) : this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function() {
      return this.international && this.IDDPrefix ? this.digits.slice(this.IDDPrefix.length) : this.digits;
    }
  }]), e;
}();
function FC(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = VC(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function VC(e, t) {
  if (e) {
    if (typeof e == "string") return Xp(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Xp(e, t);
  }
}
function Xp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var St = "x", ts = new RegExp(St);
function ea(e, t) {
  if (t < 1)
    return "";
  for (var n = ""; t > 1; )
    t & 1 && (n += e), t >>= 1, e += e;
  return n + e;
}
function Zp(e, t) {
  return e[t] === ")" && t++, BC(e.slice(0, t));
}
function BC(e) {
  for (var t = [], n = 0; n < e.length; )
    e[n] === "(" ? t.push(n) : e[n] === ")" && t.pop(), n++;
  var r = 0, i = "";
  t.push(e.length);
  for (var a = 0, o = t; a < o.length; a++) {
    var s = o[a];
    i += e.slice(r, s), r = s + 1;
  }
  return i;
}
function HC(e, t, n) {
  for (var r = FC(n.split("")), i; !(i = r()).done; ) {
    var a = i.value;
    if (e.slice(t + 1).search(ts) < 0)
      return;
    t = e.search(ts), e = e.replace(ts, a);
  }
  return [e, t];
}
function KC(e, t, n) {
  var r = n.metadata, i = n.shouldTryNationalPrefixFormattingRule, a = n.getSeparatorAfterNationalPrefix, o = new RegExp("^(?:".concat(t.pattern(), ")$"));
  if (o.test(e.nationalSignificantNumber))
    return zC(e, t, {
      metadata: r,
      shouldTryNationalPrefixFormattingRule: i,
      getSeparatorAfterNationalPrefix: a
    });
}
function WC(e, t) {
  return ro(e, t) === "IS_POSSIBLE";
}
function zC(e, t, n) {
  var r = n.metadata, i = n.shouldTryNationalPrefixFormattingRule, a = n.getSeparatorAfterNationalPrefix;
  if (e.nationalSignificantNumber, e.international, e.nationalPrefix, e.carrierCode, i(t)) {
    var o = Jp(e, t, {
      useNationalPrefixFormattingRule: !0,
      getSeparatorAfterNationalPrefix: a,
      metadata: r
    });
    if (o)
      return o;
  }
  return Jp(e, t, {
    useNationalPrefixFormattingRule: !1,
    getSeparatorAfterNationalPrefix: a,
    metadata: r
  });
}
function Jp(e, t, n) {
  var r = n.metadata, i = n.useNationalPrefixFormattingRule, a = n.getSeparatorAfterNationalPrefix, o = Lv(e.nationalSignificantNumber, t, {
    carrierCode: e.carrierCode,
    useInternationalFormat: e.international,
    withNationalPrefix: i,
    metadata: r
  });
  if (i || (e.nationalPrefix ? o = e.nationalPrefix + a(t) + o : e.complexPrefixBeforeNationalSignificantNumber && (o = e.complexPrefixBeforeNationalSignificantNumber + " " + o)), GC(o, e))
    return o;
}
function GC(e, t) {
  return Ia(e) === t.getNationalDigits();
}
function UC(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function qC(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function YC(e, t, n) {
  return t && qC(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var XC = /* @__PURE__ */ function() {
  function e() {
    UC(this, e);
  }
  return YC(e, [{
    key: "parse",
    value: function(n) {
      if (this.context = [{
        or: !0,
        instructions: []
      }], this.parsePattern(n), this.context.length !== 1)
        throw new Error("Non-finalized contexts left when pattern parse ended");
      var r = this.context[0], i = r.branches, a = r.instructions;
      if (i)
        return {
          op: "|",
          args: i.concat([ns(a)])
        };
      if (a.length === 0)
        throw new Error("Pattern is required");
      return a.length === 1 ? a[0] : a;
    }
  }, {
    key: "startContext",
    value: function(n) {
      this.context.push(n);
    }
  }, {
    key: "endContext",
    value: function() {
      this.context.pop();
    }
  }, {
    key: "getContext",
    value: function() {
      return this.context[this.context.length - 1];
    }
  }, {
    key: "parsePattern",
    value: function(n) {
      if (!n)
        throw new Error("Pattern is required");
      var r = n.match(QC);
      if (!r) {
        if (JC.test(n))
          throw new Error("Illegal characters found in a pattern: ".concat(n));
        this.getContext().instructions = this.getContext().instructions.concat(n.split(""));
        return;
      }
      var i = r[1], a = n.slice(0, r.index), o = n.slice(r.index + i.length);
      switch (i) {
        case "(?:":
          a && this.parsePattern(a), this.startContext({
            or: !0,
            instructions: [],
            branches: []
          });
          break;
        case ")":
          if (!this.getContext().or)
            throw new Error('")" operator must be preceded by "(?:" operator');
          if (a && this.parsePattern(a), this.getContext().instructions.length === 0)
            throw new Error('No instructions found after "|" operator in an "or" group');
          var s = this.getContext(), l = s.branches;
          l.push(ns(this.getContext().instructions)), this.endContext(), this.getContext().instructions.push({
            op: "|",
            args: l
          });
          break;
        case "|":
          if (!this.getContext().or)
            throw new Error('"|" operator can only be used inside "or" groups');
          if (a && this.parsePattern(a), !this.getContext().branches)
            if (this.context.length === 1)
              this.getContext().branches = [];
            else
              throw new Error('"branches" not found in an "or" group context');
          this.getContext().branches.push(ns(this.getContext().instructions)), this.getContext().instructions = [];
          break;
        case "[":
          a && this.parsePattern(a), this.startContext({
            oneOfSet: !0
          });
          break;
        case "]":
          if (!this.getContext().oneOfSet)
            throw new Error('"]" operator must be preceded by "[" operator');
          this.endContext(), this.getContext().instructions.push({
            op: "[]",
            args: ZC(a)
          });
          break;
        /* istanbul ignore next */
        default:
          throw new Error("Unknown operator: ".concat(i));
      }
      o && this.parsePattern(o);
    }
  }]), e;
}();
function ZC(e) {
  for (var t = [], n = 0; n < e.length; ) {
    if (e[n] === "-") {
      if (n === 0 || n === e.length - 1)
        throw new Error("Couldn't parse a one-of set pattern: ".concat(e));
      for (var r = e[n - 1].charCodeAt(0) + 1, i = e[n + 1].charCodeAt(0) - 1, a = r; a <= i; )
        t.push(String.fromCharCode(a)), a++;
    } else
      t.push(e[n]);
    n++;
  }
  return t;
}
var JC = /[\(\)\[\]\?\:\|]/, QC = new RegExp(
  // any of:
  "(\\||\\(\\?\\:|\\)|\\[|\\])"
);
function ns(e) {
  return e.length === 1 ? e[0] : e;
}
function Qp(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = eS(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function eS(e, t) {
  if (e) {
    if (typeof e == "string") return eh(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return eh(e, t);
  }
}
function eh(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function tS(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function nS(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function rS(e, t, n) {
  return t && nS(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var iS = /* @__PURE__ */ function() {
  function e(t) {
    tS(this, e), this.matchTree = new XC().parse(t);
  }
  return rS(e, [{
    key: "match",
    value: function(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = r.allowOverflow;
      if (!n)
        throw new Error("String is required");
      var a = sl(n.split(""), this.matchTree, !0);
      if (a && a.match && delete a.matchedChars, !(a && a.overflow && !i))
        return a;
    }
  }]), e;
}();
function sl(e, t, n) {
  if (typeof t == "string") {
    var r = e.join("");
    return t.indexOf(r) === 0 ? e.length === t.length ? {
      match: !0,
      matchedChars: e
    } : {
      partialMatch: !0
      // matchedChars: characters
    } : r.indexOf(t) === 0 ? n && e.length > t.length ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: e.slice(0, t.length)
    } : void 0;
  }
  if (Array.isArray(t)) {
    for (var i = e.slice(), a = 0; a < t.length; ) {
      var o = t[a], s = sl(i, o, n && a === t.length - 1);
      if (s) {
        if (s.overflow)
          return s;
        if (s.match) {
          if (i = i.slice(s.matchedChars.length), i.length === 0)
            return a === t.length - 1 ? {
              match: !0,
              matchedChars: e
            } : {
              partialMatch: !0
              // matchedChars: characters
            };
        } else {
          if (s.partialMatch)
            return {
              partialMatch: !0
              // matchedChars: characters
            };
          throw new Error(`Unsupported match result:
`.concat(JSON.stringify(s, null, 2)));
        }
      } else return;
      a++;
    }
    return n ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: e.slice(0, e.length - i.length)
    };
  }
  switch (t.op) {
    case "|":
      for (var l, u = Qp(t.args), c; !(c = u()).done; ) {
        var f = c.value, p = sl(e, f, n);
        if (p) {
          if (p.overflow)
            return p;
          if (p.match)
            return {
              match: !0,
              matchedChars: p.matchedChars
            };
          if (p.partialMatch)
            l = !0;
          else
            throw new Error(`Unsupported match result:
`.concat(JSON.stringify(p, null, 2)));
        }
      }
      return l ? {
        partialMatch: !0
        // matchedChars: ...
      } : void 0;
    case "[]":
      for (var h = Qp(t.args), m; !(m = h()).done; ) {
        var v = m.value;
        if (e[0] === v)
          return e.length === 1 ? {
            match: !0,
            matchedChars: e
          } : n ? {
            overflow: !0
          } : {
            match: !0,
            matchedChars: [v]
          };
      }
      return;
    /* istanbul ignore next */
    default:
      throw new Error("Unsupported instruction tree: ".concat(t));
  }
}
function th(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = aS(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function aS(e, t) {
  if (e) {
    if (typeof e == "string") return nh(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return nh(e, t);
  }
}
function nh(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function oS(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function sS(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function lS(e, t, n) {
  return t && sS(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var ll = "9", uS = 15, cS = ea(ll, uS), dS = /[- ]/, fS = function() {
  return /\[([^\[\]])*\]/g;
}, pS = function() {
  return /\d(?=[^,}][^,}])/g;
}, hS = new RegExp("[" + Pt + "]*\\$1[" + Pt + "]*(\\$\\d[" + Pt + "]*)*$"), rh = 3, mS = /* @__PURE__ */ function() {
  function e(t) {
    t.state;
    var n = t.metadata;
    oS(this, e), this.metadata = n, this.resetFormat();
  }
  return lS(e, [{
    key: "resetFormat",
    value: function() {
      this.chosenFormat = void 0, this.template = void 0, this.nationalNumberTemplate = void 0, this.populatedNationalNumberTemplate = void 0, this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function(n, r) {
      this.resetFormat(), n ? (this.isNANP = n.callingCode() === "1", this.matchingFormats = n.formats(), r.nationalSignificantNumber && this.narrowDownMatchingFormats(r)) : (this.isNANP = void 0, this.matchingFormats = []);
    }
    /**
     * Formats an updated phone number.
     * @param  {string} nextDigits — Additional phone number digits.
     * @param  {object} state — `AsYouType` state.
     * @return {[string]} Returns undefined if the updated phone number can't be formatted using any of the available formats.
     */
  }, {
    key: "format",
    value: function(n, r) {
      var i = this;
      if (WC(r.nationalSignificantNumber, this.metadata))
        for (var a = th(this.matchingFormats), o; !(o = a()).done; ) {
          var s = o.value, l = KC(r, s, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function(c) {
              return i.shouldTryNationalPrefixFormattingRule(c, {
                international: r.international,
                nationalPrefix: r.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: function(c) {
              return i.getSeparatorAfterNationalPrefix(c);
            }
          });
          if (l)
            return this.resetFormat(), this.chosenFormat = s, this.setNationalNumberTemplate(l.replace(/\d/g, St), r), this.populatedNationalNumberTemplate = l, this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(St), l;
        }
      return this.formatNationalNumberWithNextDigits(n, r);
    }
    // Formats the next phone number digits.
  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function(n, r) {
      var i = this.chosenFormat, a = this.chooseFormat(r);
      if (a)
        return a === i ? this.formatNextNationalNumberDigits(n) : this.formatNextNationalNumberDigits(r.getNationalDigits());
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function(n) {
      var r = this, i = n.nationalSignificantNumber, a = n.nationalPrefix, o = n.international, s = i, l = s.length - rh;
      l < 0 && (l = 0), this.matchingFormats = this.matchingFormats.filter(function(u) {
        return r.formatSuits(u, o, a) && r.formatMatches(u, s, l);
      }), this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1 && this.resetFormat();
    }
  }, {
    key: "formatSuits",
    value: function(n, r, i) {
      return !(i && !n.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !n.nationalPrefixIsOptionalWhenFormattingInNationalFormat() || !r && !i && n.nationalPrefixIsMandatoryWhenFormattingInNationalFormat());
    }
  }, {
    key: "formatMatches",
    value: function(n, r, i) {
      var a = n.leadingDigitsPatterns().length;
      if (a === 0)
        return !0;
      i = Math.min(i, a - 1);
      var o = n.leadingDigitsPatterns()[i];
      if (r.length < rh)
        try {
          return new iS(o).match(r, {
            allowOverflow: !0
          }) !== void 0;
        } catch (s) {
          return console.error(s), !0;
        }
      return new RegExp("^(".concat(o, ")")).test(r);
    }
  }, {
    key: "getFormatFormat",
    value: function(n, r) {
      return r ? n.internationalFormat() : n.format();
    }
  }, {
    key: "chooseFormat",
    value: function(n) {
      for (var r = this, i = function() {
        var u = o.value;
        return r.chosenFormat === u ? "break" : hS.test(r.getFormatFormat(u, n.international)) ? r.createTemplateForFormat(u, n) ? (r.chosenFormat = u, "break") : (r.matchingFormats = r.matchingFormats.filter(function(c) {
          return c !== u;
        }), "continue") : "continue";
      }, a = th(this.matchingFormats.slice()), o; !(o = a()).done; ) {
        var s = i();
        if (s === "break") break;
      }
      return this.chosenFormat || this.resetFormat(), this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function(n, r) {
      if (!(n.pattern().indexOf("|") >= 0)) {
        var i = this.getTemplateForFormat(n, r);
        if (i)
          return this.setNationalNumberTemplate(i, r), !0;
      }
    }
  }, {
    key: "getSeparatorAfterNationalPrefix",
    value: function(n) {
      return this.isNANP || n && n.nationalPrefixFormattingRule() && dS.test(n.nationalPrefixFormattingRule()) ? " " : "";
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function(n, r) {
      var i = n.IDDPrefix, a = n.missingPlus;
      return i ? r && r.spacing === !1 ? i : i + " " : a ? "" : "+";
    }
  }, {
    key: "getTemplate",
    value: function(n) {
      if (this.template) {
        for (var r = -1, i = 0, a = n.international ? this.getInternationalPrefixBeforeCountryCallingCode(n, {
          spacing: !1
        }) : ""; i < a.length + n.getDigitsWithoutInternationalPrefix().length; )
          r = this.template.indexOf(St, r + 1), i++;
        return Zp(this.template, r + 1);
      }
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function(n, r) {
      this.nationalNumberTemplate = n, this.populatedNationalNumberTemplate = n, this.populatedNationalNumberTemplatePosition = -1, r.international ? this.template = this.getInternationalPrefixBeforeCountryCallingCode(r).replace(/[\d\+]/g, St) + ea(St, r.callingCode.length) + " " + n : this.template = n;
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */
  }, {
    key: "getTemplateForFormat",
    value: function(n, r) {
      var i = r.nationalSignificantNumber, a = r.international, o = r.nationalPrefix, s = r.complexPrefixBeforeNationalSignificantNumber, l = n.pattern();
      l = l.replace(fS(), "\\d").replace(pS(), "\\d");
      var u = cS.match(l)[0];
      if (!(i.length > u.length)) {
        var c = new RegExp("^" + l + "$"), f = i.replace(/\d/g, ll);
        c.test(f) && (u = f);
        var p = this.getFormatFormat(n, a), h;
        if (this.shouldTryNationalPrefixFormattingRule(n, {
          international: a,
          nationalPrefix: o
        })) {
          var m = p.replace(kv, n.nationalPrefixFormattingRule());
          if (Ia(n.nationalPrefixFormattingRule()) === (o || "") + Ia("$1") && (p = m, h = !0, o))
            for (var v = o.length; v > 0; )
              p = p.replace(/\d/, St), v--;
        }
        var g = u.replace(new RegExp(l), p).replace(new RegExp(ll, "g"), St);
        return h || (s ? g = ea(St, s.length) + " " + g : o && (g = ea(St, o.length) + this.getSeparatorAfterNationalPrefix(n) + g)), a && (g = Dv(g)), g;
      }
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function(n) {
      var r = HC(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, n);
      if (!r) {
        this.resetFormat();
        return;
      }
      return this.populatedNationalNumberTemplate = r[0], this.populatedNationalNumberTemplatePosition = r[1], Zp(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1);
    }
  }, {
    key: "shouldTryNationalPrefixFormattingRule",
    value: function(n, r) {
      var i = r.international, a = r.nationalPrefix;
      if (n.nationalPrefixFormattingRule()) {
        var o = n.usesNationalPrefix();
        if (o && a || !o && !i)
          return !0;
      }
    }
  }]), e;
}();
function Zv(e, t) {
  return bS(e) || yS(e, t) || vS(e, t) || gS();
}
function gS() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function vS(e, t) {
  if (e) {
    if (typeof e == "string") return ih(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ih(e, t);
  }
}
function ih(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function yS(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], i = !0, a = !1, o, s;
    try {
      for (n = n.call(e); !(i = (o = n.next()).done) && (r.push(o.value), !(t && r.length === t)); i = !0)
        ;
    } catch (l) {
      a = !0, s = l;
    } finally {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (a) throw s;
      }
    }
    return r;
  }
}
function bS(e) {
  if (Array.isArray(e)) return e;
}
function xS(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function $S(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function wS(e, t, n) {
  return t && $S(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var CS = "[" + Pt + at + "]+", SS = new RegExp("^" + CS + "$", "i"), IS = "(?:[" + io + "][" + Pt + at + "]*|[" + Pt + at + "]+)", ES = new RegExp("[^" + Pt + at + "]+.*$"), OS = /[^\d\[\]]/, TS = /* @__PURE__ */ function() {
  function e(t) {
    var n = t.defaultCountry, r = t.defaultCallingCode, i = t.metadata, a = t.onNationalSignificantNumberChange;
    xS(this, e), this.defaultCountry = n, this.defaultCallingCode = r, this.metadata = i, this.onNationalSignificantNumberChange = a;
  }
  return wS(e, [{
    key: "input",
    value: function(n, r) {
      var i = _S(n), a = Zv(i, 2), o = a[0], s = a[1], l = Ia(o), u;
      return s && (r.digits || (r.startInternationalNumber(), l || (u = !0))), l && this.inputDigits(l, r), {
        digits: l,
        justLeadingPlus: u
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */
  }, {
    key: "inputDigits",
    value: function(n, r) {
      var i = r.digits, a = i.length < 3 && i.length + n.length >= 3;
      if (r.appendDigits(n), a && this.extractIddPrefix(r), this.isWaitingForCountryCallingCode(r)) {
        if (!this.extractCountryCallingCode(r))
          return;
      } else
        r.appendNationalSignificantNumberDigits(n);
      r.international || this.hasExtractedNationalSignificantNumber || this.extractNationalSignificantNumber(r.getNationalDigits(), function(o) {
        return r.update(o);
      });
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function(n) {
      var r = n.international, i = n.callingCode;
      return r && !i;
    }
    // Extracts a country calling code from a number
    // being entered in internatonal format.
  }, {
    key: "extractCountryCallingCode",
    value: function(n) {
      var r = dc("+" + n.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), i = r.countryCallingCode, a = r.number;
      if (i)
        return n.setCallingCode(i), n.update({
          nationalSignificantNumber: a
        }), !0;
    }
  }, {
    key: "reset",
    value: function(n) {
      if (n) {
        this.hasSelectedNumberingPlan = !0;
        var r = n._nationalPrefixForParsing();
        this.couldPossiblyExtractAnotherNationalSignificantNumber = r && OS.test(r);
      } else
        this.hasSelectedNumberingPlan = void 0, this.couldPossiblyExtractAnotherNationalSignificantNumber = void 0;
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */
  }, {
    key: "extractNationalSignificantNumber",
    value: function(n, r) {
      if (this.hasSelectedNumberingPlan) {
        var i = el(n, this.metadata), a = i.nationalPrefix, o = i.nationalNumber, s = i.carrierCode;
        if (o !== n)
          return this.onExtractedNationalNumber(a, s, o, n, r), !0;
      }
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */
  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function(n, r, i) {
      if (!this.hasExtractedNationalSignificantNumber)
        return this.extractNationalSignificantNumber(n, i);
      if (this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        var a = el(n, this.metadata), o = a.nationalPrefix, s = a.nationalNumber, l = a.carrierCode;
        if (s !== r)
          return this.onExtractedNationalNumber(o, l, s, n, i), !0;
      }
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function(n, r, i, a, o) {
      var s, l, u = a.lastIndexOf(i);
      if (u >= 0 && u === a.length - i.length) {
        l = !0;
        var c = a.slice(0, u);
        c !== n && (s = c);
      }
      o({
        nationalPrefix: n,
        carrierCode: r,
        nationalSignificantNumber: i,
        nationalSignificantNumberMatchesInput: l,
        complexPrefixBeforeNationalSignificantNumber: s
      }), this.hasExtractedNationalSignificantNumber = !0, this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function(n) {
      if (this.extractAnotherNationalSignificantNumber(n.getNationalDigits(), n.nationalSignificantNumber, function(r) {
        return n.update(r);
      }))
        return !0;
      if (this.extractIddPrefix(n))
        return this.extractCallingCodeAndNationalSignificantNumber(n), !0;
      if (this.fixMissingPlus(n))
        return this.extractCallingCodeAndNationalSignificantNumber(n), !0;
    }
  }, {
    key: "extractIddPrefix",
    value: function(n) {
      var r = n.international, i = n.IDDPrefix, a = n.digits;
      if (n.nationalSignificantNumber, !(r || i)) {
        var o = Mv(a, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
        if (o !== void 0 && o !== a)
          return n.update({
            IDDPrefix: a.slice(0, a.length - o.length)
          }), this.startInternationalNumber(n, {
            country: void 0,
            callingCode: void 0
          }), !0;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function(n) {
      if (!n.international) {
        var r = jv(n.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), i = r.countryCallingCode;
        if (r.number, i)
          return n.update({
            missingPlus: !0
          }), this.startInternationalNumber(n, {
            country: n.country,
            callingCode: i
          }), !0;
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function(n, r) {
      var i = r.country, a = r.callingCode;
      n.startInternationalNumber(i, a), n.nationalSignificantNumber && (n.resetNationalSignificantNumber(), this.onNationalSignificantNumberChange(), this.hasExtractedNationalSignificantNumber = void 0);
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function(n) {
      this.extractCountryCallingCode(n) && this.extractNationalSignificantNumber(n.getNationalDigits(), function(r) {
        return n.update(r);
      });
    }
  }]), e;
}();
function PS(e) {
  var t = e.search(IS);
  if (!(t < 0)) {
    e = e.slice(t);
    var n;
    return e[0] === "+" && (n = !0, e = e.slice(1)), e = e.replace(ES, ""), n && (e = "+" + e), e;
  }
}
function NS(e) {
  var t = PS(e) || "";
  return t[0] === "+" ? [t.slice(1), !0] : [t];
}
function _S(e) {
  var t = NS(e), n = Zv(t, 2), r = n[0], i = n[1];
  return SS.test(r) || (r = ""), [r, i];
}
function AS(e, t) {
  return DS(e) || jS(e, t) || MS(e, t) || RS();
}
function RS() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function MS(e, t) {
  if (e) {
    if (typeof e == "string") return ah(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ah(e, t);
  }
}
function ah(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function jS(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], i = !0, a = !1, o, s;
    try {
      for (n = n.call(e); !(i = (o = n.next()).done) && (r.push(o.value), !(t && r.length === t)); i = !0)
        ;
    } catch (l) {
      a = !0, s = l;
    } finally {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (a) throw s;
      }
    }
    return r;
  }
}
function DS(e) {
  if (Array.isArray(e)) return e;
}
function kS(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function LS(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function FS(e, t, n) {
  return t && LS(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var wr = /* @__PURE__ */ function() {
  function e(t, n) {
    kS(this, e), this.metadata = new qe(n);
    var r = this.getCountryAndCallingCode(t), i = AS(r, 2), a = i[0], o = i[1];
    this.defaultCountry = a, this.defaultCallingCode = o, this.reset();
  }
  return FS(e, [{
    key: "getCountryAndCallingCode",
    value: function(n) {
      var r, i;
      return n && (_n(n) ? (r = n.defaultCountry, i = n.defaultCallingCode) : r = n), r && !this.metadata.hasCountry(r) && (r = void 0), [r, i];
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */
  }, {
    key: "input",
    value: function(n) {
      var r = this.parser.input(n, this.state), i = r.digits, a = r.justLeadingPlus;
      if (a)
        this.formattedOutput = "+";
      else if (i) {
        this.determineTheCountryIfNeeded(), this.state.nationalSignificantNumber && this.formatter.narrowDownMatchingFormats(this.state);
        var o;
        if (this.metadata.hasSelectedNumberingPlan() && (o = this.formatter.format(i, this.state)), o === void 0 && this.parser.reExtractNationalSignificantNumber(this.state)) {
          this.determineTheCountryIfNeeded();
          var s = this.state.getNationalDigits();
          s && (o = this.formatter.format(s, this.state));
        }
        this.formattedOutput = o ? this.getFullNumber(o) : this.getNonFormattedNumber();
      }
      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function() {
      var n = this;
      return this.state = new LC({
        onCountryChange: function(i) {
          n.country = i;
        },
        onCallingCodeChange: function(i, a) {
          n.metadata.selectNumberingPlan(a, i), n.formatter.reset(n.metadata.numberingPlan, n.state), n.parser.reset(n.metadata.numberingPlan);
        }
      }), this.formatter = new mS({
        state: this.state,
        metadata: this.metadata
      }), this.parser = new TS({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function() {
          n.determineTheCountryIfNeeded(), n.formatter.reset(n.metadata.numberingPlan, n.state);
        }
      }), this.state.reset({
        country: this.defaultCountry,
        callingCode: this.defaultCallingCode
      }), this.formattedOutput = "", this;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */
  }, {
    key: "isInternational",
    value: function() {
      return this.state.international;
    }
    /**
     * Returns the "calling code" part of the phone number when it's being input
     * in an international format.
     * If no valid calling code has been entered so far, returns `undefined`.
     * @return {string} [callingCode]
     */
  }, {
    key: "getCallingCode",
    value: function() {
      if (this.isInternational())
        return this.state.callingCode;
    }
    // A legacy alias.
  }, {
    key: "getCountryCallingCode",
    value: function() {
      return this.getCallingCode();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */
  }, {
    key: "getCountry",
    value: function() {
      var n = this.state.digits;
      if (n)
        return this._getCountry();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * @return {string} [country]
     */
  }, {
    key: "_getCountry",
    value: function() {
      var n = this.state.country;
      return n;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function() {
      (!this.state.country || this.isCountryCallingCodeAmbiguous()) && this.determineTheCountry();
    }
    // Prepends `+CountryCode ` in case of an international phone number
  }, {
    key: "getFullNumber",
    value: function(n) {
      var r = this;
      if (this.isInternational()) {
        var i = function(s) {
          return r.formatter.getInternationalPrefixBeforeCountryCallingCode(r.state, {
            spacing: !!s
          }) + s;
        }, a = this.state.callingCode;
        return i(a ? n ? "".concat(a, " ").concat(n) : a : "".concat(this.state.getDigitsWithoutInternationalPrefix()));
      }
      return n;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function() {
      var n = this.state, r = n.nationalSignificantNumber, i = n.complexPrefixBeforeNationalSignificantNumber, a = n.nationalPrefix, o = r, s = i || a;
      return s && (o = s + o), o;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function() {
      var n = this.state.nationalSignificantNumberMatchesInput;
      return this.getFullNumber(n ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function() {
      var n = this.getNonFormattedNumber();
      if (n)
        return n.replace(/[\+\d]/g, St);
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function() {
      var n = this.state.callingCode, r = this.metadata.getCountryCodesForCallingCode(n);
      return r && r.length > 1;
    }
    // Determines the country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.
  }, {
    key: "determineTheCountry",
    value: function() {
      this.state.setCountry(Gv(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
        nationalNumber: this.state.nationalSignificantNumber,
        defaultCountry: this.defaultCountry,
        metadata: this.metadata
      }));
    }
    /**
     * Returns a E.164 phone number value for the user's input.
     *
     * For example, for country `"US"` and input `"(222) 333-4444"`
     * it will return `"+12223334444"`.
     *
     * For international phone number input, it will also auto-correct
     * some minor errors such as using a national prefix when writing
     * an international phone number. For example, if the user inputs
     * `"+44 0 7400 000000"` then it will return an auto-corrected
     * `"+447400000000"` phone number value.
     *
     * Will return `undefined` if no digits have been input,
     * or when inputting a phone number in national format and no
     * default country or default "country calling code" have been set.
     *
     * @return {string} [value]
     */
  }, {
    key: "getNumberValue",
    value: function() {
      var n = this.state, r = n.digits, i = n.callingCode, a = n.country, o = n.nationalSignificantNumber;
      if (r) {
        if (this.isInternational())
          return i ? "+" + i + o : "+" + r;
        if (a || i) {
          var s = a ? this.metadata.countryCallingCode() : i;
          return "+" + s + o;
        }
      }
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */
  }, {
    key: "getNumber",
    value: function() {
      var n = this.state, r = n.nationalSignificantNumber, i = n.carrierCode, a = n.callingCode, o = this._getCountry();
      if (r && !(!o && !a)) {
        if (o && o === this.defaultCountry) {
          var s = new qe(this.metadata.metadata);
          s.selectNumberingPlan(o);
          var l = s.numberingPlan.callingCode(), u = this.metadata.getCountryCodesForCallingCode(l);
          if (u.length > 1) {
            var c = zv(r, {
              countries: u,
              defaultCountry: this.defaultCountry,
              metadata: this.metadata.metadata
            });
            c && (o = c);
          }
        }
        var f = new Vv(o || a, r, this.metadata.metadata);
        return i && (f.carrierCode = i), f;
      }
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */
  }, {
    key: "isPossible",
    value: function() {
      var n = this.getNumber();
      return n ? n.isPossible() : !1;
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */
  }, {
    key: "isValid",
    value: function() {
      var n = this.getNumber();
      return n ? n.isValid() : !1;
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */
  }, {
    key: "getNationalNumber",
    value: function() {
      return this.state.nationalSignificantNumber;
    }
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */
  }, {
    key: "getChars",
    value: function() {
      return (this.state.international ? "+" : "") + this.state.digits;
    }
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */
  }, {
    key: "getTemplate",
    value: function() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || "";
    }
  }]), e;
}();
function oh(e) {
  return new qe(e).getCountries();
}
function VS(e, t, n) {
  return n || (n = t, t = void 0), new wr(t, n).input(e);
}
function Jv(e) {
  var t = e.inputFormat, n = e.country, r = e.metadata;
  return t === "NATIONAL_PART_OF_INTERNATIONAL" ? "+".concat(an(n, r)) : "";
}
function ul(e, t) {
  return t && (e = e.slice(t.length), e[0] === " " && (e = e.slice(1))), e;
}
function BS(e, t, n) {
  if (!(n && n.ignoreRest)) {
    var r = function(a) {
      if (n)
        switch (a) {
          case "end":
            n.ignoreRest = !0;
            break;
        }
    };
    return Wv(e, t, r);
  }
}
function Qv(e) {
  var t = e.onKeyDown, n = e.inputFormat;
  return ge(function(r) {
    if (r.keyCode === KS && n === "INTERNATIONAL" && r.target instanceof HTMLInputElement && HS(r.target) === WS.length) {
      r.preventDefault();
      return;
    }
    t && t(r);
  }, [t, n]);
}
function HS(e) {
  return e.selectionStart;
}
var KS = 8, WS = "+", zS = ["onKeyDown", "country", "inputFormat", "metadata", "international", "withCountryCallingCode"];
function cl() {
  return cl = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, cl.apply(this, arguments);
}
function GS(e, t) {
  if (e == null) return {};
  var n = US(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function US(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function qS(e) {
  function t(n, r) {
    var i = n.onKeyDown, a = n.country, o = n.inputFormat, s = n.metadata, l = s === void 0 ? e : s;
    n.international, n.withCountryCallingCode;
    var u = GS(n, zS), c = ge(function(p) {
      var h = new wr(a, l), m = Jv({
        inputFormat: o,
        country: a,
        metadata: l
      }), v = h.input(m + p), g = h.getTemplate();
      return m && (v = ul(v, m), g && (g = ul(g, m))), {
        text: v,
        template: g
      };
    }, [a, l]), f = Qv({
      onKeyDown: i,
      inputFormat: o
    });
    return /* @__PURE__ */ te.createElement(Ca, cl({}, u, {
      ref: r,
      parse: BS,
      format: c,
      onKeyDown: f
    }));
  }
  return t = /* @__PURE__ */ te.forwardRef(t), t.propTypes = {
    /**
     * The parsed phone number.
     * "Parsed" not in a sense of "E.164"
     * but rather in a sense of "having only
     * digits and possibly a leading plus character".
     * Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */
    value: R.string.isRequired,
    /**
     * A function of `value: string`.
     * Updates the `value` property.
     */
    onChange: R.func.isRequired,
    /**
     * A function of `event: Event`.
     * Handles `keydown` events.
     */
    onKeyDown: R.func,
    /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * This property should've been called `defaultCountry`
     * because it only applies when the user inputs a phone number in a national format
     * and is completely ignored when the user inputs a phone number in an international format.
     */
    country: R.string,
    /**
     * The format that the input field value is being input/output in.
     */
    inputFormat: R.oneOf(["INTERNATIONAL", "NATIONAL_PART_OF_INTERNATIONAL", "NATIONAL", "INTERNATIONAL_OR_NATIONAL"]).isRequired,
    /**
     * `libphonenumber-js` metadata.
     */
    metadata: R.object
  }, t;
}
const YS = qS();
var XS = ["value", "onChange", "onKeyDown", "country", "inputFormat", "metadata", "inputComponent", "international", "withCountryCallingCode"];
function dl() {
  return dl = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, dl.apply(this, arguments);
}
function ZS(e, t) {
  if (e == null) return {};
  var n = JS(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function JS(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function QS(e) {
  function t(n, r) {
    var i = n.value, a = n.onChange, o = n.onKeyDown, s = n.country, l = n.inputFormat, u = n.metadata, c = u === void 0 ? e : u, f = n.inputComponent, p = f === void 0 ? "input" : f;
    n.international, n.withCountryCallingCode;
    var h = ZS(n, XS), m = Jv({
      inputFormat: l,
      country: s,
      metadata: c
    }), v = ge(function(b) {
      var y = il(b.target.value);
      if (y === i) {
        var x = sh(m, y, s, c);
        x.indexOf(b.target.value) === 0 && (y = y.slice(0, -1));
      }
      a(y);
    }, [m, i, a, s, c]), g = Qv({
      onKeyDown: o,
      inputFormat: l
    });
    return /* @__PURE__ */ te.createElement(p, dl({}, h, {
      ref: r,
      value: sh(m, i, s, c),
      onChange: v,
      onKeyDown: g
    }));
  }
  return t = /* @__PURE__ */ te.forwardRef(t), t.propTypes = {
    /**
     * The parsed phone number.
     * "Parsed" not in a sense of "E.164"
     * but rather in a sense of "having only
     * digits and possibly a leading plus character".
     * Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */
    value: R.string.isRequired,
    /**
     * A function of `value: string`.
     * Updates the `value` property.
     */
    onChange: R.func.isRequired,
    /**
     * A function of `event: Event`.
     * Handles `keydown` events.
     */
    onKeyDown: R.func,
    /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * This property should've been called `defaultCountry`
     * because it only applies when the user inputs a phone number in a national format
     * and is completely ignored when the user inputs a phone number in an international format.
     */
    country: R.string,
    /**
     * The format that the input field value is being input/output in.
     */
    inputFormat: R.oneOf(["INTERNATIONAL", "NATIONAL_PART_OF_INTERNATIONAL", "NATIONAL", "INTERNATIONAL_OR_NATIONAL"]).isRequired,
    /**
     * `libphonenumber-js` metadata.
     */
    metadata: R.object,
    /**
     * The `<input/>` component.
     */
    inputComponent: R.elementType
  }, t;
}
const eI = QS();
function sh(e, t, n, r) {
  return ul(VS(e + t, n, r), e);
}
function tI(e) {
  return lh(e[0]) + lh(e[1]);
}
function lh(e) {
  return String.fromCodePoint(127397 + e.toUpperCase().charCodeAt(0));
}
var nI = ["value", "onChange", "options", "disabled", "readOnly"], rI = ["value", "options", "className", "iconComponent", "getIconAspectRatio", "arrowComponent", "unicodeFlags"];
function iI(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = aI(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function aI(e, t) {
  if (e) {
    if (typeof e == "string") return uh(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return uh(e, t);
  }
}
function uh(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Ea() {
  return Ea = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ea.apply(this, arguments);
}
function e1(e, t) {
  if (e == null) return {};
  var n = oI(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function oI(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function t1(e) {
  var t = e.value, n = e.onChange, r = e.options, i = e.disabled, a = e.readOnly, o = e1(e, nI), s = ge(function(l) {
    var u = l.target.value;
    n(u === "ZZ" ? void 0 : u);
  }, [n]);
  return _t(function() {
    return r1(r, t);
  }, [r, t]), /* @__PURE__ */ te.createElement("select", Ea({}, o, {
    disabled: i || a,
    readOnly: a,
    value: t || "ZZ",
    onChange: s
  }), r.map(function(l) {
    var u = l.value, c = l.label, f = l.divider;
    return /* @__PURE__ */ te.createElement("option", {
      key: f ? "|" : u || "ZZ",
      value: f ? "|" : u || "ZZ",
      disabled: !!f,
      style: f ? sI : void 0
    }, c);
  }));
}
t1.propTypes = {
  /**
   * A two-letter country code.
   * Example: "US", "RU", etc.
   */
  value: R.string,
  /**
   * A function of `value: string`.
   * Updates the `value` property.
   */
  onChange: R.func.isRequired,
  // `<select/>` options.
  options: R.arrayOf(R.shape({
    value: R.string,
    label: R.string,
    divider: R.bool
  })).isRequired,
  // `readonly` attribute doesn't work on a `<select/>`.
  // https://github.com/catamphetamine/react-phone-number-input/issues/419#issuecomment-1764384480
  // https://www.delftstack.com/howto/html/html-select-readonly/
  // To work around that, if `readOnly: true` property is passed
  // to this component, it behaves analogous to `disabled: true`.
  disabled: R.bool,
  readOnly: R.bool
};
var sI = {
  fontSize: "1px",
  backgroundColor: "currentColor",
  color: "inherit"
};
function n1(e) {
  var t = e.value, n = e.options, r = e.className, i = e.iconComponent;
  e.getIconAspectRatio;
  var a = e.arrowComponent, o = a === void 0 ? lI : a, s = e.unicodeFlags, l = e1(e, rI), u = _t(function() {
    return r1(n, t);
  }, [n, t]);
  return /* @__PURE__ */ te.createElement("div", {
    className: "PhoneInputCountry"
  }, /* @__PURE__ */ te.createElement(t1, Ea({}, l, {
    value: t,
    options: n,
    className: wa("PhoneInputCountrySelect", r)
  })), u && (s && t ? /* @__PURE__ */ te.createElement("div", {
    className: "PhoneInputCountryIconUnicode"
  }, tI(t)) : /* @__PURE__ */ te.createElement(i, {
    "aria-hidden": !0,
    country: t,
    label: u.label,
    aspectRatio: s ? 1 : void 0
  })), /* @__PURE__ */ te.createElement(o, null));
}
n1.propTypes = {
  // Country flag component.
  iconComponent: R.elementType,
  // Select arrow component.
  arrowComponent: R.elementType,
  // Set to `true` to render Unicode flag icons instead of SVG images.
  unicodeFlags: R.bool
};
function lI() {
  return /* @__PURE__ */ te.createElement("div", {
    className: "PhoneInputCountrySelectArrow"
  });
}
function r1(e, t) {
  for (var n = iI(e), r; !(r = n()).done; ) {
    var i = r.value;
    if (!i.divider && uI(i.value, t))
      return i;
  }
}
function uI(e, t) {
  return e == null ? t == null : e === t;
}
var cI = ["country", "countryName", "flags", "flagUrl"];
function fl() {
  return fl = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, fl.apply(this, arguments);
}
function dI(e, t) {
  if (e == null) return {};
  var n = fI(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function fI(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function fc(e) {
  var t = e.country, n = e.countryName, r = e.flags, i = e.flagUrl, a = dI(e, cI);
  return r && r[t] ? r[t]({
    title: n
  }) : /* @__PURE__ */ te.createElement("img", fl({}, a, {
    alt: n,
    role: n ? void 0 : "presentation",
    src: i.replace("{XX}", t).replace("{xx}", t.toLowerCase())
  }));
}
fc.propTypes = {
  // The country to be selected by default.
  // Two-letter country code ("ISO 3166-1 alpha-2").
  country: R.string.isRequired,
  // Will be HTML `title` attribute of the `<img/>`.
  countryName: R.string.isRequired,
  // Country flag icon components.
  // By default flag icons are inserted as `<img/>`s
  // with their `src` pointed to `country-flag-icons` gitlab pages website.
  // There might be cases (e.g. an offline application)
  // where having a large (3 megabyte) `<svg/>` flags
  // bundle is more appropriate.
  // `import flags from 'react-phone-number-input/flags'`.
  flags: R.objectOf(R.elementType),
  // A URL for a country flag icon.
  // By default it points to `country-flag-icons` gitlab pages website.
  flagUrl: R.string.isRequired
};
var pI = ["aspectRatio"], hI = ["title"], mI = ["title"];
function Oa() {
  return Oa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Oa.apply(this, arguments);
}
function pc(e, t) {
  if (e == null) return {};
  var n = gI(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function gI(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function ao(e) {
  var t = e.aspectRatio, n = pc(e, pI);
  return t === 1 ? /* @__PURE__ */ te.createElement(a1, n) : /* @__PURE__ */ te.createElement(i1, n);
}
ao.propTypes = {
  title: R.string.isRequired,
  aspectRatio: R.number
};
function i1(e) {
  var t = e.title, n = pc(e, hI);
  return /* @__PURE__ */ te.createElement("svg", Oa({}, n, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 50"
  }), /* @__PURE__ */ te.createElement("title", null, t), /* @__PURE__ */ te.createElement("g", {
    className: "PhoneInputInternationalIconGlobe",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "2",
    strokeMiterlimit: "10"
  }, /* @__PURE__ */ te.createElement("path", {
    strokeLinecap: "round",
    d: "M47.2,36.1C48.1,36,49,36,50,36c7.4,0,14,1.7,18.5,4.3"
  }), /* @__PURE__ */ te.createElement("path", {
    d: "M68.6,9.6C64.2,12.3,57.5,14,50,14c-7.4,0-14-1.7-18.5-4.3"
  }), /* @__PURE__ */ te.createElement("line", {
    x1: "26",
    y1: "25",
    x2: "74",
    y2: "25"
  }), /* @__PURE__ */ te.createElement("line", {
    x1: "50",
    y1: "1",
    x2: "50",
    y2: "49"
  }), /* @__PURE__ */ te.createElement("path", {
    strokeLinecap: "round",
    d: "M46.3,48.7c1.2,0.2,2.5,0.3,3.7,0.3c13.3,0,24-10.7,24-24S63.3,1,50,1S26,11.7,26,25c0,2,0.3,3.9,0.7,5.8"
  }), /* @__PURE__ */ te.createElement("path", {
    strokeLinecap: "round",
    d: "M46.8,48.2c1,0.6,2.1,0.8,3.2,0.8c6.6,0,12-10.7,12-24S56.6,1,50,1S38,11.7,38,25c0,1.4,0.1,2.7,0.2,4c0,0.1,0,0.2,0,0.2"
  })), /* @__PURE__ */ te.createElement("path", {
    className: "PhoneInputInternationalIconPhone",
    stroke: "none",
    fill: "currentColor",
    d: "M12.4,17.9c2.9-2.9,5.4-4.8,0.3-11.2S4.1,5.2,1.3,8.1C-2,11.4,1.1,23.5,13.1,35.6s24.3,15.2,27.5,11.9c2.8-2.8,7.8-6.3,1.4-11.5s-8.3-2.6-11.2,0.3c-2,2-7.2-2.2-11.7-6.7S10.4,19.9,12.4,17.9z"
  }));
}
i1.propTypes = {
  title: R.string.isRequired
};
function a1(e) {
  var t = e.title, n = pc(e, mI);
  return /* @__PURE__ */ te.createElement("svg", Oa({}, n, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }), /* @__PURE__ */ te.createElement("title", null, t), /* @__PURE__ */ te.createElement("g", {
    className: "PhoneInputInternationalIconGlobe",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "2",
    strokeLinecap: "round"
  }, /* @__PURE__ */ te.createElement("path", {
    d: "M8.45,13A21.44,21.44,0,1,1,37.08,41.56"
  }), /* @__PURE__ */ te.createElement("path", {
    d: "M19.36,35.47a36.9,36.9,0,0,1-2.28-13.24C17.08,10.39,21.88.85,27.8.85s10.72,9.54,10.72,21.38c0,6.48-1.44,12.28-3.71,16.21"
  }), /* @__PURE__ */ te.createElement("path", {
    d: "M17.41,33.4A39,39,0,0,1,27.8,32.06c6.62,0,12.55,1.5,16.48,3.86"
  }), /* @__PURE__ */ te.createElement("path", {
    d: "M44.29,8.53c-3.93,2.37-9.86,3.88-16.49,3.88S15.25,10.9,11.31,8.54"
  }), /* @__PURE__ */ te.createElement("line", {
    x1: "27.8",
    y1: "0.85",
    x2: "27.8",
    y2: "34.61"
  }), /* @__PURE__ */ te.createElement("line", {
    x1: "15.2",
    y1: "22.23",
    x2: "49.15",
    y2: "22.23"
  })), /* @__PURE__ */ te.createElement("path", {
    className: "PhoneInputInternationalIconPhone",
    stroke: "transparent",
    fill: "currentColor",
    d: "M9.42,26.64c2.22-2.22,4.15-3.59.22-8.49S3.08,17,.93,19.17c-2.49,2.48-.13,11.74,9,20.89s18.41,11.5,20.89,9c2.15-2.15,5.91-4.77,1-8.71s-6.27-2-8.49.22c-1.55,1.55-5.48-1.69-8.86-5.08S7.87,28.19,9.42,26.64Z"
  }));
}
a1.propTypes = {
  title: R.string.isRequired
};
function vI(e) {
  if (e.length < 2 || e[0] !== "+")
    return !1;
  for (var t = 1; t < e.length; ) {
    var n = e.charCodeAt(t);
    if (!(n >= 48 && n <= 57)) return !1;
    t++;
  }
  return !0;
}
function o1(e) {
  vI(e) || console.error("[react-phone-number-input] Expected the initial `value` to be a E.164 phone number. Got", e);
}
function yI(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = bI(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function bI(e, t) {
  if (e) {
    if (typeof e == "string") return ch(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ch(e, t);
  }
}
function ch(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function xI(e, t) {
  if (!t)
    return e;
  for (var n = [], r = [], i = n, a = function() {
    var u = s.value;
    if (u === "|")
      i.push({
        divider: !0
      });
    else if (u === "..." || u === "…")
      i = r;
    else {
      var c;
      u === "🌐" ? c = void 0 : c = u;
      var f = e.indexOf(e.filter(function(h) {
        return h.value === c;
      })[0]), p = e[f];
      e.splice(f, 1), i.push(p);
    }
  }, o = yI(t), s; !(s = o()).done; )
    a();
  return n.concat(e).concat(r);
}
function $I(e, t) {
  if (e && (e = e.filter(function(n) {
    switch (n) {
      case "🌐":
      case "|":
      case "...":
      case "…":
        return !0;
      default:
        return oo(n, t);
    }
  }), e.length > 0))
    return e;
}
function oo(e, t) {
  return _v(e, t) ? !0 : (console.error("Country not found: ".concat(e)), !1);
}
function s1(e, t) {
  return e && (e = e.filter(function(n) {
    return oo(n, t);
  }), e.length === 0 && (e = void 0)), e;
}
var wI = ["country", "label", "aspectRatio"];
function pl() {
  return pl = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, pl.apply(this, arguments);
}
function CI(e, t) {
  if (e == null) return {};
  var n = SI(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function SI(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function l1(e) {
  var t = e.flags, n = e.flagUrl, r = e.flagComponent, i = e.internationalIcon;
  function a(o) {
    var s = o.country, l = o.label, u = o.aspectRatio, c = CI(o, wI), f = i === ao ? u : void 0;
    return /* @__PURE__ */ te.createElement("div", pl({}, c, {
      className: wa("PhoneInputCountryIcon", {
        "PhoneInputCountryIcon--square": f === 1,
        "PhoneInputCountryIcon--border": s
      })
    }), s ? /* @__PURE__ */ te.createElement(r, {
      country: s,
      countryName: l,
      flags: t,
      flagUrl: n,
      className: "PhoneInputCountryIconImg"
    }) : /* @__PURE__ */ te.createElement(i, {
      title: l,
      aspectRatio: f,
      className: "PhoneInputCountryIconImg"
    }));
  }
  return a.propTypes = {
    country: R.string,
    label: R.string.isRequired,
    aspectRatio: R.number
  }, a;
}
l1({
  // Must be equal to `defaultProps.flagUrl` in `./PhoneInputWithCountry.js`.
  flagUrl: "https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg",
  flagComponent: fc,
  internationalIcon: ao
});
function II(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = EI(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function EI(e, t) {
  if (e) {
    if (typeof e == "string") return dh(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return dh(e, t);
  }
}
function dh(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function OI(e, t) {
  for (var n = II(e), r; !(r = n()).done; ) {
    var i = r.value;
    i && TI(i, t);
  }
}
function TI(e, t) {
  typeof e == "function" ? e(t) : e.current = t;
}
var u1 = R.shape({
  country_calling_codes: R.object.isRequired,
  countries: R.object.isRequired
}), c1 = R.objectOf(R.string);
function Zt(e, t) {
  var n = "+" + an(e, t);
  return n;
}
function PI(e) {
  var t = e.value, n = e.phoneNumber, r = e.defaultCountry, i = e.getAnyCountry, a = e.countries, o = e.required, s = e.metadata, l;
  return n && n.country ? l = n.country : r && (!t || tr(t, r, s)) && (l = r), a && a.indexOf(l) < 0 && (l = void 0), !l && o && a && a.length > 0 && (l = i()), l;
}
function NI(e) {
  var t = e.countries, n = e.countryNames, r = e.addInternationalOption, i = e.compareStringsLocales, a = e.compareStrings;
  a || (a = kI);
  var o = t.map(function(s) {
    return {
      value: s,
      // All `locale` country names included in this library
      // include all countries (this is checked at build time).
      // The only case when a country name might be missing
      // is when a developer supplies their own `labels` property.
      // To guard against such cases, a missing country name
      // is substituted by country code.
      label: n[s] || s
    };
  });
  return o.sort(function(s, l) {
    return a(s.label, l.label, i);
  }), r && o.unshift({
    label: n.ZZ
  }), o;
}
function d1(e, t) {
  return Xv(e || "", t);
}
function _I(e) {
  return e.formatNational().replace(/\D/g, "");
}
function AI(e, t) {
  var n = t.prevCountry, r = t.newCountry, i = t.metadata, a = t.useNationalFormat;
  if (n === r)
    return e;
  if (!e)
    return a ? "" : r ? Zt(r, i) : "";
  if (r) {
    if (e[0] === "+") {
      if (a)
        return e.indexOf("+" + an(r, i)) === 0 ? LI(e, r, i) : "";
      if (n) {
        var o = Zt(r, i);
        return e.indexOf(o) === 0 ? e : o;
      } else {
        var s = Zt(r, i);
        return e.indexOf(s) === 0 ? e : s;
      }
    }
  } else if (e[0] !== "+")
    return Zn(e, n, i) || "";
  return e;
}
function Zn(e, t, n) {
  if (e) {
    if (e[0] === "+") {
      if (e === "+")
        return;
      var r = new wr(t, n);
      return r.input(e), r.getNumberValue();
    }
    if (t) {
      var i = p1(e, t, n);
      return "+".concat(an(t, n)).concat(i || "");
    }
  }
}
function RI(e, t, n) {
  var r = p1(e, t, n);
  if (r) {
    var i = r.length - MI(t, n);
    if (i > 0)
      return e.slice(0, e.length - i);
  }
  return e;
}
function MI(e, t) {
  return t = new qe(t), t.selectNumberingPlan(e), t.numberingPlan.possibleLengths()[t.numberingPlan.possibleLengths().length - 1];
}
function f1(e, t) {
  var n = t.country, r = t.countries, i = t.defaultCountry, a = t.latestCountrySelectedByUser, o = t.required, s = t.metadata;
  if (e === "+")
    return n;
  var l = DI(e, s);
  if (l)
    return !r || r.indexOf(l) >= 0 ? l : void 0;
  if (n) {
    if (tr(e, n, s)) {
      if (a && tr(e, a, s))
        return a;
      if (i && tr(e, i, s))
        return i;
      if (!o)
        return;
    } else if (!o)
      return;
  }
  return n;
}
function jI(e, t) {
  var n = t.prevPhoneDigits, r = t.country, i = t.defaultCountry, a = t.latestCountrySelectedByUser, o = t.countryRequired, s = t.getAnyCountry, l = t.countries, u = t.international, c = t.limitMaxLength, f = t.countryCallingCodeEditable, p = t.metadata;
  if (u && f === !1 && r) {
    var h = Zt(r, p);
    if (e.indexOf(h) !== 0) {
      var m, v = e && e[0] !== "+";
      return v ? (e = h + e, m = Zn(e, r, p)) : e = h, {
        phoneDigits: e,
        value: m,
        country: r
      };
    }
  }
  u === !1 && r && e && e[0] === "+" && (e = fh(e, r, p)), e && r && c && (e = RI(e, r, p)), e && e[0] !== "+" && (!r || u) && (e = "+" + e), !e && n && n[0] === "+" && (u ? r = void 0 : r = i), e === "+" && n && n[0] === "+" && n.length > 1 && (r = void 0);
  var g;
  return e && (e[0] === "+" && (e === "+" || r && Zt(r, p).indexOf(e) === 0) ? g = void 0 : g = Zn(e, r, p)), g && (r = f1(g, {
    country: r,
    countries: l,
    defaultCountry: i,
    latestCountrySelectedByUser: a,
    // `countryRequired` flag is not passed here.
    // Instead, it's explicitly checked a bit later in the code.
    required: !1,
    metadata: p
  }), u === !1 && r && e && e[0] === "+" && (e = fh(e, r, p), g = Zn(e, r, p))), !r && o && (r = i || s()), {
    // `phoneDigits` returned here are a "normalized" version of the original `phoneDigits`.
    // The returned `phoneDigits` shouldn't be used anywhere except for passing it as
    // `prevPhoneDigits` parameter to this same function on next input change event.
    phoneDigits: e,
    country: r,
    value: g
  };
}
function fh(e, t, n) {
  if (e.indexOf(Zt(t, n)) === 0) {
    var r = new wr(t, n);
    r.input(e);
    var i = r.getNumber();
    return i ? i.formatNational().replace(/\D/g, "") : "";
  } else
    return e.replace(/\D/g, "");
}
function DI(e, t) {
  var n = new wr(null, t);
  return n.input(e), n.getCountry();
}
function kI(e, t, n) {
  return String.prototype.localeCompare ? e.localeCompare(t, n) : e < t ? -1 : e > t ? 1 : 0;
}
function LI(e, t, n) {
  if (t) {
    var r = "+" + an(t, n);
    if (e.length < r.length) {
      if (r.indexOf(e) === 0)
        return "";
    } else if (e.indexOf(r) === 0)
      return e.slice(r.length);
  }
  for (var i = 0, a = Object.keys(n.country_calling_codes); i < a.length; i++) {
    var o = a[i];
    if (e.indexOf(o) === 1)
      return e.slice(1 + o.length);
  }
  return "";
}
function p1(e, t, n) {
  var r = new wr(t, n);
  r.input(e);
  var i = r.getNumber();
  return i && i.nationalNumber;
}
function tr(e, t, n) {
  for (var r = Zt(t, n), i = 0; i < e.length && i < r.length; ) {
    if (e[i] !== r[i])
      return !1;
    i++;
  }
  return !0;
}
function h1(e) {
  var t = e.value, n = e.phoneNumber, r = e.defaultCountry, i = e.international, a = e.useNationalFormat, o = e.metadata;
  return (i === !1 || a) && n && n.country ? _I(n) : !t && i && r ? Zt(r, o) : t;
}
function si(e) {
  "@babel/helpers - typeof";
  return si = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, si(e);
}
function ph(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Hi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ph(Object(n), !0).forEach(function(r) {
      FI(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ph(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function FI(e, t, n) {
  return t = VI(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function VI(e) {
  var t = BI(e, "string");
  return si(t) == "symbol" ? t : t + "";
}
function BI(e, t) {
  if (si(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (si(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function HI(e, t, n) {
  var r = e.metadata, i = e.countries, a = e.defaultCountry, o = e.value, s = e.reset, l = e.international, u = e.displayInitialValueAsLocalNumber, c = e.initialValueFormat, f = t.defaultCountry, p = t.value, h = t.reset;
  n.country;
  var m = n.value, v = n.hasUserSelectedACountry, g = n.latestCountrySelectedByUser, b = function(L) {
    return h1(Hi(Hi({}, L), {}, {
      international: l,
      useNationalFormat: u || c === "national",
      metadata: r
    }));
  };
  if (s !== h)
    return {
      phoneDigits: b({
        value: void 0,
        defaultCountry: a
      }),
      value: void 0,
      country: a,
      latestCountrySelectedByUser: void 0,
      hasUserSelectedACountry: void 0
    };
  if (a !== f) {
    var y = !a || oo(a, r), x = (
      // By default, "no value has been entered" means `value` is `undefined`.
      !m || // When `international` is `true`, and some country has been pre-selected,
      // then the `<input/>` contains a pre-filled value of `+${countryCallingCode}${leadingDigits}`,
      // so in case of `international` being `true`, "the user hasn't entered anything" situation
      // doesn't just mean `value` is `undefined`, but could also mean `value` is `+${countryCallingCode}`.
      l && m === b({
        value: void 0,
        defaultCountry: f
      })
    ), w = !o && x;
    if (!v && y && w)
      return {
        country: a,
        // If `phoneDigits` is empty, then automatically select the new `country`
        // and set `phoneDigits` to `+{getCountryCallingCode(newCountry)}`.
        // The code assumes that "no phone number has been entered by the user",
        // and no `value` property has been passed, so the `phoneNumber` parameter
        // of `_getInitialPhoneDigits({ value, phoneNumber, ... })` is `undefined`.
        phoneDigits: b({
          value: void 0,
          defaultCountry: a
        }),
        // `value` is `undefined` and it stays so.
        value: void 0
      };
  }
  if (!hh(o, p) && !hh(o, m)) {
    var $, C;
    if (o) {
      o && o1(o), $ = d1(o, r);
      var T = s1(i, r);
      $ && $.country ? (!T || T.indexOf($.country) >= 0) && (C = $.country) : (C = f1(o, {
        country: void 0,
        countries: T,
        metadata: r
      }), C || a && o.indexOf(Zt(a, r)) === 0 && (C = a));
    }
    var S;
    if (o) {
      if (g) {
        var N = C ? g === C : tr(o, g, r);
        N ? C || (C = g) : S = {
          latestCountrySelectedByUser: void 0
        };
      }
    } else
      S = {
        latestCountrySelectedByUser: void 0,
        hasUserSelectedACountry: void 0
      };
    return Hi(Hi({}, S), {}, {
      phoneDigits: b({
        phoneNumber: $,
        value: o,
        defaultCountry: a
      }),
      value: o,
      country: o ? C : a
    });
  }
}
function hh(e, t) {
  return e === null && (e = void 0), t === null && (t = void 0), e === t;
}
var KI = ["name", "disabled", "readOnly", "autoComplete", "style", "className", "inputRef", "inputComponent", "numberInputProps", "smartCaret", "countrySelectComponent", "countrySelectProps", "containerComponent", "containerComponentProps", "defaultCountry", "countries", "countryOptionsOrder", "labels", "flags", "flagComponent", "flagUrl", "addInternationalOption", "internationalIcon", "displayInitialValueAsLocalNumber", "initialValueFormat", "onCountryChange", "limitMaxLength", "countryCallingCodeEditable", "focusInputOnCountrySelection", "reset", "metadata", "international", "locales"];
function ur(e) {
  "@babel/helpers - typeof";
  return ur = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ur(e);
}
function mh(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function m1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? mh(Object(n), !0).forEach(function(r) {
      Ct(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : mh(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function nr() {
  return nr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, nr.apply(this, arguments);
}
function WI(e, t) {
  if (e == null) return {};
  var n = zI(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function zI(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function GI(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function gh(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, v1(r.key), r);
  }
}
function UI(e, t, n) {
  return t && gh(e.prototype, t), n && gh(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function qI(e, t, n) {
  return t = Ta(t), YI(e, g1() ? Reflect.construct(t, n || [], Ta(e).constructor) : t.apply(e, n));
}
function YI(e, t) {
  if (t && (ur(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return XI(e);
}
function XI(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function g1() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (g1 = function() {
    return !!e;
  })();
}
function Ta(e) {
  return Ta = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Ta(e);
}
function ZI(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && hl(e, t);
}
function hl(e, t) {
  return hl = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, hl(e, t);
}
function Ct(e, t, n) {
  return t = v1(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function v1(e) {
  var t = JI(e, "string");
  return ur(t) == "symbol" ? t : t + "";
}
function JI(e, t) {
  if (ur(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (ur(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var QI = /* @__PURE__ */ function(e) {
  function t(n) {
    var r;
    GI(this, t), r = qI(this, t, [n]), Ct(r, "setInputRef", function(g) {
      OI([r.props.inputRef, r.inputRef], g);
    }), Ct(r, "isCountrySupportedWithError", function(g) {
      var b = r.props.metadata;
      return oo(g, b);
    }), Ct(r, "onCountryChange", function(g) {
      var b = r.props, y = b.international, x = b.metadata, w = b.onChange, $ = b.focusInputOnCountrySelection, C = r.state, T = C.phoneDigits, S = C.country, N = AI(T, {
        prevCountry: S,
        newCountry: g,
        metadata: x,
        // Convert the phone number to "national" format
        // when the user changes the selected country by hand.
        useNationalFormat: !y
      }), k = Zn(N, g, x);
      $ && r.inputRef.current.focus(), r.setState({
        country: g,
        latestCountrySelectedByUser: g,
        hasUserSelectedACountry: !0,
        phoneDigits: N,
        value: k
      }, function() {
        w(k);
      });
    }), Ct(r, "onChange", function(g) {
      var b = r.props, y = b.defaultCountry, x = b.onChange, w = b.addInternationalOption, $ = b.international, C = b.limitMaxLength, T = b.countryCallingCodeEditable, S = b.metadata, N = r.state, k = N.countries, L = N.phoneDigits, _ = N.country, B = N.latestCountrySelectedByUser, A = jI(g, {
        prevPhoneDigits: L,
        country: _,
        countryRequired: !w,
        defaultCountry: y,
        latestCountrySelectedByUser: B,
        getAnyCountry: function() {
          return r.getFirstSupportedCountry({
            countries: k
          });
        },
        countries: k,
        international: $,
        limitMaxLength: C,
        countryCallingCodeEditable: T,
        metadata: S
      }), q = A.phoneDigits, X = A.country, I = A.value, O = {
        phoneDigits: q,
        value: I,
        country: X
      };
      B && I && !tr(I, B, S) && (O.latestCountrySelectedByUser = void 0), T === !1 && !I && q === r.state.phoneDigits && (O.forceRerender = {}), r.setState(
        O,
        // Update the new `value` property.
        // Doing it after the `state` has been updated
        // because `onChange()` will trigger `getDerivedStateFromProps()`
        // with the new `value` which will be compared to `state.value` there.
        function() {
          return x(I);
        }
      );
    }), Ct(r, "_onFocus", function() {
      return r.setState({
        isFocused: !0
      });
    }), Ct(r, "_onBlur", function() {
      return r.setState({
        isFocused: !1
      });
    }), Ct(r, "onFocus", function(g) {
      r._onFocus();
      var b = r.props.onFocus;
      b && b(g);
    }), Ct(r, "onBlur", function(g) {
      var b = r.props.onBlur;
      r._onBlur(), b && b(g);
    }), Ct(r, "onCountryFocus", function(g) {
      r._onFocus();
      var b = r.props.countrySelectProps;
      if (b) {
        var y = b.onFocus;
        y && y(g);
      }
    }), Ct(r, "onCountryBlur", function(g) {
      r._onBlur();
      var b = r.props.countrySelectProps;
      if (b) {
        var y = b.onBlur;
        y && y(g);
      }
    }), r.inputRef = /* @__PURE__ */ te.createRef();
    var i = r.props, a = i.value;
    i.labels;
    var o = i.international, s = i.addInternationalOption, l = i.displayInitialValueAsLocalNumber, u = i.initialValueFormat, c = i.metadata, f = r.props, p = f.defaultCountry, h = f.countries;
    p && (r.isCountrySupportedWithError(p) || (p = void 0)), a && o1(a), h = s1(h, c);
    var m = d1(a, c);
    r.CountryIcon = l1(r.props);
    var v = PI({
      value: a,
      phoneNumber: m,
      defaultCountry: p,
      required: !s,
      countries: h || oh(c),
      getAnyCountry: function() {
        return r.getFirstSupportedCountry({
          countries: h
        });
      },
      metadata: c
    });
    return r.state = {
      // Workaround for `this.props` inside `getDerivedStateFromProps()`.
      props: r.props,
      // The country selected.
      country: v,
      // `countries` are stored in `this.state` because they're filtered.
      // For example, a developer might theoretically pass some unsupported
      // countries as part of the `countries` property, and because of that
      // the component uses `this.state.countries` (which are filtered)
      // instead of `this.props.countries`
      // (which could potentially contain unsupported countries).
      countries: h,
      // `phoneDigits` state property holds non-formatted user's input.
      // The reason is that there's no way of finding out
      // in which form should `value` be displayed: international or national.
      // E.g. if `value` is `+78005553535` then it could be input
      // by a user both as `8 (800) 555-35-35` and `+7 800 555 35 35`.
      // Hence storing just `value` is not sufficient for correct formatting.
      // E.g. if a user entered `8 (800) 555-35-35`
      // then value is `+78005553535` and `phoneDigits` are `88005553535`
      // and if a user entered `+7 800 555 35 35`
      // then value is `+78005553535` and `phoneDigits` are `+78005553535`.
      phoneDigits: h1({
        value: a,
        phoneNumber: m,
        defaultCountry: p,
        international: o,
        useNationalFormat: l || u === "national",
        metadata: c
      }),
      // `value` property is duplicated in state.
      // The reason is that `getDerivedStateFromProps()`
      // needs this `value` to compare to the new `value` property
      // to find out if `phoneDigits` needs updating:
      // If the `value` property was changed externally
      // then it won't be equal to `state.value`
      // in which case `phoneDigits` and `country` should be updated.
      value: a
    }, r;
  }
  return ZI(t, e), UI(t, [{
    key: "componentDidMount",
    value: function() {
      var r = this.props.onCountryChange, i = this.props.defaultCountry, a = this.state.country;
      r && (i && (this.isCountrySupportedWithError(i) || (i = void 0)), a !== i && r(a));
    }
  }, {
    key: "componentDidUpdate",
    value: function(r, i) {
      var a = this.props.onCountryChange, o = this.state.country;
      a && o !== i.country && a(o);
    }
  }, {
    key: "getCountrySelectOptions",
    value: function(r) {
      var i = r.countries, a = this.props, o = a.international, s = a.countryCallingCodeEditable, l = a.countryOptionsOrder, u = a.addInternationalOption, c = a.labels, f = a.locales, p = a.metadata;
      return this.useMemoCountrySelectOptions(function() {
        return xI(NI({
          countries: i || oh(p),
          countryNames: c,
          addInternationalOption: o && s === !1 ? !1 : u,
          compareStringsLocales: f
          // compareStrings
        }), $I(l, p));
      }, [i, l, u, c, p]);
    }
  }, {
    key: "useMemoCountrySelectOptions",
    value: function(r, i) {
      return (!this.countrySelectOptionsMemoDependencies || !tE(i, this.countrySelectOptionsMemoDependencies)) && (this.countrySelectOptionsMemo = r(), this.countrySelectOptionsMemoDependencies = i), this.countrySelectOptionsMemo;
    }
  }, {
    key: "getFirstSupportedCountry",
    value: function(r) {
      var i = r.countries, a = this.getCountrySelectOptions({
        countries: i
      });
      return a[0].value;
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.name, a = r.disabled, o = r.readOnly, s = r.autoComplete, l = r.style, u = r.className;
      r.inputRef;
      var c = r.inputComponent, f = r.numberInputProps, p = r.smartCaret, h = r.countrySelectComponent, m = r.countrySelectProps, v = r.containerComponent, g = r.containerComponentProps;
      r.defaultCountry, r.countries, r.countryOptionsOrder;
      var b = r.labels;
      r.flags, r.flagComponent, r.flagUrl, r.addInternationalOption, r.internationalIcon, r.displayInitialValueAsLocalNumber, r.initialValueFormat, r.onCountryChange, r.limitMaxLength, r.countryCallingCodeEditable, r.focusInputOnCountrySelection, r.reset;
      var y = r.metadata, x = r.international;
      r.locales;
      var w = WI(r, KI), $ = this.state, C = $.country, T = $.countries, S = $.phoneDigits, N = $.isFocused, k = p ? YS : eI, L = this.getCountrySelectOptions({
        countries: T
      });
      return /* @__PURE__ */ te.createElement(v, nr({
        style: l,
        className: wa(u, "PhoneInput", {
          "PhoneInput--focus": N,
          "PhoneInput--disabled": a,
          "PhoneInput--readOnly": o
        })
      }, g), /* @__PURE__ */ te.createElement(h, nr({
        name: i ? "".concat(i, "Country") : void 0,
        "aria-label": b.country
      }, m, {
        value: C,
        options: L,
        onChange: this.onCountryChange,
        onFocus: this.onCountryFocus,
        onBlur: this.onCountryBlur,
        disabled: a || m && m.disabled,
        readOnly: o || m && m.readOnly,
        iconComponent: this.CountryIcon
      })), /* @__PURE__ */ te.createElement(k, nr({
        ref: this.setInputRef,
        type: "tel",
        autoComplete: s
      }, f, w, {
        inputFormat: x === !0 ? "INTERNATIONAL" : x === !1 ? "NATIONAL" : "INTERNATIONAL_OR_NATIONAL",
        international: x ? !0 : void 0,
        withCountryCallingCode: x ? !0 : void 0,
        name: i,
        metadata: y,
        country: C,
        value: S || "",
        onChange: this.onChange,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        disabled: a,
        readOnly: o,
        inputComponent: c,
        className: wa("PhoneInputInput", f && f.className, w.className)
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: (
      // `state` holds previous props as `props`, and also:
      // * `country` — The currently selected country, e.g. `"RU"`.
      // * `value` — The currently entered phone number (E.164), e.g. `+78005553535`.
      // * `phoneDigits` — The parsed `<input/>` value, e.g. `8005553535`.
      // (and a couple of other less significant properties)
      function(r, i) {
        return m1({
          // Emulate `prevProps` via `state.props`.
          props: r
        }, HI(r, i.props, i));
      }
    )
  }]);
}(te.PureComponent), y1 = /* @__PURE__ */ te.forwardRef(function(e, t) {
  return /* @__PURE__ */ te.createElement(QI, nr({}, eE(e), {
    inputRef: t
  }));
});
y1.propTypes = {
  /**
   * Phone number in `E.164` format.
   *
   * Example:
   *
   * `"+12223333333"`
   *
   * Any "falsy" value like `undefined`, `null` or an empty string `""` is treated like "empty".
   */
  value: R.string,
  /**
   * A function of `value: string?`.
   *
   * Updates the `value` property as the user inputs a phone number.
   *
   * If the user erases the input value, the argument is `undefined`.
   */
  onChange: R.func.isRequired,
  /**
   * Toggles the `--focus` CSS class.
   * @ignore
   */
  onFocus: R.func,
  /**
   * `onBlur` is usually passed by `redux-form`.
   * @ignore
   */
  onBlur: R.func,
  /**
   * Set to `true` to mark both the phone number `<input/>`
   * and the country `<select/>` as `disabled`.
   */
  disabled: R.bool,
  /**
   * Set to `true` to mark both the phone number `<input/>`
   * and the country `<select/>` as `readonly`.
   */
  readOnly: R.bool,
  /**
   * Sets `autoComplete` property for phone number `<input/>`.
   *
   * Web browser's "autocomplete" feature
   * remembers the phone number being input
   * and can also autofill the `<input/>`
   * with previously remembered phone numbers.
   *
   * https://developers.google.com
   * /web/updates/2015/06/checkout-faster-with-autofill
   *
   * For example, can be used to turn it off:
   *
   * "So when should you use `autocomplete="off"`?
   *  One example is when you've implemented your own version
   *  of autocomplete for search. Another example is any form field
   *  where users will input and submit different kinds of information
   *  where it would not be useful to have the browser remember
   *  what was submitted previously".
   */
  // (is `"tel"` by default)
  autoComplete: R.string,
  /**
   * Set to `"national"` to show the initial `value` in
   * "national" format rather than "international".
   *
   * For example, if `initialValueFormat` is `"national"`
   * and the initial `value="+12133734253"` is passed
   * then the `<input/>` value will be `"(213) 373-4253"`.
   *
   * By default, `initialValueFormat` is `undefined`,
   * meaning that if the initial `value="+12133734253"` is passed
   * then the `<input/>` value will be `"+1 213 373 4253"`.
   *
   * The reason for such default behaviour is that
   * the newer generation grows up when there are no stationary phones
   * and therefore everyone inputs phone numbers in international format
   * in their smartphones so people gradually get more accustomed to
   * writing phone numbers in international format rather than in local format.
   * Future people won't be using "national" format, only "international".
   */
  // (is `undefined` by default)
  initialValueFormat: R.oneOf(["national"]),
  // `displayInitialValueAsLocalNumber` property has been
  // superceded by `initialValueFormat` property.
  displayInitialValueAsLocalNumber: R.bool,
  /**
   * The country to be selected by default.
   * For example, can be set after a GeoIP lookup.
   *
   * Example: `"US"`.
   */
  // A two-letter country code ("ISO 3166-1 alpha-2").
  defaultCountry: R.string,
  /**
   * If specified, only these countries will be available for selection.
   *
   * Example:
   *
   * `["RU", "UA", "KZ"]`
   */
  countries: R.arrayOf(R.string),
  /**
   * Custom country `<select/>` option names.
   * Also some labels like "ext" and country `<select/>` `aria-label`.
   *
   * Example:
   *
   * `{ "ZZ": "Международный", RU: "Россия", US: "США", ... }`
   *
   * See the `locales` directory for examples.
   */
  labels: c1,
  /**
   * Country `<select/>` options are sorted by their labels.
   * The default sorting function uses `a.localeCompare(b, locales)`,
   * and, if that's not available, falls back to simple `a > b` / `a < b`.
   * Some languages, like Chinese, support multiple sorting variants
   * (called "collations"), and the user might prefer one or another.
   * Also, sometimes the Operating System language is not always
   * the preferred language for a person using a website or an application,
   * so there should be a way to specify custom locale.
   * This `locales` property mimicks the `locales` argument of `Intl` constructors,
   * and can be either a Unicode BCP 47 locale identifier or an array of such locale identifiers.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument
   */
  locales: R.oneOfType([R.string, R.arrayOf(R.string)]),
  /*
   * Custom country `<select/>` options sorting function.
   * The default one uses `a.localeCompare(b)`, and,
   * if that's not available, falls back to simple `a > b`/`a < b`.
   * There have been requests to add custom sorter for cases
   * like Chinese language and "pinyin" (non-default) sorting order.
   * https://stackoverflow.com/questions/22907288/chinese-sorting-by-pinyin-in-javascript-with-localecompare
  compareStrings: PropTypes.func,
   */
  /**
   * A URL template of a country flag, where
   * "{XX}" is a two-letter country code in upper case,
   * or where "{xx}" is a two-letter country code in lower case.
   * By default it points to `country-flag-icons` gitlab pages website.
   * I imagine someone might want to download those country flag icons
   * and host them on their own servers instead
   * (all flags are available in the `country-flag-icons` library).
   * There's a catch though: new countries may be added in future,
   * so when hosting country flag icons on your own server
   * one should check the `CHANGELOG.md` every time before updating this library,
   * otherwise there's a possibility that some new country flag would be missing.
   */
  flagUrl: R.string,
  /**
   * Custom country flag icon components.
   * These flags will be used instead of the default ones.
   * The the "Flags" section of the readme for more info.
   *
   * The shape is an object where keys are country codes
   * and values are flag icon components.
   * Flag icon components receive the same properties
   * as `flagComponent` (see below).
   *
   * Example:
   *
   * `{ "RU": (props) => <img src="..."/> }`
   *
   * Example:
   *
   * `import flags from 'country-flag-icons/react/3x2'`
   *
   * `import PhoneInput from 'react-phone-number-input'`
   *
   * `<PhoneInput flags={flags} .../>`
   */
  flags: R.objectOf(R.elementType),
  /**
   * Country flag icon component.
   *
   * Takes properties:
   *
   * * `country: string` — The country code.
   * * `countryName: string` — The country name.
   * * `flagUrl: string` — The `flagUrl` property (see above).
   * * `flags: object` — The `flags` property (see above).
   */
  flagComponent: R.elementType,
  /**
   * Set to `false` to remove the "International" option from country `<select/>`.
   */
  addInternationalOption: R.bool,
  /**
   * "International" icon component.
   * Should have the same aspect ratio.
   *
   * Receives properties:
   *
   * * `title: string` — "International" country option label.
   */
  internationalIcon: R.elementType,
  /**
   * Can be used to place some countries on top of the list of country `<select/>` options.
   *
   * * `"XX"` — inserts an option for "XX" country.
   * * `"🌐"` — inserts "International" option.
   * * `"|"` — inserts a separator.
   * * `"..."` — inserts options for the rest of the countries (can be omitted, in which case it will be automatically added at the end).
   *
   * Example:
   *
   * `["US", "CA", "AU", "|", "..."]`
   */
  countryOptionsOrder: R.arrayOf(R.string),
  /**
   * `<Phone/>` component CSS style object.
   */
  style: R.object,
  /**
   * `<Phone/>` component CSS class.
   */
  className: R.string,
  /**
   * Country `<select/>` component.
   *
   * Receives properties:
   *
   * * `name: string?` — HTML `name` attribute.
   * * `value: string?` — The currently selected country code.
   * * `onChange(value: string?)` — Updates the `value`.
   * * `onFocus()` — Is used to toggle the `--focus` CSS class.
   * * `onBlur()` — Is used to toggle the `--focus` CSS class.
   * * `options: object[]` — The list of all selectable countries (including "International") each being an object of shape `{ value: string?, label: string }`.
   * * `iconComponent: PropTypes.elementType` — React component that renders a country icon: `<Icon country={value}/>`. If `country` is `undefined` then it renders an "International" icon.
   * * `disabled: boolean?` — HTML `disabled` attribute.
   * * `readOnly: boolean?` — HTML `readOnly` attribute.
   * * `tabIndex: (number|string)?` — HTML `tabIndex` attribute.
   * * `className: string` — CSS class name.
   */
  countrySelectComponent: R.elementType,
  /**
   * Country `<select/>` component props.
   * Along with the usual DOM properties such as `aria-label` and `tabIndex`,
   * some custom properties are supported, such as `arrowComponent` and `unicodeFlags`.
   */
  countrySelectProps: R.object,
  /**
   * Phone number `<input/>` component.
   *
   * Receives properties:
   *
   * * `value: string` — The formatted `value`.
   * * `onChange(event: Event)` — Updates the formatted `value` from `event.target.value`.
   * * `onFocus()` — Is used to toggle the `--focus` CSS class.
   * * `onBlur()` — Is used to toggle the `--focus` CSS class.
   * * Other properties like `type="tel"` or `autoComplete="tel"` that should be passed through to the DOM `<input/>`.
   *
   * Must also either use `React.forwardRef()` to "forward" `ref` to the `<input/>` or implement `.focus()` method.
   */
  inputComponent: R.elementType,
  /**
   * Phone number `<input/>` component props.
   */
  numberInputProps: R.object,
  /**
   * Wrapping `<div/>` component.
   *
   * Receives properties:
   *
   * * `style: object` — A component CSS style object.
   * * `className: string` — Classes to attach to the component, typically changes when component focuses or blurs.
   */
  containerComponent: R.elementType,
  /**
   * Wrapping `<div/>` component props.
   */
  containerComponentProps: R.object,
  /**
   * When the user attempts to insert a digit somewhere in the middle of a phone number,
   * the caret position is moved right before the next available digit skipping
   * any punctuation in between. This is called "smart" caret positioning.
   * Another case would be the phone number format changing as a result of
   * the user inserting the digit somewhere in the middle, which would require
   * re-positioning the caret because all digit positions have changed.
   * This "smart" caret positioning feature can be turned off by passing
   * `smartCaret={false}` property: use it in case of any possible issues
   * with caret position during phone number input.
   */
  // Is `true` by default.
  smartCaret: R.bool,
  /**
   * Set to `true` to force "international" phone number format.
   * Set to `false` to force "national" phone number format.
   * By default it's `undefined` meaning that it doesn't enforce any phone number format:
   * the user can input their phone number in either "national" or "international" format.
   */
  international: R.bool,
  /**
   * If set to `true`, the phone number input will get trimmed
   * if it exceeds the maximum length for the country.
   */
  limitMaxLength: R.bool,
  /**
   * If set to `false`, and `international` is `true`, then
   * users won't be able to erase the "country calling part"
   * of a phone number in the `<input/>`.
   */
  countryCallingCodeEditable: R.bool,
  /**
   * `libphonenumber-js` metadata.
   *
   * Can be used to pass custom `libphonenumber-js` metadata
   * to reduce the overall bundle size for those who compile "custom" metadata.
   */
  metadata: u1,
  /**
   * Is called every time the selected country changes:
   * either programmatically or when user selects it manually from the list.
   */
  // People have been asking for a way to get the selected country.
  // @see  https://github.com/catamphetamine/react-phone-number-input/issues/128
  // For some it's just a "business requirement".
  // I guess it's about gathering as much info on the user as a website can
  // without introducing any addional fields that would complicate the form
  // therefore reducing "conversion" (that's a marketing term).
  // Assuming that the phone number's country is the user's country
  // is not 100% correct but in most cases I guess it's valid.
  onCountryChange: R.func,
  /**
   * If set to `false`, will not focus the `<input/>` component
   * when the user selects a country from the list of countries.
   * This can be used to conform to the Web Content Accessibility Guidelines (WCAG).
   * Quote:
   * "On input: Changing the setting of any user interface component
   *  does not automatically cause a change of context unless the user
   *  has been advised of the behaviour before using the component."
   */
  focusInputOnCountrySelection: R.bool
};
var vh = {
  /**
   * Remember (and autofill) the value as a phone number.
   */
  autoComplete: "tel",
  /**
   * Country `<select/>` component.
   */
  countrySelectComponent: n1,
  /**
   * Flag icon component.
   */
  flagComponent: fc,
  /**
   * By default, uses icons from `country-flag-icons` gitlab pages website.
   */
  // Must be equal to `flagUrl` in `./CountryIcon.js`.
  flagUrl: "https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg",
  /**
   * Default "International" country `<select/>` option icon.
   */
  internationalIcon: ao,
  /**
   * Phone number `<input/>` component.
   */
  inputComponent: "input",
  /**
   * Wrapping `<div/>` component.
   */
  containerComponent: "div",
  /**
   * Some users requested a way to reset the component:
   * both number `<input/>` and country `<select/>`.
   * Whenever `reset` property changes both number `<input/>`
   * and country `<select/>` are reset.
   * It's not implemented as some instance `.reset()` method
   * because `ref` is forwarded to `<input/>`.
   * It's also not replaced with just resetting `country` on
   * external `value` reset, because a user could select a country
   * and then not input any `value`, and so the selected country
   * would be "stuck", if not using this `reset` property.
   */
  // https://github.com/catamphetamine/react-phone-number-input/issues/300
  reset: R.any,
  /**
   *
   */
  /**
   * Set to `false` to use "basic" caret instead of the "smart" one.
   */
  smartCaret: !0,
  /**
   * Whether to add the "International" option
   * to the list of countries.
   */
  addInternationalOption: !0,
  /**
   * If set to `false`, and `international` is `true`, then
   * users won't be able to erase the "country calling part"
   * of a phone number in the `<input/>`.
   */
  countryCallingCodeEditable: !0,
  /**
   * If set to `false`, will not focus the `<input/>` component
   * when the user selects a country from the list of countries.
   * This can be used to conform to the Web Content Accessibility Guidelines (WCAG).
   * Quote:
   * "On input: Changing the setting of any user interface component
   *  does not automatically cause a change of context unless the user
   *  has been advised of the behaviour before using the component."
   */
  focusInputOnCountrySelection: !0
};
function eE(e) {
  e = m1({}, e);
  for (var t in vh)
    e[t] === void 0 && (e[t] = vh[t]);
  return e;
}
function tE(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; ) {
    if (e[n] !== t[n])
      return !1;
    n++;
  }
  return !0;
}
function ml(e) {
  "@babel/helpers - typeof";
  return ml = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ml(e);
}
function nE(e, t, n) {
  if (n || ml(t) === "object" && (n = t, t = "NATIONAL"), !e)
    return "";
  var r = Xv(e, n);
  if (!r)
    return "";
  switch (t) {
    case "National":
      t = "NATIONAL";
      break;
    case "International":
      t = "INTERNATIONAL";
      break;
  }
  return r.format(t);
}
function rE(e, t) {
  return nE(e, "INTERNATIONAL", t);
}
const iE = {
  ext: "ext.",
  country: "Phone number country",
  phone: "Phone",
  AB: "Abkhazia",
  AC: "Ascension Island",
  AD: "Andorra",
  AE: "United Arab Emirates",
  AF: "Afghanistan",
  AG: "Antigua and Barbuda",
  AI: "Anguilla",
  AL: "Albania",
  AM: "Armenia",
  AO: "Angola",
  AQ: "Antarctica",
  AR: "Argentina",
  AS: "American Samoa",
  AT: "Austria",
  AU: "Australia",
  AW: "Aruba",
  AX: "Åland Islands",
  AZ: "Azerbaijan",
  BA: "Bosnia and Herzegovina",
  BB: "Barbados",
  BD: "Bangladesh",
  BE: "Belgium",
  BF: "Burkina Faso",
  BG: "Bulgaria",
  BH: "Bahrain",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Saint Barthélemy",
  BM: "Bermuda",
  BN: "Brunei Darussalam",
  BO: "Bolivia",
  BQ: "Bonaire, Sint Eustatius and Saba",
  BR: "Brazil",
  BS: "Bahamas",
  BT: "Bhutan",
  BV: "Bouvet Island",
  BW: "Botswana",
  BY: "Belarus",
  BZ: "Belize",
  CA: "Canada",
  CC: "Cocos (Keeling) Islands",
  CD: "Congo, Democratic Republic of the",
  CF: "Central African Republic",
  CG: "Congo",
  CH: "Switzerland",
  CI: "Cote d'Ivoire",
  CK: "Cook Islands",
  CL: "Chile",
  CM: "Cameroon",
  CN: "China",
  CO: "Colombia",
  CR: "Costa Rica",
  CU: "Cuba",
  CV: "Cape Verde",
  CW: "Curaçao",
  CX: "Christmas Island",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DE: "Germany",
  DJ: "Djibouti",
  DK: "Denmark",
  DM: "Dominica",
  DO: "Dominican Republic",
  DZ: "Algeria",
  EC: "Ecuador",
  EE: "Estonia",
  EG: "Egypt",
  EH: "Western Sahara",
  ER: "Eritrea",
  ES: "Spain",
  ET: "Ethiopia",
  FI: "Finland",
  FJ: "Fiji",
  FK: "Falkland Islands",
  FM: "Federated States of Micronesia",
  FO: "Faroe Islands",
  FR: "France",
  GA: "Gabon",
  GB: "United Kingdom",
  GD: "Grenada",
  GE: "Georgia",
  GF: "French Guiana",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibraltar",
  GL: "Greenland",
  GM: "Gambia",
  GN: "Guinea",
  GP: "Guadeloupe",
  GQ: "Equatorial Guinea",
  GR: "Greece",
  GS: "South Georgia and the South Sandwich Islands",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HK: "Hong Kong",
  HM: "Heard Island and McDonald Islands",
  HN: "Honduras",
  HR: "Croatia",
  HT: "Haiti",
  HU: "Hungary",
  ID: "Indonesia",
  IE: "Ireland",
  IL: "Israel",
  IM: "Isle of Man",
  IN: "India",
  IO: "British Indian Ocean Territory",
  IQ: "Iraq",
  IR: "Iran",
  IS: "Iceland",
  IT: "Italy",
  JE: "Jersey",
  JM: "Jamaica",
  JO: "Jordan",
  JP: "Japan",
  KE: "Kenya",
  KG: "Kyrgyzstan",
  KH: "Cambodia",
  KI: "Kiribati",
  KM: "Comoros",
  KN: "Saint Kitts and Nevis",
  KP: "North Korea",
  KR: "South Korea",
  KW: "Kuwait",
  KY: "Cayman Islands",
  KZ: "Kazakhstan",
  LA: "Laos",
  LB: "Lebanon",
  LC: "Saint Lucia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Liberia",
  LS: "Lesotho",
  LT: "Lithuania",
  LU: "Luxembourg",
  LV: "Latvia",
  LY: "Libya",
  MA: "Morocco",
  MC: "Monaco",
  MD: "Moldova",
  ME: "Montenegro",
  MF: "Saint Martin (French Part)",
  MG: "Madagascar",
  MH: "Marshall Islands",
  MK: "North Macedonia",
  ML: "Mali",
  MM: "Myanmar",
  MN: "Mongolia",
  MO: "Macao",
  MP: "Northern Mariana Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldives",
  MW: "Malawi",
  MX: "Mexico",
  MY: "Malaysia",
  MZ: "Mozambique",
  NA: "Namibia",
  NC: "New Caledonia",
  NE: "Niger",
  NF: "Norfolk Island",
  NG: "Nigeria",
  NI: "Nicaragua",
  NL: "Netherlands",
  NO: "Norway",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "New Zealand",
  OM: "Oman",
  OS: "South Ossetia",
  PA: "Panama",
  PE: "Peru",
  PF: "French Polynesia",
  PG: "Papua New Guinea",
  PH: "Philippines",
  PK: "Pakistan",
  PL: "Poland",
  PM: "Saint Pierre and Miquelon",
  PN: "Pitcairn",
  PR: "Puerto Rico",
  PS: "Palestine",
  PT: "Portugal",
  PW: "Palau",
  PY: "Paraguay",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Romania",
  RS: "Serbia",
  RU: "Russia",
  RW: "Rwanda",
  SA: "Saudi Arabia",
  SB: "Solomon Islands",
  SC: "Seychelles",
  SD: "Sudan",
  SE: "Sweden",
  SG: "Singapore",
  SH: "Saint Helena",
  SI: "Slovenia",
  SJ: "Svalbard and Jan Mayen",
  SK: "Slovakia",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somalia",
  SR: "Suriname",
  SS: "South Sudan",
  ST: "Sao Tome and Principe",
  SV: "El Salvador",
  SX: "Sint Maarten",
  SY: "Syria",
  SZ: "Swaziland",
  TA: "Tristan da Cunha",
  TC: "Turks and Caicos Islands",
  TD: "Chad",
  TF: "French Southern Territories",
  TG: "Togo",
  TH: "Thailand",
  TJ: "Tajikistan",
  TK: "Tokelau",
  TL: "Timor-Leste",
  TM: "Turkmenistan",
  TN: "Tunisia",
  TO: "Tonga",
  TR: "Turkey",
  TT: "Trinidad and Tobago",
  TV: "Tuvalu",
  TW: "Taiwan",
  TZ: "Tanzania",
  UA: "Ukraine",
  UG: "Uganda",
  UM: "United States Minor Outlying Islands",
  US: "United States",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VA: "Holy See (Vatican City State)",
  VC: "Saint Vincent and the Grenadines",
  VE: "Venezuela",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.S.",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis and Futuna",
  WS: "Samoa",
  XK: "Kosovo",
  YE: "Yemen",
  YT: "Mayotte",
  ZA: "South Africa",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  ZZ: "International"
};
var aE = ["metadata", "labels"];
function gl() {
  return gl = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, gl.apply(this, arguments);
}
function oE(e, t) {
  if (e == null) return {};
  var n = sE(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function sE(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function b1(e) {
  var t = /* @__PURE__ */ te.forwardRef(function(n, r) {
    var i = n.metadata, a = i === void 0 ? e : i, o = n.labels, s = o === void 0 ? iE : o, l = oE(n, aE);
    return /* @__PURE__ */ te.createElement(y1, gl({}, l, {
      ref: r,
      metadata: a,
      labels: s
    }));
  });
  return t.propTypes = {
    metadata: u1,
    labels: c1
  }, t;
}
b1();
function hc(e, t) {
  var n = Array.prototype.slice.call(t);
  return n.push(Tv), e.apply(this, n);
}
const lE = b1(Tv);
function yT() {
  return hc(rE, arguments);
}
function bT() {
  return hc(MC, arguments);
}
function rs() {
  return hc(an, arguments);
}
const x1 = (e, t) => {
  const { changes: n, type: r } = t;
  return r === gi.stateChangeTypes.ToggleButtonBlur ? {
    ...n,
    selectedItem: e.selectedItem,
    isOpen: !1
  } : n;
}, uE = de(
  "a:shrink-0 a:rounded-r-none a:border-r a:border-solid a:bg-surface-neutral a:focus:outline-hidden",
  {
    variants: {
      error: {
        true: "a:border-border-error",
        false: "a:border-border-neutral"
      },
      disabled: {
        true: "a:cursor-not-allowed a:bg-surface-quiet",
        false: "a:group-focus-within:border-border-active a:group-hover:bg-surface-neutral-hover a:group-hover:border-border-neutral-hover"
      }
    }
  }
), cE = ({
  testId: e,
  disabled: t = !1,
  error: n = !1,
  iconComponent: r,
  id: i,
  label: a,
  onChange: o,
  options: s,
  value: l,
  wrapperRef: u
}) => {
  const [c, f] = ue(!1), [p, h] = ue(null), { getItemProps: m, getMenuProps: v, getToggleButtonProps: g, isOpen: b, highlightedIndex: y } = gi({
    id: i,
    selectedItem: p,
    items: s,
    itemToString: (S) => (S == null ? void 0 : S.label) || "",
    onSelectedItemChange: ({ selectedItem: S }) => {
      h(S), o(S.value);
    },
    stateReducer: x1
  }), { getDropdownProps: x, getReferenceProps: w, refs: $ } = Xu({
    isOpen: b,
    elements: { reference: u.current }
  }), C = () => {
    f(!1);
  }, T = (S) => () => {
    h(S), C();
  };
  return se(() => {
    h((s == null ? void 0 : s.find((S) => S.value === l)) || null);
  }, [l]), /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
    /* @__PURE__ */ d.jsx(
      "button",
      {
        className: Y(uE({ error: n, disabled: t })),
        "data-testid": `${e}-country-selector-toggle`,
        disabled: t,
        type: "button",
        ...w(),
        ...g({
          onClick: () => f(!0)
        }),
        children: /* @__PURE__ */ d.jsx(De, { paddingBlock: "2", paddingInlineStart: "3", paddingInlineEnd: "2", children: /* @__PURE__ */ d.jsxs(Pe, { itemsAlign: "center", gap: "2", children: [
          /* @__PURE__ */ d.jsx("div", { className: "a:w-4 a:overflow-hidden a:rounded-sm", children: /* @__PURE__ */ d.jsx(r, { country: l, label: l }) }),
          l && /* @__PURE__ */ d.jsx(ie, { children: `+${rs(l)}` }),
          /* @__PURE__ */ d.jsx($e, { size: "xs", source: vi })
        ] }) })
      }
    ),
    /* @__PURE__ */ d.jsx(ba, { until: "md", children: /* @__PURE__ */ d.jsxs(
      Qu,
      {
        isOpen: c,
        testId: `${e}-country-selector-bottom-sheet`,
        onClose: C,
        children: [
          a && /* @__PURE__ */ d.jsx(De, { paddingBlockEnd: "8", children: /* @__PURE__ */ d.jsx(We, { gap: "4", children: /* @__PURE__ */ d.jsx(ie, { variant: "headingS", as: "h3", children: a }) }) }),
          /* @__PURE__ */ d.jsx(We, { children: s.map(
            (S, N) => S.value ? /* @__PURE__ */ d.jsx(
              ya,
              {
                ...m({
                  key: `list-item-${S.value}`,
                  item: S,
                  index: N,
                  refKey: "innerRef",
                  testId: `${e}-country-selector-item-${N}`,
                  onClick: T(S),
                  state: (p == null ? void 0 : p.value) === S.value ? "selected" : "enabled",
                  text: [
                    /* @__PURE__ */ d.jsxs(Pe, { itemsAlign: "center", gap: "2", wrap: "nowrap", children: [
                      /* @__PURE__ */ d.jsx("div", { className: "a:w-16 a:shrink-0", children: /* @__PURE__ */ d.jsx(ie, { color: "neutral", as: "span", children: `+${rs(S.value)}` }) }),
                      /* @__PURE__ */ d.jsx(ie, { variant: "bodyM", as: "span", truncate: !0, children: S.label })
                    ] }, S.value)
                  ]
                })
              }
            ) : null
          ) })
        ]
      }
    ) }),
    /* @__PURE__ */ d.jsx(ba, { from: "md", children: /* @__PURE__ */ d.jsx(
      Tt,
      {
        testId: `${e}-country-selector-dropdown`,
        ...v({ isOpen: b, refKey: "innerRef", ref: $.floating }, { suppressRefError: !0 }),
        ...x(),
        children: s.map(
          (S, N) => S.divider ? /* @__PURE__ */ d.jsx(Tt.Divider, {}, `divider_${N}`) : /* @__PURE__ */ d.jsx(
            Tt.Item,
            {
              ...m({
                key: S.value,
                index: N,
                item: S,
                refKey: "innerRef",
                testId: `${e}-country-selector-item-${N}`,
                isHighlighted: y === N,
                isSelected: p === S,
                text: S.label,
                onMouseDown: pt,
                adornmentStart: /* @__PURE__ */ d.jsx("div", { className: "a:mr-1 a:w-20", children: /* @__PURE__ */ d.jsx(Pe, { itemsAlign: "center", gap: "2", children: /* @__PURE__ */ d.jsx(ie, { color: "neutral", as: "span", children: `+${rs(S.value)}` }) }) })
              })
            }
          )
        )
      }
    ) })
  ] });
}, dE = de(
  [
    "a:flex a:w-full a:flex-auto a:grow a:appearance-none a:text-ellipsis a:px-3 a:py-2.5",
    "a:text-base a:text-content-neutral a:placeholder-content-subtle a:outline-hidden a:focus:text-content-neutral"
  ],
  {
    variants: {
      disabled: {
        true: "a:cursor-not-allowed a:bg-surface-quiet"
      }
    }
  }
), $1 = Th(
  ({ testId: e, disabled: t = !1, ...n }, r) => /* @__PURE__ */ d.jsx(
    "input",
    {
      ...n,
      ref: r,
      disabled: t,
      "data-testid": `${e}-input`,
      className: Y(dE({ disabled: t }))
    }
  )
);
$1.displayName = "PhoneInput";
const fE = de(
  "a:group a:flex a:flex-nowrap a:overflow-hidden a:rounded-md a:border a:border-solid a:bg-surface-neutral",
  {
    variants: {
      error: {
        true: "a:border-border-error",
        false: "a:border-border-neutral"
      },
      disabled: {
        true: "a:cursor-not-allowed a:bg-surface-quiet",
        false: "a:focus-within:border-border-active a:hover:border-border-neutral-hover"
      }
    }
  }
), pE = ({ children: e, error: t, disabled: n }) => /* @__PURE__ */ d.jsx("div", { className: Y(fE({ error: !!t, disabled: n })), children: e }), xT = ({
  countryOptionsOrder: e,
  countrySelectLabel: t,
  testId: n,
  defaultCountry: r,
  disabled: i = !1,
  error: a,
  hint: o,
  id: s,
  label: l,
  maxLength: u,
  name: c,
  onBlur: f,
  onChange: p,
  onFocus: h,
  optionalText: m,
  placeholder: v,
  value: g
}) => {
  const b = ce(null);
  return /* @__PURE__ */ d.jsx("div", { ref: b, children: /* @__PURE__ */ d.jsxs(We, { gap: "1", testId: n, children: [
    l && /* @__PURE__ */ d.jsx(za, { htmlFor: s, optionalText: m, testId: Z({ testId: n, suffix: "label" }), children: l }),
    /* @__PURE__ */ d.jsx(
      lE,
      {
        id: s,
        name: c,
        value: g == null ? void 0 : g.replace(/^00/, "+"),
        placeholder: v,
        onChange: p,
        onBlur: f,
        onFocus: h,
        testId: Z({ testId: n, suffix: "text-field" }),
        maxLength: u,
        international: !1,
        countryCallingCodeEditable: !1,
        addInternationalOption: !1,
        defaultCountry: r,
        countryOptionsOrder: e,
        containerComponent: pE,
        containerComponentProps: { error: !!a, disabled: i },
        countrySelectComponent: cE,
        countrySelectProps: {
          wrapperRef: b,
          label: t,
          testId: n,
          error: !!a,
          id: s
        },
        inputComponent: $1,
        disabled: i,
        error: a
      }
    ),
    a ? /* @__PURE__ */ d.jsx(yi, { children: a }) : o ? /* @__PURE__ */ d.jsx(ie, { as: "span", variant: "bodyS", color: i ? "subtle" : "neutral", children: o }) : null
  ] }) });
}, $T = ({ sourceSet: e, ...t }) => /* @__PURE__ */ d.jsxs("picture", { children: [
  e == null ? void 0 : e.map(({ source: n, descriptor: r }) => /* @__PURE__ */ d.jsx("source", { srcSet: n, media: r }, n)),
  /* @__PURE__ */ d.jsx(lr, { ...t })
] }), hE = ({ children: e }) => /* @__PURE__ */ d.jsx(d.Fragment, { children: e }), mE = ({ title: e, children: t }) => e ? /* @__PURE__ */ d.jsx(ie, { variant: "headingXS", children: e }) : /* @__PURE__ */ d.jsx(d.Fragment, { children: t }), gE = ({ children: e }) => /* @__PURE__ */ d.jsx(d.Fragment, { children: e }), vE = ({ children: e }) => /* @__PURE__ */ d.jsx(d.Fragment, { children: e }), w1 = 30, yh = 15, yE = 16, bE = (e, t) => {
  const n = (e == null ? void 0 : e.x) ?? 0, r = (e == null ? void 0 : e.y) ?? 0, i = n + w1 / 2, a = r + t;
  return {
    initial: {
      transform: "scale(0)"
    },
    common: ({ side: o }) => ({
      transformOrigin: {
        top: `${i}px calc(100% + ${t}px)`,
        bottom: `${i}px ${-t}px`,
        left: `calc(100% + ${t}px) ${a}px`,
        right: `${-t}px ${a}px`
      }[o],
      transitionDuration: "400ms"
    })
  };
}, fn = ({
  animated: e,
  children: t,
  testId: n,
  disableTrigger: r,
  hasCloseBtn: i,
  id: a = Ja("popover-"),
  isOpen: o,
  overflowOptions: s,
  offsetOptions: l = { mainAxis: 24 },
  placement: u = "bottom-start",
  customWidth: c
}) => {
  const f = xt(t, fn.Trigger), p = xt(t, fn.Header), h = xt(t, fn.Body), m = xt(t, fn.Footer), [v, g] = ue(o), b = ce(null), y = {
    name: "overflowPosition",
    fn: async (j) => ({
      data: await U4(j)
    })
  }, {
    x,
    y: w,
    floatingStyles: $,
    refs: { floating: C, setReference: T, setFloating: S },
    context: N,
    middlewareData: k
  } = Uu({
    open: v,
    placement: u,
    middleware: [
      B0({ padding: yE }),
      V0(l),
      Ku(),
      y,
      ...e ? [H0({ element: b })] : []
    ],
    whileElementsMounted: L0,
    onOpenChange: g
  }), L = s == null ? void 0 : s(C, k.overflowPosition, { x, y: w }), _ = L ? {
    ...$,
    ...L
  } : $;
  se(() => {
    g(o);
  }, [o]);
  const B = X0(N), A = Z0(N), { getReferenceProps: q, getFloatingProps: X } = qu([B, A]), I = () => g(!1), O = (e && typeof l != "number" && "mainAxis" in l ? l.mainAxis : yh) || yh, { isMounted: D, styles: E } = Yu(
    N,
    e ? bE(k.arrow, O) : {}
  );
  return /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
    /* @__PURE__ */ d.jsx(
      "span",
      {
        "aria-controls": a,
        "aria-expanded": v,
        "data-testid": Z({ testId: n, suffix: "trigger" }),
        id: `${a}-trigger`,
        ref: T,
        ...q(),
        onClick: r ? void 0 : () => g(!v),
        className: "a:inline-block a:cursor-pointer a:align-middle",
        children: f
      }
    ),
    D && /* @__PURE__ */ d.jsx(Gu, { children: /* @__PURE__ */ d.jsx(
      "div",
      {
        ref: S,
        "aria-labelledby": `${a}-trigger`,
        id: a,
        "data-testid": n,
        className: "a:z-popover a:h-max a:max-w-[343px] a:sm:w-full a:lg:max-w-[472px]",
        style: { ..._, width: c || "calc(100vw-32px)" },
        ...X(),
        children: /* @__PURE__ */ d.jsxs("div", { style: E, className: "a:rounded-lg a:bg-white a:p-4 a:shadow-popover a:lg:p-6", children: [
          e && /* @__PURE__ */ d.jsx(
            W0,
            {
              ref: b,
              "aria-hidden": "true",
              context: N,
              width: w1,
              height: O,
              visibility: "hidden"
            }
          ),
          /* @__PURE__ */ d.jsxs("div", { className: "a:flex a:justify-between", children: [
            p,
            i && /* @__PURE__ */ d.jsx(
              "button",
              {
                "aria-hidden": "true",
                "aria-label": "Close",
                className: Y("a:ml-auto a:flex a:shrink-0 a:grow-0 a:cursor-pointer a:pl-1"),
                "data-testid": Z({ testId: n, suffix: "close-button" }),
                onClick: I,
                children: /* @__PURE__ */ d.jsx($e, { source: bn, size: "sm", color: "current" })
              }
            )
          ] }),
          h,
          m
        ] })
      }
    ) })
  ] });
};
fn.Trigger = hE;
fn.Header = mE;
fn.Body = gE;
fn.Footer = vE;
const xE = de("a:w-fit a:inline-flex a:gap-1 a:items-center", {
  variants: {
    variant: {
      primary: "a:bg-surface-brand a:text-content-inverse",
      sale: "a:bg-surface-commercial a:text-content-inverse",
      sustainability: "a:bg-surface-sustainability a:text-content-inverse",
      dark: "a:bg-surface-dark a:text-content-inverse",
      neutral: "a:bg-surface-quiet a:text-content-emphasised",
      light: "a:bg-surface-neutral a:text-content-emphasised",
      active: "a:bg-surface-active a:text-content-inverse",
      promotion: "a:bg-surface-commercial-2 a:text-content-inverse"
    },
    size: {
      md: "a:px-2",
      lg: "a:px-3"
    },
    withIcon: {
      true: "a:px-3 a:min-h-5"
    }
  },
  defaultVariants: {
    variant: "primary",
    size: "md",
    withIcon: !1
  }
}), $E = (e) => {
  switch (e) {
    case "md":
      return "bodyXS";
    case "lg":
      return "bodyS";
  }
};
function wE({ testId: e, variant: t = "primary", size: n = "md", icon: r, text: i }) {
  return /* @__PURE__ */ d.jsxs("div", { className: Y(xE({ variant: t, withIcon: !!r, size: n })), "data-testid": e, children: [
    i && /* @__PURE__ */ d.jsx(ie, { as: "span", variant: $E(n), children: i }),
    r && /* @__PURE__ */ d.jsx($e, { source: r, size: "xs" })
  ] });
}
const CE = ({ testId: e, priceReference: t, currency: n, variant: r = "bodyXS" }) => {
  if (!(t != null && t.formattedPrice))
    return null;
  const { formattedPrice: i, priceLabel: a } = t;
  return /* @__PURE__ */ d.jsx(ie, { color: "subtle", testId: e, variant: r, children: `${a ? `${a} ` : ""}${vl(n, i)}` });
}, bh = (e, t) => {
  switch (e) {
    case "sm":
      return t ? "bodyM" : "titleS";
    case "lg":
      return t ? "bodyXL" : "titleL";
  }
}, Mr = (e) => {
  switch (e) {
    case "sm":
      return "bodyXS";
    case "lg":
      return "bodyM";
  }
}, SE = (e) => e === "lg" ? "lg" : "md", vl = (e, t) => Number(t) < 0 ? `- ${e}${Math.abs(Number(t))}` : `${e}${t}`, IE = ({
  testId: e,
  size: t = "sm",
  currency: n,
  orientation: r = "horizontal",
  align: i = "start",
  priceActual: a,
  pricePrevious: o,
  priceReference: s,
  enablePriceReference: l = !1,
  tag: u,
  caveat: c
}) => {
  var h, m, v;
  const f = r === "horizontal" ? Pe : We, p = r === "vertical" ? "1" : t === "lg" ? "2" : "1";
  return /* @__PURE__ */ d.jsxs(We, { gap: "0.5", testId: e, children: [
    /* @__PURE__ */ d.jsxs(f, { itemsAlign: "center", contentAlign: i, gap: p, children: [
      !!o && /* @__PURE__ */ d.jsxs(Pe, { itemsAlign: "center", contentAlign: i, gap: p, children: [
        o.priceLabel && ((h = o == null ? void 0 : o.priceLabel) == null ? void 0 : h.trim().length) > 0 && /* @__PURE__ */ d.jsx(
          ie,
          {
            as: "span",
            testId: Z({ testId: e, suffix: "previous-label" }),
            variant: Mr(t),
            color: "neutral",
            children: o.priceLabel
          }
        ),
        /* @__PURE__ */ d.jsx(
          ie,
          {
            as: "span",
            testId: Z({ testId: e, suffix: "previous-price" }),
            variant: bh(t, !0),
            strike: !0,
            color: "neutral",
            children: vl(n, o.formattedPrice)
          }
        )
      ] }),
      /* @__PURE__ */ d.jsxs(Pe, { itemsAlign: "center", contentAlign: i, gap: p, children: [
        ((m = a == null ? void 0 : a.priceLabel) == null ? void 0 : m.trim()) && ((v = a == null ? void 0 : a.priceLabel) == null ? void 0 : v.trim().length) > 0 && /* @__PURE__ */ d.jsxs(
          ie,
          {
            alignment: i,
            as: "span",
            testId: Z({ testId: e, suffix: "actual-label" }),
            color: o ? "commercial" : "neutral",
            variant: Mr(t),
            children: [
              a.priceLabel,
              " "
            ]
          }
        ),
        (a == null ? void 0 : a.formattedPrice) && /* @__PURE__ */ d.jsx(
          Jt,
          {
            condition: !!a.suffix,
            wrapper: (g) => /* @__PURE__ */ d.jsxs("span", { children: [
              g,
              /* @__PURE__ */ d.jsx(
                ie,
                {
                  as: "span",
                  testId: Z({ testId: e, suffix: "actual-price-suffix" }),
                  variant: Mr(t),
                  color: "neutral",
                  children: a.suffix
                }
              )
            ] }),
            children: /* @__PURE__ */ d.jsx(
              ie,
              {
                as: "span",
                testId: Z({ testId: e, suffix: "actual-price" }),
                variant: bh(t),
                color: o ? "commercial" : "neutral",
                children: vl(n, a.formattedPrice)
              }
            )
          }
        ),
        (u == null ? void 0 : u.text) && /* @__PURE__ */ d.jsx(
          wE,
          {
            testId: Z({ testId: e, suffix: "tag" }),
            variant: u.variant || "sale",
            size: SE(t),
            text: u.text
          }
        )
      ] })
    ] }),
    c && /* @__PURE__ */ d.jsx(
      ie,
      {
        testId: Z({ testId: e, suffix: "caveat" }),
        color: c.isCommercial ? "commercial" : "neutral",
        variant: Mr(t),
        alignment: i,
        children: c.text
      }
    ),
    l && /* @__PURE__ */ d.jsx(Pe, { contentAlign: i, children: /* @__PURE__ */ d.jsx(
      CE,
      {
        testId: Z({ testId: e, suffix: "price-reference" }),
        priceReference: s,
        currency: n,
        variant: Mr(t)
      }
    ) })
  ] });
}, EE = ({ children: e }) => /* @__PURE__ */ d.jsx(d.Fragment, { children: e }), mc = Rt({}), gc = () => Xe(mc), OE = ({ width: e, height: t, lazyLoad: n, url: r }) => {
  const { image: i, hoverImage: a, alt: o, testId: s } = gc();
  return i ? /* @__PURE__ */ d.jsx(Jt, { condition: !!r, wrapper: (l) => /* @__PURE__ */ d.jsx("a", { href: r, children: l }), children: /* @__PURE__ */ d.jsxs(
    "figure",
    {
      className: Y(
        "a:group/product-image a:grid a:aspect-2/3 a:overflow-hidden",
        {
          "a:h-[var(--product-tile-height)]": typeof t == "number" && t || typeof t == "object" && t.xs,
          "a:sm:h-[var(--product-tile-height-sm)]": typeof t == "object" && t.sm,
          "a:md:h-[var(--product-tile-height-md)]": typeof t == "object" && t.md,
          "a:lg:h-[var(--product-tile-height-lg)]": typeof t == "object" && t.lg,
          "a:xl:h-[var(--product-tile-height-xl)]": typeof t == "object" && t.xl,
          "a:2xl:h-[var(--product-tile-height-2xl)]": typeof t == "object" && t["2xl"]
        },
        {
          "a:w-[var(--product-tile-width)]": typeof e == "number" && e || typeof e == "object" && e.xs,
          "a:sm:w-[var(--product-tile-width-sm)]": typeof e == "object" && e.sm,
          "a:md:w-[var(--product-tile-width-md)]": typeof e == "object" && e.md,
          "a:lg:w-[var(--product-tile-width-lg)]": typeof e == "object" && e.lg,
          "a:xl:w-[var(--product-tile-width-xl)]": typeof e == "object" && e.xl,
          "a:2xl:w-[var(--product-tile-width-2xl)]": typeof e == "object" && e["2xl"]
        }
      ),
      style: {
        ...ei("--product-tile-width", e, (l) => `${l}px`),
        ...ei("--product-tile-height", t, (l) => `${l}px`)
      },
      children: [
        /* @__PURE__ */ d.jsx(
          lr,
          {
            source: i,
            alt: o,
            lazyLoad: n,
            className: Y("a:col-span-full a:row-span-full", {
              "a:transition-opacity a:duration-300 a:group-hover:opacity-0": !!a
            }),
            testId: s ? `${s}-image` : void 0
          }
        ),
        !!a && /* @__PURE__ */ d.jsx(
          lr,
          {
            source: a,
            alt: o,
            lazyLoad: n,
            className: "a:col-span-full a:row-span-full a:opacity-0 a:transition-opacity a:duration-300 a:group-hover/product-image:opacity-100",
            testId: s ? `${s}-image-hover` : void 0
          }
        )
      ]
    }
  ) }) : null;
}, TE = ({ ...e }) => {
  const { priceCaveat: t, priceActual: n, pricePrevious: r, priceReference: i, enablePriceReference: a, currency: o, testId: s } = gc();
  return !o || !n ? null : /* @__PURE__ */ d.jsx(
    IE,
    {
      ...e,
      caveat: t,
      currency: o,
      priceActual: n,
      pricePrevious: r,
      priceReference: i,
      enablePriceReference: a,
      testId: s ? `${s}-price` : void 0
    }
  );
}, PE = ({ brandOnTheSameLine: e, lineClamp: t, url: n }) => {
  const { brand: r, title: i, testId: a } = gc();
  return i ? /* @__PURE__ */ d.jsx(
    "header",
    {
      className: Y("a:group-hover/product-tile:underline", {
        [`a:line-clamp-${t}`]: !!t
      }),
      "data-testid": a ? `${a}-title` : void 0,
      children: /* @__PURE__ */ d.jsx(
        Jt,
        {
          condition: !!n,
          wrapper: (o) => /* @__PURE__ */ d.jsx(
            "a",
            {
              className: "a:block a:hover:underline a:focus:rounded-sm a:focus:outline-border-focus a:focus-visible:outline a:focus-visible:outline-2 a:focus-visible:outline-offset-1",
              href: n,
              children: o
            }
          ),
          children: /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
            r && /* @__PURE__ */ d.jsxs(
              ie,
              {
                variant: "titleS",
                as: e ? "span" : "div",
                testId: a ? `${a}-brand` : void 0,
                children: [
                  r,
                  " "
                ]
              }
            ),
            /* @__PURE__ */ d.jsx(ie, { as: e ? "span" : "div", testId: a ? `${a}_title` : void 0, children: i })
          ] })
        }
      )
    }
  ) : null;
}, cr = ({ children: e, product: t }) => /* @__PURE__ */ d.jsx(mc.Provider, { value: t, children: e });
cr.Cell = EE;
cr.Price = TE;
cr.Title = PE;
cr.Image = OE;
const NE = ({ children: e, url: t }) => {
  const n = ce(null), r = (i) => {
    var o;
    i.stopPropagation();
    const a = (o = n.current) == null ? void 0 : o.querySelector("a");
    a !== i.target && t && a && a.click();
  };
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      className: "a:group/product-tile a:cursor-pointer",
      ...Zu({ callback: r, role: "link" }),
      ref: n,
      children: e
    }
  );
}, wT = ({
  product: e,
  gap: t = "4",
  children: n,
  testId: r
}) => {
  const i = xt(n, cr.Cell, { section: "media" }), a = xt(n, cr.Cell, { section: "content" }), o = e.url ? /* @__PURE__ */ d.jsx("a", { tabIndex: 0, href: e.url, className: "a:col-span-full a:row-span-full", children: /* @__PURE__ */ d.jsx("span", { className: "a:sr-only", children: e.title }) }) : null;
  return /* @__PURE__ */ d.jsx(mc.Provider, { value: { ...e, testId: r }, children: /* @__PURE__ */ d.jsx(
    Jt,
    {
      condition: !!e.url,
      wrapper: (s) => /* @__PURE__ */ d.jsx(NE, { url: e.url, children: s }),
      children: /* @__PURE__ */ d.jsxs(ut, { as: "article", columns: "auto-1fr", gap: t, fullWidth: !0, children: [
        o,
        /* @__PURE__ */ d.jsx(ut.Cell, { rowOffset: 1, offset: 1, children: i }),
        /* @__PURE__ */ d.jsx(ut.Cell, { rowOffset: 1, offset: 2, children: a })
      ] })
    }
  ) });
}, CT = ({ html: e, id: t }) => /* @__PURE__ */ d.jsx("div", { className: "a:prose", id: t, dangerouslySetInnerHTML: { __html: e } });
function _E({
  testId: e,
  min: t = 0,
  max: n = Number.MAX_SAFE_INTEGER,
  onUpdate: r,
  spacingClasses: i,
  quantity: a = t
}) {
  const [o, s] = ue(a.toString());
  se(() => {
    s(a.toString());
  }, [a]);
  const l = (p) => {
    p.target.value === "" && s(t.toString());
  }, u = (p) => {
    if (p.target.value === "") {
      s("");
      return;
    }
    f(Number(p.target.valueAsNumber), "update");
  }, c = (p, h) => (m) => {
    m.stopPropagation(), pt(m, { bgClass: "a:bg-surface-opacity-dark", animationClass: "a:animate-ripple-translucent" });
    const v = Number(o) + p;
    f(v, h);
  }, f = (p, h) => {
    p = Math.trunc(p), p >= t && p <= n && (s(p.toString()), r(p, h));
  };
  return /* @__PURE__ */ d.jsxs(
    ut,
    {
      testId: e,
      spacingClasses: i,
      gap: "0",
      gridClasses: "a:grid-cols-[43px_48px_43px] a:grid-rows-[44px]",
      children: [
        /* @__PURE__ */ d.jsx(
          "button",
          {
            className: Y(
              "a:rounded-s-md a:border a:border-e-0 a:border-border-neutral",
              "a:relative a:overflow-hidden a:bg-surface-neutral a:p-3 a:text-center a:text-content-brand",
              "a:disabled:text-content-brand-disabled a:hover-pointer:bg-surface-neutral-hover",
              "a:focus-visible:border-2 a:focus-visible:border-yellow-600 a:focus-visible:outline-hidden"
            ),
            disabled: Number(o) <= t,
            onClick: c(-1, "decrease"),
            type: "button",
            "data-testid": Z({ testId: e, suffix: "decrease" }),
            children: /* @__PURE__ */ d.jsx($e, { size: "xs", source: Iw })
          }
        ),
        /* @__PURE__ */ d.jsx(
          "input",
          {
            className: Y(
              "a:appearance-none a:border a:border-border-neutral",
              "a:text-center a:text-content-neutral a:placeholder:text-content-subtle",
              "a:focus-visible:border-border-active a:focus-visible:outline-hidden",
              "a:bg-surface-neutral a:hover-pointer:bg-surface-neutral-hover"
            ),
            inputMode: "numeric",
            type: "number",
            min: t,
            max: n,
            value: o,
            onBlur: l,
            onChange: u,
            placeholder: t.toString(),
            "data-testid": Z({ testId: e, suffix: "input" })
          }
        ),
        /* @__PURE__ */ d.jsx(
          "button",
          {
            className: Y(
              "a:rounded-e-md a:border a:border-s-0 a:border-border-neutral",
              "a:relative a:overflow-hidden a:bg-surface-neutral a:p-3 a:text-center a:text-content-brand",
              "a:disabled:text-content-brand-disabled a:hover-pointer:bg-surface-neutral-hover",
              "a:focus-visible:border-2 a:focus-visible:border-yellow-600 a:focus-visible:outline-hidden"
            ),
            onClick: c(1, "increase"),
            disabled: Number(o) >= n,
            type: "button",
            "data-testid": Z({ testId: e, suffix: "increase" }),
            children: /* @__PURE__ */ d.jsx($e, { size: "xs", source: Ew })
          }
        )
      ]
    }
  );
}
function ST({
  testId: e,
  description: t,
  max: n,
  onQuantityUpdate: r,
  spacingClasses: i,
  subtitle: a,
  title: o,
  truncated: s = !0,
  quantity: l = 0
}) {
  return /* @__PURE__ */ d.jsxs("div", { role: "group", "data-testid": e, className: Oe("a:flex a:items-center", Ze(i)), children: [
    /* @__PURE__ */ d.jsxs("div", { className: "a:min-w-0 a:grow-1", children: [
      /* @__PURE__ */ d.jsx("div", { className: "a:mb-1 a:mr-2 a:flex a:items-center", children: /* @__PURE__ */ d.jsxs(ie, { variant: "titleS", as: "h3", truncate: s, children: [
        o,
        t && /* @__PURE__ */ d.jsx(
          xi,
          {
            testId: Z({ testId: e, suffix: "tooltip" }),
            spacingClasses: "a:ms-component-1",
            text: t
          }
        )
      ] }) }),
      a && /* @__PURE__ */ d.jsx(ie, { variant: "bodyM", as: "p", truncate: !0, children: a })
    ] }),
    /* @__PURE__ */ d.jsx("div", { className: "a:shrink-0", children: /* @__PURE__ */ d.jsx(
      _E,
      {
        quantity: l,
        max: n,
        onUpdate: r,
        testId: Z({ testId: e, suffix: "quantity-selector" })
      }
    ) })
  ] });
}
const AE = "brand", C1 = "quiet", An = {
  empty: "empty",
  filled: "filled",
  half: "half"
}, RE = (e, t) => {
  if (e <= 1 && t === 1)
    return !!Math.round(e % 1);
  const n = t - e;
  return n < 0 ? !1 : n > 0 && n < 1 ? !!Math.round(e % 1) : !1;
}, S1 = (e, t) => RE(e, t) ? An.half : e >= t ? An.filled : An.empty, ME = (e) => {
  switch (e) {
    case An.empty:
      return C1;
    case An.filled:
    case An.half:
      return AE;
  }
}, I1 = ({ fillState: e, ...t }) => {
  const n = ME(e), r = () => /* @__PURE__ */ d.jsxs(
    "svg",
    {
      className: Lh({ color: n }),
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ d.jsx("path", { d: "M12 1.501v17.107l-4.737 2.914a1.538 1.538 0 0 1-2.294-1.67l1.29-5.445-4.22-3.64a1.543 1.543 0 0 1 .875-2.705l5.53-.446 2.135-5.164a1.534 1.534 0 0 1 1.419-.951H12Z" }),
        /* @__PURE__ */ d.jsx(
          "path",
          {
            className: Y(e === An.half && `a:fill-content-${C1}`),
            d: "M12 18.608V1.501a1.534 1.534 0 0 1 1.416.951l2.133 5.164 5.532.446a1.543 1.543 0 0 1 .878 2.706h.006l-4.22 3.64 1.286 5.444a1.538 1.538 0 0 1-2.297 1.67L12 18.608Z"
          }
        )
      ]
    }
  );
  return /* @__PURE__ */ d.jsx($e, { ...t, source: r, size: "xs" });
}, jE = ({ rating: e, fillState: t, testId: n, onClick: r, onMouseEnter: i, onMouseLeave: a }) => {
  const o = () => {
    r(e);
  }, s = () => {
    i(e);
  }, l = () => {
    a();
  };
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      "data-testid": n,
      onClick: o,
      onMouseEnter: s,
      onMouseLeave: l,
      className: Y({
        "a:cursor-pointer": !!r
      }),
      children: /* @__PURE__ */ d.jsx(I1, { testId: Z({ testId: n, suffix: `icon-${e}` }), fillState: t })
    }
  );
}, DE = ({ testId: e, rating: t = 0, ratingItemsCount: n, onChange: r }) => {
  const [i, a] = ue(t), o = (u) => {
    a(u);
  }, s = () => {
    a(0);
  }, l = (u) => {
    r == null || r(u);
  };
  return /* @__PURE__ */ d.jsx(Pe, { testId: e, children: [...Array(n)].map((u, c) => {
    const f = c + 1, p = S1(i || t, f);
    return /* @__PURE__ */ d.jsx(
      jE,
      {
        rating: f,
        currentRating: t,
        fillState: p,
        onClick: l,
        onMouseEnter: o,
        onMouseLeave: s,
        testId: Z({ testId: e, suffix: "item" })
      },
      c
    );
  }) });
}, kE = ({ testId: e, rating: t = 0, ratingItemsCount: n = 5 }) => /* @__PURE__ */ d.jsx(Pe, { testId: e, children: [...Array(n)].map((r, i) => {
  const a = i + 1;
  return /* @__PURE__ */ d.jsx(
    I1,
    {
      fillState: S1(t, a),
      testId: Z({ testId: e, suffix: `icon-${a}` })
    },
    i
  );
}) }), IT = ({ testId: e, readOnly: t = !1, link: n, ...r }) => {
  const i = t ? kE : DE;
  return !!(n != null && n.text) && !!(n != null && n.onClick) ? /* @__PURE__ */ d.jsxs(Pe, { gap: "1", itemsAlign: "center", children: [
    /* @__PURE__ */ d.jsx(
      Jt,
      {
        condition: t,
        wrapper: (o) => /* @__PURE__ */ d.jsx(Xs, { testId: Z({ testId: e, suffix: "link-stars" }), onClick: n.onClick, variant: "tertiary", children: o }),
        children: i({
          testId: Z({ testId: e }),
          ...r
        })
      }
    ),
    /* @__PURE__ */ d.jsx(Xs, { testId: Z({ testId: e, suffix: "link-text" }), onClick: n.onClick, size: "sm", children: n.text })
  ] }) : /* @__PURE__ */ d.jsx(d.Fragment, { children: i({
    testId: Z({ testId: e }),
    ...r
  }) });
}, ET = (e) => /* @__PURE__ */ d.jsx(sv, { ...e, type: "radio" }), LE = de(
  [
    "a:relative a:flex a:flex-col a:items-start",
    "a:cursor-pointer a:text-left a:w-full a:overflow-hidden a:rounded-none a:p-3 a:md:hover:bg-neutral-50",
    "a:border-solid a:border a:border-neutral-300 a:border-b-0",
    // First item
    "a:first:rounded-t",
    // Last item
    "a:last:border-b a:last:border-t-0 a:last:shadow-[inset_0_1px_0] a:last:shadow-neutral-300 a:last:border-neutral-300 a:last:rounded-b",
    // Focus
    "a:focus-visible:rounded a:focus-visible:border a:focus-visible:border-neutral-600 a:focus-visible:outline-hidden a:focus-visible:ring-0"
  ],
  {
    variants: {
      state: {
        enabled: "a:bg-white",
        selected: "a:bg-neutral-100"
      }
    },
    defaultVariants: {
      state: "enabled"
    }
  }
);
function FE({
  children: e,
  testId: t,
  hasCheckbox: n,
  item: r,
  id: i,
  onClick: a,
  selectable: o,
  state: s
}) {
  const l = (u) => {
    o && (pt(u), a == null || a(u, r));
  };
  return /* @__PURE__ */ d.jsx("div", { className: Oe(LE({ state: s })), "data-testid": t, tabIndex: 0, onClick: l, children: /* @__PURE__ */ d.jsxs("section", { className: "a:flex a:w-full a:flex-row a:gap-2", children: [
    n && /* @__PURE__ */ d.jsx("div", { className: "a:mt-0.5", children: /* @__PURE__ */ d.jsx(lv, { id: i, checked: s === "selected", readOnly: !0 }) }),
    e
  ] }) });
}
const OT = (e) => {
  const [t, n] = ue(e || []);
  return { selectedItems: t, setSelectedItems: n, handleSelection: (i) => {
    if (!i)
      return;
    const a = t == null ? void 0 : t.includes(i);
    n(
      a ? t.filter((o) => o !== i) : [i, ...t]
    );
  } };
};
function TT({
  testId: e,
  hasCheckbox: t,
  items: n,
  renderItem: r,
  selectable: i,
  selectedItems: a = [],
  onSelectionChange: o
}) {
  const s = _t(
    () => n.map((l, u) => /* @__PURE__ */ d.jsx(
      FE,
      {
        id: l.id,
        hasCheckbox: t,
        selectable: i,
        state: a != null && a.includes(l) ? "selected" : null,
        item: l,
        onClick: o,
        testId: Z({ testId: e, suffix: "item" }),
        children: r(l, u)
      },
      Ja("resource-item-")
    )),
    [n, a]
  );
  return /* @__PURE__ */ d.jsx("div", { "data-testid": e, className: "a:resource-list-wrapper a:flex a:flex-col", children: s });
}
const PT = ({
  id: e,
  label: t,
  icon: n,
  error: r,
  tooltipText: i,
  testId: a
}) => /* @__PURE__ */ d.jsxs(We, { gap: "1", testId: a, children: [
  t && /* @__PURE__ */ d.jsxs(Pe, { gap: "2", wrap: "nowrap", children: [
    /* @__PURE__ */ d.jsx(za, { testId: Z({ testId: a, suffix: "label" }), htmlFor: e, children: t }),
    !!i && /* @__PURE__ */ d.jsx(xi, { testId: Z({ testId: a, suffix: "tooltip" }), text: i, children: /* @__PURE__ */ d.jsx($e, { source: Ka, size: "sm" }) })
  ] }),
  /* @__PURE__ */ d.jsx("div", { className: Y("a:relative a:[&_iframe]:min-w-full a:[&_iframe]:max-w-full"), children: /* @__PURE__ */ d.jsxs(
    Pe,
    {
      gap: "1",
      itemsAlign: "center",
      wrap: "nowrap",
      testId: Z({ testId: a, suffix: "input-wrapper" }),
      children: [
        /* @__PURE__ */ d.jsx("div", { id: e, className: "a:w-full", children: /* @__PURE__ */ d.jsx(Xt, { id: `${e}-input`, readOnly: !0 }) }),
        n && /* @__PURE__ */ d.jsx("div", { className: Y("a:absolute a:right-2"), children: /* @__PURE__ */ d.jsx(De, { padding: "2", testId: Z({ testId: a, suffix: "icon" }), children: /* @__PURE__ */ d.jsx($e, { size: "sm", source: n }) }) })
      ]
    }
  ) }),
  !!r && /* @__PURE__ */ d.jsx(yi, { testId: Z({ testId: a, suffix: "error" }), children: r })
] }), VE = (e) => /* @__PURE__ */ M.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 120, height: 120, viewBox: "0 0 120 120", ...e }, /* @__PURE__ */ M.createElement("circle", { cx: 60, cy: 60, r: 60, fillOpacity: 0.2 }), /* @__PURE__ */ M.createElement("path", { fillRule: "evenodd", d: "M51.53 75.812V44.19h2.117v31.623z", clipRule: "evenodd" }), /* @__PURE__ */ M.createElement("path", { fillRule: "evenodd", d: "M68.47 44.19v31.623h-2.117V44.189z", clipRule: "evenodd" }), /* @__PURE__ */ M.createElement("path", { fillRule: "evenodd", d: "M44.188 75.812V44.19h4.235v31.623z", clipRule: "evenodd" }), /* @__PURE__ */ M.createElement("path", { fillRule: "evenodd", d: "M75.811 44.19v31.623h-4.235V44.189z", clipRule: "evenodd" }), /* @__PURE__ */ M.createElement("path", { fillRule: "evenodd", d: "M57.176 75.812V44.19h5.648v31.623z", clipRule: "evenodd" }), /* @__PURE__ */ M.createElement("path", { fillRule: "evenodd", d: "M36 41.417A5.417 5.417 0 0 1 41.417 36h5.41v2.824h-5.41a2.593 2.593 0 0 0-2.593 2.593v5.675H36z", clipRule: "evenodd" }), /* @__PURE__ */ M.createElement("path", { fillRule: "evenodd", d: "M36 78.583A5.417 5.417 0 0 0 41.417 84h5.41v-2.823h-5.41a2.593 2.593 0 0 1-2.593-2.594v-5.675H36z", clipRule: "evenodd" }), /* @__PURE__ */ M.createElement("path", { fillRule: "evenodd", d: "M84 41.417A5.417 5.417 0 0 0 78.583 36h-5.41v2.824h5.41a2.593 2.593 0 0 1 2.594 2.593v4.062H84z", clipRule: "evenodd" }), /* @__PURE__ */ M.createElement("path", { fillRule: "evenodd", d: "M84 78.583A5.417 5.417 0 0 1 78.583 84h-5.41v-2.823h5.41a2.593 2.593 0 0 0 2.594-2.594v-4.062H84z", clipRule: "evenodd" })), BE = (e) => /* @__PURE__ */ M.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ M.createElement("path", { fillRule: "evenodd", d: "M15.016 18.5v-13h.714v13z", clipRule: "evenodd" }), /* @__PURE__ */ M.createElement("path", { fillRule: "evenodd", d: "M9.876 18.5v-13h1.19v13z", clipRule: "evenodd" }), /* @__PURE__ */ M.createElement("path", { fillRule: "evenodd", d: "M7.89 18.5v-13h.714v13z", clipRule: "evenodd" }), /* @__PURE__ */ M.createElement("path", { fillRule: "evenodd", d: "M16.575 18.5v-13h1.905v13z", clipRule: "evenodd" }), /* @__PURE__ */ M.createElement("path", { fillRule: "evenodd", d: "M5.333 18.5v-13h1.429v13z", clipRule: "evenodd" }), /* @__PURE__ */ M.createElement("path", { fillRule: "evenodd", d: "M12.52 18.5v-13h1.906v13z", clipRule: "evenodd" }), /* @__PURE__ */ M.createElement("path", { fillRule: "evenodd", d: "M2 3.827C2 2.818 2.818 2 3.827 2h2.62v.952h-2.62a.875.875 0 0 0-.875.875v2.73H2z", clipRule: "evenodd" }), /* @__PURE__ */ M.createElement("path", { fillRule: "evenodd", d: "M2 20.173C2 21.182 2.818 22 3.827 22h2.62v-.952h-2.62a.875.875 0 0 1-.875-.875v-2.73H2z", clipRule: "evenodd" }), /* @__PURE__ */ M.createElement("path", { fillRule: "evenodd", d: "M22 3.827C22 2.818 21.182 2 20.173 2h-2.62v.952h2.62c.483 0 .875.392.875.875v2.05H22z", clipRule: "evenodd" }), /* @__PURE__ */ M.createElement("path", { fillRule: "evenodd", d: "M22 20.173C22 21.182 21.182 22 20.173 22h-2.62v-.952h2.62a.875.875 0 0 0 .875-.875v-2.05H22z", clipRule: "evenodd" }));
function NT({ autoActive: e, activeLabel: t, testId: n, bottomLabel: r, onScan: i }) {
  const a = ce(null), [o, s] = ue(!1);
  se(() => {
    e && a.current && c();
  }, []);
  const l = (h) => {
    const m = h.target.value;
    a.current && (a.current.value = ""), i(m), s(!1);
  }, u = (h) => {
    h == null || h.preventDefault(), h == null || h.stopPropagation(), c();
  }, c = () => {
    s(!0), a.current && (a.current.readOnly = !0, a.current.focus({ preventScroll: !0 }), setTimeout(function() {
      a.current && (a.current.readOnly = !1);
    }));
  }, f = (h) => {
    h.preventDefault(), s(!1);
  }, p = /* @__PURE__ */ d.jsxs(
    "div",
    {
      role: "group",
      "data-testid": n,
      className: Y("a:fixed a:inset-0 a:z-scan a:flex a:items-center a:justify-center a:backdrop-blur-xs"),
      children: [
        /* @__PURE__ */ d.jsx(br, { testId: Z({ testId: n, suffix: "overlay" }), onClick: () => s(!1) }),
        /* @__PURE__ */ d.jsxs("div", { className: "a:z-modal a:flex a:items-center a:justify-center", children: [
          /* @__PURE__ */ d.jsxs(ov, { direction: "col", align: "center", children: [
            /* @__PURE__ */ d.jsx(VE, { className: "a:mb-6 a:animate-pulse a:fill-white" }),
            /* @__PURE__ */ d.jsx(ie, { as: "p", variant: "titleS", color: "inverse", children: t })
          ] }),
          /* @__PURE__ */ d.jsx("div", { className: "a:absolute a:bottom-6", children: /* @__PURE__ */ d.jsx(ie, { as: "p", variant: "bodyS", color: "inverse", children: r }) })
        ] })
      ]
    }
  );
  return /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
    /* @__PURE__ */ d.jsxs("section", { className: "a:flex", children: [
      /* @__PURE__ */ d.jsx("div", { className: "a:sr-only", children: /* @__PURE__ */ d.jsx("input", { ref: a, type: "text", onBlur: f, onChange: l }) }),
      /* @__PURE__ */ d.jsx(
        it,
        {
          variant: "plain",
          size: "sm",
          icon: {
            source: BE,
            color: "neutral"
          },
          onClick: u,
          ariaLabel: "scan button",
          testId: n
        }
      )
    ] }),
    o && di(p, document.body)
  ] });
}
const HE = ({ cellProps: e, section: t, children: n }) => /* @__PURE__ */ d.jsx(ut.Cell, { span: t === "content" ? "full" : void 0, ...e, children: n }), KE = de(
  "a:relative a:flex a:flex-col a:items-start a:text-left a:w-full a:overflow-hidden a:rounded-lg a:border a:border-solid a:p-4 a:focus:border-border-focus",
  {
    variants: {
      state: {
        resting: "a:border-border-neutral a:hover:border-border-neutral-hover a:cursor-pointer",
        active: "a:border-border-active a:hover:border-border-neutral-hover a:cursor-pointer",
        error: "a:border-border-error a:hover:border-border-neutral-hover a:cursor-pointer",
        disabled: "a:bg-surface-neutral-disabled a:border-border-neutral a:cursor-not-allowed"
      }
    },
    defaultVariants: {
      state: "resting"
    }
  }
), Ut = ({
  align: e = "baseline",
  testId: t,
  children: n,
  innerRef: r,
  id: i,
  onClick: a,
  state: o = "resting",
  hasGapX: s = !0,
  hasGapY: l = !0
}) => {
  const u = xt(n, Ut.Cell, { section: "media" }), c = xt(n, Ut.Cell, { section: "header" }), f = xt(n, Ut.Cell, { section: "tag" }), p = {
    "--selection-card-cols": `${u.length > 0 ? "auto" : ""} ${c.length > 0 ? "1fr" : ""} ${f.length > 0 ? "auto" : ""}`
  }, h = (m) => {
    o !== "disabled" && (o === "resting" && pt(m), a == null || a(m));
  };
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      id: i,
      className: Y(KE({ state: o })),
      "data-testid": t,
      onClick: h,
      style: p,
      ref: r,
      children: /* @__PURE__ */ d.jsxs(
        ut,
        {
          align: e,
          columns: "selection-card",
          fullWidth: !0,
          gapY: l ? { xs: 1, md: 2 } : { xs: 0 },
          gapX: s ? { xs: 2, md: 4 } : { xs: 0 },
          children: [
            u,
            c,
            f,
            xt(n, Ut.Cell, { section: "content" })
          ]
        }
      )
    }
  );
};
Ut.Cell = HE;
const _T = ({
  items: e,
  noneLabel: t = "None",
  testId: n,
  title: r,
  value: i,
  mobileOptionsView: a = "OptionCard",
  input: o,
  search: s,
  onReset: l,
  onSelect: u,
  onChange: c
}) => {
  const [f, p] = ue(!1), [h, m] = ue(null), v = a === "OptionCard", { getItemProps: g, getMenuProps: b, getToggleButtonProps: y, isOpen: x, highlightedIndex: w } = gi({
    id: o.id,
    selectedItem: h,
    items: e,
    isItemDisabled: (_) => !!_.disabled,
    onSelectedItemChange: ({ selectedItem: _ }) => {
      m(_), u == null || u(_), c == null || c(_.id);
    },
    itemToString: (_) => _ ? _.text : "",
    stateReducer: x1
  }), { getDropdownProps: $, getReferenceProps: C, refs: T } = Xu({ isOpen: x });
  se(() => {
    m((e == null ? void 0 : e.find((_) => _.id === i)) || null);
  }, [i]);
  const S = (_) => () => {
    m(_), u == null || u(_), c == null || c(_.id), k();
  }, N = () => {
    m(null), l == null || l(), c == null || c(), k();
  }, k = () => {
    var _;
    p(!1), (_ = s == null ? void 0 : s.onChange) == null || _.call(s, "");
  }, L = v ? /* @__PURE__ */ d.jsx(Ut, { onClick: N, children: /* @__PURE__ */ d.jsx(Ut.Cell, { section: "header", children: /* @__PURE__ */ d.jsx(ie, { variant: "bodyM", color: "neutral", children: t }) }) }) : /* @__PURE__ */ d.jsx(ya, { text: t, onClick: N });
  return /* @__PURE__ */ d.jsxs("div", { className: "a:relative", "data-testid": n, children: [
    /* @__PURE__ */ d.jsx(
      Xt,
      {
        ...o,
        readOnly: !0,
        defaultValue: h ? h.text : o.defaultValue,
        ...y({
          refKey: "innerRef",
          onClick: () => p(!0)
        }),
        ...C(),
        testId: Z({ testId: n, suffix: "text-field" }),
        outerRef: T.setReference,
        adornmentEnd: /* @__PURE__ */ d.jsx(
          it,
          {
            ...y({
              refKey: "innerRef",
              onClick: () => p(!0),
              role: "button"
            }),
            variant: "plain",
            size: "sm",
            icon: { source: vi },
            state: o.disabled ? "disabled" : "interactive",
            testId: Z({ testId: n, suffix: "text-field-button" })
          }
        )
      }
    ),
    /* @__PURE__ */ d.jsx(ba, { until: "md", children: /* @__PURE__ */ d.jsxs(
      Qu,
      {
        isOpen: f,
        testId: Z({ testId: n, suffix: `${o.id}-bottom-sheet` }),
        onClose: k,
        container: document.body,
        children: [
          /* @__PURE__ */ d.jsx(De, { paddingBlockEnd: "8", children: /* @__PURE__ */ d.jsxs(We, { gap: "4", children: [
            o.placeholder && /* @__PURE__ */ d.jsx(ie, { variant: "headingS", as: "h3", children: o.placeholder }),
            r && /* @__PURE__ */ d.jsx(ie, { variant: "headingXS", children: r }),
            s && /* @__PURE__ */ d.jsx(lc, { ...s, autoSearch: !0 })
          ] }) }),
          /* @__PURE__ */ d.jsxs(We, { gap: v ? "3" : void 0, children: [
            e.map((_, B) => {
              const A = {
                item: _,
                index: B,
                disable: _.disabled,
                refKey: "innerRef",
                onClick: S(_)
              };
              return v ? /* @__PURE__ */ d.jsx(
                Ut,
                {
                  ...g({
                    key: `option-card-${_.id}`,
                    state: _.disabled ? "disabled" : (h == null ? void 0 : h.id) === _.id ? "active" : "resting",
                    ...A
                  }),
                  children: /* @__PURE__ */ d.jsxs(Ut.Cell, { section: "header", children: [
                    /* @__PURE__ */ d.jsx(ie, { variant: "bodyM", color: "neutral", strike: _.strikethrough, children: _.text }),
                    _.hint && /* @__PURE__ */ d.jsx(ie, { variant: "bodyM", color: "subtle", children: _.hint })
                  ] })
                }
              ) : /* @__PURE__ */ d.jsx(
                ya,
                {
                  ...g({
                    key: `list-item-${_.id}`,
                    state: (h == null ? void 0 : h.id) === _.id ? "selected" : "enabled",
                    ...A
                  }),
                  text: _.text
                }
              );
            }),
            !o.required && L
          ] })
        ]
      }
    ) }),
    /* @__PURE__ */ d.jsx(ba, { from: "md", children: /* @__PURE__ */ d.jsxs(
      Tt,
      {
        ...b({ isOpen: x, refKey: "innerRef", ref: T.floating }, { suppressRefError: !0 }),
        ...$(),
        testId: Z({ testId: n, suffix: "dropdown" }),
        children: [
          e.map((_, B) => /* @__PURE__ */ d.jsx(
            Tt.Item,
            {
              ...g({
                key: _.id,
                index: B,
                item: _,
                refKey: "innerRef",
                isHighlighted: w === B,
                isSelected: (h == null ? void 0 : h.id) === _.id,
                text: _.strikethrough ? `<s>${_.text}</s>` : _.text,
                isItemDisabled: _.disabled,
                ...!_.disabled && { onMouseDown: pt }
              })
            }
          )),
          !o.required && /* @__PURE__ */ d.jsx(
            Tt.Item,
            {
              ...g({
                item: { id: "none", text: t },
                key: "none",
                refKey: "innerRef",
                text: t,
                onMouseDown: pt,
                onClick: N
              })
            }
          )
        ]
      }
    ) })
  ] });
}, AT = ({
  error: e,
  hint: t,
  id: n,
  list: r,
  name: i,
  noneLabel: a = "None",
  onBlur: o,
  onChange: s,
  onReset: l,
  onSelect: u,
  label: c,
  placeholder: f,
  required: p,
  spacingClasses: h,
  testId: m,
  title: v,
  value: g,
  search: b
}) => {
  const [y, x] = ue(!1), [w, $] = ue(), C = (L) => () => {
    $(L), u(L), k();
  }, T = () => {
    $(null), l(), k();
  }, S = () => {
    x(!0);
  }, N = /* @__PURE__ */ d.jsx(
    it,
    {
      type: "button",
      size: "sm",
      variant: "plain",
      icon: { source: vi },
      onClick: S
    }
  );
  se(() => {
    $((r == null ? void 0 : r.find((L) => L.id === g)) || null);
  }, [g]);
  const k = () => {
    x(!1), b != null && b.onChange && (b == null || b.onChange(""));
  };
  return /* @__PURE__ */ d.jsxs("div", { "data-testid": m, className: Oe(Ze(h)), children: [
    /* @__PURE__ */ d.jsx(
      Xt,
      {
        label: c,
        placeholder: f,
        hint: t,
        id: n,
        name: i,
        onBlur: o,
        onChange: s,
        readOnly: !0,
        required: p,
        error: e,
        value: w ? w.value : "",
        onFocus: () => {
          x(!0);
        },
        adornmentEnd: N
      }
    ),
    /* @__PURE__ */ d.jsxs(Qu, { isOpen: y, onClose: k, testId: "bottom-sheet-" + n, children: [
      /* @__PURE__ */ d.jsx(De, { paddingBlock: "10", children: /* @__PURE__ */ d.jsx(ie, { variant: "headingS", as: "h3", children: f }) }),
      v && /* @__PURE__ */ d.jsx(De, { paddingBlockEnd: "4", children: /* @__PURE__ */ d.jsx(ie, { variant: "titleL", as: "p", children: v }) }),
      b && /* @__PURE__ */ d.jsx(tv, { ...b, wrapperClassName: "a:mb-10 a:mt-2", autoSearch: !0 }),
      /* @__PURE__ */ d.jsxs(We, { gap: "4", children: [
        r.map((L) => /* @__PURE__ */ d.jsx(
          mp,
          {
            title: L.value,
            state: L.value === g ? "selected" : "enabled",
            onClick: C(L),
            subtitle: L.hint ? { text: L.hint, color: "subtle" } : void 0
          },
          `option-card-${L.id}`
        )),
        !p && /* @__PURE__ */ d.jsx(mp, { title: a, onClick: T })
      ] })
    ] })
  ] });
}, WE = {
  "slide-in-right-left": "a:animate-slide-out-left-right",
  "slide-in-left-right": "a:animate-slide-out-right-left",
  none: ""
}, zE = de("a:bg-white a:flex a:flex-col a:shrink-0", {
  variants: {
    side: {
      left: "a:bottom-0 a:left-0",
      right: "a:bottom-0 a:right-0"
    },
    animation: {
      "slide-in-right-left": "a:animate-slide-in-right-left",
      "slide-in-left-right": "a:animate-slide-in-left-right",
      none: ""
    },
    hasShadow: {
      true: "a:shadow-sidebar",
      false: ""
    },
    position: {
      relative: "a:relative",
      fixed: "a:fixed",
      sticky: "a:sticky"
    },
    zIndex: {
      default: "a:z-sidebar",
      overlay: "a:z-overlay",
      modal: "a:z-modal",
      sticky: "a:z-sticky"
    },
    fullHeight: {
      default: "a:top-0 a:h-dvh",
      false: "a:lg:py-3 a:py-3"
    },
    footer: {
      absolute: "a:px-6 a:pt-6 a:lg:px-8 a:lg:pt-8",
      sticky: "a:p-6 a:lg:p-8"
    }
  },
  defaultVariants: {
    side: "right",
    animation: "slide-in-right-left",
    hasShadow: !1,
    position: "relative",
    zIndex: "default",
    fullHeight: "default",
    footer: "sticky"
  }
}), GE = de("a:grow-1", {
  variants: {
    align: {
      top: "",
      middle: "a:flex a:flex-col a:justify-middle",
      bottom: "a:flex a:flex-col a:justify-end"
    }
  },
  defaultVariants: {
    align: "top"
  }
}), RT = ({
  testId: e,
  children: t,
  isOpen: n = !1,
  onClose: r,
  onCloseStart: i,
  hasCloseBtn: a = !0,
  hasCloseBtnSpacing: o = !0,
  hasBackdrop: s = !0,
  hasShadow: l = !s || !1,
  footerContent: u,
  footer: c,
  headerContent: f,
  customWidth: p,
  side: h,
  animation: m = h === "left" ? "slide-in-left-right" : "slide-in-right-left",
  align: v,
  position: g,
  zIndex: b,
  fullHeight: y
}) => {
  const [x, w] = ue(n), $ = ce(null), C = ce(null), T = m !== "none", S = () => {
    w(!1), r == null || r();
  }, N = () => {
    var k, L;
    i == null || i(), T ? ((k = $.current) == null || k.classList.remove(`a:animate-${m}`), (L = $.current) == null || L.classList.add(m && WE[m]), s && C.current && (C.current.classList.remove("a:animate-backdrop-fade-in"), C.current.classList.add("a:animate-backdrop-fade-out")), setTimeout(() => {
      S();
    }, Ay)) : S();
  };
  return se(() => {
    w((k) => (k && !n && N(), n));
  }, [n]), x ? /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
    s && /* @__PURE__ */ d.jsx(
      br,
      {
        testId: Z({ testId: e, suffix: "overlay" }),
        onClick: N,
        backdropRef: C,
        zIndex: b
      }
    ),
    /* @__PURE__ */ d.jsxs(
      "div",
      {
        "data-testid": e,
        ref: $,
        className: Oe(
          "a:overflow-auto",
          zE({ zIndex: b, side: h, animation: m, hasShadow: l, position: g, fullHeight: y, footer: c == null ? void 0 : c.position }),
          !p && "a:w-sidebar"
        ),
        style: {
          ...typeof p == "object" ? p : {
            width: p
          }
        },
        children: [
          a && /* @__PURE__ */ d.jsx(
            "div",
            {
              className: Oe("a:flex a:self-end a:-mt-4 a:-ms-4 a:-me-4", {
                "a:mb-20": o
              }),
              children: /* @__PURE__ */ d.jsx(
                it,
                {
                  onClick: N,
                  variant: "plain",
                  icon: { source: bn, size: "sm" },
                  testId: Z({ testId: e, suffix: "close-btn" })
                }
              )
            }
          ),
          f && /* @__PURE__ */ d.jsx("div", { "data-testid": "sidebar-header", className: Y("a:flex"), children: f }),
          /* @__PURE__ */ d.jsx(
            "div",
            {
              className: Oe(GE({ align: v })),
              "data-testid": Z({ testId: e, suffix: "content" }),
              children: t
            }
          ),
          ((c == null ? void 0 : c.content) || u) && /* @__PURE__ */ d.jsx(
            "div",
            {
              "data-testid": "sidebar-footer",
              className: Y({
                "a:sticky a:bottom-0 a:-mx-6 a:bg-white a:px-6 a:py-3 a:shadow-xs a:lg:-mx-8 a:lg:px-8 a:lg:py-4": (c == null ? void 0 : c.position) === "absolute",
                "a:pt-10": (c == null ? void 0 : c.position) === "sticky"
              }),
              children: (c == null ? void 0 : c.content) || u
            }
          )
        ]
      }
    )
  ] }) : null;
}, xh = (e) => /* @__PURE__ */ M.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", ...e }, /* @__PURE__ */ M.createElement("path", { d: "M8 13A5 5 0 1 0 8 3a5 5 0 0 0 0 10" })), UE = (e) => /* @__PURE__ */ M.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", ...e }, /* @__PURE__ */ M.createElement("path", { fillRule: "evenodd", d: "M3 8a5 5 0 1 0 10 0", clipRule: "evenodd" }), /* @__PURE__ */ M.createElement("path", { fillRule: "evenodd", d: "M8 13A5 5 0 1 0 8 3a5 5 0 0 0 0 10m0-8.333A3.333 3.333 0 0 1 11.333 8H4.667A3.333 3.333 0 0 1 8 4.667", clipRule: "evenodd" })), qE = (e) => /* @__PURE__ */ M.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", ...e }, /* @__PURE__ */ M.createElement("path", { fillRule: "evenodd", d: "M8 11.333a3.333 3.333 0 1 0 0-6.666 3.333 3.333 0 0 0 0 6.666M13 8A5 5 0 1 1 3 8a5 5 0 0 1 10 0", clipRule: "evenodd" }), /* @__PURE__ */ M.createElement("path", { fillRule: "evenodd", d: "M11.178 6 6 11.178 4.821 10 10 4.821z", clipRule: "evenodd" })), YE = (e) => /* @__PURE__ */ M.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", ...e }, /* @__PURE__ */ M.createElement("path", { fillRule: "evenodd", d: "M8 11.333a3.333 3.333 0 1 0 0-6.666 3.333 3.333 0 0 0 0 6.666M13 8A5 5 0 1 1 3 8a5 5 0 0 1 10 0", clipRule: "evenodd" })), E1 = {
  complete: { icon: { source: xh, color: "success" }, text: "success" },
  partiallyComplete: { icon: { source: UE, color: "success" }, text: "success" },
  incomplete: { icon: { source: YE, color: "error" }, text: "error" },
  unavailable: { icon: { source: qE, color: "neutral" }, text: "neutral" },
  informative: { icon: { source: xh, color: "informative" }, text: "informative" }
}, $h = ({ status: e }) => /* @__PURE__ */ d.jsx($e, { ...E1[e].icon, size: "xs" }), MT = ({
  status: e,
  colored: t,
  strong: n,
  children: r,
  testId: i,
  align: a = "start"
}) => /* @__PURE__ */ d.jsxs(Pe, { wrap: "nowrap", gap: "2", testId: i, contentAlign: a, children: [
  a === "start" && /* @__PURE__ */ d.jsx(De, { paddingBlockStart: "1", children: /* @__PURE__ */ d.jsx($h, { status: e }) }),
  /* @__PURE__ */ d.jsxs(ie, { color: t ? E1[e].text : "neutral", strong: n, alignment: a, children: [
    a === "end" && /* @__PURE__ */ d.jsx(De, { paddingInlineEnd: "2", display: "inline-flex", position: "relative", top: "0.75", children: /* @__PURE__ */ d.jsx($h, { status: e }) }),
    r
  ] })
] }), XE = de("a:z-10", {
  variants: {
    current: {
      true: "a:border-[2px] a:w-[12px] a:h-[12px] a:md:border-[3px] a:md:w-[16px] a:md:h-[16px] a:border-solid a:border-content-brand a:rounded-circle a:relative a:bg-white",
      false: "a:w-[10px] a:h-[10px] a:[clip-path:circle(5px)] a:md:[clip-path:circle(6px)] a:mt-[1px] a:md:w-[12px] a:md:h-[12px] a:md:mt-[2px] a:bg-content-brand"
    },
    passed: {
      true: "a:bg-content-brand",
      false: "a:bg-surface-quiet-2"
    }
  }
}), ZE = de("a:flex a:flex-col a:relative", {
  variants: {
    first: { true: "a:w-1/2" },
    last: {
      true: Y(
        'a:before:absolute a:before:top-[5px] a:before:h-[2px] a:before:content-[""] a:md:before:top-[7px]',
        "a:before:w-[200%] a:before:right-[0%]",
        "a:w-1/2"
      )
    },
    passed: { true: "a:before:bg-content-brand a:text-content-brand" },
    current: { true: "a:before:bg-content-brand a:text-content-brand" }
  },
  compoundVariants: [
    {
      first: !1,
      last: !1,
      class: Y(
        "a:w-full",
        'a:before:absolute a:before:top-[5px] a:before:h-[2px] a:before:content-[""] a:md:before:top-[7px]',
        "a:before:right-[50%] a:before:w-full"
      )
    },
    {
      passed: !1,
      current: !1,
      class: "a:before:bg-surface-quiet-2 a:text-content-subtle"
    }
  ]
}), JE = ({ children: e, testId: t }) => {
  const n = Aa.toArray(e).filter(Boolean);
  if (n.length <= 1)
    throw new Error("Stepper component should have at least 2 steps");
  return /* @__PURE__ */ d.jsx("div", { className: "a:flex a:flex-row a:justify-between", "data-testid": t, children: n.map((r, i) => {
    const a = i === 0, o = i === n.length - 1;
    return K1(r) && _a(r, { first: a, last: o });
  }) });
}, QE = ({ title: e, first: t, last: n, current: r = !1, passed: i = !1 }) => {
  const a = n ? "end" : t ? void 0 : "center";
  return /* @__PURE__ */ d.jsx("div", { className: ZE({ first: t, last: n, current: r, passed: i }), children: /* @__PURE__ */ d.jsxs(We, { itemsAlign: a, gap: "2", children: [
    /* @__PURE__ */ d.jsx("div", { className: XE({ current: r, passed: i }) }),
    /* @__PURE__ */ d.jsx(ie, { variant: "bodyXS", strong: r, children: e })
  ] }) });
};
JE.Step = QE;
const eO = de(
  "a:relative a:overflow-hidden a:flex a:items-center a:justify-center a:border a:border-solid a:transition-all a:duration-300",
  {
    variants: {
      size: {
        sm: "a:w-8 a:h-8",
        md: "a:w-9 a:h-9",
        lg: "a:w-11 a:h-11"
      },
      isRounded: {
        true: "a:rounded-circle"
      },
      checked: {
        true: "a:border-black a:p-[3px]",
        false: "a:border-transparent a:p-[5px]"
      },
      disabled: {
        true: "a:cursor-not-allowed",
        false: "a:cursor-pointer"
      }
    },
    defaultVariants: {
      isRounded: !0,
      checked: !1
    }
  }
), tO = de("a:w-full a:h-full", {
  variants: {
    isRounded: {
      true: "a:rounded-circle"
    },
    hasBorder: {
      true: "a:border a:border-solid a:border-border-neutral",
      false: ""
    }
  },
  defaultVariants: {
    isRounded: !0,
    hasBorder: !1
  }
}), O1 = ({
  testId: e,
  id: t,
  name: n,
  value: r,
  alt: i = r,
  title: a = r,
  size: o = "sm",
  imageUrl: s,
  isRounded: l,
  checked: u,
  disabled: c,
  hasBorder: f = !1,
  lazyLoad: p,
  textOverlay: h,
  onChange: m,
  onBlur: v,
  onClick: g
}) => {
  const b = (w) => {
    !c && (m == null || m(w));
  }, y = (w) => {
    !c && (v == null || v(w));
  }, x = (w) => {
    !c && (g == null || g(w));
  };
  return /* @__PURE__ */ d.jsxs(
    "label",
    {
      htmlFor: t,
      className: Y(
        "a:inline-flex a:items-center",
        c ? "a:cursor-not-allowed a:opacity-50" : "a:cursor-pointer"
      ),
      title: a,
      "data-testid": e,
      children: [
        /* @__PURE__ */ d.jsx(
          "input",
          {
            type: "radio",
            id: t,
            name: n,
            value: r,
            checked: u,
            disabled: c,
            className: "a:sr-only",
            onChange: b,
            onBlur: y,
            onClick: x
          }
        ),
        /* @__PURE__ */ d.jsxs(
          "div",
          {
            role: "button",
            className: eO({
              isRounded: l,
              checked: u,
              disabled: c,
              size: o
            }),
            children: [
              /* @__PURE__ */ d.jsx(
                "img",
                {
                  src: s,
                  alt: i,
                  title: a,
                  loading: p ? "lazy" : void 0,
                  className: tO({ isRounded: l, hasBorder: f })
                }
              ),
              h && /* @__PURE__ */ d.jsx("div", { className: "a:absolute a:inset-0 a:flex a:items-center a:justify-center", children: /* @__PURE__ */ d.jsx(ie, { variant: "bodyXS", color: "inverse", strong: !0, alignment: "center", children: h }) })
            ]
          }
        )
      ]
    }
  );
}, jT = O1, T1 = ({
  swatches: e,
  name: t,
  selectedValue: n,
  isRounded: r,
  disabled: i,
  onChange: a
}) => {
  const o = (s) => {
    a == null || a(s.target.value);
  };
  return /* @__PURE__ */ d.jsx(d.Fragment, { children: e.map((s, l) => /* @__PURE__ */ d.jsx(
    O1,
    {
      name: t,
      checked: n === s.value,
      isRounded: r,
      disabled: i,
      onChange: o,
      ...s
    },
    l
  )) });
}, nO = ({
  testId: e = "swatch-selector-expander",
  name: t,
  disabled: n,
  swatches: r,
  selectedValue: i,
  isRounded: a,
  maxAmount: o,
  onChange: s
}) => {
  const [l, u] = ue(!1), c = () => {
    u(!0);
  }, f = (h) => /* @__PURE__ */ d.jsx(
    T1,
    {
      swatches: h,
      name: t,
      selectedValue: i,
      isRounded: a,
      disabled: n,
      onChange: s
    }
  );
  return l ? f(r) : ((h, m) => {
    const [v, g] = [h.slice(0, m), h.slice(m)];
    return /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
      f(v),
      g.length > 0 && !l ? /* @__PURE__ */ d.jsx(Dn, { testId: `${e}-button`, text: `+${g.length}`, onClick: c }) : f(g)
    ] });
  })(r, o);
};
function DT({
  testId: e,
  name: t,
  swatches: n,
  disabled: r,
  maxAmount: i,
  isRounded: a = !0,
  defaultValue: o,
  onChange: s
}) {
  const [l, u] = ue(o), c = (f) => {
    r || (u(f), s == null || s(f));
  };
  return /* @__PURE__ */ d.jsx(Pe, { testId: e, gap: "2", children: i && n.length > i ? /* @__PURE__ */ d.jsx(
    nO,
    {
      testId: Z({ testId: e, suffix: "expander" }),
      swatches: n,
      name: t,
      selectedValue: l,
      isRounded: a,
      disabled: r,
      maxAmount: i,
      onChange: c
    }
  ) : /* @__PURE__ */ d.jsx(
    T1,
    {
      swatches: n,
      name: t,
      selectedValue: l,
      isRounded: a,
      disabled: r,
      onChange: c
    }
  ) });
}
const kT = ({
  id: e = "switch",
  testId: t,
  disabled: n = !1,
  checked: r = !1,
  label: i,
  name: a = e,
  value: o = e,
  readOnly: s,
  onChange: l
}) => /* @__PURE__ */ d.jsxs("label", { "data-testid": t, htmlFor: a, className: Oe({ "a:flex a:w-fit a:items-center a:gap-2": !!i }), children: [
  /* @__PURE__ */ d.jsx(
    "div",
    {
      className: Oe([
        "peer a:ring-brand-focus-outline a:relative a:h-[20px] a:w-[32px] a:rounded-xl a:ring-offset-1 a:transition-colors a:duration-100",
        'a:before:shadow-s a:before:absolute a:before:left-[2px] a:before:top-[2px] a:before:h-[16px] a:before:w-[16px] a:before:bg-white a:before:transition-all a:before:duration-100 a:before:content-[""] a:before:rounded-circle',
        "a:has-[:enabled]:cursor-pointer a:has-[:enabled]:bg-content-neutral",
        "a:has-[:enabled]:hover:bg-content-neutral-hover a:has-[:enabled]:focus:ring-1 a:has-[:enabled]:active:ring-1",
        "a:has-[:checked]:before:translate-x-[12px]",
        "a:has-[:enabled]:has-[:checked]:bg-content-informative a:has-[:enabled]:has-[:checked]:hover:bg-content-informative-hover",
        "a:has-[:disabled]:cursor-not-allowed a:has-[:disabled]:bg-content-neutral-disabled",
        "a:has-[:disabled]:has-[:checked]:bg-content-informative-disabled"
      ]),
      children: /* @__PURE__ */ d.jsx(
        "input",
        {
          id: e,
          "data-testid": Z({ testId: t, suffix: "input" }),
          name: a,
          value: o,
          type: "checkbox",
          className: "a:hidden a:enabled:visible",
          checked: r,
          disabled: n,
          readOnly: s,
          onChange: l,
          onClick: s ? (u) => u.preventDefault() : void 0
        }
      )
    }
  ),
  i && /* @__PURE__ */ d.jsx("span", { className: Oe("a:text-sm", n ? "a:cursor-not-allowed" : "a:cursor-pointer"), children: i })
] }), LT = ({
  testId: e,
  hasError: t,
  hint: n,
  id: r,
  innerRef: i,
  label: a,
  maxLength: o,
  name: s,
  onBlur: l,
  onChange: u,
  onFocus: c,
  onKeyDown: f,
  onKeyUp: p,
  readOnly: h,
  required: m,
  resizable: v,
  rows: g = 4,
  showCounter: b,
  spacingClasses: y,
  value: x,
  disabled: w = !1
}) => {
  const [$, C] = ue(x || ""), [T, S] = ue(t || !1);
  se(() => {
    S(t || !1);
  }, [t]);
  const N = (_) => {
    C(_.target.value), o && S(o < _.target.value.length), u && u(_);
  }, k = (_) => {
    _.key && _.key === "Unidentified" && L(_), p && p(_);
  }, L = (_) => {
    const B = new Event("change", { bubbles: !0, cancelable: !0 });
    _.currentTarget.dispatchEvent(B);
  };
  return /* @__PURE__ */ d.jsxs("div", { className: Oe(Ze(y)), children: [
    /* @__PURE__ */ d.jsx(
      "textarea",
      {
        id: r,
        className: Oe(
          "a:flex a:w-full a:flex-auto a:appearance-none a:rounded-md a:border a:border-solid a:border-border-neutral a:bg-surface-neutral a:p-4 a:text-base a:text-content-neutral a:placeholder-content-subtle a:outline-hidden a:autofill:bg-clip-text a:autofill:shadow-none a:focus-within:border-border-active a:hover:enabled:border-border-neutral-hover",
          {
            "a:border-border-error": T,
            "a:resize-none": !v,
            "a:cursor-not-allowed a:bg-surface-quiet": w
          }
        ),
        placeholder: a,
        name: s,
        onChange: N,
        onFocus: c,
        onBlur: l,
        onKeyDown: f,
        onKeyUp: k,
        value: x,
        readOnly: h,
        required: m,
        "data-testid": e,
        ref: i,
        rows: g,
        disabled: w
      }
    ),
    (n || b) && /* @__PURE__ */ d.jsxs(
      "div",
      {
        role: "alert",
        className: `a:flex a:pt-2 a:text-sm ${T ? "a:text-content-error" : "a:text-content-subtle"} `,
        children: [
          n && /* @__PURE__ */ d.jsx("span", { className: "a:me-auto", children: n }),
          b && o && /* @__PURE__ */ d.jsx($9, { max: o, spacingClasses: "a:ms-auto", value: $.length })
        ]
      }
    )
  ] });
}, rO = {
  headingL: "bold",
  headingM: "bold",
  headingS: "bold",
  headingXS: "bold",
  bodyM: "normal",
  bodyS: "normal",
  bodyXS: "normal",
  bodyXXS: "normal"
}, iO = de("a:m-0", {
  variants: {
    alignment: { start: "a:text-start", center: "a:text-center", end: "a:text-end" },
    variant: {
      headingL: "a:text-3xl a:sm:text-4xl a:xl:text-5xl a:font-fascia a:leading-10 a:sm:leading-10 a:xl:leading-10",
      headingM: "a:text-2xl a:sm:text-3xl a:font-fascia a:leading-10 a:sm:leading-10",
      headingS: "a:text-xl a:xl:text-2xl a:font-fascia a:leading-8",
      headingXS: "a:text-base a:sm:text-lg a:xl:text-xl a:font-fascia a:leading-6 a:sm:leading-8",
      bodyM: "a:text-base a:sm:text-lg a:xl:text-xl a:font-functional a:leading-6 a:sm:leading-8",
      bodyS: "a:text-sm a:xl:text-base a:font-functional a:leading-5 a:xl:leading-6",
      bodyXS: "a:text-xs a:font-functional a:leading-none",
      bodyXXS: "a:text-xs a:font-functional a:leading-none"
    },
    color: {
      primaryHeading: "a:text-content-emphasised",
      primaryBody: "a:text-content-emphasised",
      secondary: "a:text-neutral-500",
      tertiary: "a:text-neutral-400",
      light: "a:text-content-inverse",
      link: "a:text-neutral-500",
      success: "a:text-content-success",
      informative: "a:text-content-informative",
      warning: "a:text-content-warning",
      error: "a:text-content-error"
    },
    truncate: {
      true: "a:truncate"
    },
    strike: {
      true: "a:line-through"
    },
    fontWeight: {
      normal: "a:font-normal",
      bold: "a:font-bold"
    },
    whiteSpace: {
      normal: "a:whitespace-normal",
      preWrap: "a:whitespace-pre-wrap"
    },
    wordBreak: {
      normal: "a:break-normal",
      break: "a:break-words"
    }
  },
  defaultVariants: {
    variant: "bodyM",
    fontWeight: "normal"
  }
}), FT = ({
  alignment: e,
  as: t = "p",
  children: n,
  color: r,
  testId: i,
  fontWeight: a,
  spacingClasses: o,
  strike: s,
  truncate: l,
  variant: u,
  whiteSpace: c,
  wordBreak: f
}) => {
  const p = a || u && rO[u];
  return /* @__PURE__ */ d.jsx(
    t,
    {
      "data-testid": i,
      className: Oe(
        iO({
          alignment: e,
          truncate: l,
          variant: u,
          color: r,
          strike: s,
          fontWeight: p,
          whiteSpace: c,
          wordBreak: f
        }),
        Ze(o)
      ),
      children: n
    }
  );
}, VT = ({ testId: e, spacingClasses: t, id: n, hasBackgroundColor: r = !0, timeElements: i }) => /* @__PURE__ */ d.jsx(
  "div",
  {
    role: "group",
    id: n,
    "data-testid": e,
    className: Oe(
      "a:rounded a:p-5",
      Ze(t),
      r ? "a:bg-neutral-50" : ""
    ),
    children: i.map((a, o) => /* @__PURE__ */ d.jsx(Kr, { children: /* @__PURE__ */ d.jsxs("div", { className: `a:mt-2 ${a.subtitle ? "" : "a:mb-2"}`, children: [
      /* @__PURE__ */ d.jsxs("div", { className: "a:flex", children: [
        /* @__PURE__ */ d.jsx(
          "div",
          {
            className: Y(
              `a:me-5 a:flex a:h-8 a:w-8 a:shrink-0 a:items-center a:justify-center a:rounded-circle ${a.active ? "a:bg-neutral-800" : "a:bg-neutral-300"}`
            ),
            children: /* @__PURE__ */ d.jsx($e, { source: a.icon, color: a.active ? "inverse" : "neutral" })
          }
        ),
        /* @__PURE__ */ d.jsx("div", { className: "a:grid", children: /* @__PURE__ */ d.jsx(
          ie,
          {
            variant: "bodyM",
            truncate: !0,
            color: a.active ? "emphasised" : "neutral",
            testId: Z({ testId: e, suffix: `title-${o}` }),
            children: a.title
          }
        ) })
      ] }),
      /* @__PURE__ */ d.jsxs("div", { className: "a:flex a:min-h-8 a:pt-2", children: [
        /* @__PURE__ */ d.jsx("div", { className: "a:me-5 a:ms-4 a:w-px", children: o !== i.length - 1 && /* @__PURE__ */ d.jsx(
          "div",
          {
            "data-testid": Z({ testId: e, suffix: `divider-${o}` }),
            className: Y(
              `a:bg-neutral-300 ${a.subtitle && a.subtitle.length > 1 ? "a:h-full" : "a:h-8"}`
            )
          }
        ) }),
        /* @__PURE__ */ d.jsx("div", { className: "a:-mt-2 a:ms-4 a:grid a:pb-2", children: a.subtitle && a.subtitle.map((s, l) => /* @__PURE__ */ d.jsx(Kr, { children: s.tooltip ? /* @__PURE__ */ d.jsx(
          xi,
          {
            text: s.tooltip,
            hasCloseBtn: !1,
            testId: Z({ testId: e, suffix: "tooltip" }),
            children: /* @__PURE__ */ d.jsx(
              ie,
              {
                variant: "bodyXS",
                truncate: !0,
                color: a.active ? "subtle" : "neutral",
                testId: Z({ testId: e, suffix: `element-${o}-subtitle-${l}` }),
                children: s.text
              },
              l
            )
          }
        ) : /* @__PURE__ */ d.jsx(
          ie,
          {
            variant: "bodyXS",
            truncate: !0,
            color: a.active ? "subtle" : "neutral",
            testId: Z({ testId: e, suffix: `element-${o}-subtitle-${l}` }),
            children: s.text
          },
          l
        ) }, `${e}-${o}-${l}`)) })
      ] })
    ] }) }, o))
  }
), BT = ({ testId: e, id: t, timeElements: n }) => {
  const r = (i, a, o, s) => /* @__PURE__ */ d.jsx(
    ie,
    {
      variant: "bodyS",
      color: i ? "neutral" : "subtle",
      testId: Z({ testId: e, suffix: `element-${o}-subtitle-${s}` }),
      children: a
    },
    s
  );
  return /* @__PURE__ */ d.jsx(We, { id: t, testId: e, gap: "2", children: n.map((i, a) => {
    var o;
    return /* @__PURE__ */ d.jsxs(Pe, { gap: "3", wrap: "nowrap", children: [
      /* @__PURE__ */ d.jsxs(We, { gap: "2", itemsAlign: "center", children: [
        /* @__PURE__ */ d.jsx(
          De,
          {
            borderRadius: "circle",
            contentAlign: "between",
            padding: "2",
            backgroundColor: i.color ? i.color : i.active ? "dark" : "opacity-dark",
            testId: Z({ testId: e, suffix: `icon-${a}` }),
            children: /* @__PURE__ */ d.jsx(
              $e,
              {
                source: i.icon,
                size: "xs",
                color: "quiet",
                title: i.title
              }
            )
          }
        ),
        a !== n.length - 1 && /* @__PURE__ */ d.jsx(De, { display: "flex", flex: 1, children: /* @__PURE__ */ d.jsx(Du, { orientation: "vertical", color: "neutral" }) })
      ] }),
      /* @__PURE__ */ d.jsxs(We, { gap: "1", children: [
        i.timestamp && /* @__PURE__ */ d.jsx(
          ie,
          {
            variant: "bodyS",
            color: "subtle",
            testId: Z({ testId: e, suffix: `timestamp-${a}` }),
            children: i.timestamp
          }
        ),
        /* @__PURE__ */ d.jsx(
          ie,
          {
            variant: "bodyM",
            strong: !0,
            color: i.active ? "emphasised" : "subtle",
            testId: Z({ testId: e, suffix: `title-${a}` }),
            children: i.title
          }
        ),
        (o = i.subtitle) == null ? void 0 : o.map((s, l) => {
          var u;
          return /* @__PURE__ */ d.jsx(
            De,
            {
              display: "flex",
              paddingBlockEnd: ((u = i.subtitle) == null ? void 0 : u.length) !== l + 1 ? "0" : "6",
              children: s.tooltip ? /* @__PURE__ */ d.jsx(
                xi,
                {
                  text: s.tooltip,
                  hasCloseBtn: !1,
                  testId: Z({ testId: e, suffix: "tooltip" }),
                  children: r(!!i.active, s.text, a, l)
                }
              ) : r(!!i.active, s.text, a, l)
            },
            `${e}-${a}-${l}`
          );
        })
      ] })
    ] }, a);
  }) });
}, HT = ({ testId: e, crumbs: t }) => /* @__PURE__ */ d.jsx(De, { testId: e, children: /* @__PURE__ */ d.jsx("nav", { "aria-label": "Breadcrumb", itemScope: !0, itemType: "http://schema.org/BreadcrumbList", children: t && /* @__PURE__ */ d.jsx("ol", { className: "a:m-0 a:flex a:list-none a:gap-2 a:p-0", children: t.map((n, r) => {
  const i = r === t.length - 1;
  return /* @__PURE__ */ d.jsx(
    "li",
    {
      className: Y(
        "a:breadcrumb-hide a:align-middle",
        "a:max-md:[&:not(:nth-last-child(-n+2))]:hidden",
        "a:max-xl:[&:not(:nth-last-child(-n+4))]:md:hidden",
        "a:[&:not(:nth-last-child(-n+6))]:hidden",
        {
          "a:overflow-hidden": i,
          "a:shrink-0": !i
        }
      ),
      itemProp: "itemListElement",
      itemScope: !0,
      itemType: "http://schema.org/ListItem",
      children: i ? /* @__PURE__ */ d.jsxs(ie, { color: "neutral", truncate: !0, testId: "breadcrumb-active", children: [
        n.title,
        /* @__PURE__ */ d.jsx("meta", { itemProp: "name", content: n.title }),
        /* @__PURE__ */ d.jsx("meta", { itemProp: "position", content: (r + 1).toString() })
      ] }) : /* @__PURE__ */ d.jsxs(Pe, { gap: "2", wrap: "nowrap", children: [
        /* @__PURE__ */ d.jsxs(Xs, { href: n.url, theme: "neutral", variant: "tertiary", testId: "breadcrumb-link", children: [
          /* @__PURE__ */ d.jsx("span", { children: n.title }),
          /* @__PURE__ */ d.jsx("meta", { itemProp: "name", content: n.title }),
          /* @__PURE__ */ d.jsx("meta", { itemProp: "position", content: (r + 1).toString() })
        ] }),
        /* @__PURE__ */ d.jsx(ie, { color: "subtle", children: "/" })
      ] })
    },
    n.title.replace(/ /g, "")
  );
}) }) }) });
function P1(e = {}) {
  let t, n = [];
  const r = ["select", "slideFocus"];
  function i(u) {
    t = u;
    const {
      options: {
        axis: c
      },
      slideRects: f
    } = t.internalEngine();
    c !== "y" && (n = f.map((p) => p.height), r.forEach((p) => t.on(p, s)), s());
  }
  function a() {
    r.forEach((c) => t.off(c, s));
    const u = t.containerNode();
    u.style.height = "", u.getAttribute("style") || u.removeAttribute("style");
  }
  function o() {
    const {
      slideRegistry: u
    } = t.internalEngine(), c = u[t.selectedScrollSnap()];
    return c ? c.map((f) => n[f]).reduce((f, p) => Math.max(f, p), 0) : null;
  }
  function s() {
    o() !== null && (t.containerNode().style.height = `${o()}px`);
  }
  return {
    name: "autoHeight",
    options: e,
    init: i,
    destroy: a
  };
}
P1.globalOptions = void 0;
function aO(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function wh(e) {
  return aO(e) || Array.isArray(e);
}
function oO() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function vc(e, t) {
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length) return !1;
  const i = JSON.stringify(Object.keys(e.breakpoints || {})), a = JSON.stringify(Object.keys(t.breakpoints || {}));
  return i !== a ? !1 : n.every((o) => {
    const s = e[o], l = t[o];
    return typeof s == "function" ? `${s}` == `${l}` : !wh(s) || !wh(l) ? s === l : vc(s, l);
  });
}
function Ch(e) {
  return e.concat().sort((t, n) => t.name > n.name ? 1 : -1).map((t) => t.options);
}
function sO(e, t) {
  if (e.length !== t.length) return !1;
  const n = Ch(e), r = Ch(t);
  return n.every((i, a) => {
    const o = r[a];
    return vc(i, o);
  });
}
function yc(e) {
  return typeof e == "number";
}
function yl(e) {
  return typeof e == "string";
}
function so(e) {
  return typeof e == "boolean";
}
function Sh(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Fe(e) {
  return Math.abs(e);
}
function bc(e) {
  return Math.sign(e);
}
function Hr(e, t) {
  return Fe(e - t);
}
function lO(e, t) {
  if (e === 0 || t === 0 || Fe(e) <= Fe(t)) return 0;
  const n = Hr(Fe(e), Fe(t));
  return Fe(n / e);
}
function uO(e) {
  return Math.round(e * 100) / 100;
}
function li(e) {
  return ui(e).map(Number);
}
function Nt(e) {
  return e[$i(e)];
}
function $i(e) {
  return Math.max(0, e.length - 1);
}
function xc(e, t) {
  return t === $i(e);
}
function Ih(e, t = 0) {
  return Array.from(Array(e), (n, r) => t + r);
}
function ui(e) {
  return Object.keys(e);
}
function N1(e, t) {
  return [e, t].reduce((n, r) => (ui(r).forEach((i) => {
    const a = n[i], o = r[i], s = Sh(a) && Sh(o);
    n[i] = s ? N1(a, o) : o;
  }), n), {});
}
function bl(e, t) {
  return typeof t.MouseEvent < "u" && e instanceof t.MouseEvent;
}
function cO(e, t) {
  const n = {
    start: r,
    center: i,
    end: a
  };
  function r() {
    return 0;
  }
  function i(l) {
    return a(l) / 2;
  }
  function a(l) {
    return t - l;
  }
  function o(l, u) {
    return yl(e) ? n[e](l) : e(t, l, u);
  }
  return {
    measure: o
  };
}
function ci() {
  let e = [];
  function t(i, a, o, s = {
    passive: !0
  }) {
    let l;
    if ("addEventListener" in i)
      i.addEventListener(a, o, s), l = () => i.removeEventListener(a, o, s);
    else {
      const u = i;
      u.addListener(o), l = () => u.removeListener(o);
    }
    return e.push(l), r;
  }
  function n() {
    e = e.filter((i) => i());
  }
  const r = {
    add: t,
    clear: n
  };
  return r;
}
function dO(e, t, n, r) {
  const i = ci(), a = 1e3 / 60;
  let o = null, s = 0, l = 0;
  function u() {
    i.add(e, "visibilitychange", () => {
      e.hidden && m();
    });
  }
  function c() {
    h(), i.clear();
  }
  function f(g) {
    if (!l) return;
    o || (o = g, n(), n());
    const b = g - o;
    for (o = g, s += b; s >= a; )
      n(), s -= a;
    const y = s / a;
    r(y), l && (l = t.requestAnimationFrame(f));
  }
  function p() {
    l || (l = t.requestAnimationFrame(f));
  }
  function h() {
    t.cancelAnimationFrame(l), o = null, s = 0, l = 0;
  }
  function m() {
    o = null, s = 0;
  }
  return {
    init: u,
    destroy: c,
    start: p,
    stop: h,
    update: n,
    render: r
  };
}
function fO(e, t) {
  const n = t === "rtl", r = e === "y", i = r ? "y" : "x", a = r ? "x" : "y", o = !r && n ? -1 : 1, s = c(), l = f();
  function u(m) {
    const {
      height: v,
      width: g
    } = m;
    return r ? v : g;
  }
  function c() {
    return r ? "top" : n ? "right" : "left";
  }
  function f() {
    return r ? "bottom" : n ? "left" : "right";
  }
  function p(m) {
    return m * o;
  }
  return {
    scroll: i,
    cross: a,
    startEdge: s,
    endEdge: l,
    measureSize: u,
    direction: p
  };
}
function Mn(e = 0, t = 0) {
  const n = Fe(e - t);
  function r(u) {
    return u < e;
  }
  function i(u) {
    return u > t;
  }
  function a(u) {
    return r(u) || i(u);
  }
  function o(u) {
    return a(u) ? r(u) ? e : t : u;
  }
  function s(u) {
    return n ? u - n * Math.ceil((u - t) / n) : u;
  }
  return {
    length: n,
    max: t,
    min: e,
    constrain: o,
    reachedAny: a,
    reachedMax: i,
    reachedMin: r,
    removeOffset: s
  };
}
function _1(e, t, n) {
  const {
    constrain: r
  } = Mn(0, e), i = e + 1;
  let a = o(t);
  function o(p) {
    return n ? Fe((i + p) % i) : r(p);
  }
  function s() {
    return a;
  }
  function l(p) {
    return a = o(p), f;
  }
  function u(p) {
    return c().set(s() + p);
  }
  function c() {
    return _1(e, s(), n);
  }
  const f = {
    get: s,
    set: l,
    add: u,
    clone: c
  };
  return f;
}
function pO(e, t, n, r, i, a, o, s, l, u, c, f, p, h, m, v, g, b, y) {
  const {
    cross: x,
    direction: w
  } = e, $ = ["INPUT", "SELECT", "TEXTAREA"], C = {
    passive: !1
  }, T = ci(), S = ci(), N = Mn(50, 225).constrain(h.measure(20)), k = {
    mouse: 300,
    touch: 400
  }, L = {
    mouse: 500,
    touch: 600
  }, _ = m ? 43 : 25;
  let B = !1, A = 0, q = 0, X = !1, I = !1, O = !1, D = !1;
  function E(V) {
    if (!y) return;
    function le(ye) {
      (so(y) || y(V, ye)) && G(ye);
    }
    const ee = t;
    T.add(ee, "dragstart", (ye) => ye.preventDefault(), C).add(ee, "touchmove", () => {
    }, C).add(ee, "touchend", () => {
    }).add(ee, "touchstart", le).add(ee, "mousedown", le).add(ee, "touchcancel", U).add(ee, "contextmenu", U).add(ee, "click", J, !0);
  }
  function j() {
    T.clear(), S.clear();
  }
  function F() {
    const V = D ? n : t;
    S.add(V, "touchmove", z, C).add(V, "touchend", U).add(V, "mousemove", z, C).add(V, "mouseup", U);
  }
  function K(V) {
    const le = V.nodeName || "";
    return $.includes(le);
  }
  function H() {
    return (m ? L : k)[D ? "mouse" : "touch"];
  }
  function W(V, le) {
    const ee = f.add(bc(V) * -1), ye = c.byDistance(V, !m).distance;
    return m || Fe(V) < N ? ye : g && le ? ye * 0.5 : c.byIndex(ee.get(), 0).distance;
  }
  function G(V) {
    const le = bl(V, r);
    D = le, O = m && le && !V.buttons && B, B = Hr(i.get(), o.get()) >= 2, !(le && V.button !== 0) && (K(V.target) || (X = !0, a.pointerDown(V), u.useFriction(0).useDuration(0), i.set(o), F(), A = a.readPoint(V), q = a.readPoint(V, x), p.emit("pointerDown")));
  }
  function z(V) {
    if (!bl(V, r) && V.touches.length >= 2) return U(V);
    const ee = a.readPoint(V), ye = a.readPoint(V, x), ve = Hr(ee, A), Te = Hr(ye, q);
    if (!I && !D && (!V.cancelable || (I = ve > Te, !I)))
      return U(V);
    const je = a.pointerMove(V);
    ve > v && (O = !0), u.useFriction(0.3).useDuration(0.75), s.start(), i.add(w(je)), V.preventDefault();
  }
  function U(V) {
    const ee = c.byDistance(0, !1).index !== f.get(), ye = a.pointerUp(V) * H(), ve = W(w(ye), ee), Te = lO(ye, ve), je = _ - 10 * Te, Ae = b + Te / 50;
    I = !1, X = !1, S.clear(), u.useDuration(je).useFriction(Ae), l.distance(ve, !m), D = !1, p.emit("pointerUp");
  }
  function J(V) {
    O && (V.stopPropagation(), V.preventDefault(), O = !1);
  }
  function ne() {
    return X;
  }
  return {
    init: E,
    destroy: j,
    pointerDown: ne
  };
}
function hO(e, t) {
  let r, i;
  function a(f) {
    return f.timeStamp;
  }
  function o(f, p) {
    const m = `client${(p || e.scroll) === "x" ? "X" : "Y"}`;
    return (bl(f, t) ? f : f.touches[0])[m];
  }
  function s(f) {
    return r = f, i = f, o(f);
  }
  function l(f) {
    const p = o(f) - o(i), h = a(f) - a(r) > 170;
    return i = f, h && (r = f), p;
  }
  function u(f) {
    if (!r || !i) return 0;
    const p = o(i) - o(r), h = a(f) - a(r), m = a(f) - a(i) > 170, v = p / h;
    return h && !m && Fe(v) > 0.1 ? v : 0;
  }
  return {
    pointerDown: s,
    pointerMove: l,
    pointerUp: u,
    readPoint: o
  };
}
function mO() {
  function e(n) {
    const {
      offsetTop: r,
      offsetLeft: i,
      offsetWidth: a,
      offsetHeight: o
    } = n;
    return {
      top: r,
      right: i + a,
      bottom: r + o,
      left: i,
      width: a,
      height: o
    };
  }
  return {
    measure: e
  };
}
function gO(e) {
  function t(r) {
    return e * (r / 100);
  }
  return {
    measure: t
  };
}
function vO(e, t, n, r, i, a, o) {
  const s = [e].concat(r);
  let l, u, c = [], f = !1;
  function p(g) {
    return i.measureSize(o.measure(g));
  }
  function h(g) {
    if (!a) return;
    u = p(e), c = r.map(p);
    function b(y) {
      for (const x of y) {
        if (f) return;
        const w = x.target === e, $ = r.indexOf(x.target), C = w ? u : c[$], T = p(w ? e : r[$]);
        if (Fe(T - C) >= 0.5) {
          g.reInit(), t.emit("resize");
          break;
        }
      }
    }
    l = new ResizeObserver((y) => {
      (so(a) || a(g, y)) && b(y);
    }), n.requestAnimationFrame(() => {
      s.forEach((y) => l.observe(y));
    });
  }
  function m() {
    f = !0, l && l.disconnect();
  }
  return {
    init: h,
    destroy: m
  };
}
function yO(e, t, n, r, i, a) {
  let o = 0, s = 0, l = i, u = a, c = e.get(), f = 0;
  function p() {
    const C = r.get() - e.get(), T = !l;
    let S = 0;
    return T ? (o = 0, n.set(r), e.set(r), S = C) : (n.set(e), o += C / l, o *= u, c += o, e.add(o), S = c - f), s = bc(S), f = c, $;
  }
  function h() {
    const C = r.get() - t.get();
    return Fe(C) < 1e-3;
  }
  function m() {
    return l;
  }
  function v() {
    return s;
  }
  function g() {
    return o;
  }
  function b() {
    return x(i);
  }
  function y() {
    return w(a);
  }
  function x(C) {
    return l = C, $;
  }
  function w(C) {
    return u = C, $;
  }
  const $ = {
    direction: v,
    duration: m,
    velocity: g,
    seek: p,
    settled: h,
    useBaseFriction: y,
    useBaseDuration: b,
    useFriction: w,
    useDuration: x
  };
  return $;
}
function bO(e, t, n, r, i) {
  const a = i.measure(10), o = i.measure(50), s = Mn(0.1, 0.99);
  let l = !1;
  function u() {
    return !(l || !e.reachedAny(n.get()) || !e.reachedAny(t.get()));
  }
  function c(h) {
    if (!u()) return;
    const m = e.reachedMin(t.get()) ? "min" : "max", v = Fe(e[m] - t.get()), g = n.get() - t.get(), b = s.constrain(v / o);
    n.subtract(g * b), !h && Fe(g) < a && (n.set(e.constrain(n.get())), r.useDuration(25).useBaseFriction());
  }
  function f(h) {
    l = !h;
  }
  return {
    shouldConstrain: u,
    constrain: c,
    toggleActive: f
  };
}
function xO(e, t, n, r, i) {
  const a = Mn(-t + e, 0), o = f(), s = c(), l = p();
  function u(m, v) {
    return Hr(m, v) <= 1;
  }
  function c() {
    const m = o[0], v = Nt(o), g = o.lastIndexOf(m), b = o.indexOf(v) + 1;
    return Mn(g, b);
  }
  function f() {
    return n.map((m, v) => {
      const {
        min: g,
        max: b
      } = a, y = a.constrain(m), x = !v, w = xc(n, v);
      return x ? b : w || u(g, y) ? g : u(b, y) ? b : y;
    }).map((m) => parseFloat(m.toFixed(3)));
  }
  function p() {
    if (t <= e + i) return [a.max];
    if (r === "keepSnaps") return o;
    const {
      min: m,
      max: v
    } = s;
    return o.slice(m, v);
  }
  return {
    snapsContained: l,
    scrollContainLimit: s
  };
}
function $O(e, t, n) {
  const r = t[0], i = n ? r - e : Nt(t);
  return {
    limit: Mn(i, r)
  };
}
function wO(e, t, n, r) {
  const a = t.min + 0.1, o = t.max + 0.1, {
    reachedMin: s,
    reachedMax: l
  } = Mn(a, o);
  function u(p) {
    return p === 1 ? l(n.get()) : p === -1 ? s(n.get()) : !1;
  }
  function c(p) {
    if (!u(p)) return;
    const h = e * (p * -1);
    r.forEach((m) => m.add(h));
  }
  return {
    loop: c
  };
}
function CO(e) {
  const {
    max: t,
    length: n
  } = e;
  function r(a) {
    const o = a - t;
    return n ? o / -n : 0;
  }
  return {
    get: r
  };
}
function SO(e, t, n, r, i) {
  const {
    startEdge: a,
    endEdge: o
  } = e, {
    groupSlides: s
  } = i, l = f().map(t.measure), u = p(), c = h();
  function f() {
    return s(r).map((v) => Nt(v)[o] - v[0][a]).map(Fe);
  }
  function p() {
    return r.map((v) => n[a] - v[a]).map((v) => -Fe(v));
  }
  function h() {
    return s(u).map((v) => v[0]).map((v, g) => v + l[g]);
  }
  return {
    snaps: u,
    snapsAligned: c
  };
}
function IO(e, t, n, r, i, a) {
  const {
    groupSlides: o
  } = i, {
    min: s,
    max: l
  } = r, u = c();
  function c() {
    const p = o(a), h = !e || t === "keepSnaps";
    return n.length === 1 ? [a] : h ? p : p.slice(s, l).map((m, v, g) => {
      const b = !v, y = xc(g, v);
      if (b) {
        const x = Nt(g[0]) + 1;
        return Ih(x);
      }
      if (y) {
        const x = $i(a) - Nt(g)[0] + 1;
        return Ih(x, Nt(g)[0]);
      }
      return m;
    });
  }
  return {
    slideRegistry: u
  };
}
function EO(e, t, n, r, i) {
  const {
    reachedAny: a,
    removeOffset: o,
    constrain: s
  } = r;
  function l(m) {
    return m.concat().sort((v, g) => Fe(v) - Fe(g))[0];
  }
  function u(m) {
    const v = e ? o(m) : s(m), g = t.map((y, x) => ({
      diff: c(y - v, 0),
      index: x
    })).sort((y, x) => Fe(y.diff) - Fe(x.diff)), {
      index: b
    } = g[0];
    return {
      index: b,
      distance: v
    };
  }
  function c(m, v) {
    const g = [m, m + n, m - n];
    if (!e) return m;
    if (!v) return l(g);
    const b = g.filter((y) => bc(y) === v);
    return b.length ? l(b) : Nt(g) - n;
  }
  function f(m, v) {
    const g = t[m] - i.get(), b = c(g, v);
    return {
      index: m,
      distance: b
    };
  }
  function p(m, v) {
    const g = i.get() + m, {
      index: b,
      distance: y
    } = u(g), x = !e && a(g);
    if (!v || x) return {
      index: b,
      distance: m
    };
    const w = t[b] - y, $ = m + c(w, 0);
    return {
      index: b,
      distance: $
    };
  }
  return {
    byDistance: p,
    byIndex: f,
    shortcut: c
  };
}
function OO(e, t, n, r, i, a, o) {
  function s(f) {
    const p = f.distance, h = f.index !== t.get();
    a.add(p), p && (r.duration() ? e.start() : (e.update(), e.render(1), e.update())), h && (n.set(t.get()), t.set(f.index), o.emit("select"));
  }
  function l(f, p) {
    const h = i.byDistance(f, p);
    s(h);
  }
  function u(f, p) {
    const h = t.clone().set(f), m = i.byIndex(h.get(), p);
    s(m);
  }
  return {
    distance: l,
    index: u
  };
}
function TO(e, t, n, r, i, a, o, s) {
  const l = {
    passive: !0,
    capture: !0
  };
  let u = 0;
  function c(h) {
    if (!s) return;
    function m(v) {
      if ((/* @__PURE__ */ new Date()).getTime() - u > 10) return;
      o.emit("slideFocusStart"), e.scrollLeft = 0;
      const y = n.findIndex((x) => x.includes(v));
      yc(y) && (i.useDuration(0), r.index(y, 0), o.emit("slideFocus"));
    }
    a.add(document, "keydown", f, !1), t.forEach((v, g) => {
      a.add(v, "focus", (b) => {
        (so(s) || s(h, b)) && m(g);
      }, l);
    });
  }
  function f(h) {
    h.code === "Tab" && (u = (/* @__PURE__ */ new Date()).getTime());
  }
  return {
    init: c
  };
}
function kr(e) {
  let t = e;
  function n() {
    return t;
  }
  function r(l) {
    t = o(l);
  }
  function i(l) {
    t += o(l);
  }
  function a(l) {
    t -= o(l);
  }
  function o(l) {
    return yc(l) ? l : l.get();
  }
  return {
    get: n,
    set: r,
    add: i,
    subtract: a
  };
}
function A1(e, t) {
  const n = e.scroll === "x" ? o : s, r = t.style;
  let i = null, a = !1;
  function o(p) {
    return `translate3d(${p}px,0px,0px)`;
  }
  function s(p) {
    return `translate3d(0px,${p}px,0px)`;
  }
  function l(p) {
    if (a) return;
    const h = uO(e.direction(p));
    h !== i && (r.transform = n(h), i = h);
  }
  function u(p) {
    a = !p;
  }
  function c() {
    a || (r.transform = "", t.getAttribute("style") || t.removeAttribute("style"));
  }
  return {
    clear: c,
    to: l,
    toggleActive: u
  };
}
function PO(e, t, n, r, i, a, o, s, l) {
  const c = li(i), f = li(i).reverse(), p = b().concat(y());
  function h(T, S) {
    return T.reduce((N, k) => N - i[k], S);
  }
  function m(T, S) {
    return T.reduce((N, k) => h(N, S) > 0 ? N.concat([k]) : N, []);
  }
  function v(T) {
    return a.map((S, N) => ({
      start: S - r[N] + 0.5 + T,
      end: S + t - 0.5 + T
    }));
  }
  function g(T, S, N) {
    const k = v(S);
    return T.map((L) => {
      const _ = N ? 0 : -n, B = N ? n : 0, A = N ? "end" : "start", q = k[L][A];
      return {
        index: L,
        loopPoint: q,
        slideLocation: kr(-1),
        translate: A1(e, l[L]),
        target: () => s.get() > q ? _ : B
      };
    });
  }
  function b() {
    const T = o[0], S = m(f, T);
    return g(S, n, !1);
  }
  function y() {
    const T = t - o[0] - 1, S = m(c, T);
    return g(S, -n, !0);
  }
  function x() {
    return p.every(({
      index: T
    }) => {
      const S = c.filter((N) => N !== T);
      return h(S, t) <= 0.1;
    });
  }
  function w() {
    p.forEach((T) => {
      const {
        target: S,
        translate: N,
        slideLocation: k
      } = T, L = S();
      L !== k.get() && (N.to(L), k.set(L));
    });
  }
  function $() {
    p.forEach((T) => T.translate.clear());
  }
  return {
    canLoop: x,
    clear: $,
    loop: w,
    loopPoints: p
  };
}
function NO(e, t, n) {
  let r, i = !1;
  function a(l) {
    if (!n) return;
    function u(c) {
      for (const f of c)
        if (f.type === "childList") {
          l.reInit(), t.emit("slidesChanged");
          break;
        }
    }
    r = new MutationObserver((c) => {
      i || (so(n) || n(l, c)) && u(c);
    }), r.observe(e, {
      childList: !0
    });
  }
  function o() {
    r && r.disconnect(), i = !0;
  }
  return {
    init: a,
    destroy: o
  };
}
function _O(e, t, n, r) {
  const i = {};
  let a = null, o = null, s, l = !1;
  function u() {
    s = new IntersectionObserver((m) => {
      l || (m.forEach((v) => {
        const g = t.indexOf(v.target);
        i[g] = v;
      }), a = null, o = null, n.emit("slidesInView"));
    }, {
      root: e.parentElement,
      threshold: r
    }), t.forEach((m) => s.observe(m));
  }
  function c() {
    s && s.disconnect(), l = !0;
  }
  function f(m) {
    return ui(i).reduce((v, g) => {
      const b = parseInt(g), {
        isIntersecting: y
      } = i[b];
      return (m && y || !m && !y) && v.push(b), v;
    }, []);
  }
  function p(m = !0) {
    if (m && a) return a;
    if (!m && o) return o;
    const v = f(m);
    return m && (a = v), m || (o = v), v;
  }
  return {
    init: u,
    destroy: c,
    get: p
  };
}
function AO(e, t, n, r, i, a) {
  const {
    measureSize: o,
    startEdge: s,
    endEdge: l
  } = e, u = n[0] && i, c = m(), f = v(), p = n.map(o), h = g();
  function m() {
    if (!u) return 0;
    const y = n[0];
    return Fe(t[s] - y[s]);
  }
  function v() {
    if (!u) return 0;
    const y = a.getComputedStyle(Nt(r));
    return parseFloat(y.getPropertyValue(`margin-${l}`));
  }
  function g() {
    return n.map((y, x, w) => {
      const $ = !x, C = xc(w, x);
      return $ ? p[x] + c : C ? p[x] + f : w[x + 1][s] - y[s];
    }).map(Fe);
  }
  return {
    slideSizes: p,
    slideSizesWithGaps: h,
    startGap: c,
    endGap: f
  };
}
function RO(e, t, n, r, i, a, o, s, l) {
  const {
    startEdge: u,
    endEdge: c,
    direction: f
  } = e, p = yc(n);
  function h(b, y) {
    return li(b).filter((x) => x % y === 0).map((x) => b.slice(x, x + y));
  }
  function m(b) {
    return b.length ? li(b).reduce((y, x, w) => {
      const $ = Nt(y) || 0, C = $ === 0, T = x === $i(b), S = i[u] - a[$][u], N = i[u] - a[x][c], k = !r && C ? f(o) : 0, L = !r && T ? f(s) : 0, _ = Fe(N - L - (S + k));
      return w && _ > t + l && y.push(x), T && y.push(b.length), y;
    }, []).map((y, x, w) => {
      const $ = Math.max(w[x - 1] || 0);
      return b.slice($, y);
    }) : [];
  }
  function v(b) {
    return p ? h(b, n) : m(b);
  }
  return {
    groupSlides: v
  };
}
function MO(e, t, n, r, i, a, o) {
  const {
    align: s,
    axis: l,
    direction: u,
    startIndex: c,
    loop: f,
    duration: p,
    dragFree: h,
    dragThreshold: m,
    inViewThreshold: v,
    slidesToScroll: g,
    skipSnaps: b,
    containScroll: y,
    watchResize: x,
    watchSlides: w,
    watchDrag: $,
    watchFocus: C
  } = a, T = 2, S = mO(), N = S.measure(t), k = n.map(S.measure), L = fO(l, u), _ = L.measureSize(N), B = gO(_), A = cO(s, _), q = !f && !!y, X = f || !!y, {
    slideSizes: I,
    slideSizesWithGaps: O,
    startGap: D,
    endGap: E
  } = AO(L, N, k, n, X, i), j = RO(L, _, g, f, N, k, D, E, T), {
    snaps: F,
    snapsAligned: K
  } = SO(L, A, N, k, j), H = -Nt(F) + Nt(O), {
    snapsContained: W,
    scrollContainLimit: G
  } = xO(_, H, K, y, T), z = q ? W : K, {
    limit: U
  } = $O(H, z, f), J = _1($i(z), c, f), ne = J.clone(), ae = li(n), V = ({
    dragHandler: Bt,
    scrollBody: Cr,
    scrollBounds: Sr,
    options: {
      loop: Ln
    }
  }) => {
    Ln || Sr.constrain(Bt.pointerDown()), Cr.seek();
  }, le = ({
    scrollBody: Bt,
    translate: Cr,
    location: Sr,
    offsetLocation: Ln,
    previousLocation: lo,
    scrollLooper: uo,
    slideLooper: co,
    dragHandler: fo,
    animation: Ir,
    eventHandler: Er,
    scrollBounds: sn,
    options: {
      loop: Fn
    }
  }, Vn) => {
    const Or = Bt.settled(), po = !sn.shouldConstrain(), Tr = Fn ? Or : Or && po, Ci = Tr && !fo.pointerDown();
    Ci && Ir.stop();
    const Si = Sr.get() * Vn + lo.get() * (1 - Vn);
    Ln.set(Si), Fn && (uo.loop(Bt.direction()), co.loop()), Cr.to(Ln.get()), Ci && Er.emit("settle"), Tr || Er.emit("scroll");
  }, ee = dO(r, i, () => V(on), (Bt) => le(on, Bt)), ye = 0.68, ve = z[J.get()], Te = kr(ve), je = kr(ve), Ae = kr(ve), tt = kr(ve), Ve = yO(Te, Ae, je, tt, p, ye), Ue = EO(f, z, H, U, tt), $t = OO(ee, J, ne, Ve, Ue, tt, o), Vt = CO(U), ot = ci(), gt = _O(t, n, o, v), {
    slideRegistry: st
  } = IO(q, y, z, G, j, ae), nt = TO(e, n, st, $t, Ve, ot, o, C), on = {
    ownerDocument: r,
    ownerWindow: i,
    eventHandler: o,
    containerRect: N,
    slideRects: k,
    animation: ee,
    axis: L,
    dragHandler: pO(L, e, r, i, tt, hO(L, i), Te, ee, $t, Ve, Ue, J, o, B, h, m, b, ye, $),
    eventStore: ot,
    percentOfView: B,
    index: J,
    indexPrevious: ne,
    limit: U,
    location: Te,
    offsetLocation: Ae,
    previousLocation: je,
    options: a,
    resizeHandler: vO(t, o, i, n, L, x, S),
    scrollBody: Ve,
    scrollBounds: bO(U, Ae, tt, Ve, B),
    scrollLooper: wO(H, U, Ae, [Te, Ae, je, tt]),
    scrollProgress: Vt,
    scrollSnapList: z.map(Vt.get),
    scrollSnaps: z,
    scrollTarget: Ue,
    scrollTo: $t,
    slideLooper: PO(L, _, H, I, O, F, z, Ae, n),
    slideFocus: nt,
    slidesHandler: NO(t, o, w),
    slidesInView: gt,
    slideIndexes: ae,
    slideRegistry: st,
    slidesToScroll: j,
    target: tt,
    translate: A1(L, t)
  };
  return on;
}
function jO() {
  let e = {}, t;
  function n(u) {
    t = u;
  }
  function r(u) {
    return e[u] || [];
  }
  function i(u) {
    return r(u).forEach((c) => c(t, u)), l;
  }
  function a(u, c) {
    return e[u] = r(u).concat([c]), l;
  }
  function o(u, c) {
    return e[u] = r(u).filter((f) => f !== c), l;
  }
  function s() {
    e = {};
  }
  const l = {
    init: n,
    emit: i,
    off: o,
    on: a,
    clear: s
  };
  return l;
}
const DO = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0
};
function kO(e) {
  function t(a, o) {
    return N1(a, o || {});
  }
  function n(a) {
    const o = a.breakpoints || {}, s = ui(o).filter((l) => e.matchMedia(l).matches).map((l) => o[l]).reduce((l, u) => t(l, u), {});
    return t(a, s);
  }
  function r(a) {
    return a.map((o) => ui(o.breakpoints || {})).reduce((o, s) => o.concat(s), []).map(e.matchMedia);
  }
  return {
    mergeOptions: t,
    optionsAtMedia: n,
    optionsMediaQueries: r
  };
}
function LO(e) {
  let t = [];
  function n(a, o) {
    return t = o.filter(({
      options: s
    }) => e.optionsAtMedia(s).active !== !1), t.forEach((s) => s.init(a, e)), o.reduce((s, l) => Object.assign(s, {
      [l.name]: l
    }), {});
  }
  function r() {
    t = t.filter((a) => a.destroy());
  }
  return {
    init: n,
    destroy: r
  };
}
function Pa(e, t, n) {
  const r = e.ownerDocument, i = r.defaultView, a = kO(i), o = LO(a), s = ci(), l = jO(), {
    mergeOptions: u,
    optionsAtMedia: c,
    optionsMediaQueries: f
  } = a, {
    on: p,
    off: h,
    emit: m
  } = l, v = L;
  let g = !1, b, y = u(DO, Pa.globalOptions), x = u(y), w = [], $, C, T;
  function S() {
    const {
      container: ae,
      slides: V
    } = x;
    C = (yl(ae) ? e.querySelector(ae) : ae) || e.children[0];
    const ee = yl(V) ? C.querySelectorAll(V) : V;
    T = [].slice.call(ee || C.children);
  }
  function N(ae) {
    const V = MO(e, C, T, r, i, ae, l);
    if (ae.loop && !V.slideLooper.canLoop()) {
      const le = Object.assign({}, ae, {
        loop: !1
      });
      return N(le);
    }
    return V;
  }
  function k(ae, V) {
    g || (y = u(y, ae), x = c(y), w = V || w, S(), b = N(x), f([y, ...w.map(({
      options: le
    }) => le)]).forEach((le) => s.add(le, "change", L)), x.active && (b.translate.to(b.location.get()), b.animation.init(), b.slidesInView.init(), b.slideFocus.init(ne), b.eventHandler.init(ne), b.resizeHandler.init(ne), b.slidesHandler.init(ne), b.options.loop && b.slideLooper.loop(), C.offsetParent && T.length && b.dragHandler.init(ne), $ = o.init(ne, w)));
  }
  function L(ae, V) {
    const le = j();
    _(), k(u({
      startIndex: le
    }, ae), V), l.emit("reInit");
  }
  function _() {
    b.dragHandler.destroy(), b.eventStore.clear(), b.translate.clear(), b.slideLooper.clear(), b.resizeHandler.destroy(), b.slidesHandler.destroy(), b.slidesInView.destroy(), b.animation.destroy(), o.destroy(), s.clear();
  }
  function B() {
    g || (g = !0, s.clear(), _(), l.emit("destroy"), l.clear());
  }
  function A(ae, V, le) {
    !x.active || g || (b.scrollBody.useBaseFriction().useDuration(V === !0 ? 0 : x.duration), b.scrollTo.index(ae, le || 0));
  }
  function q(ae) {
    const V = b.index.add(1).get();
    A(V, ae, -1);
  }
  function X(ae) {
    const V = b.index.add(-1).get();
    A(V, ae, 1);
  }
  function I() {
    return b.index.add(1).get() !== j();
  }
  function O() {
    return b.index.add(-1).get() !== j();
  }
  function D() {
    return b.scrollSnapList;
  }
  function E() {
    return b.scrollProgress.get(b.offsetLocation.get());
  }
  function j() {
    return b.index.get();
  }
  function F() {
    return b.indexPrevious.get();
  }
  function K() {
    return b.slidesInView.get();
  }
  function H() {
    return b.slidesInView.get(!1);
  }
  function W() {
    return $;
  }
  function G() {
    return b;
  }
  function z() {
    return e;
  }
  function U() {
    return C;
  }
  function J() {
    return T;
  }
  const ne = {
    canScrollNext: I,
    canScrollPrev: O,
    containerNode: U,
    internalEngine: G,
    destroy: B,
    off: h,
    on: p,
    emit: m,
    plugins: W,
    previousScrollSnap: F,
    reInit: v,
    rootNode: z,
    scrollNext: q,
    scrollPrev: X,
    scrollProgress: E,
    scrollSnapList: D,
    scrollTo: A,
    selectedScrollSnap: j,
    slideNodes: J,
    slidesInView: K,
    slidesNotInView: H
  };
  return k(t, n), setTimeout(() => l.emit("init"), 0), ne;
}
Pa.globalOptions = void 0;
function $c(e = {}, t = []) {
  const n = ce(e), r = ce(t), [i, a] = ue(), [o, s] = ue(), l = ge(() => {
    i && i.reInit(n.current, r.current);
  }, [i]);
  return se(() => {
    vc(n.current, e) || (n.current = e, l());
  }, [e, l]), se(() => {
    sO(r.current, t) || (r.current = t, l());
  }, [t, l]), se(() => {
    if (oO() && o) {
      Pa.globalOptions = $c.globalOptions;
      const u = Pa(o, n.current, r.current);
      return a(u), () => u.destroy();
    } else
      a(void 0);
  }, [o, a]), [s, i];
}
$c.globalOptions = void 0;
const R1 = Rt(null);
function wi() {
  const e = Xe(R1);
  if (!e)
    throw new Error("useCarousel must be used within a <Carousel />");
  return e;
}
function KT({
  slideSize: e = "100%",
  slideHeight: t,
  orientation: n = "horizontal",
  hideOverlfow: r = !0,
  opts: i,
  // setApi,
  children: a,
  testId: o,
  ...s
}) {
  const [l, u] = $c(
    {
      align: "start",
      ...i,
      axis: n === "horizontal" ? "x" : "y"
    },
    [P1()]
  ), [c, f] = ue(!1), [p, h] = ue(!1), m = ge((y) => {
    y && (f(y.canScrollPrev()), h(y.canScrollNext()));
  }, []), v = ge(() => {
    u == null || u.scrollPrev();
  }, [u]), g = ge(() => {
    u == null || u.scrollNext();
  }, [u]), b = ge(
    (y) => {
      y.key === "ArrowLeft" ? (y.preventDefault(), v()) : y.key === "ArrowRight" && (y.preventDefault(), g());
    },
    [v, g]
  );
  return se(() => {
    if (u)
      return m(u), u.on("reInit", m), u.on("select", m), () => {
        u == null || u.off("select", m), u == null || u.off("reInit", m);
      };
  }, [u, m]), /* @__PURE__ */ d.jsx(
    R1.Provider,
    {
      value: {
        carouselRef: l,
        api: u,
        opts: i,
        orientation: n,
        hideOverlfow: r,
        scrollPrev: v,
        scrollNext: g,
        canScrollPrev: c,
        canScrollNext: p
      },
      children: /* @__PURE__ */ d.jsx(
        "div",
        {
          onKeyDownCapture: b,
          className: "a:relative",
          role: "region",
          "data-testid": Z({ testId: o, suffix: "carousel" }),
          "aria-roledescription": "carousel",
          style: {
            ...ei(
              "--carousel-slide-size",
              e,
              (y) => typeof y == "number" ? `${y}px` : y
            ),
            ...t ? ei(
              "--carousel-slide-height",
              t,
              (y) => typeof y == "number" ? `${y}px` : y
            ) : {}
          },
          ...s,
          children: a
        }
      )
    }
  );
}
function WT(e) {
  const { carouselRef: t, orientation: n, hideOverlfow: r } = wi();
  return /* @__PURE__ */ d.jsx("div", { ref: t, className: r ? "a:overflow-hidden" : void 0, children: /* @__PURE__ */ d.jsx("div", { className: Y("a:flex", n === "horizontal" ? "a:-ml-4" : "a:-mt-4 a:flex-col"), ...e }) });
}
function zT(e) {
  const { orientation: t } = wi();
  return /* @__PURE__ */ d.jsx(
    "div",
    {
      role: "group",
      "aria-roledescription": "slide",
      "data-slot": "carousel-item",
      className: Y(
        "a:min-w-0 a:shrink-0 a:grow-0 a:basis-[var(--carousel-slide-size)] a:*:h-full",
        t === "horizontal" ? "a:pl-4" : "a:pt-4"
      ),
      ...e
    }
  );
}
function GT(e) {
  const { scrollPrev: t, canScrollPrev: n } = wi();
  return /* @__PURE__ */ d.jsx(
    it,
    {
      "data-slot": "carousel-previous",
      state: n ? "interactive" : "disabled",
      onClick: t,
      icon: { source: Ha },
      size: "sm",
      variant: "tertiary",
      theme: "neutral",
      ...e
    }
  );
}
function UT(e) {
  const { scrollNext: t, canScrollNext: n } = wi();
  return /* @__PURE__ */ d.jsx(
    it,
    {
      "data-slot": "carousel-next",
      state: n ? "interactive" : "disabled",
      onClick: t,
      icon: { source: y0 },
      size: "sm",
      variant: "tertiary",
      theme: "neutral",
      ...e
    }
  );
}
function qT() {
  const { api: e } = wi(), [t, n] = ue(0), [r, i] = ue(0);
  return se(() => {
    if (!e) return;
    const a = () => n(e.selectedScrollSnap() + 1);
    return i(e.slideNodes().length), a(), e.on("select", a), e.on("reInit", a), () => {
      e.off("select", a), e.off("reInit", a);
    };
  }, [e]), /* @__PURE__ */ d.jsxs(ie, { color: "neutral", testId: "carousel-pagination", children: [
    t,
    " / ",
    r
  ] });
}
const YT = G1.version, XT = X1(Y1);
export {
  zO as Autocomplete,
  WO as AutocompleteAlpha,
  br as Backdrop,
  Ju as Badge,
  UO as Banner,
  Qu as BottomSheet,
  De as Box,
  HT as Breadcrumb,
  ba as Breakpoint,
  nv as Button,
  GO as ButtonAlpha,
  dT as ButtonLink,
  eT as Card,
  KT as Carousel,
  WT as CarouselContent,
  UT as CarouselNext,
  GT as CarouselPrevious,
  qT as CarouselSlidePagination,
  zT as CarouselSlot,
  tT as CartItem,
  nT as CartItemAlpha,
  lv as Checkbox,
  sc as CheckoutLayout,
  iT as Chip,
  rT as ChipAdornment,
  aT as Collapsible,
  h9 as CollapsibleContent,
  b9 as CollapsiblePosition,
  m9 as CollapsibleToggle,
  oT as Comment,
  Jt as ConditionalWrapper,
  sT as Container,
  x9 as ContainerRow,
  vw as ContainerbreakpointsAliases,
  $9 as Counter,
  lT as DateField,
  Du as Divider,
  yi as ErrorMessage,
  ut as Grid,
  uT as Header,
  $e as Icon,
  it as IconButton,
  fT as IconLink,
  lr as Image,
  cT as ImageMagnify,
  jT as ImageSelector,
  za as Label,
  Xs as Link,
  Dn as LinkButton,
  ya as ListItem,
  eo as Menu,
  hT as MenuIcon,
  mT as Modal,
  mp as OptionCard,
  gT as Pagination,
  vT as ParallaxImage,
  xT as PhoneField,
  $T as Picture,
  rv as PillButton,
  pT as PillLink,
  fn as Popover,
  IE as Price,
  CE as PriceReference,
  cr as ProductTile,
  EE as ProductTileCell,
  wT as ProductTileHorizontal,
  OE as ProductTileImage,
  TE as ProductTilePrice,
  PE as ProductTileTitle,
  B5 as Progress,
  CT as Prose,
  ST as QuantityItem,
  _E as QuantitySelector,
  ET as RadioButton,
  IT as Rating,
  FE as ResourceItem,
  TT as ResourceList,
  s9 as ResourceType,
  PT as SaferpayField,
  NT as ScanButton,
  L5 as Scrollable,
  tv as SearchField,
  lc as SearchFieldAlpha,
  AT as Select,
  _T as SelectAlpha,
  Ut as SelectionCard,
  RT as Sidebar,
  a9 as Spinner,
  ug as SpinnerAlpha,
  ov as Stack,
  We as StackBlock,
  Pe as StackInline,
  MT as StatusIndicator,
  JE as Stepper,
  O1 as Swatch,
  DT as SwatchSelector,
  kT as Switch,
  wE as Tag,
  FT as Text,
  ie as TextAlpha,
  LT as TextArea,
  Xt as TextField,
  av as Thumbnail,
  VT as Timeline,
  BT as TimelineAlpha,
  xi as Tooltip,
  h0 as breakpointsAliases,
  It as breakpointsView,
  yT as formatPhoneNumberIntl,
  g0 as generateBoxPropsClasses,
  Ud as generateBreakpointClasses,
  bw as generateBreakpointsMap,
  fe as generateResponsiveClassNames,
  ei as generateResponsiveVariables,
  $w as getBreakpointRange,
  Zu as getInteractiveProps,
  Kt as getScreenMaxWidth,
  Mt as getScreenMinWidth,
  Lh as iconSVGVariants,
  bT as isPossiblePhoneNumber,
  xw as isResponsiveProp,
  JO as isScreenDesktop,
  ZO as isScreenTablet,
  QO as isUserAgentAppleMobilePlatform,
  gw as mutableBreakpointsAliases,
  HO as mutableContainerBreakpointsAliases,
  YT as packageVersion,
  vl as prefixPriceWithCurrency,
  XT as preloadFonts,
  Ke as screens,
  BO as useActionStyling,
  iv as useBreakpoints,
  v9 as useCollapsible,
  p6 as useIsClient,
  yt as useMediaQuery,
  YO as useMediaQueryMatchesOnDesktop,
  qO as useMediaQueryMatchesOnDesktopLarge,
  XO as useMediaQueryMatchesOnMobile,
  OT as useResourceList,
  KO as usedContainerBreakpoints
};
